//角5、地弹簧
import makerjs from "makerjs";
import RectangleMark from "./RectangleMark";

/**
 * 计算两圆内含时的最近点坐标
 * @param {Object} c1 - 圆1对象 {x, y, r}
 * @param {Object} c2 - 圆2对象 {x, y, r}
 * @returns {Object} 最近点坐标 {x, y}
 */
 function getClosestPoint(c1, c2) {
  // 计算圆心距离
  const dx = c2.x - c1.x;
  const dy = c2.y - c1.y;
  const distance = Math.sqrt(dx * dx + dy * dy);
  
  // 处理同心圆情况
  if (distance === 0) {
      return { 
          x: c1.x + c1.r, 
          y: c1.y 
      };
  }
  
  // 计算单位方向向量
  const nx = dx / distance;
  const ny = dy / distance;
  
  //确定最近点位置（考虑半径差）
  if (c1.r > c2.r) {
      return {
          X1:c1.x + nx * c1.r,
          Y1:c1.y + ny * c1.r,
          X2: c2.x + nx * c2.r,
          Y2: c2.y + ny * c2.r,
          X3:c2.x - nx * c2.r,
          Y3:c2.y - ny * c2.r,
          d:distance
      };
  } else {
      return {
          x: c1.x - nx * c1.r,
          y: c1.y - ny * c1.r
      };
  }
}



function getCalculatingDistance(x1,y1,x2,y2,r1,r2){
  var d=Math.sqrt((x2-x1)*(x2-x1)+(y2-y1)*(y2-y1));
  var X1=x1+r1*(x2-x1)/d,Y1=y1+r1*(y2-y1)/d,
  X2=x2-r2*(x2-x1)/d,Y2=y2-r2*(y2-y1)/d,
  X3=x2+r2*(x2-x1)/d,Y3=y2+r2*(y2-y1)/d;
  var arr={d,X1,Y1,X2,Y2,X3,Y3};
  return arr;
};

//两个数组  对比 取相同部分
function getCommonAll(arr1,frame) {
  var arr2=["Rectangle","TypeCorner_myFloorSpringA","TypeCorner_myFloorSpringC","TypeCorner_myFloorSpringG","TypeCorner_myFloorSpringI","TypeCorner_myFloorSpringAC","TypeCorner_myFloorSpringAG","TypeCorner_myFloorSpringAI","TypeCorner_myFloorSpringCG","TypeCorner_myFloorSpringCI","TypeCorner_myFloorSpringGI","TypeCorner_myFloorSpringACG","TypeCorner_myFloorSpringACI","TypeCorner_myFloorSpringCGI","TypeCorner_myFloorSpringAGI","TypeCorner_myFloorSpringACGI"];
  console.log("是否调用此函数！");
  var result = [];
  for (const item1 of arr1) {
    for (const item2 of arr2) {
      if (item1 === item2) result.push(item1);
    }
  }
  if (result[0] == frame) {
        result.shift();//去掉数组第一个元素  
    
  }
  console.log("是否调用此函数！",result);
  console.log("是否调用此函数！",typeof(result));
  console.log("是否调用此函数！",result[0]);
  return result;
};
function changeArea(num){
  var areaPoint;
  switch(num){
 case "1": areaPoint = "A";break;
 case "2": areaPoint = "B";break;
 case "3": areaPoint = "C";break;
 case "4": areaPoint = "D";break;
 case "5": areaPoint = "E";break;
 case "6": areaPoint = "F";break;
 case "7": areaPoint = "G";break;
 case "8": areaPoint = "H";break;
 case "9": areaPoint = "I";break;
}
return areaPoint;
};
function showArea(data,outParam){ 
  console.log("data|||ObliqueAngle$$$$$$$$$$||||showArea====",data);
  var x=outParam.glassW*1,y=outParam.glassH*1,glassW=outParam.glassW*1,glassH=outParam.glassH*1;
  console.log("data==data.area===",data.area);
  console.log("data==typeof(data)===",typeof(data));
  console.log("data==data.length===",data.length);
  console.log("data[0]==data.length===",data[0]);
  console.log("data[1]==data.length===",data[1]);
//console.log("TypeCorner_myObj=showArea=",obj);  
    var properNum=objHasOwnProperty(data);
    console.log("properNum===",properNum);
    var arrData=[];
    var arrArea=[];
    var arrAreaNum=[];
    for (let key in data) {
      console.log("测试key0=", key);
            if (data.hasOwnProperty(key)&& key!=="0") {              
              console.log("测试key0=", key);              
              console.log("测试key0=typeof", typeof(key));
              if (key !== "Rectangle") {
                console.log("myData=", data);
              console.log("测试key2=", key);
              console.log("data[key].shape=", data[key].shape);
              console.log("data[key].area=", data[key].area);            
              arrData.push(data[key]);
              arrArea.push(changeArea(data[key].area));
              arrAreaNum.push(data[key].area);
              }         
            }
          }    
          console.log("arrData=",arrData);     
         var xa = 0, ya = y,xc = x , yc = y ,xg = 0, yg = 0,xi = x , yi = 0,
         Aa=0,Ab=0,Aaa=0,Ahd=0,Ca=0,Cb=0,Caa=0,Chd=0,Ga=0,Gb=0,Gaa=0,Ghd=0,Ia=0,Ib=0,Iaa=0,Ihd=0,
         da=0,wa=0,w1a=0,w2a=0,ha=0,h1a=0,ra=0,r1a=0,r2a=0,
         dc=0,wc=0,w1c=0,w2c=0,hc=0,h1c=0,rc=0,r1c=0,r2c=0,
         dg=0,wg=0,w1g=0,w2g=0,hg=0,h1g=0,rg=0,r1g=0,r2g=0,
         di=0,wi=0,w1i=0,w2i=0,hi=0,h1i=0,ri=0,r1i=0,r2i=0,
         xawx1=0,xawy1=0,xawx2=0,xawy2=0,xawx3=0,xawy3=0,xawx4=0,xawy4=0,
         xcwx1=0,xcwy1=0,xcwx2=0,xcwy2=0,xcwx3=0,xcwy3=0,xcwx4=0,xcwy4=0,
         xgwx1=0,xgwy1=0,xgwx2=0,xgwy2=0,xgwx3=0,xgwy3=0,xgwx4=0,xgwy4=0,
         xiwx1=0,xiwy1=0,xiwx2=0,xiwy2=0,xiwx3=0,xiwy3=0,xiwx4=0,xiwy4=0,
         arrA=[],arrC=[],arrG=[],arrI=[]; 
         if(x>y){
          for(var i = 0; i < arrAreaNum.length; i++){
            var areaNums=arrAreaNum[i];
            var r1=arrData[i].R1*1,r2=arrData[i].R2*1,d=arrData[i].D*1,r=d/2,w=arrData[i].W*1,w1=arrData[i].W1*1,w2=arrData[i].W2*1,h=arrData[i].H*1,h1=arrData[i].H1*1;
            switch(areaNums){
               case "1":   
              // console.log("switch objA.xawx",xawx); 
              //CircleTwo(x1,y1,x2,y2,r1,r2)        
               arrA=CircleTwoLong(xa+h-r1,ya-w,xa+r2,ya-w2,r1,r2);
               //arrA=CircleTwo(xa+w,ya+r1,xa+w2,ya-r2,r1,r2);
               console.log("CircleTwo==arrA==",arrA);
        Aa=ya-arrA[0]*1,  Ab=arrA[1]*1,  Ahd=h-(r1-Ab),Aaa=y-Aa;
        /**Aa 为切点 Y坐标，即xayx3 的Y轴坐标 
         * Ab为 r1为半径的圆心X坐标至切点X轴坐标差值  
         * Ahd 为切点X坐标与横线的X差值
         * Aaa 
        */
        da=d,wa=w,w1a=w1,w2a=w2,ha=h,h1a=h1,ra=r,r1a=r1,r2a=r2,
               xawx1 = xa+h, xawy1 =ya,//A位置角1坐标
            xawx2 = xa+h,xawy2 = ya-w,//A位置角2坐标
            xawx3 = xa+Ahd,xawy3 =ya-Aa,//A位置角3坐标
            xawx4 = xa,xawy4 = ya-w2;//A位置角4坐标
                break;
               case "3":        
               arrC=CircleTwoLong(xc-h+r1,yc-w,xc-r2,yc-w2,r1,r2);
               Ca=yc-arrC[0]*1,  Cb=arrC[1]*1,  Chd=h-(r1-Cb),Caa=y-Ca;
               dc=d,wc=w,w1c=w1,w2c=w2,hc=h,h1c=h1,rc=r,r1c=r1,r2c=r2,
               xcwx1 = xc-h, xcwy1 =yc,//C位置角1坐标
               xcwx2 = xc-h,xcwy2 = yc-w,//C位置角2坐标
               xcwx3 = xc-Chd,xcwy3 = yc-Ca,//C位置角3坐标
               xcwx4 = xc,xcwy4 = yc-w2;//C位置角4坐标
               break;
               case "7":                  
               
        arrG=CircleTwoLong(xg+h-r1,yg+w,xg+r2,yg+w2,r1,r2);
        Ga=arrG[0]*1,  Gb=arrG[1]*1,  Ghd=h-(r1-Gb),Gaa=x-Ga,
        dg=d,wg=w,w1g=w1,w2g=w2,hg=h,h1g=h1,rg=r,r1g=r1,r2g=r2,
               xgwx1 = xg+h, xgwy1 =yg,//G位置角1坐标
            xgwx2 = xg+h,xgwy2 = yg+w,//G位置角2坐标
            xgwx3 = xg+Ghd,xgwy3 = yg+Ga,//G位置角3坐标
            xgwx4 = xg,xgwy4 = yg+w2;//G位置角4坐标
               break;
               case "9":            
              
        arrI=CircleTwoLong(xi-h+r1,yi+w,xi-r2,yi+w2,r1,r2); 
        Ia=arrI[0]*1,  Ib=arrI[1]*1,  Ihd=h-(r1-Ib),Iaa=y-Ia,//I位置角H坐标
        di=d,wi=w,w1i=w1,w2i=w2,hi=h,h1i=h1,ri=r,r1i=r1,r2i=r2,
               xiwx1 = xi-h, xiwy1 =yi,//I位置角1坐标
            xiwx2 = xi-h,xiwy2 = yi+w,//I位置角2坐标
            xiwx3 = xi-Ihd,xiwy3 = yi+Ia,//I位置角3坐标
            xiwx4 = xi,xiwy4 = yi+w2;//I位置角4坐标 
               break;
             }
          } 
         }else{
          for(var i = 0; i < arrAreaNum.length; i++){
            var areaNums=arrAreaNum[i];
            var r1=arrData[i].R1*1,r2=arrData[i].R2*1,d=arrData[i].D*1,r=d/2,w=arrData[i].W*1,w1=arrData[i].W1*1,w2=arrData[i].W2*1,h=arrData[i].H*1,h1=arrData[i].H1*1;
            switch(areaNums){
               case "1":   
              // console.log("switch objA.xawx",xawx);         
               arrA=CircleTwo(xa+w,ya+r1,xa+w2,ya-r2,r1,r2);
        Aa=arrA[0]*1,  Ab=arrA[1]*1,  Ahd=h-(r1-Ab),Aaa=x-Aa;
        da=d,wa=w,w1a=w1,w2a=w2,ha=h,h1a=h1,ra=r,r1a=r1,r2a=r2,
               xawx1 = xa, xawy1 =ya-h,//A位置角1坐标
            xawx2 = xa+w,xawy2 = ya-h,//A位置角2坐标
            xawx3 = xa+Aa,xawy3 = ya-Ahd,//A位置角3坐标
            xawx4 = xa+w2,xawy4 = ya;//A位置角4坐标
                break;
               case "3":        
               arrC=CircleTwo(xc-w,yc+r1,xc-w2,yc-r2,r1,r2);
               Ca=arrC[0]*1,  Cb=arrC[1]*1,  Chd=h-(r1-Cb),Caa=x-Ca;
               dc=d,wc=w,w1c=w1,w2c=w2,hc=h,h1c=h1,rc=r,r1c=r1,r2c=r2,
               xcwx1 = xc, xcwy1 =yc-h,//C位置角1坐标
               xcwx2 = xc-w,xcwy2 = yc-h,//C位置角2坐标
               xcwx3 = xc-Caa,xcwy3 = yc-Chd,//C位置角3坐标
               xcwx4 = xc-w2,xcwy4 = yc;//C位置角4坐标
               break;
               case "7":                  
               
        arrG=CircleTwo(xg+w,yg-r1,xg+w2,yg+r2,r1,r2);
        Ga=arrG[0]*1,  Gb=arrG[1]*1,  Ghd=h-(r1-Gb),Gaa=x-Ga,
        dg=d,wg=w,w1g=w1,w2g=w2,hg=h,h1g=h1,rg=r,r1g=r1,r2g=r2,
               xgwx1 = xg, xgwy1 =yg+h,//G位置角1坐标
            xgwx2 = xg+w,xgwy2 = yg+h,//G位置角2坐标
            xgwx3 = xg+Ga,xgwy3 = yg+Ghd,//G位置角3坐标
            xgwx4 = xg+w2,xgwy4 = yg;//G位置角4坐标
               break;
               case "9":            
              
        arrI=CircleTwo(xi-w,yi-r1,xi-w2,yi+r2,r1,r2); 
        Ia=arrI[0]*1,  Ib=arrI[1]*1,  Ihd=h-(r1-Ib),Iaa=x-Ia,//I位置角H坐标
        di=d,wi=w,w1i=w1,w2i=w2,hi=h,h1i=h1,ri=r,r1i=r1,r2i=r2,
               xiwx1 = xi, xiwy1 =yi+h,//I位置角1坐标
            xiwx2 = xi-w,xiwy2 = yi+h,//I位置角2坐标
            xiwx3 = xi-Iaa,xiwy3 = yi+Ihd,//I位置角3坐标
            xiwx4 = xi-w2,xiwy4 = yi;//I位置角4坐标 
               break;
             }
          } 
         }      
     
          arrArea=arrArea.sort();
          arrArea=arrArea.join("");
        var whMark={Aa,Aaa,Ahd,Ca,Caa,Chd,Ga,Gaa,Ghd,Ia,Iaa,Ihd};
         var paramCoordinate = {da,wa,w1a,w2a,ha,h1a,ra,r1a,r2a,dc,wc,w1c,w2c,hc,h1c,rc,r1c,r2c,dg,wg,w1g,w2g,hg,h1g,rg,r1g,r2g,di,wi,w1i,w2i,hi,h1i,ri,r1i,r2i, xa, ya, xawx1, xawy1,xawx2, xawy2,xawx3, xawy3,xawx4, xawy4, xc, yc, xcwx1, xcwy1, xcwx2,xcwy2,xcwx3,xcwy3,xcwx4,xcwy4, xg, yg, xgwx1, xgwy1, xgwx2, xgwy2,xgwx3, xgwy3,xgwx4, xgwy4, xi, yi, xiwx1, xiwy1, xiwx2, xiwy2, xiwx3, xiwy3, xiwx4, xiwy4,glassW,glassH}
          console.log("showArea===arrData=",arrData);
          console.log("showArea===arrArea=",arrArea);
          console.log("paramCoordinate===arrArea=",paramCoordinate);
          console.log("whMark===whMark=",whMark);
          var objData=[arrArea,paramCoordinate,whMark]; 
  
  return objData;
      };
function objHasOwnProperty(obj) {
        var count = 0;
        for (var i in obj) {
          if (obj.hasOwnProperty(i)) {
            count++;
          }
        }
        return count;
      };
//获取角的字符串判断是哪个角
function getStrs(area, strs) {
  console.log("是否调用此函数getStrs（）",strs);
  var indexN=strs.length-1;
  var arrA = [];
  var TA = strs[indexN].slice(24);
  TA = TA + area;
  arrA = Array.from(TA);
  console.log("是否调用此函数getStrs()arrA==", arrA)
  arrA = arrA.sort();
  arrA = arrA.join("");
  console.log("是否调用此函数getStrs()areaPoint arrA==", arrA)
  return arrA;
};
// 矩形等去角 连线函数
function creatFloorSpring(area, param) {
  console.log("是否调用此函数creatOneCorner（）");
  console.log("是否调用此函数creatOneCorner（）param=", param);
  var xa = param.xa, ya = param.ya, xawx1 = param.xawx1, xawy1 = param.xawy1,xawx2 = param.xawx2, xawy2 = param.xawy2,xawx3 = param.xawx3, xawy3 = param.xawy3,xawx4 = param.xawx4, xawy4 = param.xawy4,
    xc = param.xc, yc = param.yc, xcwx1 = param.xcwx1, xcwy1 = param.xcwy1,xcwx2 = param.xcwx2, xcwy2 = param.xcwy2,xcwx3 = param.xcwx3, xcwy3 = param.xcwy3,xcwx4 = param.xcwx4, xcwy4 = param.xcwy4,
    xg = param.xg, yg = param.yg, xgwx1 = param.xgwx1, xgwy1 = param.xgwy1, xgwx2 = param.xgwx2, xgwy2 = param.xgwy2,xgwx3 = param.xgwx3, xgwy3 = param.xgwy3,xgwx4 = param.xgwx4, xgwy4 = param.xgwy4,
    xi = param.xi, yi = param.yi, xiwx1 = param.xiwx1, xiwy1 = param.xiwy1, xiwx2 = param.xiwx2, xiwy2 = param.xiwy2,xiwx3 = param.xiwx3, xiwy3 = param.xiwy3,xiwx4 = param.xiwx4, xiwy4 = param.xiwy4,
    r = param.r,r1 = param.r1,r2 = param.r2,w = param.w,w1 = param.w1,w2 = param.w2,h = param.h,h1 = param.h1,
    da = param.da,ra = param.ra,r1a = param.r1a,r2a = param.r2a,wa = param.wa,w1a = param.w1a,w2a = param.w2a,ha = param.ha,h1a = param.h1a,
    dc = param.dc,rc = param.rc,r1c = param.r1c,r2c = param.r2c,wc = param.wc,w1c = param.w1c,w2c = param.w2c,hc = param.hc,h1c = param.h1c,
    dg = param.dg,rg = param.rg,r1g = param.r1g,r2g = param.r2g,wg = param.wg,w1g = param.w1g,w2g = param.w2g,hg = param.hg,h1g = param.h1g,
    di = param.di,ri = param.ri,r1i = param.r1i,r2i = param.r2i,wi= param.wi,w1i = param.w1i,w2i = param.w2i,hi = param.hi,h1i = param.h1i,
    glassH=param.glassH,glassW=param.glassW,cutLine=param.cutLine,cutFilletRadius=param.cutFilletRadius,
    oAd=param.oAd,oAX1=param.oAX1,oAY1=param.oAY1,oAX2=param.oAX2,oAY2=param.oAY2,oAX3=param.oAX3,oAY3=param.oAY3,
    oCd=param.oCd,oCX1=param.oCX1,oCY1=param.oCY1,oCX2=param.oCX2,oCY2=param.oCY2,oCX3=param.oCX3,oCY3=param.oCY3,
    oGd=param.oGd,oGX1=param.oGX1,oGY1=param.oGY1,oGX2=param.oGX2,oGY2=param.oGY2,oGX3=param.oGX3,oGY3=param.oGY3,
    oId=param.oId,oIX1=param.oIX1,oIY1=param.oIY1,oIX2=param.oIX2,oIY2=param.oIY2,oIX3=param.oIX3,oIY3=param.oIY3; 
    /**
     w1aA=h1a,h1aA=-w1a,w1cA=h1c,h1cC=-w1c,w1gG=h1g,h1gG=-w1g,w1iI=h1i,h1iI=-w1i,
    
     *  */   
        console.log("$$$xawx1,xawy1,xawx2,xawy2,xawx3,xawy3,xawx4,xawy4===",xawx1,xawy1,xawx2,xawy2,xawx3,xawy3,xawx4,xawy4); 
        console.log("$$$xiwx1,xiwy1,xiwx2,xiwy2,xiwx3,xiwy3,xiwx4,xiwy4===",xiwx1,xiwy1,xiwx2,xiwy2,xiwx3,xiwy3,xiwx4,xiwy4);
        console.log("$$$xgwx1,xgwy1,xgwx2,xgwy2,xgwx3,xgwy3,xgwx4,xgwy4===",xgwx1,xgwy1,xgwx2,xgwy2,xgwx3,xgwy3,xgwx4,xgwy4);
        // console.log("$$$w1aA,h1aA===",w1aA,h1aA);
        // console.log("$$$r2a,r1a===",r2a,r1a);
    if(glassW*1>glassH * 1){
      console.log("长边在X轴￥￥￥￥￥");
      if (area == "A") {
        var myFloorSpring = {
          paths: {
            "LeftLineA": new makerjs.paths.Line([xg, yg], [xawx4, xawy4]),
            "TopBotArcA": new makerjs.paths.Arc([xawx4, xawy4],[xawx3, xawy3], r2a,false,true),   
            "TopTopArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx2, xawy2], r1a,false,false),//是否大弧,是否顺时针
            "LeftTopLineA": new makerjs.paths.Line([xawx2, xawy2],[xawx1, xawy1]),//是否大弧,是否顺时针
            "TopRightLineA": new makerjs.paths.Line([xawx1, xawy1], [xc, yc]),
            "RithgLineA": new makerjs.paths.Line([xc, yc], [xi, yi]),
            "BottomLineA": new makerjs.paths.Line([xi, yi], [xg, yg]),
            "RightHolesA": new makerjs.paths.Circle([xa+h1a, ya-w1a], ra),
          }
        };
        var myFloorSpringCut = {
          paths: {
            "TopBotArcA": new makerjs.paths.Arc([xawx4, xawy4],[xawx3, xawy3], r2a,false,true),   
            "TopTopArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx2, xawy2], r1a,false,false),//是否大弧,是否顺时针
            "LeftTopLineA": new makerjs.paths.Line([xawx2, xawy2],[xawx1, xawy1]),//是否大弧,是否顺时针
            "RightHolesA": new makerjs.paths.Circle([xa+h1a, ya-w1a], ra),
          }
        };
        var myFloorSpringCutM = {
          paths: {
            "LeftLineA": new makerjs.paths.Line([xg, yg], [xawx4, xawy4]),
            "TopBotArcA1": new makerjs.paths.Arc([xawx4, xawy4],[oAX1, oAY1], r2a,false,true),  
            "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
            "RightHolesA": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
            "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]), 
            "TopBotArcA2": new makerjs.paths.Arc([oAX1, oAY1],[xawx3, xawy3], r2a,false,false),//是否大弧,是否顺时针 
            "TopTopArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx2, xawy2], r1a,false,false),//是否大弧,是否顺时针
            "LeftTopLineA": new makerjs.paths.Line([xawx2, xawy2],[xawx1, xawy1]),//是否大弧,是否顺时针
            "TopRightLineA": new makerjs.paths.Line([xawx1, xawy1], [xc, yc]),
            "RithgLineA": new makerjs.paths.Line([xc, yc], [xi, yi]),
            "BottomLineA": new makerjs.paths.Line([xi, yi], [xg, yg]),
          }
        };
        //未加引爆槽
        var myFloorSpringWaterCut0 = {
          paths: {
             "EntryLineA":new makerjs.paths.Line([xawx4, xawy4-cutLine], [xawx4, xawy4]),    
            "TopBotArcA1": new makerjs.paths.Arc([xawx4, xawy4],[oAX1, oAY1], r2a,false,true),  
            "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
            "RightHolesA": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
            "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]), 
            "TopBotArcA2": new makerjs.paths.Arc([oAX1, oAY1],[xawx3, xawy3], r2a,false,false),//是否大弧,是否顺时针 
            "TopTopArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx2, xawy2], r1a,false,false),//是否大弧,是否顺时针
            "LeftTopLineA": new makerjs.paths.Line([xawx2, xawy2],[xawx1, xawy1]),//是否大弧,是否顺时针           
            "ExitLineA":new makerjs.paths.Line([xawx1, xawy1], [xawx1, xawy1+cutLine]),
          }
        };
        ////添加引爆槽
        var myFloorSpringWaterCut = {
          paths: {
             "EntryLineA":new makerjs.paths.Line([xawx4-cutLine, xawy4], [xawx4, xawy4]),    
            "TopBotArcA1": new makerjs.paths.Arc([xawx4, xawy4],[oAX1, oAY1], r2a,false,true),  
            "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
            "RightHolesUpA": new makerjs.paths.Arc([oAX2, oAY2], [oAX3, oAY3], ra,false,true),//圆
            "RightHolesDnA": new makerjs.paths.Arc([oAX3, oAY3],[oAX2, oAY2],  ra,false,true),//圆
            "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]), 
            "TopBotArcA2": new makerjs.paths.Arc([oAX1, oAY1],[xawx3, xawy3], r2a,false,false),//是否大弧,是否顺时针 
            "TopTopArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx2, xawy2], r1a,false,false),//是否大弧,是否顺时针
            "LeftTopLineA": new makerjs.paths.Line([xawx2, xawy2],[xawx1, xawy1]),//是否大弧,是否顺时针           
            "ExitLineA":new makerjs.paths.Line([xawx1, xawy1], [xawx1, xawy1+cutLine]),
          }
        };    
        var fillet1 = makerjs.path.fillet(myFloorSpringWaterCut.paths.EntryLineA, myFloorSpringWaterCut.paths.TopBotArcA1, cutFilletRadius);
        var fillet2 = makerjs.path.fillet(myFloorSpringWaterCut.paths.TopBotArcA1, myFloorSpringWaterCut.paths.arcAndLineA1, cutFilletRadius);
        var fillet3 = makerjs.path.fillet(myFloorSpringWaterCut.paths.arcAndLineA1, myFloorSpringWaterCut.paths.RightHolesUpA, cutFilletRadius);
        var fillet4 = makerjs.path.fillet(myFloorSpringWaterCut.paths.RightHolesDnA, myFloorSpringWaterCut.paths.arcAndLineA2, cutFilletRadius);
        var fillet5 = makerjs.path.fillet(myFloorSpringWaterCut.paths.arcAndLineA2, myFloorSpringWaterCut.paths.TopBotArcA2, cutFilletRadius); 
        var fillet6 = makerjs.path.fillet(myFloorSpringWaterCut.paths.TopBotArcA2, myFloorSpringWaterCut.paths.LeftTopLineA, cutFilletRadius); 
      myFloorSpringWaterCut.paths.fillet1 = fillet1;
      myFloorSpringWaterCut.paths.fillet2 = fillet2;
      myFloorSpringWaterCut.paths.fillet3 = fillet3;
      myFloorSpringWaterCut.paths.fillet4 = fillet4;
      myFloorSpringWaterCut.paths.fillet5 = fillet5;
      myFloorSpringWaterCut.paths.fillet6 = fillet6;
        //   var myCorner = new makerjs.models.ConnectTheDots(true, [[xg, yg], [xahx, xahy], [xawx, xawy], [xc, yc], [xi, yi]]);
      }else if (area == "C") {
        var myFloorSpring = {
          paths: {
            "RightLineC": new makerjs.paths.Line([xg, yg], [xa, ya]),
            "TopLeftLineC": new makerjs.paths.Line([xa, ya], [xcwx1, xcwy1]),   
            "TopLeftArcC": new makerjs.paths.Line([xcwx1, xcwy1],[xcwx2, xcwy2] ),//是否大弧,是否顺时针
            "TopRightArcC": new makerjs.paths.Arc([xcwx2, xcwy2],[xcwx3, xcwy3], r1c,false,false),//是否大弧,是否顺时针
            "TopRithgLineC": new makerjs.paths.Arc([xcwx3, xcwy3], [xcwx4, xcwy4], r2c,false,true),
            "RithgLineC": new makerjs.paths.Line([xcwx4, xcwy4], [xi, yi]),
            "BottomLineC": new makerjs.paths.Line([xi, yi], [xg, yg]),
            "RightHolesC": new makerjs.paths.Circle([xc-h1c, yc-w1c], rc),
          }
        };
        var myFloorSpringCut = {
          paths: { 
            "TopLeftArcC": new makerjs.paths.Line([xcwx1, xcwy1],[xcwx2, xcwy2] ),//是否大弧,是否顺时针
            "TopRightArcC": new makerjs.paths.Arc([xcwx2, xcwy2],[xcwx3, xcwy3], r1c,false,false),//是否大弧,是否顺时针
            "TopRithgLineC": new makerjs.paths.Arc([xcwx3, xcwy3], [xcwx4, xcwy4], r2c,false,true),
            "RightHolesC": new makerjs.paths.Circle([xc-h1c, yc-w1c], rc),
          }
        };
        var myFloorSpringCutM = {
          paths: {
            "RightLineC": new makerjs.paths.Line([xg, yg], [xa, ya]),
            "TopLeftLineC": new makerjs.paths.Line([xa, ya], [xcwx1, xcwy1]),   
            "TopLeftArcC": new makerjs.paths.Line([xcwx1, xcwy1],[xcwx2, xcwy2] ),//是否大弧,是否顺时针
            "TopRightArcC": new makerjs.paths.Arc([xcwx2, xcwy2],[xcwx3, xcwy3], r1c,false,false),//是否大弧,是否顺时针
            "TopRithgLineC1": new makerjs.paths.Arc([xcwx3, xcwy3], [oCX1, oCY1], r2c,false,true),          
            "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
            "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
            "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
            "TopRithgLineC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx4, xcwy4], r2c,false,true),          
            "RithgLineC": new makerjs.paths.Line([xcwx4, xcwy4], [xi, yi]),
            "BottomLineC": new makerjs.paths.Line([xi, yi], [xg, yg]),
          }
        };
        var myFloorSpringWaterCut0 = {
          paths: {
            "EntryLineC":new makerjs.paths.Line([xcwx1, xcwy1+cutLine], [xcwx1, xcwy1]),
            "TopLeftArcC": new makerjs.paths.Line([xcwx1, xcwy1],[xcwx2, xcwy2] ),//是否大弧,是否顺时针
            "TopRightArcC": new makerjs.paths.Arc([xcwx2, xcwy2],[xcwx3, xcwy3], r1c,false,false),//是否大弧,是否顺时针
            "TopRithgLineC1": new makerjs.paths.Arc([xcwx3, xcwy3], [oCX1, oCY1], r2c,false,true),          
            "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
            "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
            "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
            "TopRithgLineC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx4, xcwy4], r2c,false,true),   
            "ExitLineC":new makerjs.paths.Line([xcwx4, xcwy4], [xcwx4-cutLine, xcwy4]),  
          }
        };
        var myFloorSpringWaterCut = {
          paths: {
            "EntryLineC":new makerjs.paths.Line([xcwx1, xcwy1+cutLine], [xcwx1, xcwy1]),
            "TopLeftArcC": new makerjs.paths.Line([xcwx1, xcwy1],[xcwx2, xcwy2] ),//是否大弧,是否顺时针
            "TopRightArcC": new makerjs.paths.Arc([xcwx2, xcwy2],[xcwx3, xcwy3], r1c,false,false),//是否大弧,是否顺时针
            "TopRithgLineC1": new makerjs.paths.Arc([xcwx3, xcwy3], [oCX1, oCY1], r2c,false,true),          
            "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
            "RightHolesUpC": new makerjs.paths.Arc([oCX2, oCY2], [oCX3, oCY3], rc,false,false),
            "RightHolesDnC": new makerjs.paths.Arc([oCX3, oCY3],[oCX2, oCY2],  rc,false,false),
            "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
            "TopRithgLineC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx4, xcwy4], r2c,false,true),   
            "ExitLineC":new makerjs.paths.Line([xcwx4, xcwy4], [xcwx4+cutLine, xcwy4]),  
          }
        };
        var fillet1 = makerjs.path.fillet(myFloorSpringWaterCut.paths.TopRightArcC, myFloorSpringWaterCut.paths.TopRithgLineC1, cutFilletRadius);
        var fillet2 = makerjs.path.fillet(myFloorSpringWaterCut.paths.TopRithgLineC1, myFloorSpringWaterCut.paths.TopRithgLineConectC1, cutFilletRadius);
        var fillet3 = makerjs.path.fillet(myFloorSpringWaterCut.paths.TopRithgLineConectC1, myFloorSpringWaterCut.paths.RightHolesUpC, cutFilletRadius);
        var fillet4 = makerjs.path.fillet(myFloorSpringWaterCut.paths.RightHolesDnC, myFloorSpringWaterCut.paths.TopRithgLineConectC2, cutFilletRadius);
        var fillet5 = makerjs.path.fillet(myFloorSpringWaterCut.paths.TopRithgLineConectC2, myFloorSpringWaterCut.paths.TopRithgLineC2, cutFilletRadius); 
        var fillet6 = makerjs.path.fillet(myFloorSpringWaterCut.paths.TopRithgLineC2, myFloorSpringWaterCut.paths.ExitLineC, cutFilletRadius); 
      myFloorSpringWaterCut.paths.fillet1 = fillet1;
      myFloorSpringWaterCut.paths.fillet2 = fillet2;
      myFloorSpringWaterCut.paths.fillet3 = fillet3;
      myFloorSpringWaterCut.paths.fillet4 = fillet4;
      myFloorSpringWaterCut.paths.fillet5 = fillet5;
      myFloorSpringWaterCut.paths.fillet6 = fillet6;
      } else if (area == "G") {
        var myFloorSpring = {
          paths: {
            "LeftLineG": new makerjs.paths.Line([xgwx4, xgwy4], [xa, ya]),
            "TopLeftLineG": new makerjs.paths.Line([xa, ya],[xc, yc]),
            "RithgLineG": new makerjs.paths.Line([xc, yc], [xi, yi]),
            "BottomLineG": new makerjs.paths.Line([xi, yi], [xgwx1, xgwy1]),   
            "BottomRigthArcG": new makerjs.paths.Line([xgwx1, xgwy1],[xgwx2, xgwy2]),
            "BottomLeftArcG": new makerjs.paths.Arc([xgwx2, xgwy2],[xgwx3, xgwy3], r1g,false,false),//是否大弧,是否顺时针
            "BottomLeftLineG": new makerjs.paths.Arc([xgwx3, xgwy3], [xgwx4, xgwy4], r2g,false,true),//是否大弧,是否顺时针
            "RightHolesG": new makerjs.paths.Circle([xg+h1g, yg+w1g], rg),
          }
        };
        var myFloorSpringCut = {
          paths: {
            "BottomRigthArcG": new makerjs.paths.Line([xgwx1, xgwy1],[xgwx2, xgwy2]),
            "BottomLeftArcG": new makerjs.paths.Arc([xgwx2, xgwy2],[xgwx3, xgwy3], r1g,false,false),//是否大弧,是否顺时针
            "BottomLeftLineG": new makerjs.paths.Arc([xgwx3, xgwy3], [xgwx4, xgwy4], r2g,false,true),//是否大弧,是否顺时针
            "RightHolesG": new makerjs.paths.Circle([xg+h1g, yg+w1g], rg),
          }
        };
        var myFloorSpringCutM = {
          paths: {
            "LeftLineG": new makerjs.paths.Line([xgwx4, xgwy4], [xa, ya]),
            "TopLeftLineG": new makerjs.paths.Line([xa, ya],[xc, yc]),
            "RithgLineG": new makerjs.paths.Line([xc, yc], [xi, yi]),
            "BottomLineG": new makerjs.paths.Line([xi, yi], [xgwx1, xgwy1]),   
            "BottomRigthArcG": new makerjs.paths.Line([xgwx1, xgwy1],[xgwx2, xgwy2]),
            "BottomLeftArcG": new makerjs.paths.Arc([xgwx2, xgwy2],[xgwx3, xgwy3], r1g,false,false),//是否大弧,是否顺时针
            "BottomLeftLineG1": new makerjs.paths.Arc([xgwx3, xgwy3], [oGX1, oGY1], r2g,false,true),//是否大弧,是否顺时针           
            "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
            "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
            "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
            "BottomLeftLineG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx4, xgwy4], r2g,false,true),//是否大弧,是否顺时针
          }
        };
        var myFloorSpringWaterCut0 = {
          paths: {
            "EntryLineG":new makerjs.paths.Line([xgwx1, xgwy1-cutLine], [xgwx1, xgwy1]), 
            "BottomRigthArcG": new makerjs.paths.Line([xgwx1, xgwy1],[xgwx2, xgwy2]),
            "BottomLeftArcG": new makerjs.paths.Arc([xgwx2, xgwy2],[xgwx3, xgwy3], r1g,false,false),//是否大弧,是否顺时针
            "BottomLeftLineG1": new makerjs.paths.Arc([xgwx3, xgwy3], [oGX1, oGY1], r2g,false,true),//是否大弧,是否顺时针           
            "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
            "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
            "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
            "BottomLeftLineG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx4, xgwy4], r2g,false,true),//是否大弧,是否顺时针
            "ExitLineG":new makerjs.paths.Line([xgwx4, xgwy4], [xgwx4, xgwy4+cutLine]),
          }
        };
        var myFloorSpringWaterCut = {
          paths: {
            "EntryLineG":new makerjs.paths.Line([xgwx1, xgwy1-cutLine], [xgwx1, xgwy1]), 
            "BottomRigthArcG": new makerjs.paths.Line([xgwx1, xgwy1],[xgwx2, xgwy2]),
            "BottomLeftArcG": new makerjs.paths.Arc([xgwx2, xgwy2],[xgwx3, xgwy3], r1g,false,false),//是否大弧,是否顺时针
            "BottomLeftLineG1": new makerjs.paths.Arc([xgwx3, xgwy3], [oGX1, oGY1], r2g,false,true),//是否大弧,是否顺时针           
            "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
            "RightHolesDnG": new makerjs.paths.Arc([oGX2, oGY2], [oGX3, oGY3], rg,false,false),
            "RightHolesUpG": new makerjs.paths.Arc([oGX3, oGY3],[oGX2, oGY2], rg,false,false),
            "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
            "BottomLeftLineG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx4, xgwy4], r2g,false,true),//是否大弧,是否顺时针
            "ExitLineG":new makerjs.paths.Line([xgwx4, xgwy4], [xgwx4-cutLine, xgwy4]),
          }
        };
        
        var fillet1 = makerjs.path.fillet(myFloorSpringWaterCut.paths.BottomLeftArcG, myFloorSpringWaterCut.paths.BottomLeftLineG1, cutFilletRadius);
        var fillet2 = makerjs.path.fillet(myFloorSpringWaterCut.paths.BottomLeftLineG1, myFloorSpringWaterCut.paths.BottomLeftArcGConect1, cutFilletRadius);
        var fillet3 = makerjs.path.fillet(myFloorSpringWaterCut.paths.BottomLeftArcGConect1, myFloorSpringWaterCut.paths.RightHolesDnG, cutFilletRadius);
        var fillet4 = makerjs.path.fillet(myFloorSpringWaterCut.paths.RightHolesUpG, myFloorSpringWaterCut.paths.BottomLeftArcGConect2, cutFilletRadius);
        var fillet5 = makerjs.path.fillet(myFloorSpringWaterCut.paths.BottomLeftArcGConect2, myFloorSpringWaterCut.paths.BottomLeftLineG2, cutFilletRadius); 
        var fillet6 = makerjs.path.fillet(myFloorSpringWaterCut.paths.BottomLeftLineG2, myFloorSpringWaterCut.paths.ExitLineG, cutFilletRadius); 
      myFloorSpringWaterCut.paths.fillet1 = fillet1;
      myFloorSpringWaterCut.paths.fillet2 = fillet2;
      myFloorSpringWaterCut.paths.fillet3 = fillet3;
      myFloorSpringWaterCut.paths.fillet4 = fillet4;
      myFloorSpringWaterCut.paths.fillet5 = fillet5;
      myFloorSpringWaterCut.paths.fillet6 = fillet6;
      } else if (area == "I") {
        var myFloorSpring = {
          paths: {        
            "LeftLineI": new makerjs.paths.Line([xg, yg], [xa, ya]),
            "TopLeftLineI": new makerjs.paths.Line([xa, ya],[xc, yc]),
            "RithgLineI": new makerjs.paths.Line([xc, yc], [xiwx4, xiwy4]),
            "BottomLineI": new makerjs.paths.Arc([xiwx4, xiwy4], [xiwx3, xiwy3], r2i,false,true),   
            "BottomRigthArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx2, xiwy2], r1i,false,false),//是否大弧,是否顺时针
            "BottomLeftArcI": new makerjs.paths.Line([xiwx2, xiwy2],[xiwx1, xiwy1]),//是否大弧,是否顺时针
            "BottomLeftLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xg, xg]),
            "RightHolesI": new makerjs.paths.Circle([xi-h1i, yi+w1i], ri),
          }
        };
        var myFloorSpringCut = {
          paths: {        
            "BottomLineI": new makerjs.paths.Arc([xiwx4, xiwy4], [xiwx3, xiwy3], r2i,false,true),   
            "BottomRigthArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx2, xiwy2], r1i,false,false),//是否大弧,是否顺时针
            "BottomLeftArcI": new makerjs.paths.Line([xiwx2, xiwy2],[xiwx1, xiwy1]),//是否大弧,是否顺时针
          }
        };
        var myFloorSpringCutM = {
          paths: {        
            "LeftLineI": new makerjs.paths.Line([xg, yg], [xa, ya]),
            "TopLeftLineI": new makerjs.paths.Line([xa, ya],[xc, yc]),
            "RithgLineI": new makerjs.paths.Line([xc, yc], [xiwx4, xiwy4]),
            "BottomLineI1": new makerjs.paths.Arc([xiwx4, xiwy4], [oIX1,oIY1], r2i,false,true),
            "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
            "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
            "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),  
            "BottomLineI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx3, xiwy3], r2i,false,true), 
            "BottomRigthArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx2, xiwy2], r1i,false,false),//是否大弧,是否顺时针
            "BottomLeftArcI": new makerjs.paths.Line([xiwx2, xiwy2],[xiwx1, xiwy1]),//是否大弧,是否顺时针
            "BottomLeftLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xg, xg]),
          }
        };
        var myFloorSpringWaterCut0 = {
          paths: {  
            "EntryLineI":new makerjs.paths.Line([xiwx4, xiwy4+cutLine], [xiwx4, xiwy4]),    
            "BottomLineI1": new makerjs.paths.Arc([xiwx4, xiwy4], [oIX1,oIY1], r2i,false,true),
            "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
            "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
            "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),  
            "BottomLineI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx3, xiwy3], r2i,false,true),  
            "BottomRigthArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx2, xiwy2], r1i,false,false),//是否大弧,是否顺时针
            "BottomLeftArcI": new makerjs.paths.Line([xiwx2, xiwy2],[xiwx1, xiwy1]),//是否大弧,是否顺时针          
            "ExitLineI":new makerjs.paths.Line([xiwx1, xiwy1], [xiwx1, xiwy1-cutLine]),   
          }
        };
        var myFloorSpringWaterCut = {
          paths: {  
            "EntryLineI":new makerjs.paths.Line([xiwx4+cutLine, xiwy4], [xiwx4, xiwy4]),    
            "BottomLineI1": new makerjs.paths.Arc([xiwx4, xiwy4], [oIX1,oIY1], r2i,false,true),
            "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
            "RightHolesUpI": new makerjs.paths.Arc([oIX2,oIY2],[oIX3,oIY3],ri,false,false),
            "RightHolesDnI": new makerjs.paths.Arc([oIX3,oIY3],[oIX2,oIY2],ri,false,false),
            "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),  
            "BottomLineI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx3, xiwy3], r2i,false,true),  
            "BottomRigthArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx2, xiwy2], r1i,false,false),//是否大弧,是否顺时针
            "BottomLeftArcI": new makerjs.paths.Line([xiwx2, xiwy2],[xiwx1, xiwy1]),//是否大弧,是否顺时针          
            "ExitLineI":new makerjs.paths.Line([xiwx1, xiwy1], [xiwx1, xiwy1-cutLine]),   
          }
        };
        var fillet1 = makerjs.path.fillet(myFloorSpringWaterCut.paths.EntryLineI, myFloorSpringWaterCut.paths.BottomLineI1, cutFilletRadius);
        var fillet2 = makerjs.path.fillet(myFloorSpringWaterCut.paths.BottomLineI1, myFloorSpringWaterCut.paths.RithgLineI1, cutFilletRadius);
        var fillet3 = makerjs.path.fillet(myFloorSpringWaterCut.paths.RithgLineI1, myFloorSpringWaterCut.paths.RightHolesUpI, cutFilletRadius);
        var fillet4 = makerjs.path.fillet(myFloorSpringWaterCut.paths.RightHolesDnI, myFloorSpringWaterCut.paths.RithgLineI2, cutFilletRadius);
        var fillet5 = makerjs.path.fillet(myFloorSpringWaterCut.paths.RithgLineI2, myFloorSpringWaterCut.paths.BottomLineI2, cutFilletRadius); 
        var fillet6 = makerjs.path.fillet(myFloorSpringWaterCut.paths.BottomLineI2, myFloorSpringWaterCut.paths.BottomRigthArcI, cutFilletRadius); 
      myFloorSpringWaterCut.paths.fillet1 = fillet1;
      myFloorSpringWaterCut.paths.fillet2 = fillet2;
      myFloorSpringWaterCut.paths.fillet3 = fillet3;
      myFloorSpringWaterCut.paths.fillet4 = fillet4;
      myFloorSpringWaterCut.paths.fillet5 = fillet5;
      myFloorSpringWaterCut.paths.fillet6 = fillet6;
        // var myCorner = new makerjs.models.ConnectTheDots(true, [[xg, yg], [xa, ya], [xc, yc], [xihx, xihy], [xiwx, xiwy]]);
      } 
      // else if (area == "AC") {
      //   var myFloorSpring = {
      //     paths: {
      //       "LeftLineA": new makerjs.paths.Line([xg, yg], [xawx4, xawy4]),
      //       "TopBotArcA": new makerjs.paths.Arc([xawx4, xawy4],[xawx3, xawy3], r2a,false,true),   
      //       "TopTopArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx2, xawy2], r1a,false,false),//是否大弧,是否顺时针
      //       "LeftTopLineA": new makerjs.paths.Line([xawx2, xawy2],[xawx1, xawy1]),//是否大弧,是否顺时针
      //       "TopRightLineA": new makerjs.paths.Line([xawx1, xawy1], [xcwx1, xcwy1]), 
      //        "TopLeftArcC": new makerjs.paths.Line([xcwx1, xcwy1],[xcwx2, xcwy2]),//是否大弧,是否顺时针
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx2, xcwy2],[xcwx3, xcwy3], r1c,false,false),//是否大弧,是否顺时针
      //       "TopRithgLineC": new makerjs.paths.Arc([xcwx3, xcwy3], [xcwx4, xcwy4], r2c,false,true),
      //       "RithgLineC": new makerjs.paths.Line([xcwx4, xcwy4], [xi, yi]),
      //       "BottomLineA": new makerjs.paths.Line([xi, yi], [xg, yg]),
      //       "RightHolesA": new makerjs.paths.Circle([xa+h1a, ya-w1a], ra),
      //       "RightHolesC": new makerjs.paths.Circle([xc-h1c, yc-w1c], rc),
      //     }
      //   };
      //   var myFloorSpringCut = {
      //     paths: {
      //       "TopBotArcA": new makerjs.paths.Arc([xawx4, xawy4],[xawx3, xawy3], r2a,false,true),   
      //       "TopTopArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx2, xawy2], r1a,false,false),//是否大弧,是否顺时针
      //       "LeftTopLineA": new makerjs.paths.Line([xawx2, xawy2],[xawx1, xawy1]),//是否大弧,是否顺时针
      //        "TopLeftArcC": new makerjs.paths.Line([xcwx1, xcwy1],[xcwx2, xcwy2]),//是否大弧,是否顺时针
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx2, xcwy2],[xcwx3, xcwy3], r1c,false,false),//是否大弧,是否顺时针
      //       "TopRithgLineC": new makerjs.paths.Arc([xcwx3, xcwy3], [xcwx4, xcwy4], r2c,false,true),
      //       "RightHolesA": new makerjs.paths.Circle([xa+h1a, ya-w1a], ra),
      //       "RightHolesC": new makerjs.paths.Circle([xc-h1c, yc-w1c], rc),
      //     }
      //   };
      //   var myFloorSpringCutM = {
      //     paths: {
      //       "LeftLineA": new makerjs.paths.Line([xg, yg], [xawx4, xawy4]),
      //       "TopBotArcA1": new makerjs.paths.Arc([xawx4, xawy4],[oAX1, oAY1], r2a,false,true),  
      //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
      //       "RightHolesA": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
      //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]), 
      //       "TopBotArcA2": new makerjs.paths.Arc([oAX1, oAY1],[xawx3, xawy3], r2a,false,false),//是否大弧,是否顺时针 
      //       "TopTopArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx2, xawy2], r1a,false,false),//是否大弧,是否顺时针
      //       "LeftTopLineA": new makerjs.paths.Line([xawx2, xawy2],[xawx1, xawy1]),//是否大弧,是否顺时针
      //       "TopRightLineA": new makerjs.paths.Line([xawx1, xawy1], [xcwx1, xcwy1]), 
      //        "TopLeftArcC": new makerjs.paths.Line([xcwx1, xcwy1],[xcwx2, xcwy2]),//是否大弧,是否顺时针
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx2, xcwy2],[xcwx3, xcwy3], r1c,false,false),//是否大弧,是否顺时针
      //       "TopRithgLineC1": new makerjs.paths.Arc([xcwx3, xcwy3], [oCX1, oCY1], r2c,false,true),          
      //       "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
      //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
      //       "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
      //       "TopRithgLineC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx4, xcwy4], r2c,false,true),          
      //       "RithgLineC": new makerjs.paths.Line([xcwx4, xcwy4], [xi, yi]),
      //     }
      //   };
      //   var myFloorSpringWaterCut = {
      //     paths: {
      //       "EntryLineA":new makerjs.paths.Line([xawx4, xawy4-cutLine], [xawx4, xawy4]), 
      //       "TopBotArcA1": new makerjs.paths.Arc([xawx4, xawy4],[oAX1, oAY1], r2a,false,true),  
      //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
      //       "RightHolesA": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
      //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]), 
      //       "TopBotArcA2": new makerjs.paths.Arc([oAX1, oAY1],[xawx3, xawy3], r2a,false,false),//是否大弧,是否顺时针 
      //       "TopTopArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx2, xawy2], r1a,false,false),//是否大弧,是否顺时针
      //       "LeftTopLineA": new makerjs.paths.Line([xawx2, xawy2],[xawx1, xawy1]),//是否大弧,是否顺时针              
      //       "ExitLineA":new makerjs.paths.Line([xawx1, xawy1], [xawx1, xawy1+cutLine]),
      //       "EntryLineC":new makerjs.paths.Line([xcwx1, xcwy1+cutLine], [xcwx1, xcwy1]), 
      //        "TopLeftArcC": new makerjs.paths.Line([xcwx1, xcwy1],[xcwx2, xcwy2]),//是否大弧,是否顺时针
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx2, xcwy2],[xcwx3, xcwy3], r1c,false,false),//是否大弧,是否顺时针
      //       "TopRithgLineC1": new makerjs.paths.Arc([xcwx3, xcwy3], [oCX1, oCY1], r2c,false,true),          
      //       "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
      //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
      //       "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
      //       "TopRithgLineC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx4, xcwy4], r2c,false,true),  
      //       "ExitLineC":new makerjs.paths.Line([xcwx4, xcwy4], [xcwx4-cutLine, xcwy4]),           
      //     }
      //   };
      //   // var myFillet = new makerjs.models.ConnectTheDots(true, [[xg, yg], [xahx, xahy], [xawx, xawy], [xcwx, xcwy], [xchx, xchy],[xi, yi]]);
      // } else if (area == "AG") {
      //   var myFloorSpring = {
      //     paths: {
      //       "BottomLeftLineG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]), 
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx2, xgwy2],[xgwx3, xgwy3], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomRigthArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx4, xgwy4], r2g,false,true),//是否大弧,是否顺时针
      //       "LeftLineA": new makerjs.paths.Line([xgwx4, xgwy4], [xawx4, xawy4]),
      //       "TopLeftLineA": new makerjs.paths.Arc([xawx4, xawy4],[xawx3, xawy3], r2a,false,true), //是否大弧,是否顺时针
      //       "TopRightArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx2, xawy2], r1a,false,false),//是否大弧,是否顺时针  
      //       "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2],[xawx1, xawy1]),
      //       "TopRightLineA": new makerjs.paths.Line([xawx1, xawy1], [xc, yc]),
      //       "RithgLineA": new makerjs.paths.Line([xc, yc], [xi, yi]),
      //       "BottomLineG": new makerjs.paths.Line([xi, yi], [xgwx1, xgwy1]),  
      //       "RightHolesA": new makerjs.paths.Circle([xa+h1a, ya-w1a], ra),
      //       "RightHolesG": new makerjs.paths.Circle([xg+h1g, yg+w1g], rg),
      //     }
      //   };
      //   var myFloorSpringCut = {
      //     paths: {
      //       "BottomLeftLineG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]), 
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx2, xgwy2],[xgwx3, xgwy3], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomRigthArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx4, xgwy4], r2g,false,true),//是否大弧,是否顺时针
      //       "TopLeftLineA": new makerjs.paths.Arc([xawx4, xawy4],[xawx3, xawy3], r2a,false,true), //是否大弧,是否顺时针
      //       "TopRightArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx2, xawy2], r1a,false,false),//是否大弧,是否顺时针  
      //       "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2],[xawx1, xawy1]),
      //       "RithgLineA": new makerjs.paths.Line([xc, yc], [xi, yi]),
      //       "RightHolesA": new makerjs.paths.Circle([xa+h1a, ya-w1a], ra),
      //       "RightHolesG": new makerjs.paths.Circle([xg+h1g, yg+w1g], rg),
      //     }
      //   };
      //   var myFloorSpringCutM = {
      //     paths: {
      //       "BottomLeftLineG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]), 
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx2, xgwy2],[xgwx3, xgwy3], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG1": new makerjs.paths.Arc([xgwx3, xgwy3], [oGX1, oGY1], r2g,false,true),//是否大弧,是否顺时针           
      //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
      //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
      //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
      //       "BottomLeftLineG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx4, xgwy4], r2g,false,true),//是否大弧,是否顺时针
      //       "LeftLineA": new makerjs.paths.Line([xgwx4, xgwy4], [xawx4, xawy4]),
      //       "TopBotArcA1": new makerjs.paths.Arc([xawx4, xawy4],[oAX1, oAY1], r2a,false,true),  
      //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
      //       "RightHolesA": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
      //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]), 
      //       "TopBotArcA2": new makerjs.paths.Arc([oAX1, oAY1],[xawx3, xawy3], r2a,false,false),//是否大弧,是否顺时针 
      //       "TopRightArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx2, xawy2], r1a,false,false),//是否大弧,是否顺时针  
      //       "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2],[xawx1, xawy1]),
      //       "TopRightLineA": new makerjs.paths.Line([xawx1, xawy1], [xc, yc]),
      //       "RithgLineA": new makerjs.paths.Line([xc, yc], [xi, yi]),
      //       "BottomLineG": new makerjs.paths.Line([xi, yi], [xgwx1, xgwy1]), 
      //     }
      //   };
      //   var myFloorSpringWaterCut = {
      //     paths: {
      //       "EntryLineG":new makerjs.paths.Line([xgwx1, xgwy1-cutLine], [xgwx1, xgwy1]), 
      //       "BottomLeftLineG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]), 
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx2, xgwy2],[xgwx3, xgwy3], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG1": new makerjs.paths.Arc([xgwx3, xgwy3], [oGX1, oGY1], r2g,false,true),//是否大弧,是否顺时针           
      //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
      //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
      //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
      //       "BottomLeftLineG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx4, xgwy4], r2g,false,true),//是否大弧,是否顺时针
      //       "ExitLineG":new makerjs.paths.Line([xgwx4, xgwy4], [xgwx4, xgwy4+cutLine]),
      //       "EntryLineA":new makerjs.paths.Line([xawx4, xawy4-cutLine], [xawx4, xawy4]), 
      //       "TopBotArcA1": new makerjs.paths.Arc([xawx4, xawy4],[oAX1, oAY1], r2a,false,true),  
      //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
      //       "RightHolesA": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
      //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]), 
      //       "TopBotArcA2": new makerjs.paths.Arc([oAX1, oAY1],[xawx3, xawy3], r2a,false,false),//是否大弧,是否顺时针 
      //       "TopRightArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx2, xawy2], r1a,false,false),//是否大弧,是否顺时针  
      //       "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2],[xawx1, xawy1]),              
      //       "ExitLineA":new makerjs.paths.Line([xawx1, xawy1], [xawx1, xawy1+cutLine]),
      //       // "RithgLineA": new makerjs.paths.Line([xc, yc], [xi, yi]),  
      //     }
      //   };
      //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xahx, xahy], [xawx, xawy], [xc, yc],[xi, yi], [xgwx, xgwy]]);
      // } else if (area == "AI") {
      //   var myFloorSpring = {
      //     paths: {
      //       "LeftLineA": new makerjs.paths.Line([xg, yg], [xawx4, xawy4]),
      //       "TopBotArcA": new makerjs.paths.Arc([xawx4, xawy4],[xawx3, xawy3], r2a,false,true),   
      //       "TopTopArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx2, xawy2], r1a,false,false),//是否大弧,是否顺时针
      //       "LeftTopLineA": new makerjs.paths.Line([xawx2, xawy2],[xawx1, xawy1]),//是否大弧,是否顺时针
      //       "TopRightLineA": new makerjs.paths.Line([xawx1, xawy1], [xc, yc]),
      //       "RithgLineI": new makerjs.paths.Line([xc, yc], [xiwx4, xiwy4]),
      //       "BottomLineI": new makerjs.paths.Arc([xiwx4, xiwy4], [xiwx3, xiwy3], r2i,false,true),   
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx2, xiwy2], r1i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Line([xiwx2, xiwy2],[xiwx1, xiwy1]),//是否大弧,是否顺时针
      //       "BottomLeftLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xg, xg]),
      //       "RightHolesA": new makerjs.paths.Circle([xa+h1a, ya-w1a], ra),
      //       "RightHolesI": new makerjs.paths.Circle([xi-h1i, yi+w1i], ri),
      //     }
      //   };
      //   var myFloorSpringCut = {
      //     paths: {
      //       "TopBotArcA": new makerjs.paths.Arc([xawx4, xawy4],[xawx3, xawy3], r2a,false,true),   
      //       "TopTopArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx2, xawy2], r1a,false,false),//是否大弧,是否顺时针
      //       "LeftTopLineA": new makerjs.paths.Line([xawx2, xawy2],[xawx1, xawy1]),//是否大弧,是否顺时针
      //       "BottomLineI": new makerjs.paths.Arc([xiwx4, xiwy4], [xiwx3, xiwy3], r2i,false,true),   
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx2, xiwy2], r1i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Line([xiwx2, xiwy2],[xiwx1, xiwy1]),//是否大弧,是否顺时针
      //       "RightHolesA": new makerjs.paths.Circle([xa+h1a, ya-w1a], ra),
      //       "RightHolesI": new makerjs.paths.Circle([xi-h1i, yi+w1i], ri),
      //     }
      //   };
      //   var myFloorSpringCutM = {
      //     paths: {
      //       "LeftLineA": new makerjs.paths.Line([xg, yg], [xawx4, xawy4]),
      //       "TopBotArcA1": new makerjs.paths.Arc([xawx4, xawy4],[oAX1, oAY1], r2a,false,true),  
      //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
      //       "RightHolesA": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
      //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]), 
      //       "TopBotArcA2": new makerjs.paths.Arc([oAX1, oAY1],[xawx3, xawy3], r2a,false,false),//是否大弧,是否顺时针 
      //       "TopTopArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx2, xawy2], r1a,false,false),//是否大弧,是否顺时针
      //       "LeftTopLineA": new makerjs.paths.Line([xawx2, xawy2],[xawx1, xawy1]),//是否大弧,是否顺时针
      //       "TopRightLineA": new makerjs.paths.Line([xawx1, xawy1], [xc, yc]),
      //       "RithgLineI": new makerjs.paths.Line([xc, yc], [xiwx4, xiwy4]),
      //       "BottomLineI1": new makerjs.paths.Arc([xiwx4, xiwy4], [oIX1,oIY1], r2i,false,true),
      //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
      //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
      //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),  
      //       "BottomLineI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx3, xiwy3], r2i,false,true),  
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx2, xiwy2], r1i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Line([xiwx2, xiwy2],[xiwx1, xiwy1]),//是否大弧,是否顺时针
      //       "BottomLeftLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xg, xg]),
      //     }
      //   };
      //   var myFloorSpringWaterCut = {
      //     paths: {
      //       "EntryLineA":new makerjs.paths.Line([xawx4, xawy4-cutLine], [xawx4, xawy4]),
      //       "TopBotArcA1": new makerjs.paths.Arc([xawx4, xawy4],[oAX1, oAY1], r2a,false,true),  
      //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
      //       "RightHolesA": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
      //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]), 
      //       "TopBotArcA2": new makerjs.paths.Arc([oAX1, oAY1],[xawx3, xawy3], r2a,false,false),//是否大弧,是否顺时针 
      //       "TopTopArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx2, xawy2], r1a,false,false),//是否大弧,是否顺时针
      //       "LeftTopLineA": new makerjs.paths.Line([xawx2, xawy2],[xawx1, xawy1]),//是否大弧,是否顺时针               
      //       "ExitLineA":new makerjs.paths.Line([xawx1, xawy1], [xawx1, xawy1+cutLine]),
      //       "EntryLineI":new makerjs.paths.Line([xiwx4, xiwy4+cutLine], [xiwx4, xiwy4]), 
      //       "BottomLineI1": new makerjs.paths.Arc([xiwx4, xiwy4], [oIX1,oIY1], r2i,false,true),
      //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
      //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
      //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),  
      //       "BottomLineI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx3, xiwy3], r2i,false,true), 
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx2, xiwy2], r1i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Line([xiwx2, xiwy2],[xiwx1, xiwy1]),//是否大弧,是否顺时针          
      //       "ExitLineI":new makerjs.paths.Line([xiwx1, xiwy1], [xiwx1, xiwy1-cutLine]),
      //     }
      //   };
      //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xg, yg], [xahx, xahy], [xawx, xawy], [xc, yc], [xihx, xihy], [xiwx, xiwy]]);
      // } else if (area == "CG") {
      //   var myFloorSpring = {
      //     paths: {  
      //       "LeftLineG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx2, xgwy2],[xgwx3, xgwy3], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Arc([xgwx3, xgwy3], [xgwx4, xgwy4], r2g,false,true),//是否大弧,是否顺时针
      //       "RightLineC": new makerjs.paths.Line([xgwx4, xgwy4], [xa, ya]),
      //       "TopLeftLineC": new makerjs.paths.Line([xa, ya], [xcwx1, xcwy1]),
      //       "RithgLineC0": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),  
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx2, xcwy2],[xcwx3, xcwy3], r1c,false,false),//是否大弧,是否顺时针
      //       "TopRithgLineC": new makerjs.paths.Arc([xcwx3, xcwy3], [xcwx4, xcwy4], r2c,false,true),
      //       "RithgLineC": new makerjs.paths.Line([xcwx4, xcwy4], [xi, yi]),
      //       "BottomLineG": new makerjs.paths.Line([xi, yi], [xgwx1, xgwy1]), 
      //       "RightHolesC": new makerjs.paths.Circle([xc-h1c, yc-w1c], rc),
      //       "RightHolesG": new makerjs.paths.Circle([xg+h1g, yg+w1g], rg),
      //     }
      //   };
      //   var myFloorSpringCut = {
      //     paths: {
      //       "LeftLineG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx2, xgwy2],[xgwx3, xgwy3], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Arc([xgwx3, xgwy3], [xgwx4, xgwy4], r2g,false,true),//是否大弧,是否顺时针
      //       "RithgLineC0": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),  
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx2, xcwy2],[xcwx3, xcwy3], r1c,false,false),//是否大弧,是否顺时针
      //       "TopRithgLineC": new makerjs.paths.Arc([xcwx3, xcwy3], [xcwx4, xcwy4], r2c,false,true),
      //       "RightHolesC": new makerjs.paths.Circle([xc-h1c, yc-w1c], rc),
      //       "RightHolesG": new makerjs.paths.Circle([xg+h1g, yg+w1g], rg),
      //     }
      //   };
      //   var myFloorSpringCutM = {
      //     paths: {  
      //       "LeftLineG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx2, xgwy2],[xgwx3, xgwy3], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG1": new makerjs.paths.Arc([xgwx3, xgwy3], [oGX1, oGY1], r2g,false,true),//是否大弧,是否顺时针           
      //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
      //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
      //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
      //       "BottomLeftLineG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx4, xgwy4], r2g,false,true),//是否大弧,是否顺时针
      //       "RightLineC": new makerjs.paths.Line([xgwx4, xgwy4], [xa, ya]),
      //       "TopLeftLineC": new makerjs.paths.Line([xa, ya], [xcwx1, xcwy1]),
      //       "RithgLineC0": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),  
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx2, xcwy2],[xcwx3, xcwy3], r1c,false,false),//是否大弧,是否顺时针
      //       "TopRithgLineC1": new makerjs.paths.Arc([xcwx3, xcwy3], [oCX1, oCY1], r2c,false,true),          
      //       "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
      //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
      //       "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
      //       "TopRithgLineC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx4, xcwy4], r2c,false,true),          
      //     }
      //   };
      //   var myFloorSpringWaterCut = {
      //     paths: {
      //       "EntryLineG":new makerjs.paths.Line([xgwx1, xgwy1-cutLine], [xgwx1, xgwy1]),
      //       "LeftLineG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx2, xgwy2],[xgwx3, xgwy3], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG1": new makerjs.paths.Arc([xgwx3, xgwy3], [oGX1, oGY1], r2g,false,true),//是否大弧,是否顺时针           
      //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
      //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
      //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
      //       "BottomLeftLineG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx4, xgwy4], r2g,false,true),//是否大弧,是否顺时针 
      //       "ExitLineG":new makerjs.paths.Line([xgwx4, xgwy4], [xgwx4, xgwy4+cutLine]),
      //       "EntryLineC":new makerjs.paths.Line([xcwx1, xcwy1+cutLine], [xcwx1, xcwy1]), 
      //       "RithgLineC0": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),  
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx2, xcwy2],[xcwx3, xcwy3], r1c,false,false),//是否大弧,是否顺时针
      //       "TopRithgLineC1": new makerjs.paths.Arc([xcwx3, xcwy3], [oCX1, oCY1], r2c,false,true),          
      //       "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
      //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
      //       "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
      //       "TopRithgLineC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx4, xcwy4], r2c,false,true),  
      //       "ExitLineC":new makerjs.paths.Line([xcwx4, xcwy4], [xcwx4-cutLine, xcwy4]),           
      //     }
      //   };
    
      //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xa, ya], [xcwx, xcwy], [xchx, xchy], [xi, yi], [xgwx, xgwy]]);
      // } else if (area == "CI") {
      //   var myFloorSpring = {
      //     paths: {
      //       "RightLineC": new makerjs.paths.Line([xg, yg], [xa, ya]),
      //       "TopLeftLineC": new makerjs.paths.Line([xa, ya], [xcwx1, xcwy1]),   
      //       "TopLeftArcC": new makerjs.paths.Line([xcwx1, xcwy1],[xcwx2, xcwy2]),
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx2, xcwy2],[xcwx3, xcwy3], r1c,false,false),//是否大弧,是否顺时针
      //       "RithgLineC0": new makerjs.paths.Arc([xcwx3, xcwy3], [xcwx4, xcwy4], r2c,false,true),//是否大弧,是否顺时针
      //       "RithgLineC": new makerjs.paths.Line([xcwx4, xcwy4], [xiwx4, xiwy4]),
      //       "BottomLineI": new makerjs.paths.Arc([xiwx4, xiwy4], [xiwx3, xiwy3], r2i,false,true), //是否大弧,是否顺时针  
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx2, xiwy2], r1i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Line([xiwx2, xiwy2],[xiwx1, xiwy1]),
      //       "BottomLeftLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xg, xg]),
      //       "RightHolesC": new makerjs.paths.Circle([xc-h1c, yc-w1c], rc),
      //       "RightHolesI": new makerjs.paths.Circle([xi-h1i, yi+w1i], ri),
      //     }
      //   };
      //   var myFloorSpringCut = {
      //     paths: {
      //       "TopLeftArcC": new makerjs.paths.Line([xcwx1, xcwy1],[xcwx2, xcwy2]),
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx2, xcwy2],[xcwx3, xcwy3], r1c,false,false),//是否大弧,是否顺时针
      //       "RithgLineC0": new makerjs.paths.Arc([xcwx3, xcwy3], [xcwx4, xcwy4], r2c,false,true),//是否大弧,是否顺时针
      //       "BottomLineI": new makerjs.paths.Arc([xiwx4, xiwy4], [xiwx3, xiwy3], r2i,false,true), //是否大弧,是否顺时针  
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx2, xiwy2], r1i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Line([xiwx2, xiwy2],[xiwx1, xiwy1]),
      //       "RightHolesC": new makerjs.paths.Circle([xc-h1c, yc-w1c], rc),
      //       "RightHolesI": new makerjs.paths.Circle([xi-h1i, yi+w1i], ri),
      //     }
      //   };
      //   var myFloorSpringCutM = {
      //     paths: {
      //       "RightLineC": new makerjs.paths.Line([xg, yg], [xa, ya]),
      //       "TopLeftLineC": new makerjs.paths.Line([xa, ya], [xcwx1, xcwy1]),   
      //       "TopLeftArcC": new makerjs.paths.Line([xcwx1, xcwy1],[xcwx2, xcwy2]),
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx2, xcwy2],[xcwx3, xcwy3], r1c,false,false),//是否大弧,是否顺时针
      //       "TopRithgLineC1": new makerjs.paths.Arc([xcwx3, xcwy3], [oCX1, oCY1], r2c,false,true),          
      //       "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
      //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
      //       "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
      //       "TopRithgLineC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx4, xcwy4], r2c,false,true),          
      //       "RithgLineC": new makerjs.paths.Line([xcwx4, xcwy4], [xiwx4, xiwy4]),
      //       "BottomLineI1": new makerjs.paths.Arc([xiwx4, xiwy4], [oIX1,oIY1], r2i,false,true),
      //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
      //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
      //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),  
      //       "BottomLineI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx3, xiwy3], r2i,false,true), 
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx2, xiwy2], r1i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Line([xiwx2, xiwy2],[xiwx1, xiwy1]),
      //       "BottomLeftLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xg, xg]),
      //     }
      //   };
      //   var myFloorSpringWaterCut = {
      //     paths: {
      //       "EntryLineC":new makerjs.paths.Line([xcwx1, xcwy1+cutLine], [xcwx1, xcwy1]), 
      //       "TopLeftArcC": new makerjs.paths.Line([xcwx1, xcwy1],[xcwx2, xcwy2]),
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx2, xcwy2],[xcwx3, xcwy3], r1c,false,false),//是否大弧,是否顺时针
      //       "TopRithgLineC1": new makerjs.paths.Arc([xcwx3, xcwy3], [oCX1, oCY1], r2c,false,true),          
      //       "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
      //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
      //       "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
      //       "TopRithgLineC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx4, xcwy4], r2c,false,true),    
      //       "ExitLineC":new makerjs.paths.Line([xcwx4, xcwy4], [xcwx4-cutLine, xcwy4]),  
      //       "EntryLineI":new makerjs.paths.Line([xiwx4, xiwy4+cutLine], [xiwx4, xiwy4]),  
      //       "BottomLineI1": new makerjs.paths.Arc([xiwx4, xiwy4], [oIX1,oIY1], r2i,false,true),
      //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
      //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
      //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),  
      //       "BottomLineI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx3, xiwy3], r2i,false,true), 
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx2, xiwy2], r1i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Line([xiwx2, xiwy2],[xiwx1, xiwy1]),          
      //       "ExitLineI":new makerjs.paths.Line([xiwx1, xiwy1], [xiwx1, xiwy1-cutLine]),
      //     }
      //   };
    
      //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xg, yg], [xa, ya], [xcwx, xcwy], [xchx, xchy], [xihx, xihy], [xiwx, xiwy]]);
      // } else if (area == "GI") {
      //   var myFloorSpring = {
      //     paths: {
      //       "LeftLineG": new makerjs.paths.Line([xgwx4, xgwy4], [xa, ya]),
      //       "TopLeftLineG": new makerjs.paths.Line([xa, ya],[xc, yc]),
      //       "RithgLineI": new makerjs.paths.Line([xc, yc], [xiwx4, xiwy4]),
      //       "BottomLineI": new makerjs.paths.Arc([xiwx4, xiwy4], [xiwx3, xiwy3], r2i,false,true), //是否大弧,是否顺时针  
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx2, xiwy2], r1i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Line([xiwx2, xiwy2],[xiwx1, xiwy1]),
      //       "BottomLeftLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xgwx1, xgwy1]),
      //       "BottomRigthArcG": new makerjs.paths.Line([xgwx1, xgwy1],[xgwx2, xgwy2]),
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx2, xgwy2],[xgwx3, xgwy3], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Arc([xgwx3, xgwy3], [xgwx4, xgwy4], r2g,false,true),//是否大弧,是否顺时针
      //       "RightHolesG": new makerjs.paths.Circle([xg+h1g, yg+w1g], rg),
      //       "RightHolesI": new makerjs.paths.Circle([xi-h1i, yi+w1i], ri),
      //     }
      //   };
      //   var myFloorSpringCut = {
      //     paths: {
      //       "BottomLineI": new makerjs.paths.Arc([xiwx4, xiwy4], [xiwx3, xiwy3], r2i,false,true), //是否大弧,是否顺时针  
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx2, xiwy2], r1i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Line([xiwx2, xiwy2],[xiwx1, xiwy1]),
      //       "BottomRigthArcG": new makerjs.paths.Line([xgwx1, xgwy1],[xgwx2, xgwy2]),
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx2, xgwy2],[xgwx3, xgwy3], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Arc([xgwx3, xgwy3], [xgwx4, xgwy4], r2g,false,true),//是否大弧,是否顺时针
      //       "RightHolesG": new makerjs.paths.Circle([xg+h1g, yg+w1g], rg),
      //       "RightHolesI": new makerjs.paths.Circle([xi-h1i, yi+w1i], ri),
      //     }
      //   };
      //   var myFloorSpringCutM = {
      //     paths: {
      //       "LeftLineG": new makerjs.paths.Line([xgwx4, xgwy4], [xa, ya]),
      //       "TopLeftLineG": new makerjs.paths.Line([xa, ya],[xc, yc]),
      //       "RithgLineI": new makerjs.paths.Line([xc, yc], [xiwx4, xiwy4]),
      //       "BottomLineI1": new makerjs.paths.Arc([xiwx4, xiwy4], [oIX1,oIY1], r2i,false,true),
      //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
      //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
      //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),  
      //       "BottomLineI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx3, xiwy3], r2i,false,true),  
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx2, xiwy2], r1i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Line([xiwx2, xiwy2],[xiwx1, xiwy1]),
      //       "BottomLeftLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xgwx1, xgwy1]),
      //       "BottomRigthArcG": new makerjs.paths.Line([xgwx1, xgwy1],[xgwx2, xgwy2]),
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx2, xgwy2],[xgwx3, xgwy3], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG1": new makerjs.paths.Arc([xgwx3, xgwy3], [oGX1, oGY1], r2g,false,true),//是否大弧,是否顺时针           
      //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
      //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
      //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
      //       "BottomLeftLineG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx4, xgwy4], r2g,false,true),//是否大弧,是否顺时针
      //     }
      //   };
      //   var myFloorSpringWaterCut = {
      //     paths: {
      //       "EntryLineI":new makerjs.paths.Line([xiwx4, xiwy4+cutLine], [xiwx4, xiwy4]),
      //       "BottomLineI1": new makerjs.paths.Arc([xiwx4, xiwy4], [oIX1,oIY1], r2i,false,true),
      //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
      //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
      //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),  
      //       "BottomLineI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx3, xiwy3], r2i,false,true), 
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx2, xiwy2], r1i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Line([xiwx2, xiwy2],[xiwx1, xiwy1]),           
      //       "ExitLineI":new makerjs.paths.Line([xiwx1, xiwy1], [xiwx1, xiwy1-cutLine]),
      //       "EntryLineG":new makerjs.paths.Line([xgwx1, xgwy1-cutLine], [xgwx1, xgwy1]), 
      //       "BottomRigthArcG": new makerjs.paths.Line([xgwx1, xgwy1],[xgwx2, xgwy2]),
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx2, xgwy2],[xgwx3, xgwy3], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG1": new makerjs.paths.Arc([xgwx3, xgwy3], [oGX1, oGY1], r2g,false,true),//是否大弧,是否顺时针           
      //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
      //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
      //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
      //       "BottomLeftLineG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx4, xgwy4], r2g,false,true),//是否大弧,是否顺时针
      //       "ExitLineG":new makerjs.paths.Line([xgwx4, xgwy4], [xgwx4, xgwy4+cutLine]),
      //     }
      //   };
      //   // var myFillet = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xa, ya], [xc, yc], [xihx, xihy], [xiwx, xiwy], [xgwx, xgwy]]);
      // } else if (area == "ACG") {
      //   var myFloorSpring = {
      //     paths: {
      //       "LeftLineA": new makerjs.paths.Line([xgwx4, xgwy4], [xawx4, xawy4]),
      //       "TopLeftLineA": new makerjs.paths.Arc([xawx4, xawy4],[xawx3, xawy3], r2a,false,true),//是否大弧,是否顺时针   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx2, xawy2], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA": new makerjs.paths.Line([xawx2, xawy2],[xawx1, xawy1]),
      //       "TopRightLineA": new makerjs.paths.Line([xawx1, xawy1], [xcwx1, xcwy1]),
      //       "TopLeftArcC": new makerjs.paths.Line([xcwx1, xcwy1],[xcwx2, xcwy2]),
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx2, xcwy2],[xcwx3, xcwy3], r1c,false,false),//是否大弧,是否顺时针
      //       "RithgLineC0": new makerjs.paths.Arc([xcwx3, xcwy3], [xcwx4, xcwy4], r2c,false,true),//是否大弧,是否顺时针
      //       "RithgLineC": new makerjs.paths.Line([xcwx4, xcwy4], [xi, yi]),
      //       "BottomLineG": new makerjs.paths.Line([xi, yi], [xgwx1, xgwy1]),      
      //       "BottomRigthArcG": new makerjs.paths.Line([xgwx1, xgwy1],[xgwx2, xgwy2]),
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx2, xgwy2],[xgwx3, xgwy3], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Arc([xgwx3, xgwy3], [xgwx4, xgwy4], r2g,false,true),//是否大弧,是否顺时针
      //       "RightHolesA": new makerjs.paths.Circle([xa+h1a, ya-w1a], ra),
      //       "RightHolesC": new makerjs.paths.Circle([xc-h1c, yc-w1c], rc),
      //       "RightHolesG": new makerjs.paths.Circle([xg+h1g, yg+w1g], rg),
      //     }
      //   };
      //   var myFloorSpringCut = {
      //     paths: {
      //       "TopLeftLineA": new makerjs.paths.Arc([xawx4, xawy4],[xawx3, xawy3], r2a,false,true),//是否大弧,是否顺时针   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx2, xawy2], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA": new makerjs.paths.Line([xawx2, xawy2],[xawx1, xawy1]),
      //       "TopLeftArcC": new makerjs.paths.Line([xcwx1, xcwy1],[xcwx2, xcwy2]),
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx2, xcwy2],[xcwx3, xcwy3], r1c,false,false),//是否大弧,是否顺时针
      //       "RithgLineC0": new makerjs.paths.Arc([xcwx3, xcwy3], [xcwx4, xcwy4], r2c,false,true),//是否大弧,是否顺时针
      //       "BottomRigthArcG": new makerjs.paths.Line([xgwx1, xgwy1],[xgwx2, xgwy2]),
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx2, xgwy2],[xgwx3, xgwy3], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Arc([xgwx3, xgwy3], [xgwx4, xgwy4], r2g,false,true),//是否大弧,是否顺时针
      //       "RightHolesA": new makerjs.paths.Circle([xa+h1a, ya-w1a], ra),
      //       "RightHolesC": new makerjs.paths.Circle([xc-h1c, yc-w1c], rc),
      //       "RightHolesG": new makerjs.paths.Circle([xg+h1g, yg+w1g], rg),
      //     }
      //   };
      //   var myFloorSpringCutM = {
      //     paths: {
      //       "LeftLineA": new makerjs.paths.Line([xgwx4, xgwy4], [xawx4, xawy4]),
      //       "TopBotArcA1": new makerjs.paths.Arc([xawx4, xawy4],[oAX1, oAY1], r2a,false,true),  
      //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
      //       "RightHolesA": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
      //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]), 
      //       "TopBotArcA2": new makerjs.paths.Arc([oAX1, oAY1],[xawx3, xawy3], r2a,false,false),//是否大弧,是否顺时针 
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx2, xawy2], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA": new makerjs.paths.Line([xawx2, xawy2],[xawx1, xawy1]),
      //       "TopRightLineA": new makerjs.paths.Line([xawx1, xawy1], [xcwx1, xcwy1]),
      //       "TopLeftArcC": new makerjs.paths.Line([xcwx1, xcwy1],[xcwx2, xcwy2]),
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx2, xcwy2],[xcwx3, xcwy3], r1c,false,false),//是否大弧,是否顺时针
      //       "TopRithgLineC1": new makerjs.paths.Arc([xcwx3, xcwy3], [oCX1, oCY1], r2c,false,true),          
      //       "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
      //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
      //       "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
      //       "TopRithgLineC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx4, xcwy4], r2c,false,true),          
      //       "RithgLineC": new makerjs.paths.Line([xcwx4, xcwy4], [xi, yi]),
      //       "BottomLineG": new makerjs.paths.Line([xi, yi], [xgwx1, xgwy1]),      
      //       "BottomRigthArcG": new makerjs.paths.Line([xgwx1, xgwy1],[xgwx2, xgwy2]),
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx2, xgwy2],[xgwx3, xgwy3], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG1": new makerjs.paths.Arc([xgwx3, xgwy3], [oGX1, oGY1], r2g,false,true),//是否大弧,是否顺时针           
      //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
      //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
      //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
      //       "BottomLeftLineG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx4, xgwy4], r2g,false,true),//是否大弧,是否顺时针
      //     }
      //   };
      //   var myFloorSpringWaterCut = {
      //     paths: {
      //       "EntryLineA":new makerjs.paths.Line([xawx4, xawy4-cutLine], [xawx4, xawy4]), 
      //       "TopBotArcA1": new makerjs.paths.Arc([xawx4, xawy4],[oAX1, oAY1], r2a,false,true),  
      //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
      //       "RightHolesA": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
      //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]), 
      //       "TopBotArcA2": new makerjs.paths.Arc([oAX1, oAY1],[xawx3, xawy3], r2a,false,false),//是否大弧,是否顺时针  
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx2, xawy2], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA": new makerjs.paths.Line([xawx2, xawy2],[xawx1, xawy1]),              
      //       "ExitLineA":new makerjs.paths.Line([xawx1, xawy1], [xawx1, xawy1+cutLine]),
      //       "EntryLineC":new makerjs.paths.Line([xcwx1, xcwy1+cutLine], [xcwx1, xcwy1]),  
      //       "TopLeftArcC": new makerjs.paths.Line([xcwx1, xcwy1],[xcwx2, xcwy2]),
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx2, xcwy2],[xcwx3, xcwy3], r1c,false,false),//是否大弧,是否顺时针
      //       "TopRithgLineC1": new makerjs.paths.Arc([xcwx3, xcwy3], [oCX1, oCY1], r2c,false,true),          
      //       "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
      //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
      //       "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
      //       "TopRithgLineC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx4, xcwy4], r2c,false,true),  
      //       "ExitLineC":new makerjs.paths.Line([xcwx4, xcwy4], [xcwx4-cutLine, xcwy4]),  
      //       "EntryLineG":new makerjs.paths.Line([xgwx1, xgwy1-cutLine], [xgwx1, xgwy1]),       
      //       "BottomRigthArcG": new makerjs.paths.Line([xgwx1, xgwy1],[xgwx2, xgwy2]),
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx2, xgwy2],[xgwx3, xgwy3], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG1": new makerjs.paths.Arc([xgwx3, xgwy3], [oGX1, oGY1], r2g,false,true),//是否大弧,是否顺时针           
      //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
      //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
      //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
      //       "BottomLeftLineG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx4, xgwy4], r2g,false,true),//是否大弧,是否顺时针 
      //       "ExitLineG":new makerjs.paths.Line([xgwx4, xgwy4], [xgwx4, xgwy4+cutLine]), 
      //     }
      //   };
      //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xahx, xahy], [xawx, xawy], [xcwx, xcwy], [xchx, xchy],[xi, yi], [xgwx, xgwy]]);
      // } else if (area == "ACI") {
      //   var myFloorSpring = {
      //     paths: {
      //       "LeftLineA": new makerjs.paths.Line([xg, yg], [xawx4, xawy4]),
      //       "TopLeftLineA": new makerjs.paths.Arc([xawx4, xawy4],[xawx3, xawy3], r2a,false,true),//是否大弧,是否顺时针   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx2, xawy2], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA": new makerjs.paths.Line([xawx2, xawy2],[xawx1, xawy1]),
      //       "TopRightLineA": new makerjs.paths.Line([xawx1, xawy1], [xcwx1, xcwy1]),
      //       "TopLeftArcC": new makerjs.paths.Line([xcwx1, xcwy1],[xcwx2, xcwy2]),
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx2, xcwy2],[xcwx3, xcwy3], r1c,false,false),//是否大弧,是否顺时针
      //       "RithgLineC": new makerjs.paths.Arc([xcwx3, xcwy3], [xcwx4, xcwy4], r2c,false,true),//是否大弧,是否顺时针
      //       "BottomLineI0": new makerjs.paths.Line([xcwx4, xcwy4], [xiwx4, xiwy4]), 
      //       "BottomLineI": new makerjs.paths.Arc([xiwx4, xiwy4], [xiwx3, xiwy3], r2i,false,true), //是否大弧,是否顺时针  
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx2, xiwy2], r1i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Line([xiwx2, xiwy2],[xiwx1, xiwy1]),
      //       "BottomLeftLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xg, xg]),
      //       "RightHolesA": new makerjs.paths.Circle([xa+h1a, ya-w1a], ra),
      //       "RightHolesC": new makerjs.paths.Circle([xc-h1c, yc-w1c], rc),
      //       "RightHolesI": new makerjs.paths.Circle([xi-h1i, yi+w1i], ri),
      //     }
      //   };
      //   var myFloorSpringCut = {
      //     paths: {
      //       "TopLeftLineA": new makerjs.paths.Arc([xawx4, xawy4],[xawx3, xawy3], r2a,false,true),//是否大弧,是否顺时针   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx2, xawy2], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA": new makerjs.paths.Line([xawx2, xawy2],[xawx1, xawy1]),
      //       "TopLeftArcC": new makerjs.paths.Line([xcwx1, xcwy1],[xcwx2, xcwy2]),
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx2, xcwy2],[xcwx3, xcwy3], r1c,false,false),//是否大弧,是否顺时针
      //       "RithgLineC": new makerjs.paths.Arc([xcwx3, xcwy3], [xcwx4, xcwy4], r2c,false,true),//是否大弧,是否顺时针
      //       "BottomLineI": new makerjs.paths.Arc([xiwx4, xiwy4], [xiwx3, xiwy3], r2i,false,true), //是否大弧,是否顺时针  
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx2, xiwy2], r1i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Line([xiwx2, xiwy2],[xiwx1, xiwy1]),
      //       "RightHolesA": new makerjs.paths.Circle([xa+h1a, ya-w1a], ra),
      //       "RightHolesC": new makerjs.paths.Circle([xc-h1c, yc-w1c], rc),
      //       "RightHolesI": new makerjs.paths.Circle([xi-h1i, yi+w1i], ri),
      //     }
      //   };
      //   var myFloorSpringCutM = {
      //     paths: {
      //       "LeftLineA": new makerjs.paths.Line([xg, yg], [xawx4, xawy4]),
      //       "TopBotArcA1": new makerjs.paths.Arc([xawx4, xawy4],[oAX1, oAY1], r2a,false,true),  
      //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
      //       "RightHolesA": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
      //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]), 
      //       "TopBotArcA2": new makerjs.paths.Arc([oAX1, oAY1],[xawx3, xawy3], r2a,false,false),//是否大弧,是否顺时针 
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx2, xawy2], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA": new makerjs.paths.Line([xawx2, xawy2],[xawx1, xawy1]),
      //       "TopRightLineA": new makerjs.paths.Line([xawx1, xawy1], [xcwx1, xcwy1]),
      //       "TopLeftArcC": new makerjs.paths.Line([xcwx1, xcwy1],[xcwx2, xcwy2]),
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx2, xcwy2],[xcwx3, xcwy3], r1c,false,false),//是否大弧,是否顺时针
      //       "TopRithgLineC1": new makerjs.paths.Arc([xcwx3, xcwy3], [oCX1, oCY1], r2c,false,true),          
      //       "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
      //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
      //       "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
      //       "TopRithgLineC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx4, xcwy4], r2c,false,true),          
      //       "BottomLineI0": new makerjs.paths.Line([xcwx4, xcwy4], [xiwx4, xiwy4]), 
      //       "BottomLineI1": new makerjs.paths.Arc([xiwx4, xiwy4], [oIX1,oIY1], r2i,false,true),
      //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
      //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
      //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),  
      //       "BottomLineI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx3, xiwy3], r2i,false,true), 
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx2, xiwy2], r1i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Line([xiwx2, xiwy2],[xiwx1, xiwy1]),
      //       "BottomLeftLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xg, xg]),
      //     }
      //   };
      //   var myFloorSpringWaterCut = {
      //     paths: {
      //       "EntryLineA":new makerjs.paths.Line([xawx4, xawy4-cutLine], [xawx4, xawy4]), 
      //       "TopBotArcA1": new makerjs.paths.Arc([xawx4, xawy4],[oAX1, oAY1], r2a,false,true),  
      //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
      //       "RightHolesA": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
      //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]), 
      //       "TopBotArcA2": new makerjs.paths.Arc([oAX1, oAY1],[xawx3, xawy3], r2a,false,false),//是否大弧,是否顺时针 
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx2, xawy2], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA": new makerjs.paths.Line([xawx2, xawy2],[xawx1, xawy1]),              
      //       "ExitLineA":new makerjs.paths.Line([xawx1, xawy1], [xawx1, xawy1+cutLine]),
      //       "EntryLineC":new makerjs.paths.Line([xcwx1, xcwy1+cutLine], [xcwx1, xcwy1]),
      //       "TopLeftArcC": new makerjs.paths.Line([xcwx1, xcwy1],[xcwx2, xcwy2]),
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx2, xcwy2],[xcwx3, xcwy3], r1c,false,false),//是否大弧,是否顺时针
      //       "TopRithgLineC1": new makerjs.paths.Arc([xcwx3, xcwy3], [oCX1, oCY1], r2c,false,true),          
      //       "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
      //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
      //       "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
      //       "TopRithgLineC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx4, xcwy4], r2c,false,true),   
      //       "ExitLineC":new makerjs.paths.Line([xcwx4, xcwy4], [xcwx4-cutLine, xcwy4]),  
      //       "EntryLineI":new makerjs.paths.Line([xiwx4, xiwy4+cutLine], [xiwx4, xiwy4]),   
      //       "BottomLineI1": new makerjs.paths.Arc([xiwx4, xiwy4], [oIX1,oIY1], r2i,false,true),
      //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
      //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
      //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),  
      //       "BottomLineI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx3, xiwy3], r2i,false,true), 
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx2, xiwy2], r1i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Line([xiwx2, xiwy2],[xiwx1, xiwy1]),           
      //       "ExitLineI":new makerjs.paths.Line([xiwx1, xiwy1], [xiwx1, xiwy1-cutLine]), 
      //     }
      //   };
    
      //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xg, yg], [xahx, xahy], [xawx, xawy], [xcwx, xcwy], [xchx, xchy],[xihx, xihy], [xiwx, xiwy]]);
      // } else if (area == "AGI") {
      //   var myFloorSpring = {
      //     paths: {
      //       "LeftLineA": new makerjs.paths.Line([xgwx4, xgwy4], [xawx4, xawy4]),
      //       "TopLeftLineA": new makerjs.paths.Arc([xawx4, xawy4],[xawx3, xawy3], r2a,false,true),//是否大弧,是否顺时针   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx2, xawy2], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA": new makerjs.paths.Line([xawx2, xawy2],[xawx1, xawy1]),
      //       "TopRightLineA": new makerjs.paths.Line([xawx1, xawy1], [xc, yc]),
      //       "RithgLineI": new makerjs.paths.Line([xc, yc], [xiwx4, xiwy4]),
      //       "BottomLineI": new makerjs.paths.Arc([xiwx4, xiwy4], [xiwx3, xiwy3], r2i,false,true),//是否大弧,是否顺时针   
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx2, xiwy2], r1i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Line([xiwx2, xiwy2],[xiwx1, xiwy1]),
      //       "BottomLeftLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xgwx1, xgwy1]),  
      //       "BottomRigthArcG": new makerjs.paths.Line([xgwx1, xgwy1],[xgwx2, xgwy2]),
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx2, xgwy2],[xgwx3, xgwy3], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Arc([xgwx3, xgwy3], [xgwx4, xgwy4], r2g,false,true),//是否大弧,是否顺时针
      //       "RightHolesA": new makerjs.paths.Circle([xa+h1a, ya-w1a], ra),
      //       "RightHolesG": new makerjs.paths.Circle([xg+h1g, yg+w1g], rg),
      //       "RightHolesI": new makerjs.paths.Circle([xi-h1i, yi+w1i], ri),
      //     }
      //   };
    
      //   var myFloorSpringCut = {
      //     paths: {
      //       "TopLeftLineA": new makerjs.paths.Arc([xawx4, xawy4],[xawx3, xawy3], r2a,false,true),//是否大弧,是否顺时针   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx2, xawy2], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA": new makerjs.paths.Line([xawx2, xawy2],[xawx1, xawy1]),
      //       "BottomLineI": new makerjs.paths.Arc([xiwx4, xiwy4], [xiwx3, xiwy3], r2i,false,true),//是否大弧,是否顺时针   
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx2, xiwy2], r1i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Line([xiwx2, xiwy2],[xiwx1, xiwy1]),
      //       "BottomRigthArcG": new makerjs.paths.Line([xgwx1, xgwy1],[xgwx2, xgwy2]),
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx2, xgwy2],[xgwx3, xgwy3], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Arc([xgwx3, xgwy3], [xgwx4, xgwy4], r2g,false,true),//是否大弧,是否顺时针
      //       "RightHolesA": new makerjs.paths.Circle([xa+h1a, ya-w1a], ra),
      //       "RightHolesG": new makerjs.paths.Circle([xg+h1g, yg+w1g], rg),
      //       "RightHolesI": new makerjs.paths.Circle([xi-h1i, yi+w1i], ri),
      //     }
      //   };
      //   var myFloorSpringCutM = {
      //     paths: {
      //       "LeftLineA": new makerjs.paths.Line([xgwx4, xgwy4], [xawx4, xawy4]),
      //       "TopBotArcA1": new makerjs.paths.Arc([xawx4, xawy4],[oAX1, oAY1], r2a,false,true),  
      //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
      //       "RightHolesA": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
      //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]), 
      //       "TopBotArcA2": new makerjs.paths.Arc([oAX1, oAY1],[xawx3, xawy3], r2a,false,false),//是否大弧,是否顺时针 
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx2, xawy2], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA": new makerjs.paths.Line([xawx2, xawy2],[xawx1, xawy1]),
      //       "TopRightLineA": new makerjs.paths.Line([xawx1, xawy1], [xc, yc]),
      //       "RithgLineI": new makerjs.paths.Line([xc, yc], [xiwx4, xiwy4]),
      //       "BottomLineI1": new makerjs.paths.Arc([xiwx4, xiwy4], [oIX1,oIY1], r2i,false,true),
      //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
      //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
      //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),  
      //       "BottomLineI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx3, xiwy3], r2i,false,true),  
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx2, xiwy2], r1i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Line([xiwx2, xiwy2],[xiwx1, xiwy1]),
      //       "BottomLeftLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xgwx1, xgwy1]),  
      //       "BottomRigthArcG": new makerjs.paths.Line([xgwx1, xgwy1],[xgwx2, xgwy2]),
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx2, xgwy2],[xgwx3, xgwy3], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG1": new makerjs.paths.Arc([xgwx3, xgwy3], [oGX1, oGY1], r2g,false,true),//是否大弧,是否顺时针           
      //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
      //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
      //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
      //       "BottomLeftLineG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx4, xgwy4], r2g,false,true),//是否大弧,是否顺时针
      //     }
      //   };
    
      //   var myFloorSpringWaterCut = {
      //     paths: {
      //       "EntryLineA":new makerjs.paths.Line([xawx4, xawy4-cutLine], [xawx4, xawy4]),  
      //       "TopBotArcA1": new makerjs.paths.Arc([xawx4, xawy4],[oAX1, oAY1], r2a,false,true),  
      //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
      //       "RightHolesA": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
      //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]), 
      //       "TopBotArcA2": new makerjs.paths.Arc([oAX1, oAY1],[xawx3, xawy3], r2a,false,false),//是否大弧,是否顺时针  
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx2, xawy2], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA": new makerjs.paths.Line([xawx2, xawy2],[xawx1, xawy1]),             
      //       "ExitLineA":new makerjs.paths.Line([xawx1, xawy1], [xawx1, xawy1+cutLine]),
      //       "EntryLineI":new makerjs.paths.Line([xiwx4, xiwy4+cutLine], [xiwx4, xiwy4]), 
      //       "BottomLineI1": new makerjs.paths.Arc([xiwx4, xiwy4], [oIX1,oIY1], r2i,false,true),
      //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
      //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
      //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),  
      //       "BottomLineI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx3, xiwy3], r2i,false,true), 
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx2, xiwy2], r1i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Line([xiwx2, xiwy2],[xiwx1, xiwy1]),           
      //       "ExitLineI":new makerjs.paths.Line([xiwx1, xiwy1], [xiwx1, xiwy1-cutLine]),
      //       "EntryLineG":new makerjs.paths.Line([xgwx1, xgwy1-cutLine], [xgwx1, xgwy1]), 
      //       "BottomRigthArcG": new makerjs.paths.Line([xgwx1, xgwy1],[xgwx2, xgwy2]),
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx2, xgwy2],[xgwx3, xgwy3], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG1": new makerjs.paths.Arc([xgwx3, xgwy3], [oGX1, oGY1], r2g,false,true),//是否大弧,是否顺时针           
      //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
      //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
      //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
      //       "BottomLeftLineG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx4, xgwy4], r2g,false,true),//是否大弧,是否顺时针
      //       "ExitLineG":new makerjs.paths.Line([xgwx4, xgwy4], [xgwx4, xgwy4+cutLine]),
      //     }
      //   };
    
      //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xahx, xahy], [xawx, xawy], [xc, yc],[xihx, xihy], [xiwx, xiwy], [xgwx, xgwy]]);
      // } else if (area == "CGI") {
      //   var myFloorSpring = {
      //     paths: {
      //       "RightLineC": new makerjs.paths.Line([xgwx4, xgwy4], [xa, ya]),
      //       "TopLeftLineC": new makerjs.paths.Line([xa, ya], [xcwx1, xcwy1]),   
      //       "TopLeftArcC": new makerjs.paths.Line([xcwx1, xcwy1],[xcwx2, xcwy2]),
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx2, xcwy2],[xcwx3, xcwy3], r1c,false,false),//是否大弧,是否顺时针
      //       "RithgLineC0": new makerjs.paths.Arc([xcwx3, xcwy3], [xcwx4, xcwy4], r2c,false,true),//是否大弧,是否顺时针
      //       "RithgLineC": new makerjs.paths.Line([xcwx4, xcwy4], [xiwx4, xiwy4]),
      //       "BottomLineI": new makerjs.paths.Arc([xiwx4, xiwy4], [xiwx3, xiwy3], r2i,false,true),//是否大弧,是否顺时针   
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx2, xiwy2], r1i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Line([xiwx2, xiwy2],[xiwx1, xiwy1]),
      //       "BottomLeftLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xgwx1, xgwy1]),
      //       "BottomRigthArcG": new makerjs.paths.Line([xgwx1, xgwy1],[xgwx2, xgwy2]),
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx2, xgwy2],[xgwx3, xgwy3], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Arc([xgwx3, xgwy3], [xgwx4, xgwy4], r2g,false,true),//是否大弧,是否顺时针
      //       "RightHolesC": new makerjs.paths.Circle([xc-h1c, yc-w1c], rc),
      //       "RightHolesG": new makerjs.paths.Circle([xg+h1g, yg+w1g], rg),
      //       "RightHolesI": new makerjs.paths.Circle([xi-h1i, yi+w1i], ri),
      //     }
      //   };
      //   var myFloorSpringCut = {
      //     paths: { 
      //       "TopLeftArcC": new makerjs.paths.Line([xcwx1, xcwy1],[xcwx2, xcwy2]),
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx2, xcwy2],[xcwx3, xcwy3], r1c,false,false),//是否大弧,是否顺时针
      //       "RithgLineC0": new makerjs.paths.Arc([xcwx3, xcwy3], [xcwx4, xcwy4], r2c,false,true),//是否大弧,是否顺时针
      //       "BottomLineI": new makerjs.paths.Arc([xiwx4, xiwy4], [xiwx3, xiwy3], r2i,false,true),//是否大弧,是否顺时针   
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx2, xiwy2], r1i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Line([xiwx2, xiwy2],[xiwx1, xiwy1]),
      //       "BottomRigthArcG": new makerjs.paths.Line([xgwx1, xgwy1],[xgwx2, xgwy2]),
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx2, xgwy2],[xgwx3, xgwy3], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Arc([xgwx3, xgwy3], [xgwx4, xgwy4], r2g,false,true),//是否大弧,是否顺时针
      //       "RightHolesC": new makerjs.paths.Circle([xc-h1c, yc-w1c], rc),
      //       "RightHolesG": new makerjs.paths.Circle([xg+h1g, yg+w1g], rg),
      //       "RightHolesI": new makerjs.paths.Circle([xi-h1i, yi+w1i], ri),
      //     }
      //   };
      //   var myFloorSpringCutM = {
      //     paths: {
      //       "RightLineC": new makerjs.paths.Line([xgwx4, xgwy4], [xa, ya]),
      //       "TopLeftLineC": new makerjs.paths.Line([xa, ya], [xcwx1, xcwy1]),   
      //       "TopLeftArcC": new makerjs.paths.Line([xcwx1, xcwy1],[xcwx2, xcwy2]),
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx2, xcwy2],[xcwx3, xcwy3], r1c,false,false),//是否大弧,是否顺时针
      //       "TopRithgLineC1": new makerjs.paths.Arc([xcwx3, xcwy3], [oCX1, oCY1], r2c,false,true),          
      //       "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
      //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
      //       "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
      //       "TopRithgLineC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx4, xcwy4], r2c,false,true),          
      //       "RithgLineC": new makerjs.paths.Line([xcwx4, xcwy4], [xiwx4, xiwy4]),
      //       "BottomLineI1": new makerjs.paths.Arc([xiwx4, xiwy4], [oIX1,oIY1], r2i,false,true),
      //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
      //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
      //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),  
      //       "BottomLineI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx3, xiwy3], r2i,false,true),  
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx2, xiwy2], r1i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Line([xiwx2, xiwy2],[xiwx1, xiwy1]),
      //       "BottomLeftLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xgwx1, xgwy1]),
      //       "BottomRigthArcG": new makerjs.paths.Line([xgwx1, xgwy1],[xgwx2, xgwy2]),
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx2, xgwy2],[xgwx3, xgwy3], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG1": new makerjs.paths.Arc([xgwx3, xgwy3], [oGX1, oGY1], r2g,false,true),//是否大弧,是否顺时针           
      //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
      //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
      //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
      //       "BottomLeftLineG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx4, xgwy4], r2g,false,true),//是否大弧,是否顺时针
      //     }
      //   };
      //   var myFloorSpringWaterCut = {
      //     paths: {
      //       "EntryLineC":new makerjs.paths.Line([xcwx1, xcwy1+cutLine], [xcwx1, xcwy1]), 
      //       "TopLeftArcC": new makerjs.paths.Line([xcwx1, xcwy1],[xcwx2, xcwy2]),
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx2, xcwy2],[xcwx3, xcwy3], r1c,false,false),//是否大弧,是否顺时针
      //       "TopRithgLineC1": new makerjs.paths.Arc([xcwx3, xcwy3], [oCX1, oCY1], r2c,false,true),          
      //       "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
      //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
      //       "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
      //       "TopRithgLineC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx4, xcwy4], r2c,false,true),  
      //       "ExitLineC":new makerjs.paths.Line([xcwx4, xcwy4], [xcwx4-cutLine, xcwy4]),  
      //       "EntryLineI":new makerjs.paths.Line([xiwx4, xiwy4+cutLine], [xiwx4, xiwy4]),  
      //       "BottomLineI1": new makerjs.paths.Arc([xiwx4, xiwy4], [oIX1,oIY1], r2i,false,true),
      //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
      //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
      //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),  
      //       "BottomLineI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx3, xiwy3], r2i,false,true), 
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx2, xiwy2], r1i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Line([xiwx2, xiwy2],[xiwx1, xiwy1]),          
      //       "ExitLineI":new makerjs.paths.Line([xiwx1, xiwy1], [xiwx1, xiwy1-cutLine]),  
      //       "EntryLineG":new makerjs.paths.Line([xgwx1, xgwy1-cutLine], [xgwx1, xgwy1]), 
      //       "BottomRigthArcG": new makerjs.paths.Line([xgwx1, xgwy1],[xgwx2, xgwy2]),
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx2, xgwy2],[xgwx3, xgwy3], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG1": new makerjs.paths.Arc([xgwx3, xgwy3], [oGX1, oGY1], r2g,false,true),//是否大弧,是否顺时针           
      //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
      //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
      //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
      //       "BottomLeftLineG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx4, xgwy4], r2g,false,true),//是否大弧,是否顺时针
      //       "ExitLineG":new makerjs.paths.Line([xgwx4, xgwy4], [xgwx4, xgwy4+cutLine]),
      //     }
      //   };
      //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xa, ya], [xcwx, xcwy], [xchx, xchy],[xihx, xihy], [xiwx, xiwy], [xgwx, xgwy]]);
      // } else if (area == "ACGI") {
      //   var myFloorSpring = {
      //     paths: {
      //       "LeftLineA": new makerjs.paths.Line([xgwx4, xgwy4], [xawx4, xawy4]),
      //       "TopLeftLineA": new makerjs.paths.Arc([xawx4, xawy4],[xawx3, xawy3], r2a,false,true),//是否大弧,是否顺时针   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx2, xawy2], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA": new makerjs.paths.Line([xawx2, xawy2],[xawx1, xawy1]),
      //       "TopRightLineA": new makerjs.paths.Line([xawx1, xawy1], [xcwx1, xcwy1]),
      //       "TopLeftArcC": new makerjs.paths.Line([xcwx1, xcwy1],[xcwx2, xcwy2]),
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx2, xcwy2],[xcwx3, xcwy3], r1c,false,false),//是否大弧,是否顺时针
      //       "RithgLineC0": new makerjs.paths.Arc([xcwx3, xcwy3], [xcwx4, xcwy4], r2c,false,true),//是否大弧,是否顺时针
      //       "RithgLineC": new makerjs.paths.Line([xcwx4, xcwy4], [xiwx4, xiwy4]),
      //       "BottomLineI": new makerjs.paths.Arc([xiwx4, xiwy4], [xiwx3, xiwy3], r2i,false,true), //是否大弧,是否顺时针  
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx2, xiwy2], r1i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Line([xiwx2, xiwy2],[xiwx1, xiwy1]),
      //       "BottomLeftLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xgwx1, xgwy1]),   
      //       "BottomRigthArcG": new makerjs.paths.Line([xgwx1, xgwy1],[xgwx2, xgwy2]),
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx2, xgwy2],[xgwx3, xgwy3], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Arc([xgwx3, xgwy3], [xgwx4, xgwy4], r2g,false,true),//是否大弧,是否顺时针
      //       "RightHolesA": new makerjs.paths.Circle([xa+h1a, ya-w1a], ra),
      //       "RightHolesC": new makerjs.paths.Circle([xc-h1c, yc-w1c], rc),
      //       "RightHolesG": new makerjs.paths.Circle([xg+h1g, yg+w1g], rg),
      //       "RightHolesI": new makerjs.paths.Circle([xi-h1i, yi+w1i], ri),
      //     }
      //   };
      //   var myFloorSpringCut = {
      //     paths: {
      //       "TopLeftLineA": new makerjs.paths.Arc([xawx4, xawy4],[xawx3, xawy3], r2a,false,true),//是否大弧,是否顺时针   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx2, xawy2], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA": new makerjs.paths.Line([xawx2, xawy2],[xawx1, xawy1]),
      //       "TopLeftArcC": new makerjs.paths.Line([xcwx1, xcwy1],[xcwx2, xcwy2]),
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx2, xcwy2],[xcwx3, xcwy3], r1c,false,false),//是否大弧,是否顺时针
      //       "RithgLineC0": new makerjs.paths.Arc([xcwx3, xcwy3], [xcwx4, xcwy4], r2c,false,true),//是否大弧,是否顺时针
      //       "BottomLineI": new makerjs.paths.Arc([xiwx4, xiwy4], [xiwx3, xiwy3], r2i,false,true), //是否大弧,是否顺时针  
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx2, xiwy2], r1i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Line([xiwx2, xiwy2],[xiwx1, xiwy1]),
      //       "BottomRigthArcG": new makerjs.paths.Line([xgwx1, xgwy1],[xgwx2, xgwy2]),
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx2, xgwy2],[xgwx3, xgwy3], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Arc([xgwx3, xgwy3], [xgwx4, xgwy4], r2g,false,true),//是否大弧,是否顺时针
      //       "RightHolesA": new makerjs.paths.Circle([xa+h1a, ya-w1a], ra),
      //       "RightHolesC": new makerjs.paths.Circle([xc-h1c, yc-w1c], rc),
      //       "RightHolesG": new makerjs.paths.Circle([xg+h1g, yg+w1g], rg),
      //       "RightHolesI": new makerjs.paths.Circle([xi-h1i, yi+w1i], ri),
      //     }
      //   };
      //   var myFloorSpringCutM = {
      //     paths: {
      //       "LeftLineA": new makerjs.paths.Line([xgwx4, xgwy4], [xawx4, xawy4]),
      //       "TopBotArcA1": new makerjs.paths.Arc([xawx4, xawy4],[oAX1, oAY1], r2a,false,true),  
      //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
      //       "RightHolesA": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
      //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]), 
      //       "TopBotArcA2": new makerjs.paths.Arc([oAX1, oAY1],[xawx3, xawy3], r2a,false,false),//是否大弧,是否顺时针 
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx2, xawy2], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA": new makerjs.paths.Line([xawx2, xawy2],[xawx1, xawy1]),
      //       "TopRightLineA": new makerjs.paths.Line([xawx1, xawy1], [xcwx1, xcwy1]),
      //       "TopLeftArcC": new makerjs.paths.Line([xcwx1, xcwy1],[xcwx2, xcwy2]),
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx2, xcwy2],[xcwx3, xcwy3], r1c,false,false),//是否大弧,是否顺时针
      //       "TopRithgLineC1": new makerjs.paths.Arc([xcwx3, xcwy3], [oCX1, oCY1], r2c,false,true),          
      //       "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
      //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
      //       "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
      //       "TopRithgLineC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx4, xcwy4], r2c,false,true),          
      //       "RithgLineC": new makerjs.paths.Line([xcwx4, xcwy4], [xiwx4, xiwy4]),
      //       "BottomLineI1": new makerjs.paths.Arc([xiwx4, xiwy4], [oIX1,oIY1], r2i,false,true),
      //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
      //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
      //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),  
      //       "BottomLineI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx3, xiwy3], r2i,false,true),   
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx2, xiwy2], r1i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Line([xiwx2, xiwy2],[xiwx1, xiwy1]),
      //       "BottomLeftLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xgwx1, xgwy1]),   
      //       "BottomRigthArcG": new makerjs.paths.Line([xgwx1, xgwy1],[xgwx2, xgwy2]),
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx2, xgwy2],[xgwx3, xgwy3], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG1": new makerjs.paths.Arc([xgwx3, xgwy3], [oGX1, oGY1], r2g,false,true),//是否大弧,是否顺时针           
      //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
      //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
      //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
      //       "BottomLeftLineG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx4, xgwy4], r2g,false,true),//是否大弧,是否顺时针
      //     }
      //   };
      //   var myFloorSpringWaterCut = {
      //     paths: {
      //       "EntryLineA":new makerjs.paths.Line([xawx4, xawy4-cutLine], [xawx4, xawy4]), 
      //       "TopBotArcA1": new makerjs.paths.Arc([xawx4, xawy4],[oAX1, oAY1], r2a,false,true),  
      //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
      //       "RightHolesA": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
      //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]), 
      //       "TopBotArcA2": new makerjs.paths.Arc([oAX1, oAY1],[xawx3, xawy3], r2a,false,false),//是否大弧,是否顺时针 
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx2, xawy2], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA": new makerjs.paths.Line([xawx2, xawy2],[xawx1, xawy1]),              
      //       "ExitLineA":new makerjs.paths.Line([xawx1, xawy1], [xawx1, xawy1+cutLine]),
      //       "EntryLineC":new makerjs.paths.Line([xcwx1, xcwy1+cutLine], [xcwx1, xcwy1]), 
      //       "TopLeftArcC": new makerjs.paths.Line([xcwx1, xcwy1],[xcwx2, xcwy2]),
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx2, xcwy2],[xcwx3, xcwy3], r1c,false,false),//是否大弧,是否顺时针
      //       "TopRithgLineC1": new makerjs.paths.Arc([xcwx3, xcwy3], [oCX1, oCY1], r2c,false,true),          
      //       "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
      //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
      //       "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
      //       "TopRithgLineC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx4, xcwy4], r2c,false,true),   
      //       "ExitLineC":new makerjs.paths.Line([xcwx4, xcwy4], [xcwx4-cutLine, xcwy4]),  
      //       "EntryLineI":new makerjs.paths.Line([xiwx4, xiwy4+cutLine], [xiwx4, xiwy4]), 
      //       "BottomLineI1": new makerjs.paths.Arc([xiwx4, xiwy4], [oIX1,oIY1], r2i,false,true),
      //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
      //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
      //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),  
      //       "BottomLineI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx3, xiwy3], r2i,false,true), 
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx2, xiwy2], r1i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Line([xiwx2, xiwy2],[xiwx1, xiwy1]),          
      //       "ExitLineI":new makerjs.paths.Line([xiwx1, xiwy1], [xiwx1, xiwy1-cutLine]), 
      //       "EntryLineG":new makerjs.paths.Line([xgwx1, xgwy1-cutLine], [xgwx1, xgwy1]), 
      //       "BottomRigthArcG": new makerjs.paths.Line([xgwx1, xgwy1],[xgwx2, xgwy2]),
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx2, xgwy2],[xgwx3, xgwy3], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG1": new makerjs.paths.Arc([xgwx3, xgwy3], [oGX1, oGY1], r2g,false,true),//是否大弧,是否顺时针           
      //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
      //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
      //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
      //       "BottomLeftLineG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx4, xgwy4], r2g,false,true),//是否大弧,是否顺时针
      //       "ExitLineG":new makerjs.paths.Line([xgwx4, xgwy4], [xgwx4, xgwy4+cutLine]),
      //     }
      //   };
      //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xahx, xahy], [xawx, xawy], [xcwx, xcwy], [xchx, xchy],[xihx, xihy], [xiwx, xiwy], [xgwx, xgwy]]);
      // }
}else{
      console.log("短边在X轴￥￥￥￥￥");
      if (area == "A") {
        var myFloorSpring = {
          paths: {
            "LeftLineA": new makerjs.paths.Line([xg, yg], [xawx1, xawy1]),
            "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1],[xawx2, xawy2]),   
            "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2],[xawx3, xawy3], r1a,false,false),//是否大弧,是否顺时针
            "TopRightArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx4, xawy4], r2a,false,true),//是否大弧,是否顺时针
            "TopRightLineA": new makerjs.paths.Line([xawx4, xawy4], [xc, yc]),
            "RithgLineA": new makerjs.paths.Line([xc, yc], [xi, yi]),
            "BottomLineA": new makerjs.paths.Line([xi, yi], [xg, yg]),
            "RightHolesA": new makerjs.paths.Circle([xa+w1a, ya-h1a], ra),
          }
        };
        var myFloorSpringCut = {
          paths: {
            "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1],[xawx2, xawy2]),   
            "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2],[xawx3, xawy3], r1a,false,false),//是否大弧,是否顺时针
            "TopRightArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx4, xawy4], r2a,false,true),//是否大弧,是否顺时针
            "RightHolesA": new makerjs.paths.Circle([xa+w1a, ya-h1a], ra),
          }
        };
        var myFloorSpringCutM = {
          paths: {
            "LeftLineA": new makerjs.paths.Line([xg, yg], [xawx1, xawy1]),
            "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1],[xawx2, xawy2]),   
            "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2],[xawx3, xawy3], r1a,false,false),//是否大弧,是否顺时针
            "TopRightArcA1": new makerjs.paths.Arc([xawx3, xawy3],[oAX1, oAY1], r2a,false,true),//是否大弧,是否顺时针
            "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
            "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
            "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
            "TopRightArcA2": new makerjs.paths.Arc([oAX1, oAY1],[xawx4, xawy4], r2a,false,true),//是否大弧,是否顺时针
            "TopRightLineA": new makerjs.paths.Line([xawx4, xawy4], [xc, yc]),
            "RithgLineA": new makerjs.paths.Line([xc, yc], [xi, yi]),
            "BottomLineA": new makerjs.paths.Line([xi, yi], [xg, yg]),
          }
        };
        var myFloorSpringWaterCut0 = {
          paths: {
            "EntryLineA":new makerjs.paths.Line([xawx1-cutLine, xawy1], [xawx1, xawy1]), 
            "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1],[xawx2, xawy2]),   
            "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2],[xawx3, xawy3], r1a,false,false),//是否大弧,是否顺时针
            "TopRightArcA": new makerjs.paths.Arc([xawx3, xawy3],[oAX1, oAY1], r2a,false,true),//是否大弧,是否顺时针
            "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
            "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
            "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
            "TopRightArcA": new makerjs.paths.Arc([oAX1, oAY1],[xawx4, xawy4], r2a,false,true),//是否大弧,是否顺时针          
            "ExitLineA":new makerjs.paths.Line([xawx4, xawy4], [xawx4+cutLine, xawy4]),
          }
        };
        var myFloorSpringWaterCut = {
          paths: {
            "EntryLineA":new makerjs.paths.Line([xawx1-cutLine, xawy1], [xawx1, xawy1]), 
            "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1],[xawx2, xawy2]),   
            "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2],[xawx3, xawy3], r1a,false,false),//是否大弧,是否顺时针
            "TopRightArcA1": new makerjs.paths.Arc([xawx3, xawy3],[oAX1, oAY1], r2a,false,true),//是否大弧,是否顺时针
            "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
            "CircleA1": new makerjs.paths.Arc([oAX2, oAY2], [oAX3, oAY3], ra,false,true),//圆
            "CircleA2": new makerjs.paths.Arc([oAX3, oAY3],[oAX2, oAY2], ra,false,true),//圆
            "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
            "TopRightArcA2": new makerjs.paths.Arc([oAX1, oAY1],[xawx4, xawy4], r2a,false,true),//是否大弧,是否顺时针          
            "ExitLineA":new makerjs.paths.Line([xawx4, xawy4], [xawx4, xawy4+cutLine]),
          }
        };   
        var fillet1 = makerjs.path.fillet(myFloorSpringWaterCut.paths.TopLeftArcA, myFloorSpringWaterCut.paths.TopRightArcA1, cutFilletRadius);
        var fillet2 = makerjs.path.fillet(myFloorSpringWaterCut.paths.TopRightArcA1, myFloorSpringWaterCut.paths.arcAndLineA1, cutFilletRadius);
        var fillet3 = makerjs.path.fillet(myFloorSpringWaterCut.paths.arcAndLineA1, myFloorSpringWaterCut.paths.CircleA1, cutFilletRadius);
        var fillet4 = makerjs.path.fillet(myFloorSpringWaterCut.paths.CircleA2, myFloorSpringWaterCut.paths.arcAndLineA2, cutFilletRadius);
        var fillet5 = makerjs.path.fillet(myFloorSpringWaterCut.paths.arcAndLineA2, myFloorSpringWaterCut.paths.TopRightArcA2, cutFilletRadius); 
        var fillet6 = makerjs.path.fillet(myFloorSpringWaterCut.paths.TopRightArcA2, myFloorSpringWaterCut.paths.ExitLineA, cutFilletRadius); 
      myFloorSpringWaterCut.paths.fillet1 = fillet1;
      myFloorSpringWaterCut.paths.fillet2 = fillet2;
      myFloorSpringWaterCut.paths.fillet3 = fillet3;
      myFloorSpringWaterCut.paths.fillet4 = fillet4;
      myFloorSpringWaterCut.paths.fillet5 = fillet5;
      myFloorSpringWaterCut.paths.fillet6 = fillet6;
    
        //   var myCorner = new makerjs.models.ConnectTheDots(true, [[xg, yg], [xahx, xahy], [xawx, xawy], [xc, yc], [xi, yi]]);
      } else if (area == "C") {
        var myFloorSpring = {
          paths: {
            "RightLineC": new makerjs.paths.Line([xg, yg], [xa, ya]),
            "TopLeftLineC": new makerjs.paths.Line([xa, ya], [xcwx4, xcwy4]),   
            "TopLeftArcC": new makerjs.paths.Arc([xcwx4, xcwy4],[xcwx3, xcwy3], r2c,false,true ),//是否大弧,是否顺时针
            "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3],[xcwx2, xcwy2], r1c,false,false),//是否大弧,是否顺时针
            "TopRithgLineC": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
            "RithgLineC": new makerjs.paths.Line([xcwx1, xcwy1], [xi, yi]),
            "BottomLineC": new makerjs.paths.Line([xi, yi], [xg, yg]),
            "RightHolesC": new makerjs.paths.Circle([xc-w1c, yc-h1c], rc),
          }
        };
        var myFloorSpringCut = {
          paths: {  
            "TopLeftArcC": new makerjs.paths.Arc([xcwx4, xcwy4],[xcwx3, xcwy3], r2c,false,true ),//是否大弧,是否顺时针
            "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3],[xcwx2, xcwy2], r1c,false,false),//是否大弧,是否顺时针
            "TopRithgLineC": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
            "RightHolesC": new makerjs.paths.Circle([xc-w1c, yc-h1c], rc),
          }
        };
        var myFloorSpringCutM = {
          paths: {
            "RightLineC": new makerjs.paths.Line([xg, yg], [xa, ya]),
            "TopLeftLineC": new makerjs.paths.Line([xa, ya], [xcwx4, xcwy4]),   
            "TopLeftArcC1": new makerjs.paths.Arc([xcwx4, xcwy4],[oCX1, oCY1], r2c,false,true ),//是否大弧,是否顺时针
            "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
            "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
            "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
            "TopLeftArcC2": new makerjs.paths.Arc([oCX1, oCY1],[xcwx3, xcwy3], r2c,false,true ),//是否大弧,是否顺时针
            "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3],[xcwx2, xcwy2], r1c,false,false),//是否大弧,是否顺时针
            "TopRithgLineC": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
            "RithgLineC": new makerjs.paths.Line([xcwx1, xcwy1], [xi, yi]),
            "BottomLineC": new makerjs.paths.Line([xi, yi], [xg, yg]),
          }
        };
        var myFloorSpringWaterCut0 = {
          paths: {  
            "EntryLineC":new makerjs.paths.Line([xcwx4-cutLine, xcwy4], [xcwx4, xcwy4]), 
            "TopLeftArcC1": new makerjs.paths.Arc([xcwx4, xcwy4],[oCX1, oCY1], r2c,false,true ),//是否大弧,是否顺时针
            "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
            "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
            "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
            "TopLeftArcC2": new makerjs.paths.Arc([oCX1, oCY1],[xcwx3, xcwy3], r2c,false,true ),//是否大弧,是否顺时针
            "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3],[xcwx2, xcwy2], r1c,false,false),//是否大弧,是否顺时针
            "TopRithgLineC": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
            "ExitLineC":new makerjs.paths.Line([xcwx1, xcwy1], [xcwx1+cutLine, xcwy1]),  
          }
        };
        var myFloorSpringWaterCut = {
          paths: {  
            "EntryLineC":new makerjs.paths.Line([xcwx4, xcwy4+cutLine], [xcwx4, xcwy4]), 
            "TopLeftArcC1": new makerjs.paths.Arc([xcwx4, xcwy4],[oCX1, oCY1], r2c,false,true ),//是否大弧,是否顺时针
            "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
            "RightHolesC1": new makerjs.paths.Arc([oCX2, oCY2], [oCX3, oCY3], rc,false,true ),
            "RightHolesC2": new makerjs.paths.Arc([oCX3, oCY3],[oCX2, oCY2],  rc,false,true ),
            "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
            "TopLeftArcC2": new makerjs.paths.Arc([oCX1, oCY1],[xcwx3, xcwy3], r2c,false,true ),//是否大弧,是否顺时针
            "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3],[xcwx2, xcwy2], r1c,false,false),//是否大弧,是否顺时针
            "TopRithgLineC": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
            "ExitLineC":new makerjs.paths.Line([xcwx1, xcwy1], [xcwx1+cutLine, xcwy1]),  
          }
        };  
        var fillet1 = makerjs.path.fillet(myFloorSpringWaterCut.paths.EntryLineC, myFloorSpringWaterCut.paths.TopLeftArcC1, cutFilletRadius);
        var fillet2 = makerjs.path.fillet(myFloorSpringWaterCut.paths.TopLeftArcC1, myFloorSpringWaterCut.paths.TopRithgLineConectC1, cutFilletRadius);
        var fillet3 = makerjs.path.fillet(myFloorSpringWaterCut.paths.TopRithgLineConectC1, myFloorSpringWaterCut.paths.RightHolesC1, cutFilletRadius);
        var fillet4 = makerjs.path.fillet(myFloorSpringWaterCut.paths.RightHolesC2, myFloorSpringWaterCut.paths.TopRithgLineConectC2, cutFilletRadius);
        var fillet5 = makerjs.path.fillet(myFloorSpringWaterCut.paths.TopRithgLineConectC2, myFloorSpringWaterCut.paths.TopLeftArcC2, cutFilletRadius); 
        var fillet6 = makerjs.path.fillet(myFloorSpringWaterCut.paths.TopRightArcC, myFloorSpringWaterCut.paths.TopRithgLineC, cutFilletRadius); 
      myFloorSpringWaterCut.paths.fillet1 = fillet1;
      myFloorSpringWaterCut.paths.fillet2 = fillet2;
      myFloorSpringWaterCut.paths.fillet3 = fillet3;
      myFloorSpringWaterCut.paths.fillet4 = fillet4;
      myFloorSpringWaterCut.paths.fillet5 = fillet5;
      myFloorSpringWaterCut.paths.fillet6 = fillet6;
        // var myCorner = new makerjs.models.ConnectTheDots(true, [[xg, yg], [xa, ya], [xcwx, xcwy], [xchx, xchy], [xi, yi]]);
      } else if (area == "G") {
        var myFloorSpring = {
          paths: {
            "LeftLineG": new makerjs.paths.Line([xgwx1, xgwy1], [xa, ya]),
            "TopLeftLineG": new makerjs.paths.Line([xa, ya],[xc, yc]),
            "RithgLineG": new makerjs.paths.Line([xc, yc], [xi, yi]),
            "BottomLineG": new makerjs.paths.Line([xi, yi], [xgwx4, xgwy4]),   
            "BottomRigthArcG": new makerjs.paths.Arc([xgwx4, xgwy4],[xgwx3, xgwy3], r2g,false,true),//是否大弧,是否顺时针
            "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx2, xgwy2], r1g,false,false),//是否大弧,是否顺时针
            "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
            "RightHolesG": new makerjs.paths.Circle([xg+w1g, yg+h1g], rg),
          }
        };
        var myFloorSpringCut = {
          paths: {
            "BottomRigthArcG": new makerjs.paths.Arc([xgwx4, xgwy4],[xgwx3, xgwy3], r2g,false,true),//是否大弧,是否顺时针
            "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx2, xgwy2], r1g,false,false),//是否大弧,是否顺时针
            "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
            "RightHolesG": new makerjs.paths.Circle([xg+w1g, yg+h1g], rg),
          }
        };
        var myFloorSpringCutM = {
          paths: {
            "LeftLineG": new makerjs.paths.Line([xgwx1, xgwy1], [xa, ya]),
            "TopLeftLineG": new makerjs.paths.Line([xa, ya],[xc, yc]),
            "RithgLineG": new makerjs.paths.Line([xc, yc], [xi, yi]),
            "BottomLineG": new makerjs.paths.Line([xi, yi], [xgwx4, xgwy4]),   
            "BottomRigthArcG1": new makerjs.paths.Arc([xgwx4, xgwy4],[oGX1, oGY1], r2g,false,true),//是否大弧,是否顺时针            
            "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
            "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
            "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
            "BottomRigthArcG2": new makerjs.paths.Arc([oGX1, oGY1],[xgwx3, xgwy3], r2g,false,true),//是否大弧,是否顺时针 
            "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx2, xgwy2], r1g,false,false),//是否大弧,是否顺时针
            "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
          }
        };
        var myFloorSpringWaterCut = {
          paths: {
            "EntryLineG":new makerjs.paths.Line([xgwx4-cutLine, xgwy4], [xgwx4, xgwy4]), 
            "BottomRigthArcG1": new makerjs.paths.Arc([xgwx4, xgwy4],[oGX1, oGY1], r2g,false,true),//是否大弧,是否顺时针            
            "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
            "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
            "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
            "BottomRigthArcG2": new makerjs.paths.Arc([oGX1, oGY1],[xgwx3, xgwy3], r2g,false,true),//是否大弧,是否顺时针 
            "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx2, xgwy2], r1g,false,false),//是否大弧,是否顺时针
            "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
            "ExitLineG":new makerjs.paths.Line([xgwx1, xgwy1], [xgwx1+cutLine, xgwy1]),
          }
        };
        var myFloorSpringWaterCut = {
          paths: {
            "EntryLineG":new makerjs.paths.Line([xgwx4, xgwy4-cutLine], [xgwx4, xgwy4]), 
            "BottomRigthArcG1": new makerjs.paths.Arc([xgwx4, xgwy4],[oGX1, oGY1], r2g,false,true),//是否大弧,是否顺时针            
            "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
            "RightHolesG1": new makerjs.paths.Arc([oGX2, oGY2], [oGX3, oGY3], rg,false,true),
            "RightHolesG2": new makerjs.paths.Arc([oGX3, oGY3],[oGX2, oGY2], rg,false,true),
            "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
            "BottomRigthArcG2": new makerjs.paths.Arc([oGX1, oGY1],[xgwx3, xgwy3], r2g,false,true),//是否大弧,是否顺时针 
            "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx2, xgwy2], r1g,false,false),//是否大弧,是否顺时针
            "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
            "ExitLineG":new makerjs.paths.Line([xgwx1, xgwy1], [xgwx1-cutLine, xgwy1]),
          }
        }; 
        var fillet1 = makerjs.path.fillet(myFloorSpringWaterCut.paths.EntryLineG, myFloorSpringWaterCut.paths.BottomRigthArcG1, cutFilletRadius);
        var fillet2 = makerjs.path.fillet(myFloorSpringWaterCut.paths.BottomRigthArcG1, myFloorSpringWaterCut.paths.BottomLeftArcGConect1, cutFilletRadius);
        var fillet3 = makerjs.path.fillet(myFloorSpringWaterCut.paths.BottomLeftArcGConect1, myFloorSpringWaterCut.paths.RightHolesG1, cutFilletRadius);
        var fillet4 = makerjs.path.fillet(myFloorSpringWaterCut.paths.RightHolesG2, myFloorSpringWaterCut.paths.BottomLeftArcGConect2, cutFilletRadius);
        var fillet5 = makerjs.path.fillet(myFloorSpringWaterCut.paths.BottomLeftArcGConect2, myFloorSpringWaterCut.paths.BottomRigthArcG2, cutFilletRadius); 
        var fillet6 = makerjs.path.fillet(myFloorSpringWaterCut.paths.BottomRigthArcG2, myFloorSpringWaterCut.paths.BottomLeftArcG, cutFilletRadius); 
      myFloorSpringWaterCut.paths.fillet1 = fillet1;
      myFloorSpringWaterCut.paths.fillet2 = fillet2;
      myFloorSpringWaterCut.paths.fillet3 = fillet3;
      myFloorSpringWaterCut.paths.fillet4 = fillet4;
      myFloorSpringWaterCut.paths.fillet5 = fillet5;
      myFloorSpringWaterCut.paths.fillet6 = fillet6;
        // var myCorner = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xa, ya], [xc, yc], [xi, yi], [xgwx, xgwy]]);
      } else if (area == "I") {
        var myFloorSpring = {
          paths: {        
            "LeftLineI": new makerjs.paths.Line([xg, yg], [xa, ya]),
            "TopLeftLineI": new makerjs.paths.Line([xa, ya],[xc, yc]),
            "RithgLineI": new makerjs.paths.Line([xc, yc], [xiwx1, xiwy1]),
            "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),   
            "BottomRigthArcI": new makerjs.paths.Arc([xiwx2, xiwy2],[xiwx3, xiwy3], r2i,false,false),//是否大弧,是否顺时针
            "BottomLeftArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx4, xiwy4], r1i,false,true),//是否大弧,是否顺时针
            "BottomLeftLineI": new makerjs.paths.Line([xiwx4, xiwy4], [xg, xg]),
            "RightHolesI": new makerjs.paths.Circle([xi-w1i, yi+h1i], ri),
          }
        };
        var myFloorSpringCut = {
          paths: {      
            "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),   
            "BottomRigthArcI": new makerjs.paths.Arc([xiwx2, xiwy2],[xiwx3, xiwy3], r2i,false,false),//是否大弧,是否顺时针
            "BottomLeftArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx4, xiwy4], r1i,false,true),//是否大弧,是否顺时针
            "RightHolesI": new makerjs.paths.Circle([xi-w1i, yi+h1i], ri),
          }
        };
        var myFloorSpringCutM = {
          paths: {        
            "LeftLineI": new makerjs.paths.Line([xg, yg], [xa, ya]),
            "TopLeftLineI": new makerjs.paths.Line([xa, ya],[xc, yc]),
            "RithgLineI": new makerjs.paths.Line([xc, yc], [xiwx1, xiwy1]),
            "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),   
            "BottomRigthArcI1": new makerjs.paths.Arc([xiwx2, xiwy2],[xiwx3, xiwy3], r2i,false,false),//是否大弧,是否顺时针
            "BottomRigthArcI2": new makerjs.paths.Arc([xiwx3, xiwy3],[oIX1,oIY1], r2i,false,false),//是否大弧,是否顺时针
            "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
            "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
            "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
            "BottomLeftArcI": new makerjs.paths.Arc([oIX1,oIY1],[xiwx4, xiwy4], r1i,false,true),//是否大弧,是否顺时针
            "BottomLeftLineI": new makerjs.paths.Line([xiwx4, xiwy4], [xg, xg]),
          }
        };
        var myFloorSpringWaterCut0 = {
          paths: {  
            "EntryLineI":new makerjs.paths.Line([xiwx1+cutLine, xiwy1], [xiwx1, xiwy1]), 
            "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),    
            "BottomRigthArcI1": new makerjs.paths.Arc([xiwx2, xiwy2],[oIX1,oIY1], r2i,false,false),//是否大弧,是否顺时针
            "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
            "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
            "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
            "BottomRigthArcI2": new makerjs.paths.Arc([oIX1,oIY1],[xiwx3, xiwy3], r2i,false,false),//是否大弧,是否顺时针
            "BottomLeftArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx4, xiwy4], r1i,false,true),//是否大弧,是否顺时针         
            "ExitLineI":new makerjs.paths.Line([xiwx4, xiwy4], [xiwx4-cutLine, xiwy4]),
          }
        };
        var myFloorSpringWaterCut = {
          paths: {  
            "EntryLineI":new makerjs.paths.Line([xiwx1+cutLine, xiwy1], [xiwx1, xiwy1]), 
            "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),    
            "BottomLineArc2I": new makerjs.paths.Arc([xiwx2, xiwy2], [xiwx3, xiwy3], r2i,false,false),    
            "BottomRigthArcI1": new makerjs.paths.Arc([xiwx3, xiwy3],[oIX1,oIY1], r2i,false,false),//是否大弧,是否顺时针
            "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
            "RightHolesI1": new makerjs.paths.Arc([oIX2,oIY2],[oIX3,oIY3],ri,false,false),
            "RightHolesI2": new makerjs.paths.Arc([oIX3,oIY3],[oIX2,oIY2],ri,false,false),
            "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
            "BottomLeftArcI": new makerjs.paths.Arc([oIX1,oIY1],[xiwx4, xiwy4], r1i,false,true),//是否大弧,是否顺时针         
            "ExitLineI":new makerjs.paths.Line([xiwx4, xiwy4], [xiwx4, xiwy4-cutLine]),
          }
        };
        var fillet1 = makerjs.path.fillet(myFloorSpringWaterCut.paths.BottomLineArc2I, myFloorSpringWaterCut.paths.BottomRigthArcI1, cutFilletRadius);
        var fillet2 = makerjs.path.fillet(myFloorSpringWaterCut.paths.BottomRigthArcI1, myFloorSpringWaterCut.paths.RithgLineI1, cutFilletRadius);
        var fillet3 = makerjs.path.fillet(myFloorSpringWaterCut.paths.RithgLineI1, myFloorSpringWaterCut.paths.RightHolesI1, cutFilletRadius);
        var fillet4 = makerjs.path.fillet(myFloorSpringWaterCut.paths.RightHolesI2, myFloorSpringWaterCut.paths.RithgLineI2, cutFilletRadius);
        var fillet5 = makerjs.path.fillet(myFloorSpringWaterCut.paths.RithgLineI2, myFloorSpringWaterCut.paths.BottomLeftArcI, cutFilletRadius); 
        var fillet6 = makerjs.path.fillet(myFloorSpringWaterCut.paths.BottomLeftArcI, myFloorSpringWaterCut.paths.ExitLineI, cutFilletRadius); 
      myFloorSpringWaterCut.paths.fillet1 = fillet1;
      myFloorSpringWaterCut.paths.fillet2 = fillet2;
      myFloorSpringWaterCut.paths.fillet3 = fillet3;
      myFloorSpringWaterCut.paths.fillet4 = fillet4;
      myFloorSpringWaterCut.paths.fillet5 = fillet5;
      myFloorSpringWaterCut.paths.fillet6 = fillet6;
        // var myCorner = new makerjs.models.ConnectTheDots(true, [[xg, yg], [xa, ya], [xc, yc], [xihx, xihy], [xiwx, xiwy]]);
      } 
      // else if (area == "AC") {
      //   var myFloorSpring = {
      //     paths: {
      //       "LeftLineA": new makerjs.paths.Line([xg, yg], [xawx1, xawy1]),
      //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1],[xawx2, xawy2]),   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2],[xawx3, xawy3], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx4, xawy4], r2a,false,true),//是否大弧,是否顺时针
      //       "TopRightLineA": new makerjs.paths.Line([xawx4, xawy4], [xcwx4, xcwy4]),  
      //        "TopLeftArcC": new makerjs.paths.Arc([xcwx4, xcwy4],[xcwx3, xcwy3], r2c,false,true),//是否大弧,是否顺时针
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3],[xcwx2, xcwy2], r1c,false,false),//是否大弧,是否顺时针
      //       "TopRithgLineC": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
      //       "RithgLineC": new makerjs.paths.Line([xcwx1, xcwy1], [xi, yi]),
      //       "BottomLineA": new makerjs.paths.Line([xi, yi], [xg, yg]),
      //       "RightHolesA": new makerjs.paths.Circle([xa+w1a, ya-h1a], ra),
      //       "RightHolesC": new makerjs.paths.Circle([xc-w1c, yc-h1c], rc),
      //     }
      //   };
      //   var myFloorSpringCut = {
      //     paths: {
      //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1],[xawx2, xawy2]),   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2],[xawx3, xawy3], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx4, xawy4], r2a,false,true),//是否大弧,是否顺时针
      //        "TopLeftArcC": new makerjs.paths.Arc([xcwx4, xcwy4],[xcwx3, xcwy3], r2c,false,true),//是否大弧,是否顺时针
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3],[xcwx2, xcwy2], r1c,false,false),//是否大弧,是否顺时针
      //       "TopRithgLineC": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
      //       "RightHolesA": new makerjs.paths.Circle([xa+w1a, ya-h1a], ra),
      //       "RightHolesC": new makerjs.paths.Circle([xc-w1c, yc-h1c], rc),
      //     }
      //   };
      //   var myFloorSpringCutM = {
      //     paths: {
      //       "LeftLineA": new makerjs.paths.Line([xg, yg], [xawx1, xawy1]),
      //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1],[xawx2, xawy2]),   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2],[xawx3, xawy3], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA1": new makerjs.paths.Arc([xawx3, xawy3],[oAX1, oAY1], r2a,false,true),//是否大弧,是否顺时针
      //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
      //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
      //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
      //       "TopRightArcA2": new makerjs.paths.Arc([oAX1, oAY1],[xawx4, xawy4], r2a,false,true),//是否大弧,是否顺时针
      //       "TopRightLineA": new makerjs.paths.Line([xawx4, xawy4], [xcwx4, xcwy4]),  
      //       "TopLeftArcC1": new makerjs.paths.Arc([xcwx4, xcwy4],[oCX1, oCY1], r2c,false,true ),//是否大弧,是否顺时针
      //       "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
      //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
      //       "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
      //       "TopLeftArcC2": new makerjs.paths.Arc([oCX1, oCY1],[xcwx3, xcwy3], r2c,false,true ),//是否大弧,是否顺时针
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3],[xcwx2, xcwy2], r1c,false,false),//是否大弧,是否顺时针
      //       "TopRithgLineC": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
      //       "RithgLineC": new makerjs.paths.Line([xcwx1, xcwy1], [xi, yi]),
      //       "BottomLineA": new makerjs.paths.Line([xi, yi], [xg, yg]),
      //     }
      //   };
      //   var myFloorSpringWaterCut = {
      //     paths: {
      //       "EntryLineA":new makerjs.paths.Line([xawx1-cutLine, xawy1], [xawx1, xawy1]),  
      //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1],[xawx2, xawy2]),   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2],[xawx3, xawy3], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA1": new makerjs.paths.Arc([xawx3, xawy3],[oAX1, oAY1], r2a,false,true),//是否大弧,是否顺时针
      //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
      //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
      //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
      //       "TopRightArcA2": new makerjs.paths.Arc([oAX1, oAY1],[xawx4, xawy4], r2a,false,true),//是否大弧,是否顺时针        
      //       "ExitLineA":new makerjs.paths.Line([xawx4, xawy4], [xawx4+cutLine, xawy4]),
      //       "EntryLineC":new makerjs.paths.Line([xcwx4-cutLine, xcwy4], [xcwx4, xcwy4]), 
      //       "TopLeftArcC1": new makerjs.paths.Arc([xcwx4, xcwy4],[oCX1, oCY1], r2c,false,true ),//是否大弧,是否顺时针
      //       "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
      //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
      //       "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
      //       "TopLeftArcC2": new makerjs.paths.Arc([oCX1, oCY1],[xcwx3, xcwy3], r2c,false,true ),//是否大弧,是否顺时针
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3],[xcwx2, xcwy2], r1c,false,false),//是否大弧,是否顺时针
      //       "TopRithgLineC": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]), 
      //       "ExitLineC":new makerjs.paths.Line([xcwx1, xcwy1], [xcwx1+cutLine, xcwy1]),  
      //     }
      //   };
      //   // var myFillet = new makerjs.models.ConnectTheDots(true, [[xg, yg], [xahx, xahy], [xawx, xawy], [xcwx, xcwy], [xchx, xchy],[xi, yi]]);
      // } else if (area == "AG") {
      //   var myFloorSpring = {
      //     paths: {
      //       "LeftLineA": new makerjs.paths.Line([xgwx1, xgwy1], [xawx1, xawy1]),
      //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1],[xawx2, xawy2]),   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2],[xawx3, xawy3], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx4, xawy4], r2a,false,true),//是否大弧,是否顺时针
      //       "TopRightLineA": new makerjs.paths.Line([xawx4, xawy4], [xc, yc]),
      //       "RithgLineA": new makerjs.paths.Line([xc, yc], [xi, yi]),
      //       "BottomLineG": new makerjs.paths.Line([xi, yi], [xgwx4, xgwy4]),   
      //       "BottomRigthArcG": new makerjs.paths.Arc([xgwx4, xgwy4],[xgwx3, xgwy3], r2g,false,true),//是否大弧,是否顺时针
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx2, xgwy2], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
      //       "RightHolesA": new makerjs.paths.Circle([xa+w1a, ya-h1a], ra),
      //       "RightHolesG": new makerjs.paths.Circle([xg+w1g, yg+h1g], rg),
      //     }
      //   };
      //   var myFloorSpringCut = {
      //     paths: {
      //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1],[xawx2, xawy2]),   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2],[xawx3, xawy3], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx4, xawy4], r2a,false,true),//是否大弧,是否顺时针
      //       "BottomRigthArcG": new makerjs.paths.Arc([xgwx4, xgwy4],[xgwx3, xgwy3], r2g,false,true),//是否大弧,是否顺时针
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx2, xgwy2], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
      //       "RightHolesA": new makerjs.paths.Circle([xa+w1a, ya-h1a], ra),
      //       "RightHolesG": new makerjs.paths.Circle([xg+w1g, yg+h1g], rg),
      //     }
      //   };
      //   var myFloorSpringCutM = {
      //     paths: {
      //       "LeftLineA": new makerjs.paths.Line([xgwx1, xgwy1], [xawx1, xawy1]),
      //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1],[xawx2, xawy2]),   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2],[xawx3, xawy3], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA1": new makerjs.paths.Arc([xawx3, xawy3],[oAX1, oAY1], r2a,false,true),//是否大弧,是否顺时针
      //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
      //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
      //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
      //       "TopRightArcA3": new makerjs.paths.Arc([oAX1, oAY1],[xawx4, xawy4], r2a,false,true),//是否大弧,是否顺时针
      //       "TopRightLineA": new makerjs.paths.Line([xawx4, xawy4], [xc, yc]),
      //       "RithgLineA": new makerjs.paths.Line([xc, yc], [xi, yi]),
      //       "BottomLineG": new makerjs.paths.Line([xi, yi], [xgwx4, xgwy4]),   
      //       "BottomRigthArcG1": new makerjs.paths.Arc([xgwx4, xgwy4],[oGX1, oGY1], r2g,false,true),//是否大弧,是否顺时针            
      //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
      //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
      //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
      //       "BottomRigthArcG2": new makerjs.paths.Arc([oGX1, oGY1],[xgwx3, xgwy3], r2g,false,true),//是否大弧,是否顺时针 
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx2, xgwy2], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
      //     }
      //   };
      //   var myFloorSpringWaterCut = {
      //     paths: {
      //       "EntryLineA":new makerjs.paths.Line([xawx1-cutLine, xawy1], [xawx1, xawy1]),  
      //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1],[xawx2, xawy2]),   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2],[xawx3, xawy3], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA1": new makerjs.paths.Arc([xawx3, xawy3],[oAX1, oAY1], r2a,false,true),//是否大弧,是否顺时针
      //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
      //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
      //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
      //       "TopRightArcA2": new makerjs.paths.Arc([oAX1, oAY1],[xawx4, xawy4], r2a,false,true),//是否大弧,是否顺时针         
      //       "ExitLineA":new makerjs.paths.Line([xawx4, xawy4], [xawx4+cutLine, xawy4]),
      //       "EntryLineG":new makerjs.paths.Line([xgwx4-cutLine, xgwy4], [xgwx4, xgwy4]), 
      //       "BottomRigthArcG1": new makerjs.paths.Arc([xgwx4, xgwy4],[oGX1, oGY1], r2g,false,true),//是否大弧,是否顺时针            
      //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
      //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
      //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
      //       "BottomRigthArcG2": new makerjs.paths.Arc([oGX1, oGY1],[xgwx3, xgwy3], r2g,false,true),//是否大弧,是否顺时针 
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx2, xgwy2], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
      //       "ExitLineG":new makerjs.paths.Line([xgwx1, xgwy1], [xgwx1+cutLine, xgwy1]),
      //     }
      //   };
      //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xahx, xahy], [xawx, xawy], [xc, yc],[xi, yi], [xgwx, xgwy]]);
      // } else if (area == "AI") {
      //   var myFloorSpring = {
      //     paths: {
      //       "LeftLineA": new makerjs.paths.Line([xg, yg], [xawx1, xawy1]),
      //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1],[xawx2, xawy2]),   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2],[xawx3, xawy3], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx4, xawy4], r2a,false,true),//是否大弧,是否顺时针
      //       "TopRightLineA": new makerjs.paths.Line([xawx4, xawy4], [xc, yc]),
      //       "RithgLineI": new makerjs.paths.Line([xc, yc], [xiwx1, xiwy1]),
      //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),   
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx2, xiwy2],[xiwx3, xiwy3], r2i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx4, xiwy4], r1i,false,true),//是否大弧,是否顺时针
      //       "BottomLeftLineI": new makerjs.paths.Line([xiwx4, xiwy4], [xg, xg]),
      //       "RightHolesA": new makerjs.paths.Circle([xa+w1a, ya-h1a], ra),
      //       "RightHolesI": new makerjs.paths.Circle([xi-w1i, yi+h1i], ri),
      //     }
      //   };
      //   var myFloorSpringCut = {
      //     paths: {
      //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1],[xawx2, xawy2]),   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2],[xawx3, xawy3], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx4, xawy4], r2a,false,true),//是否大弧,是否顺时针
      //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),   
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx2, xiwy2],[xiwx3, xiwy3], r2i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx4, xiwy4], r1i,false,true),//是否大弧,是否顺时针
      //       "RightHolesA": new makerjs.paths.Circle([xa+w1a, ya-h1a], r),
      //       "RightHolesI": new makerjs.paths.Circle([xi-w1i, yi+h1i], ri),
      //     }
      //   };
      //   var myFloorSpringCutM = {
      //     paths: {
      //       "LeftLineA": new makerjs.paths.Line([xg, yg], [xawx1, xawy1]),
      //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1],[xawx2, xawy2]),   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2],[xawx3, xawy3], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA1": new makerjs.paths.Arc([xawx3, xawy3],[oAX1, oAY1], r2a,false,true),//是否大弧,是否顺时针
      //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
      //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
      //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
      //       "TopRightArcA2": new makerjs.paths.Arc([oAX1, oAY1],[xawx4, xawy4], r2a,false,true),//是否大弧,是否顺时针
      //       "TopRightLineA": new makerjs.paths.Line([xawx4, xawy4], [xc, yc]),
      //       "RithgLineI": new makerjs.paths.Line([xc, yc], [xiwx1, xiwy1]),
      //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),     
      //       "BottomRigthArcI1": new makerjs.paths.Arc([xiwx2, xiwy2],[oIX1,oIY1], r2i,false,false),//是否大弧,是否顺时针
      //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
      //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
      //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
      //       "BottomRigthArcI2": new makerjs.paths.Arc([oIX1,oIY1],[xiwx3, xiwy3], r2i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx4, xiwy4], r1i,false,true),//是否大弧,是否顺时针
      //       "BottomLeftLineI": new makerjs.paths.Line([xiwx4, xiwy4], [xg, xg]),
      //     }
      //   };
      //   var myFloorSpringWaterCut = {
      //     paths: {
      //       "EntryLineA":new makerjs.paths.Line([xawx1-cutLine, xawy1], [xawx1, xawy1]),  
      //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1],[xawx2, xawy2]),   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2],[xawx3, xawy3], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA1": new makerjs.paths.Arc([xawx3, xawy3],[oAX1, oAY1], r2a,false,true),//是否大弧,是否顺时针
      //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
      //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
      //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
      //       "TopRightArcA2": new makerjs.paths.Arc([oAX1, oAY1],[xawx4, xawy4], r2a,false,true),//是否大弧,是否顺时针         
      //       "ExitLineA":new makerjs.paths.Line([xawx4, xawy4], [xawx4+cutLine, xawy4]),
      //       "EntryLineI":new makerjs.paths.Line([xiwx1+cutLine, xiwy1], [xiwx1, xiwy1]), 
      //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),   
      //       "BottomRigthArcI1": new makerjs.paths.Arc([xiwx2, xiwy2],[oIX1,oIY1], r2i,false,false),//是否大弧,是否顺时针
      //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
      //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
      //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
      //       "BottomRigthArcI2": new makerjs.paths.Arc([oIX1,oIY1],[xiwx3, xiwy3], r2i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx4, xiwy4], r1i,false,true),//是否大弧,是否顺时针         
      //       "ExitLineI":new makerjs.paths.Line([xiwx4, xiwy4], [xiwx4-cutLine, xiwy4]),
      //     }
      //   };
      //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xg, yg], [xahx, xahy], [xawx, xawy], [xc, yc], [xihx, xihy], [xiwx, xiwy]]);
      // } else if (area == "CG") {
      //   var myFloorSpring = {
      //     paths: {
      //       "RightLineC": new makerjs.paths.Line([xgwx1, xgwy1], [xa, ya]),
      //       "TopLeftLineC": new makerjs.paths.Line([xa, ya], [xcwx4, xcwy4]),   
      //       "TopLeftArcC": new makerjs.paths.Arc([xcwx4, xcwy4],[xcwx3, xcwy3], r2c,false,true),//是否大弧,是否顺时针
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3],[xcwx2, xcwy2], r1c,false,false),//是否大弧,是否顺时针
      //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
      //       "RithgLineC": new makerjs.paths.Line([xcwx1, xcwy1], [xi, yi]),
      //       "BottomLineG": new makerjs.paths.Line([xi, yi], [xgwx4, xgwy4]),   
      //       "BottomRigthArcG": new makerjs.paths.Arc([xgwx4, xgwy4],[xgwx3, xgwy3], r2g,false,true),//是否大弧,是否顺时针
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx2, xgwy2], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
      //       "RightHolesC": new makerjs.paths.Circle([xc-w1c, yc-h1c], rc),
      //       "RightHolesG": new makerjs.paths.Circle([xg+w1g, yg+h1g], rg),
      //     }
      //   };
      //   var myFloorSpringCut = {
      //     paths: {
      //       "TopLeftArcC": new makerjs.paths.Arc([xcwx4, xcwy4],[xcwx3, xcwy3], r2c,false,true),//是否大弧,是否顺时针
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3],[xcwx2, xcwy2], r1c,false,false),//是否大弧,是否顺时针
      //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
      //       "BottomRigthArcG": new makerjs.paths.Arc([xgwx4, xgwy4],[xgwx3, xgwy3], r2g,false,true),//是否大弧,是否顺时针
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx2, xgwy2], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
      //       "RightHolesC": new makerjs.paths.Circle([xc-w1c, yc-h1c], rc),
      //       "RightHolesG": new makerjs.paths.Circle([xg+w1g, yg+h1g], rg),
      //     }
      //   };
      //   var myFloorSpringCutM = {
      //     paths: {
      //       "RightLineC": new makerjs.paths.Line([xgwx1, xgwy1], [xa, ya]),
      //       "TopLeftLineC": new makerjs.paths.Line([xa, ya], [xcwx4, xcwy4]),   
      //       "TopLeftArcC1": new makerjs.paths.Arc([xcwx4, xcwy4],[oCX1, oCY1], r2c,false,true ),//是否大弧,是否顺时针
      //       "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
      //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
      //       "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
      //       "TopLeftArcC2": new makerjs.paths.Arc([oCX1, oCY1],[xcwx3, xcwy3], r2c,false,true ),//是否大弧,是否顺时针
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3],[xcwx2, xcwy2], r1c,false,false),//是否大弧,是否顺时针
      //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
      //       "RithgLineC": new makerjs.paths.Line([xcwx1, xcwy1], [xi, yi]),
      //       "BottomLineG": new makerjs.paths.Line([xi, yi], [xgwx4, xgwy4]),   
      //       "BottomRigthArcG1": new makerjs.paths.Arc([xgwx4, xgwy4],[oGX1, oGY1], r2g,false,true),//是否大弧,是否顺时针            
      //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
      //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
      //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
      //       "BottomRigthArcG2": new makerjs.paths.Arc([oGX1, oGY1],[xgwx3, xgwy3], r2g,false,true),//是否大弧,是否顺时针 
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx2, xgwy2], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
      //     }
      //   };
      //   var myFloorSpringWaterCut = {
      //     paths: {
      //       "EntryLineC":new makerjs.paths.Line([xcwx4-cutLine, xcwy4], [xcwx4, xcwy4]), 
      //       "TopLeftArcC1": new makerjs.paths.Arc([xcwx4, xcwy4],[oCX1, oCY1], r2c,false,true ),//是否大弧,是否顺时针
      //       "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
      //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
      //       "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
      //       "TopLeftArcC2": new makerjs.paths.Arc([oCX1, oCY1],[xcwx3, xcwy3], r2c,false,true ),//是否大弧,是否顺时针
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3],[xcwx2, xcwy2], r1c,false,false),//是否大弧,是否顺时针
      //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
      //       "ExitLineC":new makerjs.paths.Line([xcwx1, xcwy1], [xcwx1+cutLine, xcwy1]),  
      //       "EntryLineG":new makerjs.paths.Line([xgwx4-cutLine, xgwy4], [xgwx4, xgwy4]), 
      //       "BottomRigthArcG1": new makerjs.paths.Arc([xgwx4, xgwy4],[oGX1, oGY1], r2g,false,true),//是否大弧,是否顺时针            
      //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
      //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
      //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
      //       "BottomRigthArcG2": new makerjs.paths.Arc([oGX1, oGY1],[xgwx3, xgwy3], r2g,false,true),//是否大弧,是否顺时针 
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx2, xgwy2], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
      //       "ExitLineG":new makerjs.paths.Line([xgwx1, xgwy1], [xgwx1+cutLine, xgwy1]),
      //     }
      //   };
    
      //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xa, ya], [xcwx, xcwy], [xchx, xchy], [xi, yi], [xgwx, xgwy]]);
      // } else if (area == "CI") {
      //   var myFloorSpring = {
      //     paths: {
      //       "RightLineC": new makerjs.paths.Line([xg, yg], [xa, ya]),
      //       "TopLeftLineC": new makerjs.paths.Line([xa, ya], [xcwx4, xcwy4]),   
      //       "TopLeftArcC": new makerjs.paths.Arc([xcwx4, xcwy4],[xcwx3, xcwy3], r2c,false,true),//是否大弧,是否顺时针
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3],[xcwx2, xcwy2], r1c,false,false),//是否大弧,是否顺时针
      //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
      //       "RithgLineC": new makerjs.paths.Line([xcwx1, xcwy1], [xiwx1, xiwy1]),
      //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),   
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx2, xiwy2],[xiwx3, xiwy3], r2i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx4, xiwy4], r1i,false,true),//是否大弧,是否顺时针
      //       "BottomLeftLineI": new makerjs.paths.Line([xiwx4, xiwy4], [xg, xg]),
      //       "RightHolesC": new makerjs.paths.Circle([xc-w1c, yc-h1c], rc),
      //       "RightHolesI": new makerjs.paths.Circle([xi-w1i, yi+h1i], ri),
      //     }
      //   };
      //   var myFloorSpringCut = {
      //     paths: { 
      //       "TopLeftArcC": new makerjs.paths.Arc([xcwx4, xcwy4],[xcwx3, xcwy3], r2c,false,true),//是否大弧,是否顺时针
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3],[xcwx2, xcwy2], r1c,false,false),//是否大弧,是否顺时针
      //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
      //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),   
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx2, xiwy2],[xiwx3, xiwy3], r2i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx4, xiwy4], r1i,false,true),//是否大弧,是否顺时针
      //       "RightHolesC": new makerjs.paths.Circle([xc-w1c, yc-h1c], rc),
      //       "RightHolesI": new makerjs.paths.Circle([xi-w1i, yi+h1i], ri),
      //     }
      //   };
      //   var myFloorSpringCutM = {
      //     paths: {
      //       "RightLineC": new makerjs.paths.Line([xg, yg], [xa, ya]),
      //       "TopLeftLineC": new makerjs.paths.Line([xa, ya], [xcwx4, xcwy4]),   
      //       "TopLeftArcC1": new makerjs.paths.Arc([xcwx4, xcwy4],[oCX1, oCY1], r2c,false,true ),//是否大弧,是否顺时针
      //       "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
      //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
      //       "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
      //       "TopLeftArcC2": new makerjs.paths.Arc([oCX1, oCY1],[xcwx3, xcwy3], r2c,false,true ),//是否大弧,是否顺时针
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3],[xcwx2, xcwy2], r1c,false,false),//是否大弧,是否顺时针
      //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
      //       "RithgLineC": new makerjs.paths.Line([xcwx1, xcwy1], [xiwx1, xiwy1]),
      //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),   
      //       "BottomRigthArcI1": new makerjs.paths.Arc([xiwx2, xiwy2],[oIX1,oIY1], r2i,false,false),//是否大弧,是否顺时针
      //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
      //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
      //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
      //       "BottomRigthArcI2": new makerjs.paths.Arc([oIX1,oIY1],[xiwx3, xiwy3], r2i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx4, xiwy4], r1i,false,true),//是否大弧,是否顺时针
      //       "BottomLeftLineI": new makerjs.paths.Line([xiwx4, xiwy4], [xg, xg]),
      //     }
      //   };
      //   var myFloorSpringWaterCut = {
      //     paths: { 
      //       "EntryLineC":new makerjs.paths.Line([xcwx4-cutLine, xcwy4], [xcwx4, xcwy4]), 
      //       "TopLeftArcC1": new makerjs.paths.Arc([xcwx4, xcwy4],[oCX1, oCY1], r2c,false,true ),//是否大弧,是否顺时针
      //       "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
      //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
      //       "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
      //       "TopLeftArcC2": new makerjs.paths.Arc([oCX1, oCY1],[xcwx3, xcwy3], r2c,false,true ),//是否大弧,是否顺时针
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3],[xcwx2, xcwy2], r1c,false,false),//是否大弧,是否顺时针
      //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
      //       "ExitLineC":new makerjs.paths.Line([xcwx1, xcwy1], [xcwx1+cutLine, xcwy1]),  
      //       "EntryLineI":new makerjs.paths.Line([xiwx1+cutLine, xiwy1], [xiwx1, xiwy1]),  
      //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),     
      //       "BottomRigthArcI1": new makerjs.paths.Arc([xiwx2, xiwy2],[oIX1,oIY1], r2i,false,false),//是否大弧,是否顺时针
      //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
      //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
      //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
      //       "BottomRigthArcI2": new makerjs.paths.Arc([oIX1,oIY1],[xiwx3, xiwy3], r2i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx4, xiwy4], r1i,false,true),//是否大弧,是否顺时针        
      //       "ExitLineI":new makerjs.paths.Line([xiwx4, xiwy4], [xiwx4-cutLine, xiwy4]),
      //     }
      //   };
    
      //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xg, yg], [xa, ya], [xcwx, xcwy], [xchx, xchy], [xihx, xihy], [xiwx, xiwy]]);
      // } else if (area == "GI") {
      //   var myFloorSpring = {
      //     paths: {
      //       "LeftLineG": new makerjs.paths.Line([xgwx1, xgwy1], [xa, ya]),
      //       "TopLeftLineG": new makerjs.paths.Line([xa, ya],[xc, yc]),
      //       "RithgLineI": new makerjs.paths.Line([xc, yc], [xiwx1, xiwy1]),
      //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),   
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx2, xiwy2],[xiwx3, xiwy3], r2i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx4, xiwy4], r1i,false,true),//是否大弧,是否顺时针
      //       "BottomLeftLineI": new makerjs.paths.Line([xiwx4, xiwy4], [xgwx4, xgwy4]),
      //       "BottomRigthArcG": new makerjs.paths.Arc([xgwx4, xgwy4],[xgwx3, xgwy3], r2g,false,true),//是否大弧,是否顺时针
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx2, xgwy2], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
      //       "RightHolesG": new makerjs.paths.Circle([xg+w1g, yg+h1g], rg),
      //       "RightHolesI": new makerjs.paths.Circle([xi-w1i, yi+h1i], ri),
      //     }
      //   };
      //   var myFloorSpringCut = {
      //     paths: {
      //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),   
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx2, xiwy2],[xiwx3, xiwy3], r2i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx4, xiwy4], r1i,false,true),//是否大弧,是否顺时针
      //       "BottomRigthArcG": new makerjs.paths.Arc([xgwx4, xgwy4],[xgwx3, xgwy3], r2g,false,true),//是否大弧,是否顺时针
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx2, xgwy2], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
      //       "RightHolesG": new makerjs.paths.Circle([xg+w1g, yg+h1g], rg),
      //       "RightHolesI": new makerjs.paths.Circle([xi-w1i, yi+h1i], ri),
      //     }
      //   };
      //   var myFloorSpringCutM = {
      //     paths: {
      //       "LeftLineG": new makerjs.paths.Line([xgwx1, xgwy1], [xa, ya]),
      //       "TopLeftLineG": new makerjs.paths.Line([xa, ya],[xc, yc]),
      //       "RithgLineI": new makerjs.paths.Line([xc, yc], [xiwx1, xiwy1]),
      //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),    
      //       "BottomRigthArcI1": new makerjs.paths.Arc([xiwx2, xiwy2],[oIX1,oIY1], r2i,false,false),//是否大弧,是否顺时针
      //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
      //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
      //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
      //       "BottomRigthArcI2": new makerjs.paths.Arc([oIX1,oIY1],[xiwx3, xiwy3], r2i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx4, xiwy4], r1i,false,true),//是否大弧,是否顺时针
      //       "BottomLeftLineI": new makerjs.paths.Line([xiwx4, xiwy4], [xgwx4, xgwy4]),
      //       "BottomRigthArcG1": new makerjs.paths.Arc([xgwx4, xgwy4],[oGX1, oGY1], r2g,false,true),//是否大弧,是否顺时针            
      //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
      //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
      //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
      //       "BottomRigthArcG2": new makerjs.paths.Arc([oGX1, oGY1],[xgwx3, xgwy3], r2g,false,true),//是否大弧,是否顺时针 
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx2, xgwy2], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
      //     }
      //   };
      //   var myFloorSpringWaterCut = {
      //     paths: {
      //       "EntryLineI":new makerjs.paths.Line([xiwx1+cutLine, xiwy1], [xiwx1, xiwy1]), 
      //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),   
      //       "BottomRigthArcI1": new makerjs.paths.Arc([xiwx2, xiwy2],[oIX1,oIY1], r2i,false,false),//是否大弧,是否顺时针
      //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
      //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
      //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
      //       "BottomRigthArcI2": new makerjs.paths.Arc([oIX1,oIY1],[xiwx3, xiwy3], r2i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx4, xiwy4], r1i,false,true),//是否大弧,是否顺时针         
      //       "ExitLineI":new makerjs.paths.Line([xiwx4, xiwy4], [xiwx4-cutLine, xiwy4]),
      //       "EntryLineG":new makerjs.paths.Line([xgwx4-cutLine, xgwy4], [xgwx4, xgwy4]), 
      //       "BottomRigthArcG1": new makerjs.paths.Arc([xgwx4, xgwy4],[oGX1, oGY1], r2g,false,true),//是否大弧,是否顺时针            
      //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
      //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
      //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
      //       "BottomRigthArcG2": new makerjs.paths.Arc([oGX1, oGY1],[xgwx3, xgwy3], r2g,false,true),//是否大弧,是否顺时针 
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx2, xgwy2], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
      //       "ExitLineG":new makerjs.paths.Line([xgwx1, xgwy1], [xgwx1+cutLine, xgwy1]),
      //     }
      //   };
      //   // var myFillet = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xa, ya], [xc, yc], [xihx, xihy], [xiwx, xiwy], [xgwx, xgwy]]);
      // } else if (area == "ACG") {
      //   var myFloorSpring = {
      //     paths: {
      //       "LeftLineA": new makerjs.paths.Line([xgwx1, xgwy1], [xawx1, xawy1]),
      //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1],[xawx2, xawy2]),   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2],[xawx3, xawy3], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx4, xawy4], r2a,false,true),//是否大弧,是否顺时针
      //       "TopRightLineA": new makerjs.paths.Line([xawx4, xawy4], [xcwx4, xcwy4]),
      //       "TopLeftArcC": new makerjs.paths.Arc([xcwx4, xcwy4],[xcwx3, xcwy3], r2c,false,true),//是否大弧,是否顺时针
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3],[xcwx2, xcwy2], r1c,false,false),//是否大弧,是否顺时针
      //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
      //       "RithgLineC": new makerjs.paths.Line([xcwx1, xcwy1], [xi, yi]),
      //       "BottomLineG": new makerjs.paths.Line([xi, yi], [xgwx4, xgwy4]),      
      //       "BottomRigthArcG": new makerjs.paths.Arc([xgwx4, xgwy4],[xgwx3, xgwy3], r2g,false,true),//是否大弧,是否顺时针
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx2, xgwy2], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
      //       "RightHolesA": new makerjs.paths.Circle([xa+w1a, ya-h1a], ra),
      //       "RightHolesC": new makerjs.paths.Circle([xc-w1c, yc-h1c], rc),
      //       "RightHolesG": new makerjs.paths.Circle([xg+w1g, yg+h1g], rg),
      //     }
      //   };
      //   var myFloorSpringCut = {
      //     paths: {
      //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1],[xawx2, xawy2]),   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2],[xawx3, xawy3], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx4, xawy4], r2a,false,true),//是否大弧,是否顺时针
      //       "TopLeftArcC": new makerjs.paths.Arc([xcwx4, xcwy4],[xcwx3, xcwy3], r2c,false,true),//是否大弧,是否顺时针
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3],[xcwx2, xcwy2], r1c,false,false),//是否大弧,是否顺时针
      //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]), 
      //       "BottomRigthArcG": new makerjs.paths.Arc([xgwx4, xgwy4],[xgwx3, xgwy3], r2g,false,true),//是否大弧,是否顺时针
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx2, xgwy2], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
      //       "RightHolesA": new makerjs.paths.Circle([xa+w1a, ya-h1a], ra),
      //       "RightHolesC": new makerjs.paths.Circle([xc-w1c, yc-h1c], rc),
      //       "RightHolesG": new makerjs.paths.Circle([xg+w1g, yg+h1g], rg),
      //     }
      //   };
      //   var myFloorSpringCutM = {
      //     paths: {
      //       "LeftLineA": new makerjs.paths.Line([xgwx1, xgwy1], [xawx1, xawy1]),
      //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1],[xawx2, xawy2]),   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2],[xawx3, xawy3], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA": new makerjs.paths.Arc([xawx3, xawy3],[oAX1, oAY1], r2a,false,true),//是否大弧,是否顺时针
      //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
      //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
      //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
      //       "TopRightArcA": new makerjs.paths.Arc([oAX1, oAY1],[xawx4, xawy4], r2a,false,true),//是否大弧,是否顺时针
      //       "TopRightLineA": new makerjs.paths.Line([xawx4, xawy4], [xcwx4, xcwy4]),
      //       "TopLeftArcC1": new makerjs.paths.Arc([xcwx4, xcwy4],[oCX1, oCY1], r2c,false,true ),//是否大弧,是否顺时针
      //       "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
      //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
      //       "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
      //       "TopLeftArcC2": new makerjs.paths.Arc([oCX1, oCY1],[xcwx3, xcwy3], r2c,false,true ),//是否大弧,是否顺时针
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3],[xcwx2, xcwy2], r1c,false,false),//是否大弧,是否顺时针
      //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
      //       "RithgLineC": new makerjs.paths.Line([xcwx1, xcwy1], [xi, yi]),
      //       "BottomLineG": new makerjs.paths.Line([xi, yi], [xgwx4, xgwy4]), 
      //       "BottomRigthArcG1": new makerjs.paths.Arc([xgwx4, xgwy4],[oGX1, oGY1], r2g,false,true),//是否大弧,是否顺时针            
      //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
      //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
      //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
      //       "BottomRigthArcG2": new makerjs.paths.Arc([oGX1, oGY1],[xgwx3, xgwy3], r2g,false,true),//是否大弧,是否顺时针 
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx2, xgwy2], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
      //     }
      //   };
      //   var myFloorSpringWaterCut = {
      //     paths: {
      //       "EntryLineA":new makerjs.paths.Line([xawx1-cutLine, xawy1], [xawx1, xawy1]),
      //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1],[xawx2, xawy2]),   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2],[xawx3, xawy3], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA": new makerjs.paths.Arc([xawx3, xawy3],[oAX1, oAY1], r2a,false,true),//是否大弧,是否顺时针
      //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
      //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
      //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
      //       "TopRightArcA": new makerjs.paths.Arc([oAX1, oAY1],[xawx4, xawy4], r2a,false,true),//是否大弧,是否顺时针           
      //       "ExitLineA":new makerjs.paths.Line([xawx4, xawy4], [xawx4+cutLine, xawy4]),
      //       "EntryLineC":new makerjs.paths.Line([xcwx4-cutLine, xcwy4], [xcwx4, xcwy4]), 
      //       "TopLeftArcC1": new makerjs.paths.Arc([xcwx4, xcwy4],[oCX1, oCY1], r2c,false,true ),//是否大弧,是否顺时针
      //       "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
      //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
      //       "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
      //       "TopLeftArcC2": new makerjs.paths.Arc([oCX1, oCY1],[xcwx3, xcwy3], r2c,false,true ),//是否大弧,是否顺时针
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3],[xcwx2, xcwy2], r1c,false,false),//是否大弧,是否顺时针
      //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]), 
      //       "ExitLineC":new makerjs.paths.Line([xcwx1, xcwy1], [xcwx1+cutLine, xcwy1]),  
      //       "EntryLineG":new makerjs.paths.Line([xgwx4-cutLine, xgwy4], [xgwx4, xgwy4]), 
      //       "BottomRigthArcG1": new makerjs.paths.Arc([xgwx4, xgwy4],[oGX1, oGY1], r2g,false,true),//是否大弧,是否顺时针            
      //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
      //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
      //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
      //       "BottomRigthArcG2": new makerjs.paths.Arc([oGX1, oGY1],[xgwx3, xgwy3], r2g,false,true),//是否大弧,是否顺时针 
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx2, xgwy2], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
      //       "ExitLineG":new makerjs.paths.Line([xgwx1, xgwy1], [xgwx1+cutLine, xgwy1]),
      //     }
      //   };
      //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xahx, xahy], [xawx, xawy], [xcwx, xcwy], [xchx, xchy],[xi, yi], [xgwx, xgwy]]);
      // } else if (area == "ACI") {
      //   var myFloorSpring = {
      //     paths: {
      //       "LeftLineA": new makerjs.paths.Line([xg, yg], [xawx1, xawy1]),
      //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1],[xawx2, xawy2]),   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2],[xawx3, xawy3], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx4, xawy4], r2a,false,true),//是否大弧,是否顺时针
      //       "TopRightLineA": new makerjs.paths.Line([xawx4, xawy4], [xcwx4, xcwy4]),
      //       "TopLeftArcC": new makerjs.paths.Arc([xcwx4, xcwy4],[xcwx3, xcwy3], r2c,false,true),//是否大弧,是否顺时针
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3],[xcwx2, xcwy2], r1c,false,false),//是否大弧,是否顺时针
      //       "RithgLineC": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
      //       "BottomLineI0": new makerjs.paths.Line([xcwx1, xcwy1], [xiwx1, xiwy1]), 
      //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),   
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx2, xiwy2],[xiwx3, xiwy3], r2i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx4, xiwy4], r1i,false,true),//是否大弧,是否顺时针
      //       "BottomLeftLineI": new makerjs.paths.Line([xiwx4, xiwy4], [xg, xg]),
      //       "RightHolesA": new makerjs.paths.Circle([xa+w1a, ya-h1a], ra),
      //       "RightHolesC": new makerjs.paths.Circle([xc-w1c, yc-h1c], rc),
      //       "RightHolesI": new makerjs.paths.Circle([xi-w1i, yi+h1i], ri),
      //     }
      //   };
      //   var myFloorSpringCut = {
      //     paths: {
      //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1],[xawx2, xawy2]),   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2],[xawx3, xawy3], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx4, xawy4], r2a,false,true),//是否大弧,是否顺时针
      //       "TopLeftArcC": new makerjs.paths.Arc([xcwx4, xcwy4],[xcwx3, xcwy3], r2c,false,true),//是否大弧,是否顺时针
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3],[xcwx2, xcwy2], r1c,false,false),//是否大弧,是否顺时针
      //       "RithgLineC": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
      //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),   
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx2, xiwy2],[xiwx3, xiwy3], r2i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx4, xiwy4], r1i,false,true),//是否大弧,是否顺时针
      //       "RightHolesA": new makerjs.paths.Circle([xa+w1a, ya-h1a], ra),
      //       "RightHolesC": new makerjs.paths.Circle([xc-w1c, yc-h1c], rc),
      //       "RightHolesI": new makerjs.paths.Circle([xi-w1i, yi+h1i], ri),
      //     }
      //   };
      //   var myFloorSpringCutM = {
      //     paths: {
      //       "LeftLineA": new makerjs.paths.Line([xg, yg], [xawx1, xawy1]),
      //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1],[xawx2, xawy2]),   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2],[xawx3, xawy3], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA1": new makerjs.paths.Arc([xawx3, xawy3],[oAX1, oAY1], r2a,false,true),//是否大弧,是否顺时针
      //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
      //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
      //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
      //       "TopRightArcA2": new makerjs.paths.Arc([oAX1, oAY1],[xawx4, xawy4], r2a,false,true),//是否大弧,是否顺时针
      //       "TopRightLineA": new makerjs.paths.Line([xawx4, xawy4], [xcwx4, xcwy4]),
      //       "TopLeftArcC1": new makerjs.paths.Arc([xcwx4, xcwy4],[oCX1, oCY1], r2c,false,true ),//是否大弧,是否顺时针
      //       "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
      //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
      //       "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
      //       "TopLeftArcC2": new makerjs.paths.Arc([oCX1, oCY1],[xcwx3, xcwy3], r2c,false,true ),//是否大弧,是否顺时针
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3],[xcwx2, xcwy2], r1c,false,false),//是否大弧,是否顺时针
      //       "RithgLineC": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
      //       "BottomLineI0": new makerjs.paths.Line([xcwx1, xcwy1], [xiwx1, xiwy1]), 
      //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),    
      //       "BottomRigthArcI1": new makerjs.paths.Arc([xiwx2, xiwy2],[oIX1,oIY1], r2i,false,false),//是否大弧,是否顺时针
      //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
      //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
      //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
      //       "BottomRigthArcI2": new makerjs.paths.Arc([oIX1,oIY1],[xiwx3, xiwy3], r2i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx4, xiwy4], r1i,false,true),//是否大弧,是否顺时针
      //       "BottomLeftLineI": new makerjs.paths.Line([xiwx4, xiwy4], [xg, xg]),
      //     }
      //   };
      //   var myFloorSpringWaterCut = {
      //     paths: {
      //       "EntryLineA":new makerjs.paths.Line([xawx1-cutLine, xawy1], [xawx1, xawy1]), 
      //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1],[xawx2, xawy2]),   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2],[xawx3, xawy3], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA1": new makerjs.paths.Arc([xawx3, xawy3],[oAX1, oAY1], r2a,false,true),//是否大弧,是否顺时针
      //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
      //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
      //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
      //       "TopRightArcA2": new makerjs.paths.Arc([oAX1, oAY1],[xawx4, xawy4], r2a,false,true),//是否大弧,是否顺时针          
      //       "ExitLineA":new makerjs.paths.Line([xawx4, xawy4], [xawx4+cutLine, xawy4]),
      //       "EntryLineC":new makerjs.paths.Line([xcwx4-cutLine, xcwy4], [xcwx4, xcwy4]), 
      //       "TopLeftArcC1": new makerjs.paths.Arc([xcwx4, xcwy4],[oCX1, oCY1], r2c,false,true ),//是否大弧,是否顺时针
      //       "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
      //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
      //       "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
      //       "TopLeftArcC2": new makerjs.paths.Arc([oCX1, oCY1],[xcwx3, xcwy3], r2c,false,true ),//是否大弧,是否顺时针
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3],[xcwx2, xcwy2], r1c,false,false),//是否大弧,是否顺时针
      //       "RithgLineC": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
      //       "ExitLineC":new makerjs.paths.Line([xcwx1, xcwy1], [xcwx1+cutLine, xcwy1]),  
      //       "EntryLineI":new makerjs.paths.Line([xiwx1+cutLine, xiwy1], [xiwx1, xiwy1]),
      //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),    
      //       "BottomRigthArcI1": new makerjs.paths.Arc([xiwx2, xiwy2],[oIX1,oIY1], r2i,false,false),//是否大弧,是否顺时针
      //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
      //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
      //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
      //       "BottomRigthArcI2": new makerjs.paths.Arc([oIX1,oIY1],[xiwx3, xiwy3], r2i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx4, xiwy4], r1i,false,true),//是否大弧,是否顺时针          
      //       "ExitLineI":new makerjs.paths.Line([xiwx4, xiwy4], [xiwx4-cutLine, xiwy4]),
      //     }
      //   };
    
      //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xg, yg], [xahx, xahy], [xawx, xawy], [xcwx, xcwy], [xchx, xchy],[xihx, xihy], [xiwx, xiwy]]);
      // } else if (area == "AGI") {
      //   var myFloorSpring = {
      //     paths: {
      //       "LeftLineA": new makerjs.paths.Line([xgwx1, xgwy1], [xawx1, xawy1]),
      //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1],[xawx2, xawy2]),   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2],[xawx3, xawy3], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx4, xawy4], r2a,false,true),//是否大弧,是否顺时针
      //       "TopRightLineA": new makerjs.paths.Line([xawx4, xawy4], [xc, yc]),
      //       "RithgLineI": new makerjs.paths.Line([xc, yc], [xiwx1, xiwy1]),
      //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),   
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx2, xiwy2],[xiwx3, xiwy3], r2i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx4, xiwy4], r1i,false,true),//是否大弧,是否顺时针
      //       "BottomLeftLineI": new makerjs.paths.Line([xiwx4, xiwy4], [xgwx4, xgwy4]),  
      //       "BottomRigthArcG": new makerjs.paths.Arc([xgwx4, xgwy4],[xgwx3, xgwy3], r2g,false,true),//是否大弧,是否顺时针
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx2, xgwy2], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
      //       "RightHolesA": new makerjs.paths.Circle([xa+w1a, ya-h1a], ra),
      //       "RightHolesG": new makerjs.paths.Circle([xg+w1g, yg+h1g], rg),
      //       "RightHolesI": new makerjs.paths.Circle([xi-w1i, yi+h1i], ri),
      //     }
      //   };
    
      //   var myFloorSpringCut = {
      //     paths: {
      //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1],[xawx2, xawy2]),   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2],[xawx3, xawy3], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx4, xawy4], r2a,false,true),//是否大弧,是否顺时针
      //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),   
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx2, xiwy2],[xiwx3, xiwy3], r2i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx4, xiwy4], r1i,false,true),//是否大弧,是否顺时针
      //       "BottomRigthArcG": new makerjs.paths.Arc([xgwx4, xgwy4],[xgwx3, xgwy3], r2g,false,true),//是否大弧,是否顺时针
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx2, xgwy2], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
      //       "RightHolesA": new makerjs.paths.Circle([xa+w1a, ya-h1a], ra),
      //       "RightHolesG": new makerjs.paths.Circle([xg+w1g, yg+h1g], rg),
      //       "RightHolesI": new makerjs.paths.Circle([xi-w1i, yi+h1i], ri),
      //     }
      //   };
      //   var myFloorSpringCutM = {
      //     paths: {
      //       "LeftLineA": new makerjs.paths.Line([xgwx1, xgwy1], [xawx1, xawy1]),
      //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1],[xawx2, xawy2]),   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2],[xawx3, xawy3], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA1": new makerjs.paths.Arc([xawx3, xawy3],[oAX1, oAY1], r2a,false,true),//是否大弧,是否顺时针
      //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
      //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
      //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
      //       "TopRightArcA2": new makerjs.paths.Arc([oAX1, oAY1],[xawx4, xawy4], r2a,false,true),//是否大弧,是否顺时针
      //       "TopRightLineA": new makerjs.paths.Line([xawx4, xawy4], [xc, yc]),
      //       "RithgLineI": new makerjs.paths.Line([xc, yc], [xiwx1, xiwy1]),
      //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),    
      //       "BottomRigthArcI1": new makerjs.paths.Arc([xiwx2, xiwy2],[oIX1,oIY1], r2i,false,false),//是否大弧,是否顺时针
      //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
      //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
      //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
      //       "BottomRigthArcI2": new makerjs.paths.Arc([oIX1,oIY1],[xiwx3, xiwy3], r2i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx4, xiwy4], r1i,false,true),//是否大弧,是否顺时针
      //       "BottomLeftLineI": new makerjs.paths.Line([xiwx4, xiwy4], [xgwx4, xgwy4]),  
      //       "BottomRigthArcG1": new makerjs.paths.Arc([xgwx4, xgwy4],[oGX1, oGY1], r2g,false,true),//是否大弧,是否顺时针            
      //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
      //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
      //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
      //       "BottomRigthArcG2": new makerjs.paths.Arc([oGX1, oGY1],[xgwx3, xgwy3], r2g,false,true),//是否大弧,是否顺时针 
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx2, xgwy2], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
      //     }
      //   };
    
      //   var myFloorSpringWaterCut = {
      //     paths: {
      //       "EntryLineA":new makerjs.paths.Line([xawx1-cutLine, xawy1], [xawx1, xawy1]), 
      //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1],[xawx2, xawy2]),   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2],[xawx3, xawy3], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA1": new makerjs.paths.Arc([xawx3, xawy3],[oAX1, oAY1], r2a,false,true),//是否大弧,是否顺时针
      //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
      //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
      //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
      //       "TopRightArcA2": new makerjs.paths.Arc([oAX1, oAY1],[xawx4, xawy4], r2a,false,true),//是否大弧,是否顺时针          
      //       "ExitLineA":new makerjs.paths.Line([xawx4, xawy4], [xawx4+cutLine, xawy4]),
      //       "EntryLineI":new makerjs.paths.Line([xiwx1+cutLine, xiwy1], [xiwx1, xiwy1]), 
      //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),    
      //       "BottomRigthArcI1": new makerjs.paths.Arc([xiwx2, xiwy2],[oIX1,oIY1], r2i,false,false),//是否大弧,是否顺时针
      //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
      //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
      //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
      //       "BottomRigthArcI2": new makerjs.paths.Arc([oIX1,oIY1],[xiwx3, xiwy3], r2i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx4, xiwy4], r1i,false,true),//是否大弧,是否顺时针         
      //       "ExitLineI":new makerjs.paths.Line([xiwx4, xiwy4], [xiwx4-cutLine, xiwy4]),
      //       "EntryLineG":new makerjs.paths.Line([xgwx4-cutLine, xgwy4], [xgwx4, xgwy4]), 
      //       "BottomRigthArcG1": new makerjs.paths.Arc([xgwx4, xgwy4],[oGX1, oGY1], r2g,false,true),//是否大弧,是否顺时针            
      //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
      //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
      //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
      //       "BottomRigthArcG2": new makerjs.paths.Arc([oGX1, oGY1],[xgwx3, xgwy3], r2g,false,true),//是否大弧,是否顺时针 
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx2, xgwy2], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
      //       "ExitLineG":new makerjs.paths.Line([xgwx1, xgwy1], [xgwx1+cutLine, xgwy1]),
      //     }
      //   };
    
      //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xahx, xahy], [xawx, xawy], [xc, yc],[xihx, xihy], [xiwx, xiwy], [xgwx, xgwy]]);
      // } else if (area == "CGI") {
      //   var myFloorSpring = {
      //     paths: {
      //       "RightLineC": new makerjs.paths.Line([xgwx1, xgwy1], [xa, ya]),
      //       "TopLeftLineC": new makerjs.paths.Line([xa, ya], [xcwx4, xcwy4]),   
      //       "TopLeftArcC": new makerjs.paths.Arc([xcwx4, xcwy4],[xcwx3, xcwy3], r2c,false,true),//是否大弧,是否顺时针
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3],[xcwx2, xcwy2], r1c,false,false),//是否大弧,是否顺时针
      //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
      //       "RithgLineC": new makerjs.paths.Line([xcwx1, xcwy1], [xiwx1, xiwy1]),
      //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),   
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx2, xiwy2],[xiwx3, xiwy3], r2i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx4, xiwy4], r1i,false,true),//是否大弧,是否顺时针
      //       "BottomLeftLineI": new makerjs.paths.Line([xiwx4, xiwy4], [xgwx4, xgwy4]),
      //       "BottomRigthArcG": new makerjs.paths.Arc([xgwx4, xgwy4],[xgwx3, xgwy3], r2g,false,true),//是否大弧,是否顺时针
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx2, xgwy2], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
      //       "RightHolesC": new makerjs.paths.Circle([xc-w1c, yc-h1c], rc),
      //       "RightHolesG": new makerjs.paths.Circle([xg+w1g, yg+h1g], rg),
      //       "RightHolesI": new makerjs.paths.Circle([xi-w1i, yi+h1i], ri),
      //     }
      //   };
      //   var myFloorSpringCut = {
      //     paths: { 
      //       "TopLeftArcC": new makerjs.paths.Arc([xcwx4, xcwy4],[xcwx3, xcwy3], r2c,false,true),//是否大弧,是否顺时针
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3],[xcwx2, xcwy2], r1c,false,false),//是否大弧,是否顺时针
      //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
      //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),   
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx2, xiwy2],[xiwx3, xiwy3], r2i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx4, xiwy4], r1i,false,true),//是否大弧,是否顺时针
      //       "BottomRigthArcG": new makerjs.paths.Arc([xgwx4, xgwy4],[xgwx3, xgwy3], r2g,false,true),//是否大弧,是否顺时针
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx2, xgwy2], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
      //       "RightHolesC": new makerjs.paths.Circle([xc-w1c, yc-h1c], rc),
      //       "RightHolesG": new makerjs.paths.Circle([xg+w1g, yg+h1g], rg),
      //       "RightHolesI": new makerjs.paths.Circle([xi-w1i, yi+h1i], ri),
      //     }
      //   };
      //   var myFloorSpringCutM = {
      //     paths: {
      //       "RightLineC": new makerjs.paths.Line([xgwx1, xgwy1], [xa, ya]),
      //       "TopLeftLineC": new makerjs.paths.Line([xa, ya], [xcwx4, xcwy4]),  
      //       "TopLeftArcC1": new makerjs.paths.Arc([xcwx4, xcwy4],[oCX1, oCY1], r2c,false,true ),//是否大弧,是否顺时针
      //       "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
      //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
      //       "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
      //       "TopLeftArcC2": new makerjs.paths.Arc([oCX1, oCY1],[xcwx3, xcwy3], r2c,false,true ),//是否大弧,是否顺时针
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3],[xcwx2, xcwy2], r1c,false,false),//是否大弧,是否顺时针
      //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
      //       "RithgLineC": new makerjs.paths.Line([xcwx1, xcwy1], [xiwx1, xiwy1]),
      //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),   
      //       "BottomRigthArcI1": new makerjs.paths.Arc([xiwx2, xiwy2],[oIX1,oIY1], r2i,false,false),//是否大弧,是否顺时针
      //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
      //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
      //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
      //       "BottomRigthArcI2": new makerjs.paths.Arc([oIX1,oIY1],[xiwx3, xiwy3], r2i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx4, xiwy4], r1i,false,true),//是否大弧,是否顺时针
      //       "BottomLeftLineI": new makerjs.paths.Line([xiwx4, xiwy4], [xgwx4, xgwy4]),
      //       "BottomRigthArcG1": new makerjs.paths.Arc([xgwx4, xgwy4],[oGX1, oGY1], r2g,false,true),//是否大弧,是否顺时针            
      //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
      //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
      //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
      //       "BottomRigthArcG2": new makerjs.paths.Arc([oGX1, oGY1],[xgwx3, xgwy3], r2g,false,true),//是否大弧,是否顺时针 
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx2, xgwy2], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
      //     }
      //   };
      //   var myFloorSpringWaterCut = {
      //     paths: { 
      //       "EntryLineC":new makerjs.paths.Line([xcwx4-cutLine, xcwy4], [xcwx4, xcwy4]), 
      //       "TopLeftArcC1": new makerjs.paths.Arc([xcwx4, xcwy4],[oCX1, oCY1], r2c,false,true ),//是否大弧,是否顺时针
      //       "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
      //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
      //       "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
      //       "TopLeftArcC2": new makerjs.paths.Arc([oCX1, oCY1],[xcwx3, xcwy3], r2c,false,true ),//是否大弧,是否顺时针
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3],[xcwx2, xcwy2], r1c,false,false),//是否大弧,是否顺时针
      //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
      //       "ExitLineC":new makerjs.paths.Line([xcwx1, xcwy1], [xcwx1+cutLine, xcwy1]),  
      //       "EntryLineI":new makerjs.paths.Line([xiwx1+cutLine, xiwy1], [xiwx1, xiwy1]), 
      //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),     
      //       "BottomRigthArcI1": new makerjs.paths.Arc([xiwx2, xiwy2],[oIX1,oIY1], r2i,false,false),//是否大弧,是否顺时针
      //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
      //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
      //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
      //       "BottomRigthArcI2": new makerjs.paths.Arc([oIX1,oIY1],[xiwx3, xiwy3], r2i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx4, xiwy4], r1i,false,true),//是否大弧,是否顺时针         
      //       "ExitLineI":new makerjs.paths.Line([xiwx4, xiwy4], [xiwx4-cutLine, xiwy4]),
      //       "EntryLineG":new makerjs.paths.Line([xgwx4-cutLine, xgwy4], [xgwx4, xgwy4]),
      //       "BottomRigthArcG1": new makerjs.paths.Arc([xgwx4, xgwy4],[oGX1, oGY1], r2g,false,true),//是否大弧,是否顺时针            
      //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
      //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
      //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
      //       "BottomRigthArcG2": new makerjs.paths.Arc([oGX1, oGY1],[xgwx3, xgwy3], r2g,false,true),//是否大弧,是否顺时针 
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx2, xgwy2], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]), 
      //       "ExitLineG":new makerjs.paths.Line([xgwx1, xgwy1], [xgwx1+cutLine, xgwy1]),
      //     }
      //   };
      //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xa, ya], [xcwx, xcwy], [xchx, xchy],[xihx, xihy], [xiwx, xiwy], [xgwx, xgwy]]);
      // } else if (area == "ACGI") {
      //   var myFloorSpring = {
      //     paths: {
      //       "LeftLineA": new makerjs.paths.Line([xgwx1, xgwy1], [xawx1, xawy1]),
      //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1],[xawx2, xawy2]),   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2],[xawx3, xawy3], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx4, xawy4], r2a,false,true),//是否大弧,是否顺时针
      //       "TopRightLineA": new makerjs.paths.Line([xawx4, xawy4], [xcwx4, xcwy4]),
      //       "TopLeftArcC": new makerjs.paths.Arc([xcwx4, xcwy4],[xcwx3, xcwy3], r2c,false,true),//是否大弧,是否顺时针
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3],[xcwx2, xcwy2], r1c,false,false),//是否大弧,是否顺时针
      //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
      //       "RithgLineC": new makerjs.paths.Line([xcwx1, xcwy1], [xiwx1, xiwy1]),
      //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),   
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx2, xiwy2],[xiwx3, xiwy3], r2i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx4, xiwy4], r1i,false,true),//是否大弧,是否顺时针
      //       "BottomLeftLineI": new makerjs.paths.Line([xiwx4, xiwy4], [xgwx4, xgwy4]),   
      //       "BottomRigthArcG": new makerjs.paths.Arc([xgwx4, xgwy4],[xgwx3, xgwy3], r2g,false,true),//是否大弧,是否顺时针
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx2, xgwy2], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
      //       "RightHolesA": new makerjs.paths.Circle([xa+w1a, ya-h1a], ra),
      //       "RightHolesC": new makerjs.paths.Circle([xc-w1c, yc-h1c], rc),
      //       "RightHolesG": new makerjs.paths.Circle([xg+w1g, yg+h1g], rg),
      //       "RightHolesI": new makerjs.paths.Circle([xi-w1i, yi+h1i], ri),
      //     }
      //   };
      //   var myFloorSpringCut = {
      //     paths: {
      //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1],[xawx2, xawy2]),   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2],[xawx3, xawy3], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA": new makerjs.paths.Arc([xawx3, xawy3],[xawx4, xawy4], r2a,false,true),//是否大弧,是否顺时针
      //       "TopLeftArcC": new makerjs.paths.Arc([xcwx4, xcwy4],[xcwx3, xcwy3], r2c,false,true),//是否大弧,是否顺时针
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3],[xcwx2, xcwy2], r1c,false,false),//是否大弧,是否顺时针
      //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
      //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),   
      //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx2, xiwy2],[xiwx3, xiwy3], r2i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx4, xiwy4], r1i,false,true),//是否大弧,是否顺时针
      //       "BottomRigthArcG": new makerjs.paths.Arc([xgwx4, xgwy4],[xgwx3, xgwy3], r2g,false,true),//是否大弧,是否顺时针
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx2, xgwy2], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
      //       "RightHolesA": new makerjs.paths.Circle([xa+w1a, ya-h1a], ra),
      //       "RightHolesC": new makerjs.paths.Circle([xc-w1c, yc-h1c], rc),
      //       "RightHolesG": new makerjs.paths.Circle([xg+w1g, yg+h1g], rg),
      //       "RightHolesI": new makerjs.paths.Circle([xi-w1i, yi+h1i], ri),
      //     }
      //   };
      //   var myFloorSpringCutM = {
      //     paths: {
      //       "LeftLineA": new makerjs.paths.Line([xgwx1, xgwy1], [xawx1, xawy1]),
      //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1],[xawx2, xawy2]),   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2],[xawx3, xawy3], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA1": new makerjs.paths.Arc([xawx3, xawy3],[oAX1, oAY1], r2a,false,true),//是否大弧,是否顺时针
      //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
      //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
      //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
      //       "TopRightArcA2": new makerjs.paths.Arc([oAX1, oAY1],[xawx4, xawy4], r2a,false,true),//是否大弧,是否顺时针
      //       "TopRightLineA": new makerjs.paths.Line([xawx4, xawy4], [xcwx4, xcwy4]),
      //       "TopLeftArcC1": new makerjs.paths.Arc([xcwx4, xcwy4],[oCX1, oCY1], r2c,false,true ),//是否大弧,是否顺时针
      //       "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
      //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
      //       "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
      //       "TopLeftArcC2": new makerjs.paths.Arc([oCX1, oCY1],[xcwx3, xcwy3], r2c,false,true ),//是否大弧,是否顺时针
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3],[xcwx2, xcwy2], r1c,false,false),//是否大弧,是否顺时针
      //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
      //       "RithgLineC": new makerjs.paths.Line([xcwx1, xcwy1], [xiwx1, xiwy1]),
      //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),    
      //       "BottomRigthArcI1": new makerjs.paths.Arc([xiwx2, xiwy2],[oIX1,oIY1], r2i,false,false),//是否大弧,是否顺时针
      //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
      //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
      //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
      //       "BottomRigthArcI2": new makerjs.paths.Arc([oIX1,oIY1],[xiwx3, xiwy3], r2i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx4, xiwy4], r1i,false,true),//是否大弧,是否顺时针
      //       "BottomLeftLineI": new makerjs.paths.Line([xiwx4, xiwy4], [xgwx4, xgwy4]),   
      //       "BottomRigthArcG1": new makerjs.paths.Arc([xgwx4, xgwy4],[oGX1, oGY1], r2g,false,true),//是否大弧,是否顺时针            
      //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
      //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
      //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
      //       "BottomRigthArcG2": new makerjs.paths.Arc([oGX1, oGY1],[xgwx3, xgwy3], r2g,false,true),//是否大弧,是否顺时针 
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx2, xgwy2], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
      //     }
      //   };
      //   var myFloorSpringWaterCut = {
      //     paths: {
      //       "EntryLineA":new makerjs.paths.Line([xawx1-cutLine, xawy1], [xawx1, xawy1]), 
      //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1],[xawx2, xawy2]),   
      //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2],[xawx3, xawy3], r1a,false,false),//是否大弧,是否顺时针
      //       "TopRightArcA1": new makerjs.paths.Arc([xawx3, xawy3],[oAX1, oAY1], r2a,false,true),//是否大弧,是否顺时针
      //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
      //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
      //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
      //       "TopRightArcA2": new makerjs.paths.Arc([oAX1, oAY1],[xawx4, xawy4], r2a,false,true),//是否大弧,是否顺时针          
      //       "ExitLineA":new makerjs.paths.Line([xawx4, xawy4], [xawx4+cutLine, xawy4]),
      //       "EntryLineC":new makerjs.paths.Line([xcwx4-cutLine, xcwy4], [xcwx4, xcwy4]), 
      //       "TopLeftArcC1": new makerjs.paths.Arc([xcwx4, xcwy4],[oCX1, oCY1], r2c,false,true ),//是否大弧,是否顺时针
      //       "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
      //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
      //       "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
      //       "TopLeftArcC2": new makerjs.paths.Arc([oCX1, oCY1],[xcwx3, xcwy3], r2c,false,true ),//是否大弧,是否顺时针
      //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3],[xcwx2, xcwy2], r1c,false,false),//是否大弧,是否顺时针
      //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
      //       "ExitLineC":new makerjs.paths.Line([xcwx1, xcwy1], [xcwx1+cutLine, xcwy1]),  
      //       "EntryLineI":new makerjs.paths.Line([xiwx1+cutLine, xiwy1], [xiwx1, xiwy1]),
      //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),    
      //       "BottomRigthArcI1": new makerjs.paths.Arc([xiwx2, xiwy2],[oIX1,oIY1], r2i,false,false),//是否大弧,是否顺时针
      //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
      //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
      //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
      //       "BottomRigthArcI2": new makerjs.paths.Arc([oIX1,oIY1],[xiwx3, xiwy3], r2i,false,false),//是否大弧,是否顺时针
      //       "BottomLeftArcI": new makerjs.paths.Arc([xiwx3, xiwy3],[xiwx4, xiwy4], r1i,false,true),//是否大弧,是否顺时针          
      //       "ExitLineI":new makerjs.paths.Line([xiwx4, xiwy4], [xiwx4-cutLine, xiwy4]),
      //       "EntryLineG":new makerjs.paths.Line([xgwx4-cutLine, xgwy4], [xgwx4, xgwy4]), 
      //       "BottomRigthArcG1": new makerjs.paths.Arc([xgwx4, xgwy4],[oGX1, oGY1], r2g,false,true),//是否大弧,是否顺时针            
      //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
      //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
      //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
      //       "BottomRigthArcG2": new makerjs.paths.Arc([oGX1, oGY1],[xgwx3, xgwy3], r2g,false,true),//是否大弧,是否顺时针 
      //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3],[xgwx2, xgwy2], r1g,false,false),//是否大弧,是否顺时针
      //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
      //       "ExitLineG":new makerjs.paths.Line([xgwx1, xgwy1], [xgwx1+cutLine, xgwy1]),
      //     }
      //   };
      //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xahx, xahy], [xawx, xawy], [xcwx, xcwy], [xchx, xchy],[xihx, xihy], [xiwx, xiwy], [xgwx, xgwy]]);
      // }
}
  
  return [myFloorSpring,myFloorSpringCut,myFloorSpringCutM,myFloorSpringWaterCut];
};
// 矩形等去角标记 连线函数
function creatFloorSpringMark(outParam, area, param, inputParam, fixedParam, OffsetParam, zoom) {
  console.log("是否调用此函数creatFloorSpringMark()");
  console.log("是否调用此函数param", param);
  console.log("是否调用此函数outParam", outParam);
  console.log("是否调用此函数inputParam", inputParam);
  console.log("是否调用此函数OffsetParam", OffsetParam);
  console.log("是否调用此函数fixedParam", fixedParam);
  var HH = outParam.H, WW = outParam.W, D = inputParam.D,H = inputParam.H, H1 = inputParam.H1, W = inputParam.W, W1 = inputParam.W1, W2 = inputParam.W2, W2 = inputParam.W2, R = inputParam.R, R1 = inputParam.R1, R2 = inputParam.R2,
    markShiftTwo = fixedParam.markShiftTwo * 1, myZoom = zoom * 1,
    // rd = OffsetParam.rMark * 1,
      Aa=inputParam.Aa*1,Aaa=inputParam.Aaa*1,Ahd=inputParam.Ahd*1,
      Ca=inputParam.Ca*1,Caa=inputParam.Caa*1,Chd=inputParam.Chd*1,
      Ga=inputParam.Ga*1,Gaa=inputParam.Gaa*1,Ghd=inputParam.Ghd*1,
      Ia=inputParam.Ia*1,Iaa=inputParam.Iaa*1,Ihd=inputParam.Ihd*1,
    //   ihd=OffsetParam.ihd*1,iwd=OffsetParam.iwd*1,iwdd=OffsetParam.iwdd*1,
    xa = param.xa, ya = param.ya, xawx1 = param.xawx1, xawy1 = param.xawy1,xawx2 = param.xawx2, xawy2 = param.xawy2,xawx3 = param.xawx3, xawy3 = param.xawy3,xawx4 = param.xawx4, xawy4 = param.xawy4,
    xc = param.xc, yc = param.yc, xcwx1 = param.xcwx1, xcwy1 = param.xcwy1,xcwx2 = param.xcwx2, xcwy2 = param.xcwy2,xcwx3 = param.xcwx3, xcwy3 = param.xcwy3,xcwx4 = param.xcwx4, xcwy4 = param.xcwy4,
    xg = param.xg, yg = param.yg, xgwx1 = param.xgwx1, xgwy1 = param.xgwy1, xgwx2 = param.xgwx2, xgwy2 = param.xgwy2,xgwx3 = param.xgwx3, xgwy3 = param.xgwy3,xgwx4 = param.xgwx4, xgwy4 = param.xgwy4,
    xi = param.xi, yi = param.yi, xiwx1 = param.xiwx1, xiwy1 = param.xiwy1, xiwx2 = param.xiwx2, xiwy2 = param.xiwy2,xiwx3 = param.xiwx3, xiwy3 = param.xiwy3,xiwx4 = param.xiwx4, xiwy4 = param.xiwy4,
    r = param.r,r1 = param.r1,r2 = param.r2,w = param.w,w1 = param.w1,w2 = param.w2,h = param.h,h1 = param.h1,
    da = param.da,ra = param.ra,r1a = param.r1a,r2a = param.r2a,wa = param.wa,w1a = param.w1a,w2a = param.w2a,ha = param.ha,h1a = param.h1a,
    dc = param.dc,rc = param.rc,r1c = param.r1c,r2c = param.r2c,wc = param.wc,w1c = param.w1c,w2c = param.w2c,hc = param.hc,h1c = param.h1c,
    dg = param.dg,rg = param.rg,r1g = param.r1g,r2g = param.r2g,wg = param.wg,w1g = param.w1g,w2g = param.w2g,hg = param.hg,h1g = param.h1g,
    di = param.di,ri = param.ri,r1i = param.r1i,r2i = param.r2i,wi= param.wi,w1i = param.w1i,w2i = param.w2i,hi = param.hi,h1i = param.h1i,    
    markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
    markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,
    glassH=param.glassH,glassW=param.glassW,
    d = D * 1 * myZoom,
    h = H * 1 * myZoom,
    h1 = H1 * 1 * myZoom,
    w = W * 1 * myZoom,
    w1 = W1 * 1 * myZoom,
    w2 = W2 * 1 * myZoom,
    r = R * 1 * myZoom,
    r1 = R1 * 1 * myZoom,
    r2 = R2 * 1 * myZoom,

    hh = HH * 1 * myZoom,
    ww = WW * 1 * myZoom;
    if (r !== 0) {
      var TxtR = "R=" + R;
    }if (r1 !== 0) {
      var TxtR1 = "R1=" + R1;
    }if (r2 !== 0) {
      var TxtR2 = "R2=" + R2;
    }if (w !== 0) {
      var TxtW = "W=" + W;
    }if (w1 !== 0) {
      var TxtW1 = "W1=" + W1;
    }if (w2 !== 0) {
      var TxtW2 = "W2=" + W2;
    }if (h !== 0) {
      var TxtH = "H=" + H;
    }if (h1 !== 0) {
      var TxtH1 = "H1=" + H1;
    }if (d !== 0) {
      var TxtD = "D=" + D;
    }
    ///////////////////
    
    if (ra !== 0) {
      var TxtRa = "R=" + ra.toString();
    }if (r1a !== 0) {
      var TxtR1a = "R1=" + r1a.toString();
    }if (r2a !== 0) {
      var TxtR2a = "R2=" + r2a.toString();
    }if (wa !== 0) {
      var TxtWa = "W=" + wa.toString();
    }if (w1a !== 0) {
      var TxtW1a = "W1=" + w1a.toString();
    }if (w2a !== 0) {
      var TxtW2a = "W2=" + w2a.toString();
    }if (ha !== 0) {
      var TxtHa = "H=" + ha.toString();
    }if (h1a !== 0) {
      var TxtH1a = "H1=" + h1a.toString();
    }if (da !== 0) {
      var TxtDa = "D=" + da.toString();
    }

    //////////////////////
    
    if (rc !== 0) {
      var TxtRc = "R=" + rc.toString();
    }if (r1c !== 0) {
      var TxtR1c = "R1=" + r1c.toString();
    }if (r2c !== 0) {
      var TxtR2c = "R2=" + r2c.toString();
    }if (wc !== 0) {
      var TxtWc = "W=" + wc.toString();
    }if (w1c !== 0) {
      var TxtW1c = "W1=" + w1c.toString();
    }if (w2c !== 0) {
      var TxtW2c = "W2=" + w2c.toString();
    }if (hc !== 0) {
      var TxtHc = "H=" + hc.toString();
    }if (h1c !== 0) {
      var TxtH1c = "H1=" + h1c.toString();
    }if (dc !== 0) {
      var TxtDc = "D=" + dc.toString();
    }

    ////////////////////////
    
    if (rg !== 0) {
      var TxtRg = "R=" + rg.toString();
    }if (r1g !== 0) {
      var TxtR1g = "R1=" + r1g.toString();
    }if (r2g !== 0) {
      var TxtR2g = "R2=" + r2g.toString();
    }if (wg !== 0) {
      var TxtWg = "W=" + wg.toString();
    }if (w1g !== 0) {
      var TxtW1g = "W1=" + w1g.toString();
    }if (w2g !== 0) {
      var TxtW2g = "W2=" + w2g.toString();
    }if (hg !== 0) {
      var TxtHg = "H=" + hg.toString();
    }if (h1g !== 0) {
      var TxtH1g = "H1=" + h1g.toString();
    }if (dg !== 0) {
      var TxtDg = "D=" + dg.toString();
    }
    //////////////////////////////
    
    if (ri !== 0) {
      var TxtRi = "R=" + ri.toString();
    }if (r1i !== 0) {
      var TxtR1i = "R1=" + r1i.toString();
    }if (r2i !== 0) {
      var TxtR2i = "R2=" + r2i.toString();
    }if (wi !== 0) {
      var TxtWi = "W=" + wi.toString();
    }if (w1i !== 0) {
      var TxtW1i = "W1=" + w1i.toString();
    }if (w2i !== 0) {
      var TxtW2i = "W2=" + w2i.toString();
    }if (hi !== 0) {
      var TxtHi = "H=" + hi.toString();
    }if (h1i !== 0) {
      var TxtH1i = "H1=" + h1i.toString();
    }if (di !== 0) {
      var TxtDi = "D=" + di.toString();
    }
console.log("*******************");
console.log("console.log TxtRg,TxtR1g,TxtR2g,TxtWg,TxtHg,TxtH1g,TxtDg",TxtRg,TxtR1g,TxtR2g,TxtWg,TxtHg,TxtH1g,TxtDg)
console.log("console.log TxtRg,TxtR1g,TxtR2g,TxtWg,TxtHg,TxtH1g,TxtDg",rg,r1g,r2g,wg,hg,h1g,dg)
console.log("&&&&&&&&&&&&&&&&&&&&&&&Aa,Aaa,Ahd,Ca,Caa,Chd,Ga,Gaa,Ghd,Ia,Iaa,Ihd",Aa,Aaa,Ahd,Ca,Caa,Chd,Ga,Gaa,Ghd,Ia,Iaa,Ihd);
console.log("glassW,glassH==",glassW,glassH);
if(glassW*1>glassH * 1){
  console.log("长边在X轴￥￥￥￥￥");
  if (area == "A") {    
    var myFsAMakerWA = {
      paths: {
        "WALine0": new makerjs.paths.Line([xa+ha,ya], [xa+ha+markShiftThree,ya]),//左上角
        "WALine1": new makerjs.paths.Line([xa+ha,ya-wa], [xa+ha+markShiftThree,ya-wa]),//左上角
        "WALine2":new makerjs.paths.Line([xa+ha+markShift,ya], [xa+ha+markShift,ya-wa]),
      }
    };
    var myFsAMakerW1A = {
      paths: {
       "W1ALine0":new makerjs.paths.Line([xa+ha+da+markShift,ya], [xa+ha+da+markShift,ya-w1a]),
       "W1ALine1": new makerjs.paths.Line([xa+h1a,ya-w1a], [xa+h1a+da+markShiftThree,ya-w1a]),//左上角
      }
    };
    var myFsAMakerW2A = {
      paths: {
       "W2ALine0":new makerjs.paths.Line([xa+ha+ha+markShiftThree,ya], [xa+ha+ha+markShiftThree,ya-w2a]),
        "W2ALine1": new makerjs.paths.Line([xa,ya-w2a], [xa+ha+ha+markShiftFour,ya-w2a]),//左上角
      }
    };
    var myFsAMakerHA = {
      
      paths: {
       "HALine0":new makerjs.paths.Line([xa,ya], [xa, ya+markShiftFour]),
       "HALine1": new makerjs.paths.Line([xa+ha,ya], [xa+ha, ya+markShiftFour]),//左上角
       "HALine2": new makerjs.paths.Line([xa,ya+markShiftTwo], [xa+ha,ya+markShiftTwo]),//左上角
      }
    };
    var myFsAMakerH1A = {    
      paths: {
       "H1ALine0":new makerjs.paths.Line([xa+h1a,ya-w1a], [xa+h1a, ya-w1a-da/2-markShiftFour]),
       "H1ALine1": new makerjs.paths.Line([xa,ya-w2a-markShift], [xa+h1a,ya-w2a-markShift]),//左上角
      }
    };
 
    var myFsAMakerR2A = {    
      paths: {
       "R2ALine1": new makerjs.paths.Line([xa,ya-w2a], [xa+r2a+markShiftFour, ya-w2a]),//左上角
       "R2ALine2": new makerjs.paths.Line([xa,ya-Aa+markShiftTwo], [xa+Ahd,ya-Aa]),//左上角
      }
    };
    var myFsAMakerR1A = {    
      paths: {
       "R1ALine1": new makerjs.paths.Line([xa+Ahd,ya-wa], [xa+Ahd+markShift,ya-wa-markShift]),//左上角
      }
    };
    var myFsAMakerDA = {    
      paths: {
       "DALine1": new makerjs.paths.Line([xa+h1a,ya-w1a], [xa+h1a+da+markShiftFour+markHolesOneD,ya-w1a-markShift-markHolesOneD]),//左上角
      }
    };
    /**************************************************** */
    
  makerjs.model.addCaption(myFsAMakerWA, TxtWa, [xa+ha+markShiftThree,ya], [xa+ha+markShiftThree,ya-wa]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1A, TxtW1a, [xa+ha+da+markShiftThree,ya], [xa+ha+da+markShiftThree,ya-w1a]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2A, TxtW2a, [xa+ha+ha+da+markShiftFour,ya], [xa+ha+ha+da+markShiftFour,ya-w2a]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHA, TxtHa, [xa,ya+markShiftFour], [xa+ha,ya+markShiftFour]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1A, TxtH1a, [xa,ya-w2a-markShiftThree], [xa+h1a,ya-w2a-markShiftThree]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2A, TxtR2a,[xa+Ahd-markShiftThree,ya-Aa+markShiftThree], [xa+Ahd-markShift,ya-Aa+markShift]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1A, TxtR1a, [xa+Ahd,ya-wa], [xa+Ahd+markShift,ya-wa-markShift]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDA, TxtDa, [xa+h1a+da+markShiftFour+markHolesOneD,ya-w1a-markShift-markHolesOneD],[xa+h1a+da+markShiftFour+markHolesOneD,ya-w1a-markHolesOneD-markShiftFour]);//D文字标注  
    
  /**************************************************** */
  
    var markers = {
      myFsAMakerWA,
      myFsAMakerW1A,
       myFsAMakerW2A,
       myFsAMakerHA,
      myFsAMakerH1A,
       myFsAMakerR2A,
      myFsAMakerR1A,
      myFsAMakerDA,
    }

  } else if (area == "C") {
 
    /*****************  C  *********** */
    var myFsAMakerWC = {
      paths: {
        "WCLine0": new makerjs.paths.Line([xc-hc,yc], [xc-hc-markShiftThree,yc]),//左上角
        "WCLine1": new makerjs.paths.Line([xc-hc,yc-wc], [xc-hc-markShiftThree,yc-wc]),//左上角
        "WCLine2":new makerjs.paths.Line([xc-hc-markShift,yc-wc], [xc-hc-markShift,yc]),
      }
    };
    var myFsAMakerW1C = {
      paths: {
       "W1CLine0":new makerjs.paths.Line([xc-hc-dc-markShift,yc-w1c], [xc-hc-dc-markShift,yc]),
       "W1CLine1": new makerjs.paths.Line([xc-h1c,yc-w1c], [xc-h1c-dc-markShiftThree,yc-w1c]),//左上角
      }
    };
    var myFsAMakerW2C = {
      paths: {
       "W2CLine0":new makerjs.paths.Line([xc-hc-hc-markShiftThree,yc], [xc-hc-hc-markShiftThree,yc-w2c]),
        "W2CLine1": new makerjs.paths.Line([xc,yc-w2c], [xc-hc-hc-dc-markShiftFour,yc-w2c]),//左上角
      }
    };
    var myFsAMakerHC = {      
      paths: {
       "HCLine0":new makerjs.paths.Line([xc,yc], [xc, yc+markShiftFour]),
       "HCLine1": new makerjs.paths.Line([xc-hc,yc], [xc-hc, yc+markShiftFour]),//左上角
       "HCLine2": new makerjs.paths.Line([xc,yc+markShiftTwo], [xc-hc,yc+markShiftTwo]),//左上角
      }
    };
    var myFsAMakerH1C = {    
      paths: {
       "H1CLine0":new makerjs.paths.Line([xc-h1c,yc-w1c], [xc-h1c, yc-w1c-dc/2-markShiftFour]),
       "H1CLine1": new makerjs.paths.Line([xc,yc-w2c-markShift], [xc-h1c,yc-w2c-markShift]),//左上角
      }
    };
    var myFsAMakerR2C = {    
      paths: {
      //  "R2CLine1": new makerjs.paths.Line([xc-w2,yc], [xc-w2, yc-r2-markShiftFour]),//左上角
       "R2CLine2": new makerjs.paths.Line([xc,yc-Ca+markShiftTwo], [xc-Chd,yc-Ca]),//左上角
      }
    };
    var myFsAMakerR1C = {    
      paths: {
       "R1CLine1": new makerjs.paths.Line([xc-Chd,yc-wc], [xc-Chd-markShift,yc-wc-markShift]),//左上角
      }
    };
    var myFsAMakerDC = {    
      paths: {
       "DCLine1": new makerjs.paths.Line([xc-h1c,yc-w1c], [xc-h1c-dc-markShiftFour-markHolesOneD,yc-w1c-markShift-markHolesOneD]),//左上角
      }
    };
       
  /**************************************************** */

  
  makerjs.model.addCaption(myFsAMakerWC, TxtWc, [xc-hc-markShiftThree,yc-wc], [xc-hc-markShiftThree,yc]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1C, TxtW1c, [xc-hc-dc-markShiftThree,yc-w1c], [xc-hc-dc-markShiftThree,yc]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2C, TxtW2c, [xc-hc-hc-dc-markShiftFour,yc-w2c], [xc-hc-hc-dc-markShiftFour,yc]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHC, TxtHc, [xc-hc,yc+markShiftFour], [xc,yc+markShiftFour]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1C, TxtH1c, [xc-h1c,yc-w2c-markShiftThree], [xc,yc-w2c-markShiftThree]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2C, TxtR2c, [xc-Chd+markShift,yc-Ca+markShift], [xc-Chd+markShiftThree,yc-Ca+markShiftThree]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1C, TxtR1c, [xc-Chd-markShift,yc-wc-markShift], [xc-Chd,yc-wc]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDC, TxtDc, [xc-h1c-dc-markShiftFour-markHolesOneD,yc-w1c-markShift-markHolesOneD],[xc-h1c-dc-markShiftFour-markHolesOneD,yc-w1c-markHolesOneD-markShiftFour]);//D文字标注  
    

  /******************************************************** */
    
      var markers = {
        myFsAMakerWC,
        myFsAMakerW1C,
         myFsAMakerW2C,
         myFsAMakerHC,
        myFsAMakerH1C,
         myFsAMakerR2C,
        myFsAMakerR1C,
        myFsAMakerDC,
      }
  } else if (area == "G") {
  
    /****************** G   ************** */
    var myFsAMakerWG = {
      paths: {
        "WGLine0": new makerjs.paths.Line([xg+hg,yg], [xg+hg+markShiftThree,yg]),//左上角
        "WGLine1": new makerjs.paths.Line([xg+hg,yg+wg], [xg+hg+markShiftThree,yg+wg]),//左上角
        "WGLine2":new makerjs.paths.Line([xg+hg+markShift,yg], [xg+hg+markShift,yg+wg]),
      }
    };
    var myFsAMakerW1G = {
      paths: {
        "W1GLine0":new makerjs.paths.Line([xg+hg+dg+markShift,yg], [xg+hg+dg+markShift,yg+w1g]),
        "W1GLine1": new makerjs.paths.Line([xg+h1g,yg+w1g], [xg+h1g+dg+markShiftThree,yg+w1g]),//左上角
      }
    };
    var myFsAMakerW2G = {
      paths: {
        "W2GLine0":new makerjs.paths.Line([xg+hg+hg+markShiftThree,yg], [xg+hg+hg+markShiftThree,yg+w2g]),
        "W2GLine1": new makerjs.paths.Line([xg,yg+w2g], [xg+hg+hg+dg+markShiftFour,yg+w2g]),//左上角
      }
    };
    var myFsAMakerHG = {      
      paths: {
        "HGLine0":new makerjs.paths.Line([xg,yg], [xg, yg-markShiftFour]),
        "HGLine1": new makerjs.paths.Line([xg+hg,yg], [xg+hg, yg-markShiftFour]),//左上角
        "HGLine2": new makerjs.paths.Line([xg,yg-markShiftTwo], [xg+hg,yg-markShiftTwo]),//左上角
      }
    };
    var myFsAMakerH1G = {    
      paths: {
        "H1GLine0":new makerjs.paths.Line([xg+h1g,yg+w1g], [xg+h1g, yg+w1g+dg/2+markShiftFour]),
        "H1GLine1": new makerjs.paths.Line([xg,yg+w2g+markShift], [xg+h1g,yg+w2g+markShift]),//左上角
      }
    };
    var myFsAMakerR2G = {    
      paths: {
        "R2GLine1": new makerjs.paths.Line([xg,yg+w2g], [xg+r2g+markShiftFour, yg+w2g]),//左上角
        "R2GLine2": new makerjs.paths.Line([xg,yg+Ga-markShiftTwo], [xg+Ghd,yg+Ga]),//左上角
      }
    };
    var myFsAMakerR1G = {    
      paths: {
        "R1GLine1": new makerjs.paths.Line([xg+Ghd,yg+wg], [xg+Ghd+markShift,yg+wg+markShift]),//左上角
      }
    };
    var myFsAMakerDG = {    
      paths: {
        "DGLine1": new makerjs.paths.Line([xg+h1g,yg+w1g], [xg+h1g+dg+markShiftFour+markHolesOneD,yg+w1g+markShift+markHolesOneD]),//左上角
      }
    };

    
    /**************************************************** */
  
  /******************************************************** */
  makerjs.model.addCaption(myFsAMakerWG, TxtWg, [xg+hg+markShiftThree,yg], [xg+hg+markShiftThree,yg+wg]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1G, TxtW1g, [xg+hg+dg+markShiftThree,yg], [xg+hg+dg+markShiftThree,yg+w1g]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2G, TxtW2g, [xg+hg+hg+dg+markShiftFour,yg], [xg+hg+hg+dg+markShiftFour,yg+w2g]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHG, TxtHg, [xg,yg-markShiftFour], [xg+hg,yg-markShiftFour]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1G, TxtH1g, [xg,yg+w2g+markShiftThree], [xg+h1g,yg+w2g+markShiftThree]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2G, TxtR2g, [xg+Ghd-markShiftThree,yg+Ga-markShiftThree], [xg+Ghd-markShift,yg+Ga-markShift]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1G, TxtR1g, [xg+Ghd,yg+wg], [xg+Ghd+markShift,yg+wg+markShift]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDG, TxtDg, [xg+h1g+dg+markShiftFour+markHolesOneD,yg+w1g+markShift+markHolesOneD],[xg+h1g+dg+markShiftFour+markHolesOneD,yg+w1g+markHolesOneD+markShiftFour]);//D文字标注  
    
  /******************************************************** */
  
/********************************************* */  
      var markers = {
        myFsAMakerWG,
        myFsAMakerW1G,
         myFsAMakerW2G,
         myFsAMakerHG,
        myFsAMakerH1G,
         myFsAMakerR2G,
        myFsAMakerR1G,
        myFsAMakerDG,
      }
    
  } else if (area == "I") {
  
    /************************   I  ******************* */
    var myFsAMakerWI = {
      paths: {
       // "WILine0": new makerjs.paths.Line([xi,yi+hi], [xi,yi+hi+markShiftThree]),//左上角
        "WILine1": new makerjs.paths.Line([xi-hi,yi+wi], [xi-hi-markShiftThree,yi+wi]),//左上角
        "WILine2":new makerjs.paths.Line([xi-hi-markShift,yi], [xi-hi-markShift,yi+wi]),
      }
    };
    var myFsAMakerW1I = {
      paths: {
       "W1ILine0":new makerjs.paths.Line([xi-hi-di-markShift,yi], [xi-hi-di-markShift,yi+w1i]),
       "W1ILine1": new makerjs.paths.Line([xi-h1i,yi+w1i], [xi-h1i-di-markShiftThree,yi+w1i]),//左上角
      }
    };



    var myFsAMakerW2I = {
      paths: {
       "W2ILine0":new makerjs.paths.Line([xi-hi-hi-markShiftThree,yi], [xi-hi-hi-markShiftThree,yi+w2i]),
        "W2ILine1": new makerjs.paths.Line([xi,yi+w2i], [xi-hi-hi-di-markShiftFour,yi+w2i]),//左上角
      }
    };
    var myFsAMakerHI = {      
      paths: {
       "HILine0":new makerjs.paths.Line([xi,yi], [xi, yi-markShiftFour]),
       "HILine1": new makerjs.paths.Line([xi-hi,yi], [xi-hi, yi-markShiftFour]),//左上角
       "HILine2": new makerjs.paths.Line([xi,yi-markShiftTwo], [xi-hi,yi-markShiftTwo]),//左上角
      }
    };
    var myFsAMakerH1I = {    
      paths: {
       "H1ILine0":new makerjs.paths.Line([xi-h1i,yi+w1i], [xi-h1i, yi+w1i+di/2+markShiftFour]),
       "H1ILine1": new makerjs.paths.Line([xi,yi+w2i+markShift], [xi-h1i,yi+w2i+markShift]),//左上角
      }
    };
    var myFsAMakerR2I = {    
      paths: {
      //  "R2ILine1": new makerjs.paths.Line([xi-w2,yi], [xi-w2, yi-r2-markShiftFour]),//左上角
       "R2ILine2": new makerjs.paths.Line([xi,yi+Ia-markShiftTwo], [xi-Ihd,yi+Ia]),//左上角
      }
    };
    var myFsAMakerR1I = {    
      paths: {
       "R1ILine1": new makerjs.paths.Line([xi-Ihd,yi+wi], [xi-Ihd-markShift,yi+wi+markShift]),//左上角
      }
    };
    var myFsAMakerDI = {    
      paths: {
       "DILine1": new makerjs.paths.Line([xi-h1i,yi+w1i], [xi-h1i-di-markShiftFour-markHolesOneD,yi+w1i+markShift+markHolesOneD]),//左上角
      }
    };

     
  /******************************************************** */
  
  makerjs.model.addCaption(myFsAMakerWI, TxtWi, [xi-hi-markShiftThree,yi], [xi-hi-markShiftThree,yi+wi]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1I, TxtW1i, [xi-hi-di-markShiftThree,yi], [xi-hi-di-markShiftThree,yi+w1i]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2I, TxtW2i, [xi-hi-hi-di-markShiftFour,yi], [xi-hi-hi-di-markShiftFour,yi+w2i]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHI, TxtHi, [xi-hi,yi-markShiftFour], [xi,yi-markShiftFour]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1I, TxtH1i, [xi-h1i,yi+w2i+markShiftThree], [xi,yi+w2i+markShiftThree]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2I, TxtR2i, [xi-Ihd+markShift,yi+Ia-markShift], [xi-Ihd+markShiftThree,yi+Ia-markShiftThree]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1I, TxtR1i, [xi-Ihd-markShift,yi+wi+markShift], [xi-Ihd,yi+wi]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDI, TxtDi,[xi-h1i-di-markShiftFour-markHolesOneD,yi+w1i+markHolesOneD+markShiftFour], [xi-h1i-di-markShiftFour-markHolesOneD,yi+w1i+markShift+markHolesOneD]);//D文字标注  
   
/***************************************************/  
      var markers = {
         myFsAMakerWI,
         myFsAMakerW1I,
         myFsAMakerW2I,
         myFsAMakerHI,
         myFsAMakerH1I,
         myFsAMakerR2I,
         myFsAMakerR1I,
         myFsAMakerDI,
      }   
    
  } else if (area == "AC") {
    var myFsAMakerWA = {
      paths: {
        "WALine0": new makerjs.paths.Line([xa+ha,ya], [xa+ha+markShiftThree,ya]),//左上角
        "WALine1": new makerjs.paths.Line([xa+ha,ya-wa], [xa+ha+markShiftThree,ya-wa]),//左上角
        "WALine2":new makerjs.paths.Line([xa+ha+markShift,ya], [xa+ha+markShift,ya-wa]),
      }
    };
    var myFsAMakerW1A = {
      paths: {
       "W1ALine0":new makerjs.paths.Line([xa+ha+da+markShift,ya], [xa+ha+da+markShift,ya-w1a]),
       "W1ALine1": new makerjs.paths.Line([xa+h1a,ya-w1a], [xa+h1a+da+markShiftThree,ya-w1a]),//左上角
      }
    };
    var myFsAMakerW2A = {
      paths: {
       "W2ALine0":new makerjs.paths.Line([xa+ha+ha+markShiftThree,ya], [xa+ha+ha+markShiftThree,ya-w2a]),
        "W2ALine1": new makerjs.paths.Line([xa,ya-w2a], [xa+ha+ha+markShiftFour,ya-w2a]),//左上角
      }
    };
    var myFsAMakerHA = {
      
      paths: {
       "HALine0":new makerjs.paths.Line([xa,ya], [xa, ya+markShiftFour]),
       "HALine1": new makerjs.paths.Line([xa+ha,ya], [xa+ha, ya+markShiftFour]),//左上角
       "HALine2": new makerjs.paths.Line([xa,ya+markShiftTwo], [xa+ha,ya+markShiftTwo]),//左上角
      }
    };
    var myFsAMakerH1A = {    
      paths: {
       "H1ALine0":new makerjs.paths.Line([xa+h1a,ya-w1a], [xa+h1a, ya-w1a-da/2-markShiftFour]),
       "H1ALine1": new makerjs.paths.Line([xa,ya-w2a-markShift], [xa+h1a,ya-w2a-markShift]),//左上角
      }
    };
 
    var myFsAMakerR2A = {    
      paths: {
       "R2ALine1": new makerjs.paths.Line([xa,ya-w2a], [xa+r2a+markShiftFour, ya-w2a]),//左上角
       "R2ALine2": new makerjs.paths.Line([xa,ya-Aa+markShiftTwo], [xa+Ahd,ya-Aa]),//左上角
      }
    };
    var myFsAMakerR1A = {    
      paths: {
       "R1ALine1": new makerjs.paths.Line([xa+Ahd,ya-wa], [xa+Ahd+markShift,ya-wa-markShift]),//左上角
      }
    };
    var myFsAMakerDA = {    
      paths: {
       "DALine1": new makerjs.paths.Line([xa+h1a,ya-w1a], [xa+h1a+da+markShiftFour+markHolesOneD,ya-w1a-markShift-markHolesOneD]),//左上角
      }
    };
    /**************************************************** */
      /*****************  C  *********** */
      var myFsAMakerWC = {
        paths: {
          "WCLine0": new makerjs.paths.Line([xc-hc,yc], [xc-hc-markShiftThree,yc]),//左上角
          "WCLine1": new makerjs.paths.Line([xc-hc,yc-wc], [xc-hc-markShiftThree,yc-wc]),//左上角
          "WCLine2":new makerjs.paths.Line([xc-hc-markShift,yc-wc], [xc-hc-markShift,yc]),
        }
      };
      var myFsAMakerW1C = {
        paths: {
         "W1CLine0":new makerjs.paths.Line([xc-hc-dc-markShift,yc-w1c], [xc-hc-dc-markShift,yc]),
         "W1CLine1": new makerjs.paths.Line([xc-h1c,yc-w1c], [xc-h1c-dc-markShiftThree,yc-w1c]),//左上角
        }
      };
      var myFsAMakerW2C = {
        paths: {
         "W2CLine0":new makerjs.paths.Line([xc-hc-hc-markShiftThree,yc], [xc-hc-hc-markShiftThree,yc-w2c]),
          "W2CLine1": new makerjs.paths.Line([xc,yc-w2c], [xc-hc-hc-dc-markShiftFour,yc-w2c]),//左上角
        }
      };
      var myFsAMakerHC = {      
        paths: {
         "HCLine0":new makerjs.paths.Line([xc,yc], [xc, yc+markShiftFour]),
         "HCLine1": new makerjs.paths.Line([xc-hc,yc], [xc-hc, yc+markShiftFour]),//左上角
         "HCLine2": new makerjs.paths.Line([xc,yc+markShiftTwo], [xc-hc,yc+markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1C = {    
        paths: {
         "H1CLine0":new makerjs.paths.Line([xc-h1c,yc-w1c], [xc-h1c, yc-w1c-dc/2-markShiftFour]),
         "H1CLine1": new makerjs.paths.Line([xc,yc-w2c-markShift], [xc-h1c,yc-w2c-markShift]),//左上角
        }
      };
      var myFsAMakerR2C = {    
        paths: {
        //  "R2CLine1": new makerjs.paths.Line([xc-w2,yc], [xc-w2, yc-r2-markShiftFour]),//左上角
         "R2CLine2": new makerjs.paths.Line([xc,yc-Ca+markShiftTwo], [xc-Chd,yc-Ca]),//左上角
        }
      };
      var myFsAMakerR1C = {    
        paths: {
         "R1CLine1": new makerjs.paths.Line([xc-Chd,yc-wc], [xc-Chd-markShift,yc-wc-markShift]),//左上角
        }
      };
      var myFsAMakerDC = {    
        paths: {
         "DCLine1": new makerjs.paths.Line([xc-h1c,yc-w1c], [xc-h1c-dc-markShiftFour-markHolesOneD,yc-w1c-markShift-markHolesOneD]),//左上角
        }
      };
     
    
    makerjs.model.addCaption(myFsAMakerWC, TxtWc, [xc-hc-markShiftThree,yc-wc], [xc-hc-markShiftThree,yc]);//半径文字  
    makerjs.model.addCaption(myFsAMakerW1C, TxtW1c, [xc-hc-dc-markShiftThree,yc-w1c], [xc-hc-dc-markShiftThree,yc]);//W1文字标注 
    makerjs.model.addCaption(myFsAMakerW2C, TxtW2c, [xc-hc-hc-dc-markShiftFour,yc-w2c], [xc-hc-hc-dc-markShiftFour,yc]);//W1文字标注
    makerjs.model.addCaption(myFsAMakerHC, TxtHc, [xc-hc,yc+markShiftFour], [xc,yc+markShiftFour]);//H文字标注
    makerjs.model.addCaption(myFsAMakerH1C, TxtH1c, [xc-h1c,yc-w2c-markShiftThree], [xc,yc-w2c-markShiftThree]);//H1文字标注
    makerjs.model.addCaption(myFsAMakerR2C, TxtR2c, [xc-Chd+markShift,yc-Ca+markShift], [xc-Chd+markShiftThree,yc-Ca+markShiftThree]);//R2文字标注
    makerjs.model.addCaption(myFsAMakerR1C, TxtR1c, [xc-Chd-markShift,yc-wc-markShift], [xc-Chd,yc-wc]);//R1文字标注
    makerjs.model.addCaption(myFsAMakerDC, TxtDc, [xc-h1c-dc-markShiftFour-markHolesOneD,yc-w1c-markShift-markHolesOneD],[xc-h1c-dc-markShiftFour-markHolesOneD,yc-w1c-markHolesOneD-markShiftFour]);//D文字标注  
      
  
    /******************************************************** */
    
  makerjs.model.addCaption(myFsAMakerWA, TxtWa, [xa+ha+markShiftThree,ya], [xa+ha+markShiftThree,ya-wa]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1A, TxtW1a, [xa+ha+da+markShiftThree,ya], [xa+ha+da+markShiftThree,ya-w1a]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2A, TxtW2a, [xa+ha+ha+da+markShiftFour,ya], [xa+ha+ha+da+markShiftFour,ya-w2a]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHA, TxtHa, [xa,ya+markShiftFour], [xa+ha,ya+markShiftFour]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1A, TxtH1a, [xa,ya-w2a-markShiftThree], [xa+h1a,ya-w2a-markShiftThree]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2A, TxtR2a,[xa+Ahd-markShiftThree,ya-Aa+markShiftThree], [xa+Ahd-markShift,ya-Aa+markShift]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1A, TxtR1a, [xa+Ahd,ya-wa], [xa+Ahd+markShift,ya-wa-markShift]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDA, TxtDa, [xa+h1a+da+markShiftFour+markHolesOneD,ya-w1a-markShift-markHolesOneD],[xa+h1a+da+markShiftFour+markHolesOneD,ya-w1a-markHolesOneD-markShiftFour]);//D文字标注  
   
  /**************************************************** */

  /******************************************************** */
  var markers = {
    /**A */
        myFsAMakerWA,
        myFsAMakerW1A,
         myFsAMakerW2A,
         myFsAMakerHA,
        myFsAMakerH1A,
         myFsAMakerR2A,
        myFsAMakerR1A,
        myFsAMakerDA,
        /**C */
        myFsAMakerWC,
        myFsAMakerW1C,
         myFsAMakerW2C,
         myFsAMakerHC,
        myFsAMakerH1C,
         myFsAMakerR2C,
        myFsAMakerR1C,
        myFsAMakerDC,
        /** G*/        
       
      }
  

    
  } else if (area == "AG") {
    var myFsAMakerWA = {
      paths: {
        "WALine0": new makerjs.paths.Line([xa+ha,ya], [xa+ha+markShiftThree,ya]),//左上角
        "WALine1": new makerjs.paths.Line([xa+ha,ya-wa], [xa+ha+markShiftThree,ya-wa]),//左上角
        "WALine2":new makerjs.paths.Line([xa+ha+markShift,ya], [xa+ha+markShift,ya-wa]),
      }
    };
    var myFsAMakerW1A = {
      paths: {
       "W1ALine0":new makerjs.paths.Line([xa+ha+da+markShift,ya], [xa+ha+da+markShift,ya-w1a]),
       "W1ALine1": new makerjs.paths.Line([xa+h1a,ya-w1a], [xa+h1a+da+markShiftThree,ya-w1a]),//左上角
      }
    };
    var myFsAMakerW2A = {
      paths: {
       "W2ALine0":new makerjs.paths.Line([xa+ha+ha+markShiftThree,ya], [xa+ha+ha+markShiftThree,ya-w2a]),
        "W2ALine1": new makerjs.paths.Line([xa,ya-w2a], [xa+ha+ha+markShiftFour,ya-w2a]),//左上角
      }
    };
    var myFsAMakerHA = {
      
      paths: {
       "HALine0":new makerjs.paths.Line([xa,ya], [xa, ya+markShiftFour]),
       "HALine1": new makerjs.paths.Line([xa+ha,ya], [xa+ha, ya+markShiftFour]),//左上角
       "HALine2": new makerjs.paths.Line([xa,ya+markShiftTwo], [xa+ha,ya+markShiftTwo]),//左上角
      }
    };
    var myFsAMakerH1A = {    
      paths: {
       "H1ALine0":new makerjs.paths.Line([xa+h1a,ya-w1a], [xa+h1a, ya-w1a-da/2-markShiftFour]),
       "H1ALine1": new makerjs.paths.Line([xa,ya-w2a-markShift], [xa+h1a,ya-w2a-markShift]),//左上角
      }
    };
 
    var myFsAMakerR2A = {    
      paths: {
       "R2ALine1": new makerjs.paths.Line([xa,ya-w2a], [xa+r2a+markShiftFour, ya-w2a]),//左上角
       "R2ALine2": new makerjs.paths.Line([xa,ya-Aa+markShiftTwo], [xa+Ahd,ya-Aa]),//左上角
      }
    };
    var myFsAMakerR1A = {    
      paths: {
       "R1ALine1": new makerjs.paths.Line([xa+Ahd,ya-wa], [xa+Ahd+markShift,ya-wa-markShift]),//左上角
      }
    };
    var myFsAMakerDA = {    
      paths: {
       "DALine1": new makerjs.paths.Line([xa+h1a,ya-w1a], [xa+h1a+da+markShiftFour+markHolesOneD,ya-w1a-markShift-markHolesOneD]),//左上角
      }
    };
    /**************************************************** */
    /****************** G   ************** */
    var myFsAMakerWG = {
      paths: {
        "WGLine0": new makerjs.paths.Line([xg+hg,yg], [xg+hg+markShiftThree,yg]),//左上角
        "WGLine1": new makerjs.paths.Line([xg+hg,yg+wg], [xg+hg+markShiftThree,yg+wg]),//左上角
        "WGLine2":new makerjs.paths.Line([xg+hg+markShift,yg], [xg+hg+markShift,yg+wg]),
      }
    };
    var myFsAMakerW1G = {
      paths: {
        "W1GLine0":new makerjs.paths.Line([xg+hg+dg+markShift,yg], [xg+hg+dg+markShift,yg+w1g]),
        "W1GLine1": new makerjs.paths.Line([xg+h1g,yg+w1g], [xg+h1g+dg+markShiftThree,yg+w1g]),//左上角
      }
    };
    var myFsAMakerW2G = {
      paths: {
        "W2GLine0":new makerjs.paths.Line([xg+hg+hg+markShiftThree,yg], [xg+hg+hg+markShiftThree,yg+w2g]),
        "W2GLine1": new makerjs.paths.Line([xg,yg+w2g], [xg+hg+hg+dg+markShiftFour,yg+w2g]),//左上角
      }
    };
    var myFsAMakerHG = {      
      paths: {
        "HGLine0":new makerjs.paths.Line([xg,yg], [xg, yg-markShiftFour]),
        "HGLine1": new makerjs.paths.Line([xg+hg,yg], [xg+hg, yg-markShiftFour]),//左上角
        "HGLine2": new makerjs.paths.Line([xg,yg-markShiftTwo], [xg+hg,yg-markShiftTwo]),//左上角
      }
    };
    var myFsAMakerH1G = {    
      paths: {
        "H1GLine0":new makerjs.paths.Line([xg+h1g,yg+w1g], [xg+h1g, yg+w1g+dg/2+markShiftFour]),
        "H1GLine1": new makerjs.paths.Line([xg,yg+w2g+markShift], [xg+h1g,yg+w2g+markShift]),//左上角
      }
    };
    var myFsAMakerR2G = {    
      paths: {
        "R2GLine1": new makerjs.paths.Line([xg,yg+w2g], [xg+r2g+markShiftFour, yg+w2g]),//左上角
        "R2GLine2": new makerjs.paths.Line([xg,yg+Ga-markShiftTwo], [xg+Ghd,yg+Ga]),//左上角
      }
    };
    var myFsAMakerR1G = {    
      paths: {
        "R1GLine1": new makerjs.paths.Line([xg+Ghd,yg+wg], [xg+Ghd+markShift,yg+wg+markShift]),//左上角
      }
    };
    var myFsAMakerDG = {    
      paths: {
        "DGLine1": new makerjs.paths.Line([xg+h1g,yg+w1g], [xg+h1g+dg+markShiftFour+markHolesOneD,yg+w1g+markShift+markHolesOneD]),//左上角
      }
    };

  /******************************************************** */
  makerjs.model.addCaption(myFsAMakerWG, TxtWg, [xg+hg+markShiftThree,yg], [xg+hg+markShiftThree,yg+wg]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1G, TxtW1g, [xg+hg+dg+markShiftThree,yg], [xg+hg+dg+markShiftThree,yg+w1g]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2G, TxtW2g, [xg+hg+hg+dg+markShiftFour,yg], [xg+hg+hg+dg+markShiftFour,yg+w2g]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHG, TxtHg, [xg,yg-markShiftFour], [xg+hg,yg-markShiftFour]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1G, TxtH1g, [xg,yg+w2g+markShiftThree], [xg+h1g,yg+w2g+markShiftThree]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2G, TxtR2g, [xg+Ghd-markShiftThree,yg+Ga-markShiftThree], [xg+Ghd-markShift,yg+Ga-markShift]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1G, TxtR1g, [xg+Ghd,yg+wg], [xg+Ghd+markShift,yg+wg+markShift]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDG, TxtDg, [xg+h1g+dg+markShiftFour+markHolesOneD,yg+w1g+markShift+markHolesOneD],[xg+h1g+dg+markShiftFour+markHolesOneD,yg+w1g+markHolesOneD+markShiftFour]);//D文字标注  
    
  
    /******************************************************** */
    
  makerjs.model.addCaption(myFsAMakerWA, TxtWa, [xa+ha+markShiftThree,ya], [xa+ha+markShiftThree,ya-wa]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1A, TxtW1a, [xa+ha+da+markShiftThree,ya], [xa+ha+da+markShiftThree,ya-w1a]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2A, TxtW2a, [xa+ha+ha+da+markShiftFour,ya], [xa+ha+ha+da+markShiftFour,ya-w2a]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHA, TxtHa, [xa,ya+markShiftFour], [xa+ha,ya+markShiftFour]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1A, TxtH1a, [xa,ya-w2a-markShiftThree], [xa+h1a,ya-w2a-markShiftThree]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2A, TxtR2a,[xa+Ahd-markShiftThree,ya-Aa+markShiftThree], [xa+Ahd-markShift,ya-Aa+markShift]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1A, TxtR1a, [xa+Ahd,ya-wa], [xa+Ahd+markShift,ya-wa-markShift]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDA, TxtDa, [xa+h1a+da+markShiftFour+markHolesOneD,ya-w1a-markShift-markHolesOneD],[xa+h1a+da+markShiftFour+markHolesOneD,ya-w1a-markHolesOneD-markShiftFour]);//D文字标注  
   
  /**************************************************** */

  /******************************************************** */
  var markers = {
    /**A */
        myFsAMakerWA,
        myFsAMakerW1A,
         myFsAMakerW2A,
         myFsAMakerHA,
        myFsAMakerH1A,
         myFsAMakerR2A,
        myFsAMakerR1A,
        myFsAMakerDA,
        /**C */
        /** G*/        
        myFsAMakerWG,
        myFsAMakerW1G,
         myFsAMakerW2G,
         myFsAMakerHG,
        myFsAMakerH1G,
         myFsAMakerR2G,
        myFsAMakerR1G,
        myFsAMakerDG,
        /**I */
      }
  

    // var myFilletMark = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xahx, xahy], [xawx, xawy], [xc, yc],[xi, yi], [xgwx, xgwy]]);
  } else if (area == "AI") {
    var myFsAMakerWA = {
      paths: {
        "WALine0": new makerjs.paths.Line([xa+ha,ya], [xa+ha+markShiftThree,ya]),//左上角
        "WALine1": new makerjs.paths.Line([xa+ha,ya-wa], [xa+ha+markShiftThree,ya-wa]),//左上角
        "WALine2":new makerjs.paths.Line([xa+ha+markShift,ya], [xa+ha+markShift,ya-wa]),
      }
    };
    var myFsAMakerW1A = {
      paths: {
       "W1ALine0":new makerjs.paths.Line([xa+ha+da+markShift,ya], [xa+ha+da+markShift,ya-w1a]),
       "W1ALine1": new makerjs.paths.Line([xa+h1a,ya-w1a], [xa+h1a+da+markShiftThree,ya-w1a]),//左上角
      }
    };
    var myFsAMakerW2A = {
      paths: {
       "W2ALine0":new makerjs.paths.Line([xa+ha+ha+markShiftThree,ya], [xa+ha+ha+markShiftThree,ya-w2a]),
        "W2ALine1": new makerjs.paths.Line([xa,ya-w2a], [xa+ha+ha+markShiftFour,ya-w2a]),//左上角
      }
    };
    var myFsAMakerHA = {
      
      paths: {
       "HALine0":new makerjs.paths.Line([xa,ya], [xa, ya+markShiftFour]),
       "HALine1": new makerjs.paths.Line([xa+ha,ya], [xa+ha, ya+markShiftFour]),//左上角
       "HALine2": new makerjs.paths.Line([xa,ya+markShiftTwo], [xa+ha,ya+markShiftTwo]),//左上角
      }
    };
    var myFsAMakerH1A = {    
      paths: {
       "H1ALine0":new makerjs.paths.Line([xa+h1a,ya-w1a], [xa+h1a, ya-w1a-da/2-markShiftFour]),
       "H1ALine1": new makerjs.paths.Line([xa,ya-w2a-markShift], [xa+h1a,ya-w2a-markShift]),//左上角
      }
    };
 
    var myFsAMakerR2A = {    
      paths: {
       "R2ALine1": new makerjs.paths.Line([xa,ya-w2a], [xa+r2a+markShiftFour, ya-w2a]),//左上角
       "R2ALine2": new makerjs.paths.Line([xa,ya-Aa+markShiftTwo], [xa+Ahd,ya-Aa]),//左上角
      }
    };
    var myFsAMakerR1A = {    
      paths: {
       "R1ALine1": new makerjs.paths.Line([xa+Ahd,ya-wa], [xa+Ahd+markShift,ya-wa-markShift]),//左上角
      }
    };
    var myFsAMakerDA = {    
      paths: {
       "DALine1": new makerjs.paths.Line([xa+h1a,ya-w1a], [xa+h1a+da+markShiftFour+markHolesOneD,ya-w1a-markShift-markHolesOneD]),//左上角
      }
    }; 
    /************************   I  ******************* */
    var myFsAMakerWI = {
      paths: {
       // "WILine0": new makerjs.paths.Line([xi,yi+hi], [xi,yi+hi+markShiftThree]),//左上角
        "WILine1": new makerjs.paths.Line([xi-hi,yi+wi], [xi-hi-markShiftThree,yi+wi]),//左上角
        "WILine2":new makerjs.paths.Line([xi-hi-markShift,yi], [xi-hi-markShift,yi+wi]),
      }
    };
    var myFsAMakerW1I = {
      paths: {
       "W1ILine0":new makerjs.paths.Line([xi-hi-di-markShift,yi], [xi-hi-di-markShift,yi+w1i]),
       "W1ILine1": new makerjs.paths.Line([xi-h1i,yi+w1i], [xi-h1i-di-markShiftThree,yi+w1i]),//左上角
      }
    };
    var myFsAMakerW2I = {
      paths: {
       "W2ILine0":new makerjs.paths.Line([xi-hi-hi-markShiftThree,yi], [xi-hi-hi-markShiftThree,yi+w2i]),
        "W2ILine1": new makerjs.paths.Line([xi,yi+w2i], [xi-hi-hi-di-markShiftFour,yi+w2i]),//左上角
      }
    };
    var myFsAMakerHI = {      
      paths: {
       "HILine0":new makerjs.paths.Line([xi,yi], [xi, yi-markShiftFour]),
       "HILine1": new makerjs.paths.Line([xi-hi,yi], [xi-hi, yi-markShiftFour]),//左上角
       "HILine2": new makerjs.paths.Line([xi,yi-markShiftTwo], [xi-hi,yi-markShiftTwo]),//左上角
      }
    };
    var myFsAMakerH1I = {    
      paths: {
       "H1ILine0":new makerjs.paths.Line([xi-h1i,yi+w1i], [xi-h1i, yi+w1i+di/2+markShiftFour]),
       "H1ILine1": new makerjs.paths.Line([xi,yi+w2i+markShift], [xi-h1i,yi+w2i+markShift]),//左上角
      }
    };
    var myFsAMakerR2I = {    
      paths: {
      //  "R2ILine1": new makerjs.paths.Line([xi-w2,yi], [xi-w2, yi-r2-markShiftFour]),//左上角
       "R2ILine2": new makerjs.paths.Line([xi,yi+Ia-markShiftTwo], [xi-Ihd,yi+Ia]),//左上角
      }
    };
    var myFsAMakerR1I = {    
      paths: {
       "R1ILine1": new makerjs.paths.Line([xi-Ihd,yi+wi], [xi-Ihd-markShift,yi+wi+markShift]),//左上角
      }
    };
    var myFsAMakerDI = {    
      paths: {
       "DILine1": new makerjs.paths.Line([xi-h1i,yi+w1i], [xi-h1i-di-markShiftFour-markHolesOneD,yi+w1i+markShift+markHolesOneD]),//左上角
      }
    };
     
  /******************************************************** */  
  makerjs.model.addCaption(myFsAMakerWI, TxtWi, [xi-hi-markShiftThree,yi], [xi-hi-markShiftThree,yi+wi]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1I, TxtW1i, [xi-hi-di-markShiftThree,yi], [xi-hi-di-markShiftThree,yi+w1i]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2I, TxtW2i, [xi-hi-hi-di-markShiftFour,yi], [xi-hi-hi-di-markShiftFour,yi+w2i]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHI, TxtHi, [xi-hi,yi-markShiftFour], [xi,yi-markShiftFour]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1I, TxtH1i, [xi-h1i,yi+w2i+markShiftThree], [xi,yi+w2i+markShiftThree]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2I, TxtR2i, [xi-Ihd+markShift,yi+Ia-markShift], [xi-Ihd+markShiftThree,yi+Ia-markShiftThree]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1I, TxtR1i, [xi-Ihd-markShift,yi+wi+markShift], [xi-Ihd,yi+wi]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDI, TxtDi,[xi-h1i-di-markShiftFour-markHolesOneD,yi+w1i+markHolesOneD+markShiftFour], [xi-h1i-di-markShiftFour-markHolesOneD,yi+w1i+markShift+markHolesOneD]);//D文字标注  
   
/***************************************************/  
    
  makerjs.model.addCaption(myFsAMakerWA, TxtWa, [xa+ha+markShiftThree,ya], [xa+ha+markShiftThree,ya-wa]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1A, TxtW1a, [xa+ha+da+markShiftThree,ya], [xa+ha+da+markShiftThree,ya-w1a]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2A, TxtW2a, [xa+ha+ha+da+markShiftFour,ya], [xa+ha+ha+da+markShiftFour,ya-w2a]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHA, TxtHa, [xa,ya+markShiftFour], [xa+ha,ya+markShiftFour]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1A, TxtH1a, [xa,ya-w2a-markShiftThree], [xa+h1a,ya-w2a-markShiftThree]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2A, TxtR2a,[xa+Ahd-markShiftThree,ya-Aa+markShiftThree], [xa+Ahd-markShift,ya-Aa+markShift]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1A, TxtR1a, [xa+Ahd,ya-wa], [xa+Ahd+markShift,ya-wa-markShift]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDA, TxtDa, [xa+h1a+da+markShiftFour+markHolesOneD,ya-w1a-markShift-markHolesOneD],[xa+h1a+da+markShiftFour+markHolesOneD,ya-w1a-markHolesOneD-markShiftFour]);//D文字标注  
   
  /**************************************************** */

  /******************************************************** */
  var markers = {
    /**A */
        myFsAMakerWA,
        myFsAMakerW1A,
         myFsAMakerW2A,
         myFsAMakerHA,
        myFsAMakerH1A,
         myFsAMakerR2A,
        myFsAMakerR1A,
        myFsAMakerDA,
        /**C */
        /**I */
        myFsAMakerWI,
        myFsAMakerW1I,
         myFsAMakerW2I,
         myFsAMakerHI,
        myFsAMakerH1I,
         myFsAMakerR2I,
        myFsAMakerR1I,
        myFsAMakerDI,
      }
  

    // var myFilletMark = new makerjs.models.ConnectTheDots(true, [[xg, yg], [xahx, xahy], [xawx, xawy], [xc, yc], [xihx, xihy], [xiwx, xiwy]]);
  } else if (area == "CG") {
      /*****************  C  *********** */
      var myFsAMakerWC = {
        paths: {
          "WCLine0": new makerjs.paths.Line([xc-hc,yc], [xc-hc-markShiftThree,yc]),//左上角
          "WCLine1": new makerjs.paths.Line([xc-hc,yc-wc], [xc-hc-markShiftThree,yc-wc]),//左上角
          "WCLine2":new makerjs.paths.Line([xc-hc-markShift,yc-wc], [xc-hc-markShift,yc]),
        }
      };
      var myFsAMakerW1C = {
        paths: {
         "W1CLine0":new makerjs.paths.Line([xc-hc-dc-markShift,yc-w1c], [xc-hc-dc-markShift,yc]),
         "W1CLine1": new makerjs.paths.Line([xc-h1c,yc-w1c], [xc-h1c-dc-markShiftThree,yc-w1c]),//左上角
        }
      };
      var myFsAMakerW2C = {
        paths: {
         "W2CLine0":new makerjs.paths.Line([xc-hc-hc-markShiftThree,yc], [xc-hc-hc-markShiftThree,yc-w2c]),
          "W2CLine1": new makerjs.paths.Line([xc,yc-w2c], [xc-hc-hc-dc-markShiftFour,yc-w2c]),//左上角
        }
      };
      var myFsAMakerHC = {      
        paths: {
         "HCLine0":new makerjs.paths.Line([xc,yc], [xc, yc+markShiftFour]),
         "HCLine1": new makerjs.paths.Line([xc-hc,yc], [xc-hc, yc+markShiftFour]),//左上角
         "HCLine2": new makerjs.paths.Line([xc,yc+markShiftTwo], [xc-hc,yc+markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1C = {    
        paths: {
         "H1CLine0":new makerjs.paths.Line([xc-h1c,yc-w1c], [xc-h1c, yc-w1c-dc/2-markShiftFour]),
         "H1CLine1": new makerjs.paths.Line([xc,yc-w2c-markShift], [xc-h1c,yc-w2c-markShift]),//左上角
        }
      };
      var myFsAMakerR2C = {    
        paths: {
        //  "R2CLine1": new makerjs.paths.Line([xc-w2,yc], [xc-w2, yc-r2-markShiftFour]),//左上角
         "R2CLine2": new makerjs.paths.Line([xc,yc-Ca+markShiftTwo], [xc-Chd,yc-Ca]),//左上角
        }
      };
      var myFsAMakerR1C = {    
        paths: {
         "R1CLine1": new makerjs.paths.Line([xc-Chd,yc-wc], [xc-Chd-markShift,yc-wc-markShift]),//左上角
        }
      };
      var myFsAMakerDC = {    
        paths: {
         "DCLine1": new makerjs.paths.Line([xc-h1c,yc-w1c], [xc-h1c-dc-markShiftFour-markHolesOneD,yc-w1c-markShift-markHolesOneD]),//左上角
        }
      };
         
    /**************************************************** */ 
    /****************** G   ************** */
    var myFsAMakerWG = {
      paths: {
        "WGLine0": new makerjs.paths.Line([xg+hg,yg], [xg+hg+markShiftThree,yg]),//左上角
        "WGLine1": new makerjs.paths.Line([xg+hg,yg+wg], [xg+hg+markShiftThree,yg+wg]),//左上角
        "WGLine2":new makerjs.paths.Line([xg+hg+markShift,yg], [xg+hg+markShift,yg+wg]),
      }
    };
    var myFsAMakerW1G = {
      paths: {
        "W1GLine0":new makerjs.paths.Line([xg+hg+dg+markShift,yg], [xg+hg+dg+markShift,yg+w1g]),
        "W1GLine1": new makerjs.paths.Line([xg+h1g,yg+w1g], [xg+h1g+dg+markShiftThree,yg+w1g]),//左上角
      }
    };
    var myFsAMakerW2G = {
      paths: {
        "W2GLine0":new makerjs.paths.Line([xg+hg+hg+markShiftThree,yg], [xg+hg+hg+markShiftThree,yg+w2g]),
        "W2GLine1": new makerjs.paths.Line([xg,yg+w2g], [xg+hg+hg+dg+markShiftFour,yg+w2g]),//左上角
      }
    };
    var myFsAMakerHG = {      
      paths: {
        "HGLine0":new makerjs.paths.Line([xg,yg], [xg, yg-markShiftFour]),
        "HGLine1": new makerjs.paths.Line([xg+hg,yg], [xg+hg, yg-markShiftFour]),//左上角
        "HGLine2": new makerjs.paths.Line([xg,yg-markShiftTwo], [xg+hg,yg-markShiftTwo]),//左上角
      }
    };
    var myFsAMakerH1G = {    
      paths: {
        "H1GLine0":new makerjs.paths.Line([xg+h1g,yg+w1g], [xg+h1g, yg+w1g+dg/2+markShiftFour]),
        "H1GLine1": new makerjs.paths.Line([xg,yg+w2g+markShift], [xg+h1g,yg+w2g+markShift]),//左上角
      }
    };
    var myFsAMakerR2G = {    
      paths: {
        "R2GLine1": new makerjs.paths.Line([xg,yg+w2g], [xg+r2g+markShiftFour, yg+w2g]),//左上角
        "R2GLine2": new makerjs.paths.Line([xg,yg+Ga-markShiftTwo], [xg+Ghd,yg+Ga]),//左上角
      }
    };
    var myFsAMakerR1G = {    
      paths: {
        "R1GLine1": new makerjs.paths.Line([xg+Ghd,yg+wg], [xg+Ghd+markShift,yg+wg+markShift]),//左上角
      }
    };
    var myFsAMakerDG = {    
      paths: {
        "DGLine1": new makerjs.paths.Line([xg+h1g,yg+w1g], [xg+h1g+dg+markShiftFour+markHolesOneD,yg+w1g+markShift+markHolesOneD]),//左上角
      }
    };

  makerjs.model.addCaption(myFsAMakerWG, TxtWg, [xg+hg+markShiftThree,yg], [xg+hg+markShiftThree,yg+wg]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1G, TxtW1g, [xg+hg+dg+markShiftThree,yg], [xg+hg+dg+markShiftThree,yg+w1g]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2G, TxtW2g, [xg+hg+hg+dg+markShiftFour,yg], [xg+hg+hg+dg+markShiftFour,yg+w2g]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHG, TxtHg, [xg,yg-markShiftFour], [xg+hg,yg-markShiftFour]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1G, TxtH1g, [xg,yg+w2g+markShiftThree], [xg+h1g,yg+w2g+markShiftThree]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2G, TxtR2g, [xg+Ghd-markShiftThree,yg+Ga-markShiftThree], [xg+Ghd-markShift,yg+Ga-markShift]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1G, TxtR1g, [xg+Ghd,yg+wg], [xg+Ghd+markShift,yg+wg+markShift]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDG, TxtDg, [xg+h1g+dg+markShiftFour+markHolesOneD,yg+w1g+markShift+markHolesOneD],[xg+h1g+dg+markShiftFour+markHolesOneD,yg+w1g+markHolesOneD+markShiftFour]);//D文字标注  
    
  /******************************************************** */ 
    
    makerjs.model.addCaption(myFsAMakerWC, TxtWc, [xc-hc-markShiftThree,yc-wc], [xc-hc-markShiftThree,yc]);//半径文字  
    makerjs.model.addCaption(myFsAMakerW1C, TxtW1c, [xc-hc-dc-markShiftThree,yc-w1c], [xc-hc-dc-markShiftThree,yc]);//W1文字标注 
    makerjs.model.addCaption(myFsAMakerW2C, TxtW2c, [xc-hc-hc-dc-markShiftFour,yc-w2c], [xc-hc-hc-dc-markShiftFour,yc]);//W1文字标注
    makerjs.model.addCaption(myFsAMakerHC, TxtHc, [xc-hc,yc+markShiftFour], [xc,yc+markShiftFour]);//H文字标注
    makerjs.model.addCaption(myFsAMakerH1C, TxtH1c, [xc-h1c,yc-w2c-markShiftThree], [xc,yc-w2c-markShiftThree]);//H1文字标注
    makerjs.model.addCaption(myFsAMakerR2C, TxtR2c, [xc-Chd+markShift,yc-Ca+markShift], [xc-Chd+markShiftThree,yc-Ca+markShiftThree]);//R2文字标注
    makerjs.model.addCaption(myFsAMakerR1C, TxtR1c, [xc-Chd-markShift,yc-wc-markShift], [xc-Chd,yc-wc]);//R1文字标注
    makerjs.model.addCaption(myFsAMakerDC, TxtDc, [xc-h1c-dc-markShiftFour-markHolesOneD,yc-w1c-markShift-markHolesOneD],[xc-h1c-dc-markShiftFour-markHolesOneD,yc-w1c-markHolesOneD-markShiftFour]);//D文字标注  
  
  /******************************************************** */
  var markers = {
    /**A */
        /**C */
        myFsAMakerWC,
        myFsAMakerW1C,
         myFsAMakerW2C,
         myFsAMakerHC,
        myFsAMakerH1C,
         myFsAMakerR2C,
        myFsAMakerR1C,
        myFsAMakerDC,
        /** G*/        
        myFsAMakerWG,
        myFsAMakerW1G,
         myFsAMakerW2G,
         myFsAMakerHG,
        myFsAMakerH1G,
         myFsAMakerR2G,
        myFsAMakerR1G,
        myFsAMakerDG,
        /**I */
      }
  

    // var myFilletMark = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xa, ya], [xcwx, xcwy], [xchx, xchy], [xi, yi], [xgwx, xgwy]]);
  } else if (area == "CI") {
      /*****************  C  *********** */
      var myFsAMakerWC = {
        paths: {
          "WCLine0": new makerjs.paths.Line([xc-hc,yc], [xc-hc-markShiftThree,yc]),//左上角
          "WCLine1": new makerjs.paths.Line([xc-hc,yc-wc], [xc-hc-markShiftThree,yc-wc]),//左上角
          "WCLine2":new makerjs.paths.Line([xc-hc-markShift,yc-wc], [xc-hc-markShift,yc]),
        }
      };
      var myFsAMakerW1C = {
        paths: {
         "W1CLine0":new makerjs.paths.Line([xc-hc-dc-markShift,yc-w1c], [xc-hc-dc-markShift,yc]),
         "W1CLine1": new makerjs.paths.Line([xc-h1c,yc-w1c], [xc-h1c-dc-markShiftThree,yc-w1c]),//左上角
        }
      };
      var myFsAMakerW2C = {
        paths: {
         "W2CLine0":new makerjs.paths.Line([xc-hc-hc-markShiftThree,yc], [xc-hc-hc-markShiftThree,yc-w2c]),
          "W2CLine1": new makerjs.paths.Line([xc,yc-w2c], [xc-hc-hc-dc-markShiftFour,yc-w2c]),//左上角
        }
      };
      var myFsAMakerHC = {      
        paths: {
         "HCLine0":new makerjs.paths.Line([xc,yc], [xc, yc+markShiftFour]),
         "HCLine1": new makerjs.paths.Line([xc-hc,yc], [xc-hc, yc+markShiftFour]),//左上角
         "HCLine2": new makerjs.paths.Line([xc,yc+markShiftTwo], [xc-hc,yc+markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1C = {    
        paths: {
         "H1CLine0":new makerjs.paths.Line([xc-h1c,yc-w1c], [xc-h1c, yc-w1c-dc/2-markShiftFour]),
         "H1CLine1": new makerjs.paths.Line([xc,yc-w2c-markShift], [xc-h1c,yc-w2c-markShift]),//左上角
        }
      };
      var myFsAMakerR2C = {    
        paths: {
        //  "R2CLine1": new makerjs.paths.Line([xc-w2,yc], [xc-w2, yc-r2-markShiftFour]),//左上角
         "R2CLine2": new makerjs.paths.Line([xc,yc-Ca+markShiftTwo], [xc-Chd,yc-Ca]),//左上角
        }
      };
      var myFsAMakerR1C = {    
        paths: {
         "R1CLine1": new makerjs.paths.Line([xc-Chd,yc-wc], [xc-Chd-markShift,yc-wc-markShift]),//左上角
        }
      };
      var myFsAMakerDC = {    
        paths: {
         "DCLine1": new makerjs.paths.Line([xc-h1c,yc-w1c], [xc-h1c-dc-markShiftFour-markHolesOneD,yc-w1c-markShift-markHolesOneD]),//左上角
        }
      };
         
    /**************************************************** */ 
    /************************   I  ******************* */
    var myFsAMakerWI = {
      paths: {
       // "WILine0": new makerjs.paths.Line([xi,yi+hi], [xi,yi+hi+markShiftThree]),//左上角
        "WILine1": new makerjs.paths.Line([xi-hi,yi+wi], [xi-hi-markShiftThree,yi+wi]),//左上角
        "WILine2":new makerjs.paths.Line([xi-hi-markShift,yi], [xi-hi-markShift,yi+wi]),
      }
    };
    var myFsAMakerW1I = {
      paths: {
       "W1ILine0":new makerjs.paths.Line([xi-hi-di-markShift,yi], [xi-hi-di-markShift,yi+w1i]),
       "W1ILine1": new makerjs.paths.Line([xi-h1i,yi+w1i], [xi-h1i-di-markShiftThree,yi+w1i]),//左上角
      }
    };
    var myFsAMakerW2I = {
      paths: {
       "W2ILine0":new makerjs.paths.Line([xi-hi-hi-markShiftThree,yi], [xi-hi-hi-markShiftThree,yi+w2i]),
        "W2ILine1": new makerjs.paths.Line([xi,yi+w2i], [xi-hi-hi-di-markShiftFour,yi+w2i]),//左上角
      }
    };
    var myFsAMakerHI = {      
      paths: {
       "HILine0":new makerjs.paths.Line([xi,yi], [xi, yi-markShiftFour]),
       "HILine1": new makerjs.paths.Line([xi-hi,yi], [xi-hi, yi-markShiftFour]),//左上角
       "HILine2": new makerjs.paths.Line([xi,yi-markShiftTwo], [xi-hi,yi-markShiftTwo]),//左上角
      }
    };
    var myFsAMakerH1I = {    
      paths: {
       "H1ILine0":new makerjs.paths.Line([xi-h1i,yi+w1i], [xi-h1i, yi+w1i+di/2+markShiftFour]),
       "H1ILine1": new makerjs.paths.Line([xi,yi+w2i+markShift], [xi-h1i,yi+w2i+markShift]),//左上角
      }
    };
    var myFsAMakerR2I = {    
      paths: {
      //  "R2ILine1": new makerjs.paths.Line([xi-w2,yi], [xi-w2, yi-r2-markShiftFour]),//左上角
       "R2ILine2": new makerjs.paths.Line([xi,yi+Ia-markShiftTwo], [xi-Ihd,yi+Ia]),//左上角
      }
    };
    var myFsAMakerR1I = {    
      paths: {
       "R1ILine1": new makerjs.paths.Line([xi-Ihd,yi+wi], [xi-Ihd-markShift,yi+wi+markShift]),//左上角
      }
    };
    var myFsAMakerDI = {    
      paths: {
       "DILine1": new makerjs.paths.Line([xi-h1i,yi+w1i], [xi-h1i-di-markShiftFour-markHolesOneD,yi+w1i+markShift+markHolesOneD]),//左上角
      }
    };
     
  /******************************************************** */  
  makerjs.model.addCaption(myFsAMakerWI, TxtWi, [xi-hi-markShiftThree,yi], [xi-hi-markShiftThree,yi+wi]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1I, TxtW1i, [xi-hi-di-markShiftThree,yi], [xi-hi-di-markShiftThree,yi+w1i]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2I, TxtW2i, [xi-hi-hi-di-markShiftFour,yi], [xi-hi-hi-di-markShiftFour,yi+w2i]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHI, TxtHi, [xi-hi,yi-markShiftFour], [xi,yi-markShiftFour]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1I, TxtH1i, [xi-h1i,yi+w2i+markShiftThree], [xi,yi+w2i+markShiftThree]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2I, TxtR2i, [xi-Ihd+markShift,yi+Ia-markShift], [xi-Ihd+markShiftThree,yi+Ia-markShiftThree]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1I, TxtR1i, [xi-Ihd-markShift,yi+wi+markShift], [xi-Ihd,yi+wi]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDI, TxtDi,[xi-h1i-di-markShiftFour-markHolesOneD,yi+w1i+markHolesOneD+markShiftFour], [xi-h1i-di-markShiftFour-markHolesOneD,yi+w1i+markShift+markHolesOneD]);//D文字标注  
   
/***************************************************/  
  /******************************************************** */ 
    
    makerjs.model.addCaption(myFsAMakerWC, TxtWc, [xc-hc-markShiftThree,yc-wc], [xc-hc-markShiftThree,yc]);//半径文字  
    makerjs.model.addCaption(myFsAMakerW1C, TxtW1c, [xc-hc-dc-markShiftThree,yc-w1c], [xc-hc-dc-markShiftThree,yc]);//W1文字标注 
    makerjs.model.addCaption(myFsAMakerW2C, TxtW2c, [xc-hc-hc-dc-markShiftFour,yc-w2c], [xc-hc-hc-dc-markShiftFour,yc]);//W1文字标注
    makerjs.model.addCaption(myFsAMakerHC, TxtHc, [xc-hc,yc+markShiftFour], [xc,yc+markShiftFour]);//H文字标注
    makerjs.model.addCaption(myFsAMakerH1C, TxtH1c, [xc-h1c,yc-w2c-markShiftThree], [xc,yc-w2c-markShiftThree]);//H1文字标注
    makerjs.model.addCaption(myFsAMakerR2C, TxtR2c, [xc-Chd+markShift,yc-Ca+markShift], [xc-Chd+markShiftThree,yc-Ca+markShiftThree]);//R2文字标注
    makerjs.model.addCaption(myFsAMakerR1C, TxtR1c, [xc-Chd-markShift,yc-wc-markShift], [xc-Chd,yc-wc]);//R1文字标注
    makerjs.model.addCaption(myFsAMakerDC, TxtDc, [xc-h1c-dc-markShiftFour-markHolesOneD,yc-w1c-markShift-markHolesOneD],[xc-h1c-dc-markShiftFour-markHolesOneD,yc-w1c-markHolesOneD-markShiftFour]);//D文字标注  
      
  
  /**************************************************** */

  /******************************************************** */
  var markers = {
    /**A */
        /**C */
        myFsAMakerWC,
        myFsAMakerW1C,
         myFsAMakerW2C,
         myFsAMakerHC,
        myFsAMakerH1C,
         myFsAMakerR2C,
        myFsAMakerR1C,
        myFsAMakerDC,
        /** G*/        
        /**I */
        myFsAMakerWI,
        myFsAMakerW1I,
         myFsAMakerW2I,
         myFsAMakerHI,
        myFsAMakerH1I,
         myFsAMakerR2I,
        myFsAMakerR1I,
        myFsAMakerDI,
      }
  

    // var myFilletMark = new makerjs.models.ConnectTheDots(true, [[xg, yg], [xa, ya], [xcwx, xcwy], [xchx, xchy], [xihx, xihy], [xiwx, xiwy]]);
  } else if (area == "GI") {
    /****************** G   ************** */
    var myFsAMakerWG = {
      paths: {
        "WGLine0": new makerjs.paths.Line([xg+hg,yg], [xg+hg+markShiftThree,yg]),//左上角
        "WGLine1": new makerjs.paths.Line([xg+hg,yg+wg], [xg+hg+markShiftThree,yg+wg]),//左上角
        "WGLine2":new makerjs.paths.Line([xg+hg+markShift,yg], [xg+hg+markShift,yg+wg]),
      }
    };
    var myFsAMakerW1G = {
      paths: {
        "W1GLine0":new makerjs.paths.Line([xg+hg+dg+markShift,yg], [xg+hg+dg+markShift,yg+w1g]),
        "W1GLine1": new makerjs.paths.Line([xg+h1g,yg+w1g], [xg+h1g+dg+markShiftThree,yg+w1g]),//左上角
      }
    };
    var myFsAMakerW2G = {
      paths: {
        "W2GLine0":new makerjs.paths.Line([xg+hg+hg+markShiftThree,yg], [xg+hg+hg+markShiftThree,yg+w2g]),
        "W2GLine1": new makerjs.paths.Line([xg,yg+w2g], [xg+hg+hg+dg+markShiftFour,yg+w2g]),//左上角
      }
    };
    var myFsAMakerHG = {      
      paths: {
        "HGLine0":new makerjs.paths.Line([xg,yg], [xg, yg-markShiftFour]),
        "HGLine1": new makerjs.paths.Line([xg+hg,yg], [xg+hg, yg-markShiftFour]),//左上角
        "HGLine2": new makerjs.paths.Line([xg,yg-markShiftTwo], [xg+hg,yg-markShiftTwo]),//左上角
      }
    };
    var myFsAMakerH1G = {    
      paths: {
        "H1GLine0":new makerjs.paths.Line([xg+h1g,yg+w1g], [xg+h1g, yg+w1g+dg/2+markShiftFour]),
        "H1GLine1": new makerjs.paths.Line([xg,yg+w2g+markShift], [xg+h1g,yg+w2g+markShift]),//左上角
      }
    };
    var myFsAMakerR2G = {    
      paths: {
        "R2GLine1": new makerjs.paths.Line([xg,yg+w2g], [xg+r2g+markShiftFour, yg+w2g]),//左上角
        "R2GLine2": new makerjs.paths.Line([xg,yg+Ga-markShiftTwo], [xg+Ghd,yg+Ga]),//左上角
      }
    };
    var myFsAMakerR1G = {    
      paths: {
        "R1GLine1": new makerjs.paths.Line([xg+Ghd,yg+wg], [xg+Ghd+markShift,yg+wg+markShift]),//左上角
      }
    };
    var myFsAMakerDG = {    
      paths: {
        "DGLine1": new makerjs.paths.Line([xg+h1g,yg+w1g], [xg+h1g+dg+markShiftFour+markHolesOneD,yg+w1g+markShift+markHolesOneD]),//左上角
      }
    };

    
    /**************************************************** */  
    /************************   I  ******************* */
    var myFsAMakerWI = {
      paths: {
       // "WILine0": new makerjs.paths.Line([xi,yi+hi], [xi,yi+hi+markShiftThree]),//左上角
        "WILine1": new makerjs.paths.Line([xi-hi,yi+wi], [xi-hi-markShiftThree,yi+wi]),//左上角
        "WILine2":new makerjs.paths.Line([xi-hi-markShift,yi], [xi-hi-markShift,yi+wi]),
      }
    };
    var myFsAMakerW1I = {
      paths: {
       "W1ILine0":new makerjs.paths.Line([xi-hi-di-markShift,yi], [xi-hi-di-markShift,yi+w1i]),
       "W1ILine1": new makerjs.paths.Line([xi-h1i,yi+w1i], [xi-h1i-di-markShiftThree,yi+w1i]),//左上角
      }
    };
    var myFsAMakerW2I = {
      paths: {
       "W2ILine0":new makerjs.paths.Line([xi-hi-hi-markShiftThree,yi], [xi-hi-hi-markShiftThree,yi+w2i]),
        "W2ILine1": new makerjs.paths.Line([xi,yi+w2i], [xi-hi-hi-di-markShiftFour,yi+w2i]),//左上角
      }
    };
    var myFsAMakerHI = {      
      paths: {
       "HILine0":new makerjs.paths.Line([xi,yi], [xi, yi-markShiftFour]),
       "HILine1": new makerjs.paths.Line([xi-hi,yi], [xi-hi, yi-markShiftFour]),//左上角
       "HILine2": new makerjs.paths.Line([xi,yi-markShiftTwo], [xi-hi,yi-markShiftTwo]),//左上角
      }
    };
    var myFsAMakerH1I = {    
      paths: {
       "H1ILine0":new makerjs.paths.Line([xi-h1i,yi+w1i], [xi-h1i, yi+w1i+di/2+markShiftFour]),
       "H1ILine1": new makerjs.paths.Line([xi,yi+w2i+markShift], [xi-h1i,yi+w2i+markShift]),//左上角
      }
    };
    var myFsAMakerR2I = {    
      paths: {
      //  "R2ILine1": new makerjs.paths.Line([xi-w2,yi], [xi-w2, yi-r2-markShiftFour]),//左上角
       "R2ILine2": new makerjs.paths.Line([xi,yi+Ia-markShiftTwo], [xi-Ihd,yi+Ia]),//左上角
      }
    };
    var myFsAMakerR1I = {    
      paths: {
       "R1ILine1": new makerjs.paths.Line([xi-Ihd,yi+wi], [xi-Ihd-markShift,yi+wi+markShift]),//左上角
      }
    };
    var myFsAMakerDI = {    
      paths: {
       "DILine1": new makerjs.paths.Line([xi-h1i,yi+w1i], [xi-h1i-di-markShiftFour-markHolesOneD,yi+w1i+markShift+markHolesOneD]),//左上角
      }
    };
     
  /******************************************************** */  
  makerjs.model.addCaption(myFsAMakerWI, TxtWi, [xi-hi-markShiftThree,yi], [xi-hi-markShiftThree,yi+wi]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1I, TxtW1i, [xi-hi-di-markShiftThree,yi], [xi-hi-di-markShiftThree,yi+w1i]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2I, TxtW2i, [xi-hi-hi-di-markShiftFour,yi], [xi-hi-hi-di-markShiftFour,yi+w2i]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHI, TxtHi, [xi-hi,yi-markShiftFour], [xi,yi-markShiftFour]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1I, TxtH1i, [xi-h1i,yi+w2i+markShiftThree], [xi,yi+w2i+markShiftThree]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2I, TxtR2i, [xi-Ihd+markShift,yi+Ia-markShift], [xi-Ihd+markShiftThree,yi+Ia-markShiftThree]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1I, TxtR1i, [xi-Ihd-markShift,yi+wi+markShift], [xi-Ihd,yi+wi]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDI, TxtDi,[xi-h1i-di-markShiftFour-markHolesOneD,yi+w1i+markHolesOneD+markShiftFour], [xi-h1i-di-markShiftFour-markHolesOneD,yi+w1i+markShift+markHolesOneD]);//D文字标注  
   
/***************************************************/  
  /******************************************************** */
  makerjs.model.addCaption(myFsAMakerWG, TxtWg, [xg+hg+markShiftThree,yg], [xg+hg+markShiftThree,yg+wg]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1G, TxtW1g, [xg+hg+dg+markShiftThree,yg], [xg+hg+dg+markShiftThree,yg+w1g]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2G, TxtW2g, [xg+hg+hg+dg+markShiftFour,yg], [xg+hg+hg+dg+markShiftFour,yg+w2g]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHG, TxtHg, [xg,yg-markShiftFour], [xg+hg,yg-markShiftFour]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1G, TxtH1g, [xg,yg+w2g+markShiftThree], [xg+h1g,yg+w2g+markShiftThree]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2G, TxtR2g, [xg+Ghd-markShiftThree,yg+Ga-markShiftThree], [xg+Ghd-markShift,yg+Ga-markShift]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1G, TxtR1g, [xg+Ghd,yg+wg], [xg+Ghd+markShift,yg+wg+markShift]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDG, TxtDg, [xg+h1g+dg+markShiftFour+markHolesOneD,yg+w1g+markShift+markHolesOneD],[xg+h1g+dg+markShiftFour+markHolesOneD,yg+w1g+markHolesOneD+markShiftFour]);//D文字标注  
    
  
  /******************************************************** */
  var markers = {
    /**A */
        /** G*/        
        myFsAMakerWG,
        myFsAMakerW1G,
         myFsAMakerW2G,
         myFsAMakerHG,
        myFsAMakerH1G,
         myFsAMakerR2G,
        myFsAMakerR1G,
        myFsAMakerDG,
        /**I */
        myFsAMakerWI,
        myFsAMakerW1I,
         myFsAMakerW2I,
         myFsAMakerHI,
        myFsAMakerH1I,
         myFsAMakerR2I,
        myFsAMakerR1I,
        myFsAMakerDI,
      }
  

   
    // var myFilletMark = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xa, ya], [xc, yc], [xihx, xihy], [xiwx, xiwy], [xgwx, xgwy]]);
  } else if (area == "ACG") {
    var myFsAMakerWA = {
      paths: {
        "WALine0": new makerjs.paths.Line([xa+ha,ya], [xa+ha+markShiftThree,ya]),//左上角
        "WALine1": new makerjs.paths.Line([xa+ha,ya-wa], [xa+ha+markShiftThree,ya-wa]),//左上角
        "WALine2":new makerjs.paths.Line([xa+ha+markShift,ya], [xa+ha+markShift,ya-wa]),
      }
    };
    var myFsAMakerW1A = {
      paths: {
       "W1ALine0":new makerjs.paths.Line([xa+ha+da+markShift,ya], [xa+ha+da+markShift,ya-w1a]),
       "W1ALine1": new makerjs.paths.Line([xa+h1a,ya-w1a], [xa+h1a+da+markShiftThree,ya-w1a]),//左上角
      }
    };
    var myFsAMakerW2A = {
      paths: {
       "W2ALine0":new makerjs.paths.Line([xa+ha+ha+markShiftThree,ya], [xa+ha+ha+markShiftThree,ya-w2a]),
        "W2ALine1": new makerjs.paths.Line([xa,ya-w2a], [xa+ha+ha+markShiftFour,ya-w2a]),//左上角
      }
    };
    var myFsAMakerHA = {
      
      paths: {
       "HALine0":new makerjs.paths.Line([xa,ya], [xa, ya+markShiftFour]),
       "HALine1": new makerjs.paths.Line([xa+ha,ya], [xa+ha, ya+markShiftFour]),//左上角
       "HALine2": new makerjs.paths.Line([xa,ya+markShiftTwo], [xa+ha,ya+markShiftTwo]),//左上角
      }
    };
    var myFsAMakerH1A = {    
      paths: {
       "H1ALine0":new makerjs.paths.Line([xa+h1a,ya-w1a], [xa+h1a, ya-w1a-da/2-markShiftFour]),
       "H1ALine1": new makerjs.paths.Line([xa,ya-w2a-markShift], [xa+h1a,ya-w2a-markShift]),//左上角
      }
    };
 
    var myFsAMakerR2A = {    
      paths: {
       "R2ALine1": new makerjs.paths.Line([xa,ya-w2a], [xa+r2a+markShiftFour, ya-w2a]),//左上角
       "R2ALine2": new makerjs.paths.Line([xa,ya-Aa+markShiftTwo], [xa+Ahd,ya-Aa]),//左上角
      }
    };
    var myFsAMakerR1A = {    
      paths: {
       "R1ALine1": new makerjs.paths.Line([xa+Ahd,ya-wa], [xa+Ahd+markShift,ya-wa-markShift]),//左上角
      }
    };
    var myFsAMakerDA = {    
      paths: {
       "DALine1": new makerjs.paths.Line([xa+h1a,ya-w1a], [xa+h1a+da+markShiftFour+markHolesOneD,ya-w1a-markShift-markHolesOneD]),//左上角
      }
    };
    /**************************************************** */
      /*****************  C  *********** */
      var myFsAMakerWC = {
        paths: {
          "WCLine0": new makerjs.paths.Line([xc-hc,yc], [xc-hc-markShiftThree,yc]),//左上角
          "WCLine1": new makerjs.paths.Line([xc-hc,yc-wc], [xc-hc-markShiftThree,yc-wc]),//左上角
          "WCLine2":new makerjs.paths.Line([xc-hc-markShift,yc-wc], [xc-hc-markShift,yc]),
        }
      };
      var myFsAMakerW1C = {
        paths: {
         "W1CLine0":new makerjs.paths.Line([xc-hc-dc-markShift,yc-w1c], [xc-hc-dc-markShift,yc]),
         "W1CLine1": new makerjs.paths.Line([xc-h1c,yc-w1c], [xc-h1c-dc-markShiftThree,yc-w1c]),//左上角
        }
      };
      var myFsAMakerW2C = {
        paths: {
         "W2CLine0":new makerjs.paths.Line([xc-hc-hc-markShiftThree,yc], [xc-hc-hc-markShiftThree,yc-w2c]),
          "W2CLine1": new makerjs.paths.Line([xc,yc-w2c], [xc-hc-hc-dc-markShiftFour,yc-w2c]),//左上角
        }
      };
      var myFsAMakerHC = {      
        paths: {
         "HCLine0":new makerjs.paths.Line([xc,yc], [xc, yc+markShiftFour]),
         "HCLine1": new makerjs.paths.Line([xc-hc,yc], [xc-hc, yc+markShiftFour]),//左上角
         "HCLine2": new makerjs.paths.Line([xc,yc+markShiftTwo], [xc-hc,yc+markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1C = {    
        paths: {
         "H1CLine0":new makerjs.paths.Line([xc-h1c,yc-w1c], [xc-h1c, yc-w1c-dc/2-markShiftFour]),
         "H1CLine1": new makerjs.paths.Line([xc,yc-w2c-markShift], [xc-h1c,yc-w2c-markShift]),//左上角
        }
      };
      var myFsAMakerR2C = {    
        paths: {
        //  "R2CLine1": new makerjs.paths.Line([xc-w2,yc], [xc-w2, yc-r2-markShiftFour]),//左上角
         "R2CLine2": new makerjs.paths.Line([xc,yc-Ca+markShiftTwo], [xc-Chd,yc-Ca]),//左上角
        }
      };
      var myFsAMakerR1C = {    
        paths: {
         "R1CLine1": new makerjs.paths.Line([xc-Chd,yc-wc], [xc-Chd-markShift,yc-wc-markShift]),//左上角
        }
      };
      var myFsAMakerDC = {    
        paths: {
         "DCLine1": new makerjs.paths.Line([xc-h1c,yc-w1c], [xc-h1c-dc-markShiftFour-markHolesOneD,yc-w1c-markShift-markHolesOneD]),//左上角
        }
      };
         
    /**************************************************** */ 
    /****************** G   ************** */
    var myFsAMakerWG = {
      paths: {
        "WGLine0": new makerjs.paths.Line([xg+hg,yg], [xg+hg+markShiftThree,yg]),//左上角
        "WGLine1": new makerjs.paths.Line([xg+hg,yg+wg], [xg+hg+markShiftThree,yg+wg]),//左上角
        "WGLine2":new makerjs.paths.Line([xg+hg+markShift,yg], [xg+hg+markShift,yg+wg]),
      }
    };
    var myFsAMakerW1G = {
      paths: {
        "W1GLine0":new makerjs.paths.Line([xg+hg+dg+markShift,yg], [xg+hg+dg+markShift,yg+w1g]),
        "W1GLine1": new makerjs.paths.Line([xg+h1g,yg+w1g], [xg+h1g+dg+markShiftThree,yg+w1g]),//左上角
      }
    };
    var myFsAMakerW2G = {
      paths: {
        "W2GLine0":new makerjs.paths.Line([xg+hg+hg+markShiftThree,yg], [xg+hg+hg+markShiftThree,yg+w2g]),
        "W2GLine1": new makerjs.paths.Line([xg,yg+w2g], [xg+hg+hg+dg+markShiftFour,yg+w2g]),//左上角
      }
    };
    var myFsAMakerHG = {      
      paths: {
        "HGLine0":new makerjs.paths.Line([xg,yg], [xg, yg-markShiftFour]),
        "HGLine1": new makerjs.paths.Line([xg+hg,yg], [xg+hg, yg-markShiftFour]),//左上角
        "HGLine2": new makerjs.paths.Line([xg,yg-markShiftTwo], [xg+hg,yg-markShiftTwo]),//左上角
      }
    };
    var myFsAMakerH1G = {    
      paths: {
        "H1GLine0":new makerjs.paths.Line([xg+h1g,yg+w1g], [xg+h1g, yg+w1g+dg/2+markShiftFour]),
        "H1GLine1": new makerjs.paths.Line([xg,yg+w2g+markShift], [xg+h1g,yg+w2g+markShift]),//左上角
      }
    };
    var myFsAMakerR2G = {    
      paths: {
        "R2GLine1": new makerjs.paths.Line([xg,yg+w2g], [xg+r2g+markShiftFour, yg+w2g]),//左上角
        "R2GLine2": new makerjs.paths.Line([xg,yg+Ga-markShiftTwo], [xg+Ghd,yg+Ga]),//左上角
      }
    };
    var myFsAMakerR1G = {    
      paths: {
        "R1GLine1": new makerjs.paths.Line([xg+Ghd,yg+wg], [xg+Ghd+markShift,yg+wg+markShift]),//左上角
      }
    };
    var myFsAMakerDG = {    
      paths: {
        "DGLine1": new makerjs.paths.Line([xg+h1g,yg+w1g], [xg+h1g+dg+markShiftFour+markHolesOneD,yg+w1g+markShift+markHolesOneD]),//左上角
      }
    };

    
  /******************************************************** */
  makerjs.model.addCaption(myFsAMakerWG, TxtWg, [xg+hg+markShiftThree,yg], [xg+hg+markShiftThree,yg+wg]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1G, TxtW1g, [xg+hg+dg+markShiftThree,yg], [xg+hg+dg+markShiftThree,yg+w1g]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2G, TxtW2g, [xg+hg+hg+dg+markShiftFour,yg], [xg+hg+hg+dg+markShiftFour,yg+w2g]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHG, TxtHg, [xg,yg-markShiftFour], [xg+hg,yg-markShiftFour]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1G, TxtH1g, [xg,yg+w2g+markShiftThree], [xg+h1g,yg+w2g+markShiftThree]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2G, TxtR2g, [xg+Ghd-markShiftThree,yg+Ga-markShiftThree], [xg+Ghd-markShift,yg+Ga-markShift]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1G, TxtR1g, [xg+Ghd,yg+wg], [xg+Ghd+markShift,yg+wg+markShift]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDG, TxtDg, [xg+h1g+dg+markShiftFour+markHolesOneD,yg+w1g+markShift+markHolesOneD],[xg+h1g+dg+markShiftFour+markHolesOneD,yg+w1g+markHolesOneD+markShiftFour]);//D文字标注  
    
  /******************************************************** */ 
    
    makerjs.model.addCaption(myFsAMakerWC, TxtWc, [xc-hc-markShiftThree,yc-wc], [xc-hc-markShiftThree,yc]);//半径文字  
    makerjs.model.addCaption(myFsAMakerW1C, TxtW1c, [xc-hc-dc-markShiftThree,yc-w1c], [xc-hc-dc-markShiftThree,yc]);//W1文字标注 
    makerjs.model.addCaption(myFsAMakerW2C, TxtW2c, [xc-hc-hc-dc-markShiftFour,yc-w2c], [xc-hc-hc-dc-markShiftFour,yc]);//W1文字标注
    makerjs.model.addCaption(myFsAMakerHC, TxtHc, [xc-hc,yc+markShiftFour], [xc,yc+markShiftFour]);//H文字标注
    makerjs.model.addCaption(myFsAMakerH1C, TxtH1c, [xc-h1c,yc-w2c-markShiftThree], [xc,yc-w2c-markShiftThree]);//H1文字标注
    makerjs.model.addCaption(myFsAMakerR2C, TxtR2c, [xc-Chd+markShift,yc-Ca+markShift], [xc-Chd+markShiftThree,yc-Ca+markShiftThree]);//R2文字标注
    makerjs.model.addCaption(myFsAMakerR1C, TxtR1c, [xc-Chd-markShift,yc-wc-markShift], [xc-Chd,yc-wc]);//R1文字标注
    makerjs.model.addCaption(myFsAMakerDC, TxtDc, [xc-h1c-dc-markShiftFour-markHolesOneD,yc-w1c-markShift-markHolesOneD],[xc-h1c-dc-markShiftFour-markHolesOneD,yc-w1c-markHolesOneD-markShiftFour]);//D文字标注  
      
  
    /******************************************************** */
    
  makerjs.model.addCaption(myFsAMakerWA, TxtWa, [xa+ha+markShiftThree,ya], [xa+ha+markShiftThree,ya-wa]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1A, TxtW1a, [xa+ha+da+markShiftThree,ya], [xa+ha+da+markShiftThree,ya-w1a]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2A, TxtW2a, [xa+ha+ha+da+markShiftFour,ya], [xa+ha+ha+da+markShiftFour,ya-w2a]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHA, TxtHa, [xa,ya+markShiftFour], [xa+ha,ya+markShiftFour]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1A, TxtH1a, [xa,ya-w2a-markShiftThree], [xa+h1a,ya-w2a-markShiftThree]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2A, TxtR2a,[xa+Ahd-markShiftThree,ya-Aa+markShiftThree], [xa+Ahd-markShift,ya-Aa+markShift]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1A, TxtR1a, [xa+Ahd,ya-wa], [xa+Ahd+markShift,ya-wa-markShift]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDA, TxtDa, [xa+h1a+da+markShiftFour+markHolesOneD,ya-w1a-markShift-markHolesOneD],[xa+h1a+da+markShiftFour+markHolesOneD,ya-w1a-markHolesOneD-markShiftFour]);//D文字标注  
   
  /**************************************************** */

  
  /******************************************************** */
  /******************************************************** */
  var markers = {
    /**A */
        myFsAMakerWA,
        myFsAMakerW1A,
         myFsAMakerW2A,
         myFsAMakerHA,
        myFsAMakerH1A,
         myFsAMakerR2A,
        myFsAMakerR1A,
        myFsAMakerDA,
        /**C */
        myFsAMakerWC,
        myFsAMakerW1C,
         myFsAMakerW2C,
         myFsAMakerHC,
        myFsAMakerH1C,
         myFsAMakerR2C,
        myFsAMakerR1C,
        myFsAMakerDC,
        /** G*/        
        myFsAMakerWG,
        myFsAMakerW1G,
         myFsAMakerW2G,
         myFsAMakerHG,
        myFsAMakerH1G,
         myFsAMakerR2G,
        myFsAMakerR1G,
        myFsAMakerDG,
        /**I */
      }
  

    // var myFilletMark = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xahx, xahy], [xawx, xawy], [xcwx, xcwy], [xchx, xchy],[xi, yi], [xgwx, xgwy]]);
  } else if (area == "ACI") {
    var myFsAMakerWA = {
      paths: {
        "WALine0": new makerjs.paths.Line([xa+ha,ya], [xa+ha+markShiftThree,ya]),//左上角
        "WALine1": new makerjs.paths.Line([xa+ha,ya-wa], [xa+ha+markShiftThree,ya-wa]),//左上角
        "WALine2":new makerjs.paths.Line([xa+ha+markShift,ya], [xa+ha+markShift,ya-wa]),
      }
    };
    var myFsAMakerW1A = {
      paths: {
       "W1ALine0":new makerjs.paths.Line([xa+ha+da+markShift,ya], [xa+ha+da+markShift,ya-w1a]),
       "W1ALine1": new makerjs.paths.Line([xa+h1a,ya-w1a], [xa+h1a+da+markShiftThree,ya-w1a]),//左上角
      }
    };
    var myFsAMakerW2A = {
      paths: {
       "W2ALine0":new makerjs.paths.Line([xa+ha+ha+markShiftThree,ya], [xa+ha+ha+markShiftThree,ya-w2a]),
        "W2ALine1": new makerjs.paths.Line([xa,ya-w2a], [xa+ha+ha+markShiftFour,ya-w2a]),//左上角
      }
    };
    var myFsAMakerHA = {
      
      paths: {
       "HALine0":new makerjs.paths.Line([xa,ya], [xa, ya+markShiftFour]),
       "HALine1": new makerjs.paths.Line([xa+ha,ya], [xa+ha, ya+markShiftFour]),//左上角
       "HALine2": new makerjs.paths.Line([xa,ya+markShiftTwo], [xa+ha,ya+markShiftTwo]),//左上角
      }
    };
    var myFsAMakerH1A = {    
      paths: {
       "H1ALine0":new makerjs.paths.Line([xa+h1a,ya-w1a], [xa+h1a, ya-w1a-da/2-markShiftFour]),
       "H1ALine1": new makerjs.paths.Line([xa,ya-w2a-markShift], [xa+h1a,ya-w2a-markShift]),//左上角
      }
    };
 
    var myFsAMakerR2A = {    
      paths: {
       "R2ALine1": new makerjs.paths.Line([xa,ya-w2a], [xa+r2a+markShiftFour, ya-w2a]),//左上角
       "R2ALine2": new makerjs.paths.Line([xa,ya-Aa+markShiftTwo], [xa+Ahd,ya-Aa]),//左上角
      }
    };
    var myFsAMakerR1A = {    
      paths: {
       "R1ALine1": new makerjs.paths.Line([xa+Ahd,ya-wa], [xa+Ahd+markShift,ya-wa-markShift]),//左上角
      }
    };
    var myFsAMakerDA = {    
      paths: {
       "DALine1": new makerjs.paths.Line([xa+h1a,ya-w1a], [xa+h1a+da+markShiftFour+markHolesOneD,ya-w1a-markShift-markHolesOneD]),//左上角
      }
    };
    /**************************************************** */
      /*****************  C  *********** */
      var myFsAMakerWC = {
        paths: {
          "WCLine0": new makerjs.paths.Line([xc-hc,yc], [xc-hc-markShiftThree,yc]),//左上角
          "WCLine1": new makerjs.paths.Line([xc-hc,yc-wc], [xc-hc-markShiftThree,yc-wc]),//左上角
          "WCLine2":new makerjs.paths.Line([xc-hc-markShift,yc-wc], [xc-hc-markShift,yc]),
        }
      };
      var myFsAMakerW1C = {
        paths: {
         "W1CLine0":new makerjs.paths.Line([xc-hc-dc-markShift,yc-w1c], [xc-hc-dc-markShift,yc]),
         "W1CLine1": new makerjs.paths.Line([xc-h1c,yc-w1c], [xc-h1c-dc-markShiftThree,yc-w1c]),//左上角
        }
      };
      var myFsAMakerW2C = {
        paths: {
         "W2CLine0":new makerjs.paths.Line([xc-hc-hc-markShiftThree,yc], [xc-hc-hc-markShiftThree,yc-w2c]),
          "W2CLine1": new makerjs.paths.Line([xc,yc-w2c], [xc-hc-hc-dc-markShiftFour,yc-w2c]),//左上角
        }
      };
      var myFsAMakerHC = {      
        paths: {
         "HCLine0":new makerjs.paths.Line([xc,yc], [xc, yc+markShiftFour]),
         "HCLine1": new makerjs.paths.Line([xc-hc,yc], [xc-hc, yc+markShiftFour]),//左上角
         "HCLine2": new makerjs.paths.Line([xc,yc+markShiftTwo], [xc-hc,yc+markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1C = {    
        paths: {
         "H1CLine0":new makerjs.paths.Line([xc-h1c,yc-w1c], [xc-h1c, yc-w1c-dc/2-markShiftFour]),
         "H1CLine1": new makerjs.paths.Line([xc,yc-w2c-markShift], [xc-h1c,yc-w2c-markShift]),//左上角
        }
      };
      var myFsAMakerR2C = {    
        paths: {
        //  "R2CLine1": new makerjs.paths.Line([xc-w2,yc], [xc-w2, yc-r2-markShiftFour]),//左上角
         "R2CLine2": new makerjs.paths.Line([xc,yc-Ca+markShiftTwo], [xc-Chd,yc-Ca]),//左上角
        }
      };
      var myFsAMakerR1C = {    
        paths: {
         "R1CLine1": new makerjs.paths.Line([xc-Chd,yc-wc], [xc-Chd-markShift,yc-wc-markShift]),//左上角
        }
      };
      var myFsAMakerDC = {    
        paths: {
         "DCLine1": new makerjs.paths.Line([xc-h1c,yc-w1c], [xc-h1c-dc-markShiftFour-markHolesOneD,yc-w1c-markShift-markHolesOneD]),//左上角
        }
      };
         
    /**************************************************** */ 
    
    /************************   I  ******************* */
    var myFsAMakerWI = {
      paths: {
       // "WILine0": new makerjs.paths.Line([xi,yi+hi], [xi,yi+hi+markShiftThree]),//左上角
        "WILine1": new makerjs.paths.Line([xi-hi,yi+wi], [xi-hi-markShiftThree,yi+wi]),//左上角
        "WILine2":new makerjs.paths.Line([xi-hi-markShift,yi], [xi-hi-markShift,yi+wi]),
      }
    };
    var myFsAMakerW1I = {
      paths: {
       "W1ILine0":new makerjs.paths.Line([xi-hi-di-markShift,yi], [xi-hi-di-markShift,yi+w1i]),
       "W1ILine1": new makerjs.paths.Line([xi-h1i,yi+w1i], [xi-h1i-di-markShiftThree,yi+w1i]),//左上角
      }
    };
    var myFsAMakerW2I = {
      paths: {
       "W2ILine0":new makerjs.paths.Line([xi-hi-hi-markShiftThree,yi], [xi-hi-hi-markShiftThree,yi+w2i]),
        "W2ILine1": new makerjs.paths.Line([xi,yi+w2i], [xi-hi-hi-di-markShiftFour,yi+w2i]),//左上角
      }
    };
    var myFsAMakerHI = {      
      paths: {
       "HILine0":new makerjs.paths.Line([xi,yi], [xi, yi-markShiftFour]),
       "HILine1": new makerjs.paths.Line([xi-hi,yi], [xi-hi, yi-markShiftFour]),//左上角
       "HILine2": new makerjs.paths.Line([xi,yi-markShiftTwo], [xi-hi,yi-markShiftTwo]),//左上角
      }
    };
    var myFsAMakerH1I = {    
      paths: {
       "H1ILine0":new makerjs.paths.Line([xi-h1i,yi+w1i], [xi-h1i, yi+w1i+di/2+markShiftFour]),
       "H1ILine1": new makerjs.paths.Line([xi,yi+w2i+markShift], [xi-h1i,yi+w2i+markShift]),//左上角
      }
    };
    var myFsAMakerR2I = {    
      paths: {
      //  "R2ILine1": new makerjs.paths.Line([xi-w2,yi], [xi-w2, yi-r2-markShiftFour]),//左上角
       "R2ILine2": new makerjs.paths.Line([xi,yi+Ia-markShiftTwo], [xi-Ihd,yi+Ia]),//左上角
      }
    };
    var myFsAMakerR1I = {    
      paths: {
       "R1ILine1": new makerjs.paths.Line([xi-Ihd,yi+wi], [xi-Ihd-markShift,yi+wi+markShift]),//左上角
      }
    };
    var myFsAMakerDI = {    
      paths: {
       "DILine1": new makerjs.paths.Line([xi-h1i,yi+w1i], [xi-h1i-di-markShiftFour-markHolesOneD,yi+w1i+markShift+markHolesOneD]),//左上角
      }
    };
     
  /******************************************************** */  
  makerjs.model.addCaption(myFsAMakerWI, TxtWi, [xi-hi-markShiftThree,yi], [xi-hi-markShiftThree,yi+wi]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1I, TxtW1i, [xi-hi-di-markShiftThree,yi], [xi-hi-di-markShiftThree,yi+w1i]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2I, TxtW2i, [xi-hi-hi-di-markShiftFour,yi], [xi-hi-hi-di-markShiftFour,yi+w2i]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHI, TxtHi, [xi-hi,yi-markShiftFour], [xi,yi-markShiftFour]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1I, TxtH1i, [xi-h1i,yi+w2i+markShiftThree], [xi,yi+w2i+markShiftThree]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2I, TxtR2i, [xi-Ihd+markShift,yi+Ia-markShift], [xi-Ihd+markShiftThree,yi+Ia-markShiftThree]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1I, TxtR1i, [xi-Ihd-markShift,yi+wi+markShift], [xi-Ihd,yi+wi]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDI, TxtDi,[xi-h1i-di-markShiftFour-markHolesOneD,yi+w1i+markHolesOneD+markShiftFour], [xi-h1i-di-markShiftFour-markHolesOneD,yi+w1i+markShift+markHolesOneD]);//D文字标注  
   
/***************************************************/  
  /******************************************************** */ 
    
    makerjs.model.addCaption(myFsAMakerWC, TxtWc, [xc-hc-markShiftThree,yc-wc], [xc-hc-markShiftThree,yc]);//半径文字  
    makerjs.model.addCaption(myFsAMakerW1C, TxtW1c, [xc-hc-dc-markShiftThree,yc-w1c], [xc-hc-dc-markShiftThree,yc]);//W1文字标注 
    makerjs.model.addCaption(myFsAMakerW2C, TxtW2c, [xc-hc-hc-dc-markShiftFour,yc-w2c], [xc-hc-hc-dc-markShiftFour,yc]);//W1文字标注
    makerjs.model.addCaption(myFsAMakerHC, TxtHc, [xc-hc,yc+markShiftFour], [xc,yc+markShiftFour]);//H文字标注
    makerjs.model.addCaption(myFsAMakerH1C, TxtH1c, [xc-h1c,yc-w2c-markShiftThree], [xc,yc-w2c-markShiftThree]);//H1文字标注
    makerjs.model.addCaption(myFsAMakerR2C, TxtR2c, [xc-Chd+markShift,yc-Ca+markShift], [xc-Chd+markShiftThree,yc-Ca+markShiftThree]);//R2文字标注
    makerjs.model.addCaption(myFsAMakerR1C, TxtR1c, [xc-Chd-markShift,yc-wc-markShift], [xc-Chd,yc-wc]);//R1文字标注
    makerjs.model.addCaption(myFsAMakerDC, TxtDc, [xc-h1c-dc-markShiftFour-markHolesOneD,yc-w1c-markShift-markHolesOneD],[xc-h1c-dc-markShiftFour-markHolesOneD,yc-w1c-markHolesOneD-markShiftFour]);//D文字标注  
      
  
    /******************************************************** */
    
  makerjs.model.addCaption(myFsAMakerWA, TxtWa, [xa+ha+markShiftThree,ya], [xa+ha+markShiftThree,ya-wa]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1A, TxtW1a, [xa+ha+da+markShiftThree,ya], [xa+ha+da+markShiftThree,ya-w1a]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2A, TxtW2a, [xa+ha+ha+da+markShiftFour,ya], [xa+ha+ha+da+markShiftFour,ya-w2a]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHA, TxtHa, [xa,ya+markShiftFour], [xa+ha,ya+markShiftFour]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1A, TxtH1a, [xa,ya-w2a-markShiftThree], [xa+h1a,ya-w2a-markShiftThree]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2A, TxtR2a,[xa+Ahd-markShiftThree,ya-Aa+markShiftThree], [xa+Ahd-markShift,ya-Aa+markShift]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1A, TxtR1a, [xa+Ahd,ya-wa], [xa+Ahd+markShift,ya-wa-markShift]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDA, TxtDa, [xa+h1a+da+markShiftFour+markHolesOneD,ya-w1a-markShift-markHolesOneD],[xa+h1a+da+markShiftFour+markHolesOneD,ya-w1a-markHolesOneD-markShiftFour]);//D文字标注  
   
  /**************************************************** */

  /******************************************************** */
  var markers = {
    /**A */
        myFsAMakerWA,
        myFsAMakerW1A,
         myFsAMakerW2A,
         myFsAMakerHA,
        myFsAMakerH1A,
         myFsAMakerR2A,
        myFsAMakerR1A,
        myFsAMakerDA,
        /**C */
        myFsAMakerWC,
        myFsAMakerW1C,
         myFsAMakerW2C,
         myFsAMakerHC,
        myFsAMakerH1C,
         myFsAMakerR2C,
        myFsAMakerR1C,
        myFsAMakerDC,
        /** G*/   
        /**I */
        myFsAMakerWI,
        myFsAMakerW1I,
         myFsAMakerW2I,
         myFsAMakerHI,
        myFsAMakerH1I,
         myFsAMakerR2I,
        myFsAMakerR1I,
        myFsAMakerDI,
      }
  

    // var myFilletMark = new makerjs.models.ConnectTheDots(true, [[xg, yg], [xahx, xahy], [xawx, xawy], [xcwx, xcwy], [xchx, xchy],[xihx, xihy], [xiwx, xiwy]]);
  } else if (area == "AGI") {
    var myFsAMakerWA = {
      paths: {
        "WALine0": new makerjs.paths.Line([xa+ha,ya], [xa+ha+markShiftThree,ya]),//左上角
        "WALine1": new makerjs.paths.Line([xa+ha,ya-wa], [xa+ha+markShiftThree,ya-wa]),//左上角
        "WALine2":new makerjs.paths.Line([xa+ha+markShift,ya], [xa+ha+markShift,ya-wa]),
      }
    };
    var myFsAMakerW1A = {
      paths: {
       "W1ALine0":new makerjs.paths.Line([xa+ha+da+markShift,ya], [xa+ha+da+markShift,ya-w1a]),
       "W1ALine1": new makerjs.paths.Line([xa+h1a,ya-w1a], [xa+h1a+da+markShiftThree,ya-w1a]),//左上角
      }
    };
    var myFsAMakerW2A = {
      paths: {
       "W2ALine0":new makerjs.paths.Line([xa+ha+ha+markShiftThree,ya], [xa+ha+ha+markShiftThree,ya-w2a]),
        "W2ALine1": new makerjs.paths.Line([xa,ya-w2a], [xa+ha+ha+markShiftFour,ya-w2a]),//左上角
      }
    };
    var myFsAMakerHA = {
      
      paths: {
       "HALine0":new makerjs.paths.Line([xa,ya], [xa, ya+markShiftFour]),
       "HALine1": new makerjs.paths.Line([xa+ha,ya], [xa+ha, ya+markShiftFour]),//左上角
       "HALine2": new makerjs.paths.Line([xa,ya+markShiftTwo], [xa+ha,ya+markShiftTwo]),//左上角
      }
    };
    var myFsAMakerH1A = {    
      paths: {
       "H1ALine0":new makerjs.paths.Line([xa+h1a,ya-w1a], [xa+h1a, ya-w1a-da/2-markShiftFour]),
       "H1ALine1": new makerjs.paths.Line([xa,ya-w2a-markShift], [xa+h1a,ya-w2a-markShift]),//左上角
      }
    };
 
    var myFsAMakerR2A = {    
      paths: {
       "R2ALine1": new makerjs.paths.Line([xa,ya-w2a], [xa+r2a+markShiftFour, ya-w2a]),//左上角
       "R2ALine2": new makerjs.paths.Line([xa,ya-Aa+markShiftTwo], [xa+Ahd,ya-Aa]),//左上角
      }
    };
    var myFsAMakerR1A = {    
      paths: {
       "R1ALine1": new makerjs.paths.Line([xa+Ahd,ya-wa], [xa+Ahd+markShift,ya-wa-markShift]),//左上角
      }
    };
    var myFsAMakerDA = {    
      paths: {
       "DALine1": new makerjs.paths.Line([xa+h1a,ya-w1a], [xa+h1a+da+markShiftFour+markHolesOneD,ya-w1a-markShift-markHolesOneD]),//左上角
      }
    };
    /**************************************************** */
     
         
    /**************************************************** */ 
    /****************** G   ************** */
    var myFsAMakerWG = {
      paths: {
        "WGLine0": new makerjs.paths.Line([xg+hg,yg], [xg+hg+markShiftThree,yg]),//左上角
        "WGLine1": new makerjs.paths.Line([xg+hg,yg+wg], [xg+hg+markShiftThree,yg+wg]),//左上角
        "WGLine2":new makerjs.paths.Line([xg+hg+markShift,yg], [xg+hg+markShift,yg+wg]),
      }
    };
    var myFsAMakerW1G = {
      paths: {
        "W1GLine0":new makerjs.paths.Line([xg+hg+dg+markShift,yg], [xg+hg+dg+markShift,yg+w1g]),
        "W1GLine1": new makerjs.paths.Line([xg+h1g,yg+w1g], [xg+h1g+dg+markShiftThree,yg+w1g]),//左上角
      }
    };
    var myFsAMakerW2G = {
      paths: {
        "W2GLine0":new makerjs.paths.Line([xg+hg+hg+markShiftThree,yg], [xg+hg+hg+markShiftThree,yg+w2g]),
        "W2GLine1": new makerjs.paths.Line([xg,yg+w2g], [xg+hg+hg+dg+markShiftFour,yg+w2g]),//左上角
      }
    };
    var myFsAMakerHG = {      
      paths: {
        "HGLine0":new makerjs.paths.Line([xg,yg], [xg, yg-markShiftFour]),
        "HGLine1": new makerjs.paths.Line([xg+hg,yg], [xg+hg, yg-markShiftFour]),//左上角
        "HGLine2": new makerjs.paths.Line([xg,yg-markShiftTwo], [xg+hg,yg-markShiftTwo]),//左上角
      }
    };
    var myFsAMakerH1G = {    
      paths: {
        "H1GLine0":new makerjs.paths.Line([xg+h1g,yg+w1g], [xg+h1g, yg+w1g+dg/2+markShiftFour]),
        "H1GLine1": new makerjs.paths.Line([xg,yg+w2g+markShift], [xg+h1g,yg+w2g+markShift]),//左上角
      }
    };
    var myFsAMakerR2G = {    
      paths: {
        "R2GLine1": new makerjs.paths.Line([xg,yg+w2g], [xg+r2g+markShiftFour, yg+w2g]),//左上角
        "R2GLine2": new makerjs.paths.Line([xg,yg+Ga-markShiftTwo], [xg+Ghd,yg+Ga]),//左上角
      }
    };
    var myFsAMakerR1G = {    
      paths: {
        "R1GLine1": new makerjs.paths.Line([xg+Ghd,yg+wg], [xg+Ghd+markShift,yg+wg+markShift]),//左上角
      }
    };
    var myFsAMakerDG = {    
      paths: {
        "DGLine1": new makerjs.paths.Line([xg+h1g,yg+w1g], [xg+h1g+dg+markShiftFour+markHolesOneD,yg+w1g+markShift+markHolesOneD]),//左上角
      }
    };

    
    /**************************************************** */  
    /************************   I  ******************* */
    var myFsAMakerWI = {
      paths: {
       // "WILine0": new makerjs.paths.Line([xi,yi+hi], [xi,yi+hi+markShiftThree]),//左上角
        "WILine1": new makerjs.paths.Line([xi-hi,yi+wi], [xi-hi-markShiftThree,yi+wi]),//左上角
        "WILine2":new makerjs.paths.Line([xi-hi-markShift,yi], [xi-hi-markShift,yi+wi]),
      }
    };
    var myFsAMakerW1I = {
      paths: {
       "W1ILine0":new makerjs.paths.Line([xi-hi-di-markShift,yi], [xi-hi-di-markShift,yi+w1i]),
       "W1ILine1": new makerjs.paths.Line([xi-h1i,yi+w1i], [xi-h1i-di-markShiftThree,yi+w1i]),//左上角
      }
    };
    var myFsAMakerW2I = {
      paths: {
       "W2ILine0":new makerjs.paths.Line([xi-hi-hi-markShiftThree,yi], [xi-hi-hi-markShiftThree,yi+w2i]),
        "W2ILine1": new makerjs.paths.Line([xi,yi+w2i], [xi-hi-hi-di-markShiftFour,yi+w2i]),//左上角
      }
    };
    var myFsAMakerHI = {      
      paths: {
       "HILine0":new makerjs.paths.Line([xi,yi], [xi, yi-markShiftFour]),
       "HILine1": new makerjs.paths.Line([xi-hi,yi], [xi-hi, yi-markShiftFour]),//左上角
       "HILine2": new makerjs.paths.Line([xi,yi-markShiftTwo], [xi-hi,yi-markShiftTwo]),//左上角
      }
    };
    var myFsAMakerH1I = {    
      paths: {
       "H1ILine0":new makerjs.paths.Line([xi-h1i,yi+w1i], [xi-h1i, yi+w1i+di/2+markShiftFour]),
       "H1ILine1": new makerjs.paths.Line([xi,yi+w2i+markShift], [xi-h1i,yi+w2i+markShift]),//左上角
      }
    };
    var myFsAMakerR2I = {    
      paths: {
      //  "R2ILine1": new makerjs.paths.Line([xi-w2,yi], [xi-w2, yi-r2-markShiftFour]),//左上角
       "R2ILine2": new makerjs.paths.Line([xi,yi+Ia-markShiftTwo], [xi-Ihd,yi+Ia]),//左上角
      }
    };
    var myFsAMakerR1I = {    
      paths: {
       "R1ILine1": new makerjs.paths.Line([xi-Ihd,yi+wi], [xi-Ihd-markShift,yi+wi+markShift]),//左上角
      }
    };
    var myFsAMakerDI = {    
      paths: {
       "DILine1": new makerjs.paths.Line([xi-h1i,yi+w1i], [xi-h1i-di-markShiftFour-markHolesOneD,yi+w1i+markShift+markHolesOneD]),//左上角
      }
    };
     
  /******************************************************** */  
  makerjs.model.addCaption(myFsAMakerWI, TxtWi, [xi-hi-markShiftThree,yi], [xi-hi-markShiftThree,yi+wi]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1I, TxtW1i, [xi-hi-di-markShiftThree,yi], [xi-hi-di-markShiftThree,yi+w1i]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2I, TxtW2i, [xi-hi-hi-di-markShiftFour,yi], [xi-hi-hi-di-markShiftFour,yi+w2i]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHI, TxtHi, [xi-hi,yi-markShiftFour], [xi,yi-markShiftFour]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1I, TxtH1i, [xi-h1i,yi+w2i+markShiftThree], [xi,yi+w2i+markShiftThree]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2I, TxtR2i, [xi-Ihd+markShift,yi+Ia-markShift], [xi-Ihd+markShiftThree,yi+Ia-markShiftThree]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1I, TxtR1i, [xi-Ihd-markShift,yi+wi+markShift], [xi-Ihd,yi+wi]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDI, TxtDi,[xi-h1i-di-markShiftFour-markHolesOneD,yi+w1i+markHolesOneD+markShiftFour], [xi-h1i-di-markShiftFour-markHolesOneD,yi+w1i+markShift+markHolesOneD]);//D文字标注  
   
/***************************************************/  
  /******************************************************** */
  makerjs.model.addCaption(myFsAMakerWG, TxtWg, [xg+hg+markShiftThree,yg], [xg+hg+markShiftThree,yg+wg]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1G, TxtW1g, [xg+hg+dg+markShiftThree,yg], [xg+hg+dg+markShiftThree,yg+w1g]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2G, TxtW2g, [xg+hg+hg+dg+markShiftFour,yg], [xg+hg+hg+dg+markShiftFour,yg+w2g]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHG, TxtHg, [xg,yg-markShiftFour], [xg+hg,yg-markShiftFour]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1G, TxtH1g, [xg,yg+w2g+markShiftThree], [xg+h1g,yg+w2g+markShiftThree]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2G, TxtR2g, [xg+Ghd-markShiftThree,yg+Ga-markShiftThree], [xg+Ghd-markShift,yg+Ga-markShift]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1G, TxtR1g, [xg+Ghd,yg+wg], [xg+Ghd+markShift,yg+wg+markShift]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDG, TxtDg, [xg+h1g+dg+markShiftFour+markHolesOneD,yg+w1g+markShift+markHolesOneD],[xg+h1g+dg+markShiftFour+markHolesOneD,yg+w1g+markHolesOneD+markShiftFour]);//D文字标注  
    
  /******************************************************** */ 
  
    /******************************************************** */
    
  makerjs.model.addCaption(myFsAMakerWA, TxtWa, [xa+ha+markShiftThree,ya], [xa+ha+markShiftThree,ya-wa]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1A, TxtW1a, [xa+ha+da+markShiftThree,ya], [xa+ha+da+markShiftThree,ya-w1a]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2A, TxtW2a, [xa+ha+ha+da+markShiftFour,ya], [xa+ha+ha+da+markShiftFour,ya-w2a]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHA, TxtHa, [xa,ya+markShiftFour], [xa+ha,ya+markShiftFour]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1A, TxtH1a, [xa,ya-w2a-markShiftThree], [xa+h1a,ya-w2a-markShiftThree]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2A, TxtR2a,[xa+Ahd-markShiftThree,ya-Aa+markShiftThree], [xa+Ahd-markShift,ya-Aa+markShift]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1A, TxtR1a, [xa+Ahd,ya-wa], [xa+Ahd+markShift,ya-wa-markShift]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDA, TxtDa, [xa+h1a+da+markShiftFour+markHolesOneD,ya-w1a-markShift-markHolesOneD],[xa+h1a+da+markShiftFour+markHolesOneD,ya-w1a-markHolesOneD-markShiftFour]);//D文字标注  
  

  /******************************************************** */
  var markers = {
    /**A */
        myFsAMakerWA,
        myFsAMakerW1A,
         myFsAMakerW2A,
         myFsAMakerHA,
        myFsAMakerH1A,
         myFsAMakerR2A,
        myFsAMakerR1A,
        myFsAMakerDA,
        /**C */
        /** G*/        
        myFsAMakerWG,
        myFsAMakerW1G,
         myFsAMakerW2G,
         myFsAMakerHG,
        myFsAMakerH1G,
         myFsAMakerR2G,
        myFsAMakerR1G,
        myFsAMakerDG,
        /**I */
        myFsAMakerWI,
        myFsAMakerW1I,
         myFsAMakerW2I,
         myFsAMakerHI,
        myFsAMakerH1I,
         myFsAMakerR2I,
        myFsAMakerR1I,
        myFsAMakerDI,
      }
  

    // var myFilletMark = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xahx, xahy], [xawx, xawy], [xc, yc],[xihx, xihy], [xiwx, xiwy], [xgwx, xgwy]]);
  } else if (area == "CGI") {
    var myFsAMakerWA = {
      paths: {
        "WALine0": new makerjs.paths.Line([xa+ha,ya], [xa+ha+markShiftThree,ya]),//左上角
        "WALine1": new makerjs.paths.Line([xa+ha,ya-wa], [xa+ha+markShiftThree,ya-wa]),//左上角
        "WALine2":new makerjs.paths.Line([xa+ha+markShift,ya], [xa+ha+markShift,ya-wa]),
      }
    };
    var myFsAMakerW1A = {
      paths: {
       "W1ALine0":new makerjs.paths.Line([xa+ha+da+markShift,ya], [xa+ha+da+markShift,ya-w1a]),
       "W1ALine1": new makerjs.paths.Line([xa+h1a,ya-w1a], [xa+h1a+da+markShiftThree,ya-w1a]),//左上角
      }
    };
    var myFsAMakerW2A = {
      paths: {
       "W2ALine0":new makerjs.paths.Line([xa+ha+ha+markShiftThree,ya], [xa+ha+ha+markShiftThree,ya-w2a]),
        "W2ALine1": new makerjs.paths.Line([xa,ya-w2a], [xa+ha+ha+markShiftFour,ya-w2a]),//左上角
      }
    };
    var myFsAMakerHA = {
      
      paths: {
       "HALine0":new makerjs.paths.Line([xa,ya], [xa, ya+markShiftFour]),
       "HALine1": new makerjs.paths.Line([xa+ha,ya], [xa+ha, ya+markShiftFour]),//左上角
       "HALine2": new makerjs.paths.Line([xa,ya+markShiftTwo], [xa+ha,ya+markShiftTwo]),//左上角
      }
    };
    var myFsAMakerH1A = {    
      paths: {
       "H1ALine0":new makerjs.paths.Line([xa+h1a,ya-w1a], [xa+h1a, ya-w1a-da/2-markShiftFour]),
       "H1ALine1": new makerjs.paths.Line([xa,ya-w2a-markShift], [xa+h1a,ya-w2a-markShift]),//左上角
      }
    };
 
    var myFsAMakerR2A = {    
      paths: {
       "R2ALine1": new makerjs.paths.Line([xa,ya-w2a], [xa+r2a+markShiftFour, ya-w2a]),//左上角
       "R2ALine2": new makerjs.paths.Line([xa,ya-Aa+markShiftTwo], [xa+Ahd,ya-Aa]),//左上角
      }
    };
    var myFsAMakerR1A = {    
      paths: {
       "R1ALine1": new makerjs.paths.Line([xa+Ahd,ya-wa], [xa+Ahd+markShift,ya-wa-markShift]),//左上角
      }
    };
    var myFsAMakerDA = {    
      paths: {
       "DALine1": new makerjs.paths.Line([xa+h1a,ya-w1a], [xa+h1a+da+markShiftFour+markHolesOneD,ya-w1a-markShift-markHolesOneD]),//左上角
      }
    };
    /**************************************************** */
      /*****************  C  *********** */
      var myFsAMakerWC = {
        paths: {
          "WCLine0": new makerjs.paths.Line([xc-hc,yc], [xc-hc-markShiftThree,yc]),//左上角
          "WCLine1": new makerjs.paths.Line([xc-hc,yc-wc], [xc-hc-markShiftThree,yc-wc]),//左上角
          "WCLine2":new makerjs.paths.Line([xc-hc-markShift,yc-wc], [xc-hc-markShift,yc]),
        }
      };
      var myFsAMakerW1C = {
        paths: {
         "W1CLine0":new makerjs.paths.Line([xc-hc-dc-markShift,yc-w1c], [xc-hc-dc-markShift,yc]),
         "W1CLine1": new makerjs.paths.Line([xc-h1c,yc-w1c], [xc-h1c-dc-markShiftThree,yc-w1c]),//左上角
        }
      };
      var myFsAMakerW2C = {
        paths: {
         "W2CLine0":new makerjs.paths.Line([xc-hc-hc-markShiftThree,yc], [xc-hc-hc-markShiftThree,yc-w2c]),
          "W2CLine1": new makerjs.paths.Line([xc,yc-w2c], [xc-hc-hc-dc-markShiftFour,yc-w2c]),//左上角
        }
      };
      var myFsAMakerHC = {      
        paths: {
         "HCLine0":new makerjs.paths.Line([xc,yc], [xc, yc+markShiftFour]),
         "HCLine1": new makerjs.paths.Line([xc-hc,yc], [xc-hc, yc+markShiftFour]),//左上角
         "HCLine2": new makerjs.paths.Line([xc,yc+markShiftTwo], [xc-hc,yc+markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1C = {    
        paths: {
         "H1CLine0":new makerjs.paths.Line([xc-h1c,yc-w1c], [xc-h1c, yc-w1c-dc/2-markShiftFour]),
         "H1CLine1": new makerjs.paths.Line([xc,yc-w2c-markShift], [xc-h1c,yc-w2c-markShift]),//左上角
        }
      };
      var myFsAMakerR2C = {    
        paths: {
        //  "R2CLine1": new makerjs.paths.Line([xc-w2,yc], [xc-w2, yc-r2-markShiftFour]),//左上角
         "R2CLine2": new makerjs.paths.Line([xc,yc-Ca+markShiftTwo], [xc-Chd,yc-Ca]),//左上角
        }
      };
      var myFsAMakerR1C = {    
        paths: {
         "R1CLine1": new makerjs.paths.Line([xc-Chd,yc-wc], [xc-Chd-markShift,yc-wc-markShift]),//左上角
        }
      };
      var myFsAMakerDC = {    
        paths: {
         "DCLine1": new makerjs.paths.Line([xc-h1c,yc-w1c], [xc-h1c-dc-markShiftFour-markHolesOneD,yc-w1c-markShift-markHolesOneD]),//左上角
        }
      };
         
    /**************************************************** */ 
    /****************** G   ************** */
    var myFsAMakerWG = {
      paths: {
        "WGLine0": new makerjs.paths.Line([xg+hg,yg], [xg+hg+markShiftThree,yg]),//左上角
        "WGLine1": new makerjs.paths.Line([xg+hg,yg+wg], [xg+hg+markShiftThree,yg+wg]),//左上角
        "WGLine2":new makerjs.paths.Line([xg+hg+markShift,yg], [xg+hg+markShift,yg+wg]),
      }
    };
    var myFsAMakerW1G = {
      paths: {
        "W1GLine0":new makerjs.paths.Line([xg+hg+dg+markShift,yg], [xg+hg+dg+markShift,yg+w1g]),
        "W1GLine1": new makerjs.paths.Line([xg+h1g,yg+w1g], [xg+h1g+dg+markShiftThree,yg+w1g]),//左上角
      }
    };
    var myFsAMakerW2G = {
      paths: {
        "W2GLine0":new makerjs.paths.Line([xg+hg+hg+markShiftThree,yg], [xg+hg+hg+markShiftThree,yg+w2g]),
        "W2GLine1": new makerjs.paths.Line([xg,yg+w2g], [xg+hg+hg+dg+markShiftFour,yg+w2g]),//左上角
      }
    };
    var myFsAMakerHG = {      
      paths: {
        "HGLine0":new makerjs.paths.Line([xg,yg], [xg, yg-markShiftFour]),
        "HGLine1": new makerjs.paths.Line([xg+hg,yg], [xg+hg, yg-markShiftFour]),//左上角
        "HGLine2": new makerjs.paths.Line([xg,yg-markShiftTwo], [xg+hg,yg-markShiftTwo]),//左上角
      }
    };
    var myFsAMakerH1G = {    
      paths: {
        "H1GLine0":new makerjs.paths.Line([xg+h1g,yg+w1g], [xg+h1g, yg+w1g+dg/2+markShiftFour]),
        "H1GLine1": new makerjs.paths.Line([xg,yg+w2g+markShift], [xg+h1g,yg+w2g+markShift]),//左上角
      }
    };
    var myFsAMakerR2G = {    
      paths: {
        "R2GLine1": new makerjs.paths.Line([xg,yg+w2g], [xg+r2g+markShiftFour, yg+w2g]),//左上角
        "R2GLine2": new makerjs.paths.Line([xg,yg+Ga-markShiftTwo], [xg+Ghd,yg+Ga]),//左上角
      }
    };
    var myFsAMakerR1G = {    
      paths: {
        "R1GLine1": new makerjs.paths.Line([xg+Ghd,yg+wg], [xg+Ghd+markShift,yg+wg+markShift]),//左上角
      }
    };
    var myFsAMakerDG = {    
      paths: {
        "DGLine1": new makerjs.paths.Line([xg+h1g,yg+w1g], [xg+h1g+dg+markShiftFour+markHolesOneD,yg+w1g+markShift+markHolesOneD]),//左上角
      }
    };

    
    /**************************************************** */  
    /************************   I  ******************* */
    var myFsAMakerWI = {
      paths: {
       // "WILine0": new makerjs.paths.Line([xi,yi+hi], [xi,yi+hi+markShiftThree]),//左上角
        "WILine1": new makerjs.paths.Line([xi-hi,yi+wi], [xi-hi-markShiftThree,yi+wi]),//左上角
        "WILine2":new makerjs.paths.Line([xi-hi-markShift,yi], [xi-hi-markShift,yi+wi]),
      }
    };
    var myFsAMakerW1I = {
      paths: {
       "W1ILine0":new makerjs.paths.Line([xi-hi-di-markShift,yi], [xi-hi-di-markShift,yi+w1i]),
       "W1ILine1": new makerjs.paths.Line([xi-h1i,yi+w1i], [xi-h1i-di-markShiftThree,yi+w1i]),//左上角
      }
    };
    var myFsAMakerW2I = {
      paths: {
       "W2ILine0":new makerjs.paths.Line([xi-hi-hi-markShiftThree,yi], [xi-hi-hi-markShiftThree,yi+w2i]),
        "W2ILine1": new makerjs.paths.Line([xi,yi+w2i], [xi-hi-hi-di-markShiftFour,yi+w2i]),//左上角
      }
    };
    var myFsAMakerHI = {      
      paths: {
       "HILine0":new makerjs.paths.Line([xi,yi], [xi, yi-markShiftFour]),
       "HILine1": new makerjs.paths.Line([xi-hi,yi], [xi-hi, yi-markShiftFour]),//左上角
       "HILine2": new makerjs.paths.Line([xi,yi-markShiftTwo], [xi-hi,yi-markShiftTwo]),//左上角
      }
    };
    var myFsAMakerH1I = {    
      paths: {
       "H1ILine0":new makerjs.paths.Line([xi-h1i,yi+w1i], [xi-h1i, yi+w1i+di/2+markShiftFour]),
       "H1ILine1": new makerjs.paths.Line([xi,yi+w2i+markShift], [xi-h1i,yi+w2i+markShift]),//左上角
      }
    };
    var myFsAMakerR2I = {    
      paths: {
      //  "R2ILine1": new makerjs.paths.Line([xi-w2,yi], [xi-w2, yi-r2-markShiftFour]),//左上角
       "R2ILine2": new makerjs.paths.Line([xi,yi+Ia-markShiftTwo], [xi-Ihd,yi+Ia]),//左上角
      }
    };
    var myFsAMakerR1I = {    
      paths: {
       "R1ILine1": new makerjs.paths.Line([xi-Ihd,yi+wi], [xi-Ihd-markShift,yi+wi+markShift]),//左上角
      }
    };
    var myFsAMakerDI = {    
      paths: {
       "DILine1": new makerjs.paths.Line([xi-h1i,yi+w1i], [xi-h1i-di-markShiftFour-markHolesOneD,yi+w1i+markShift+markHolesOneD]),//左上角
      }
    };
     
  /******************************************************** */  
  makerjs.model.addCaption(myFsAMakerWI, TxtWi, [xi-hi-markShiftThree,yi], [xi-hi-markShiftThree,yi+wi]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1I, TxtW1i, [xi-hi-di-markShiftThree,yi], [xi-hi-di-markShiftThree,yi+w1i]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2I, TxtW2i, [xi-hi-hi-di-markShiftFour,yi], [xi-hi-hi-di-markShiftFour,yi+w2i]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHI, TxtHi, [xi-hi,yi-markShiftFour], [xi,yi-markShiftFour]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1I, TxtH1i, [xi-h1i,yi+w2i+markShiftThree], [xi,yi+w2i+markShiftThree]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2I, TxtR2i, [xi-Ihd+markShift,yi+Ia-markShift], [xi-Ihd+markShiftThree,yi+Ia-markShiftThree]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1I, TxtR1i, [xi-Ihd-markShift,yi+wi+markShift], [xi-Ihd,yi+wi]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDI, TxtDi,[xi-h1i-di-markShiftFour-markHolesOneD,yi+w1i+markHolesOneD+markShiftFour], [xi-h1i-di-markShiftFour-markHolesOneD,yi+w1i+markShift+markHolesOneD]);//D文字标注  
   
/***************************************************/  
  /******************************************************** */
  makerjs.model.addCaption(myFsAMakerWG, TxtWg, [xg+hg+markShiftThree,yg], [xg+hg+markShiftThree,yg+wg]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1G, TxtW1g, [xg+hg+dg+markShiftThree,yg], [xg+hg+dg+markShiftThree,yg+w1g]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2G, TxtW2g, [xg+hg+hg+dg+markShiftFour,yg], [xg+hg+hg+dg+markShiftFour,yg+w2g]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHG, TxtHg, [xg,yg-markShiftFour], [xg+hg,yg-markShiftFour]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1G, TxtH1g, [xg,yg+w2g+markShiftThree], [xg+h1g,yg+w2g+markShiftThree]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2G, TxtR2g, [xg+Ghd-markShiftThree,yg+Ga-markShiftThree], [xg+Ghd-markShift,yg+Ga-markShift]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1G, TxtR1g, [xg+Ghd,yg+wg], [xg+Ghd+markShift,yg+wg+markShift]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDG, TxtDg, [xg+h1g+dg+markShiftFour+markHolesOneD,yg+w1g+markShift+markHolesOneD],[xg+h1g+dg+markShiftFour+markHolesOneD,yg+w1g+markHolesOneD+markShiftFour]);//D文字标注  
    
  /******************************************************** */ 
    
    makerjs.model.addCaption(myFsAMakerWC, TxtWc, [xc-hc-markShiftThree,yc-wc], [xc-hc-markShiftThree,yc]);//半径文字  
    makerjs.model.addCaption(myFsAMakerW1C, TxtW1c, [xc-hc-dc-markShiftThree,yc-w1c], [xc-hc-dc-markShiftThree,yc]);//W1文字标注 
    makerjs.model.addCaption(myFsAMakerW2C, TxtW2c, [xc-hc-hc-dc-markShiftFour,yc-w2c], [xc-hc-hc-dc-markShiftFour,yc]);//W1文字标注
    makerjs.model.addCaption(myFsAMakerHC, TxtHc, [xc-hc,yc+markShiftFour], [xc,yc+markShiftFour]);//H文字标注
    makerjs.model.addCaption(myFsAMakerH1C, TxtH1c, [xc-h1c,yc-w2c-markShiftThree], [xc,yc-w2c-markShiftThree]);//H1文字标注
    makerjs.model.addCaption(myFsAMakerR2C, TxtR2c, [xc-Chd+markShift,yc-Ca+markShift], [xc-Chd+markShiftThree,yc-Ca+markShiftThree]);//R2文字标注
    makerjs.model.addCaption(myFsAMakerR1C, TxtR1c, [xc-Chd-markShift,yc-wc-markShift], [xc-Chd,yc-wc]);//R1文字标注
    makerjs.model.addCaption(myFsAMakerDC, TxtDc, [xc-h1c-dc-markShiftFour-markHolesOneD,yc-w1c-markShift-markHolesOneD],[xc-h1c-dc-markShiftFour-markHolesOneD,yc-w1c-markHolesOneD-markShiftFour]);//D文字标注  
      
  
    /******************************************************** */
  /******************************************************** */
  var markers = {
        /**C */
        myFsAMakerWC,
        myFsAMakerW1C,
         myFsAMakerW2C,
         myFsAMakerHC,
        myFsAMakerH1C,
         myFsAMakerR2C,
        myFsAMakerR1C,
        myFsAMakerDC,
        /** G*/        
        myFsAMakerWG,
        myFsAMakerW1G,
         myFsAMakerW2G,
         myFsAMakerHG,
        myFsAMakerH1G,
         myFsAMakerR2G,
        myFsAMakerR1G,
        myFsAMakerDG,
        /**I */
        myFsAMakerWI,
        myFsAMakerW1I,
         myFsAMakerW2I,
         myFsAMakerHI,
        myFsAMakerH1I,
         myFsAMakerR2I,
        myFsAMakerR1I,
        myFsAMakerDI,
      }
  

    // var myFilletMark = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xa, ya], [xcwx, xcwy], [xchx, xchy],[xihx, xihy], [xiwx, xiwy], [xgwx, xgwy]]);
  } else if (area == "ACGI") {
    var myFsAMakerWA = {
      paths: {
        "WALine0": new makerjs.paths.Line([xa+ha,ya], [xa+ha+markShiftThree,ya]),//左上角
        "WALine1": new makerjs.paths.Line([xa+ha,ya-wa], [xa+ha+markShiftThree,ya-wa]),//左上角
        "WALine2":new makerjs.paths.Line([xa+ha+markShift,ya], [xa+ha+markShift,ya-wa]),
      }
    };
    var myFsAMakerW1A = {
      paths: {
       "W1ALine0":new makerjs.paths.Line([xa+ha+da+markShift,ya], [xa+ha+da+markShift,ya-w1a]),
       "W1ALine1": new makerjs.paths.Line([xa+h1a,ya-w1a], [xa+h1a+da+markShiftThree,ya-w1a]),//左上角
      }
    };
    var myFsAMakerW2A = {
      paths: {
       "W2ALine0":new makerjs.paths.Line([xa+ha+ha+markShiftThree,ya], [xa+ha+ha+markShiftThree,ya-w2a]),
        "W2ALine1": new makerjs.paths.Line([xa,ya-w2a], [xa+ha+ha+markShiftFour,ya-w2a]),//左上角
      }
    };
    var myFsAMakerHA = {
      
      paths: {
       "HALine0":new makerjs.paths.Line([xa,ya], [xa, ya+markShiftFour]),
       "HALine1": new makerjs.paths.Line([xa+ha,ya], [xa+ha, ya+markShiftFour]),//左上角
       "HALine2": new makerjs.paths.Line([xa,ya+markShiftTwo], [xa+ha,ya+markShiftTwo]),//左上角
      }
    };
    var myFsAMakerH1A = {    
      paths: {
       "H1ALine0":new makerjs.paths.Line([xa+h1a,ya-w1a], [xa+h1a, ya-w1a-da/2-markShiftFour]),
       "H1ALine1": new makerjs.paths.Line([xa,ya-w2a-markShift], [xa+h1a,ya-w2a-markShift]),//左上角
      }
    };
 
    var myFsAMakerR2A = {    
      paths: {
       "R2ALine1": new makerjs.paths.Line([xa,ya-w2a], [xa+r2a+markShiftFour, ya-w2a]),//左上角
       "R2ALine2": new makerjs.paths.Line([xa,ya-Aa+markShiftTwo], [xa+Ahd,ya-Aa]),//左上角
      }
    };
    var myFsAMakerR1A = {    
      paths: {
       "R1ALine1": new makerjs.paths.Line([xa+Ahd,ya-wa], [xa+Ahd+markShift,ya-wa-markShift]),//左上角
      }
    };
    var myFsAMakerDA = {    
      paths: {
       "DALine1": new makerjs.paths.Line([xa+h1a,ya-w1a], [xa+h1a+da+markShiftFour+markHolesOneD,ya-w1a-markShift-markHolesOneD]),//左上角
      }
    };
    /**************************************************** */
      /*****************  C  *********** */
      var myFsAMakerWC = {
        paths: {
          "WCLine0": new makerjs.paths.Line([xc-hc,yc], [xc-hc-markShiftThree,yc]),//左上角
          "WCLine1": new makerjs.paths.Line([xc-hc,yc-wc], [xc-hc-markShiftThree,yc-wc]),//左上角
          "WCLine2":new makerjs.paths.Line([xc-hc-markShift,yc-wc], [xc-hc-markShift,yc]),
        }
      };
      var myFsAMakerW1C = {
        paths: {
         "W1CLine0":new makerjs.paths.Line([xc-hc-dc-markShift,yc-w1c], [xc-hc-dc-markShift,yc]),
         "W1CLine1": new makerjs.paths.Line([xc-h1c,yc-w1c], [xc-h1c-dc-markShiftThree,yc-w1c]),//左上角
        }
      };
      var myFsAMakerW2C = {
        paths: {
         "W2CLine0":new makerjs.paths.Line([xc-hc-hc-markShiftThree,yc], [xc-hc-hc-markShiftThree,yc-w2c]),
          "W2CLine1": new makerjs.paths.Line([xc,yc-w2c], [xc-hc-hc-dc-markShiftFour,yc-w2c]),//左上角
        }
      };
      var myFsAMakerHC = {      
        paths: {
         "HCLine0":new makerjs.paths.Line([xc,yc], [xc, yc+markShiftFour]),
         "HCLine1": new makerjs.paths.Line([xc-hc,yc], [xc-hc, yc+markShiftFour]),//左上角
         "HCLine2": new makerjs.paths.Line([xc,yc+markShiftTwo], [xc-hc,yc+markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1C = {    
        paths: {
         "H1CLine0":new makerjs.paths.Line([xc-h1c,yc-w1c], [xc-h1c, yc-w1c-dc/2-markShiftFour]),
         "H1CLine1": new makerjs.paths.Line([xc,yc-w2c-markShift], [xc-h1c,yc-w2c-markShift]),//左上角
        }
      };
      var myFsAMakerR2C = {    
        paths: {
        //  "R2CLine1": new makerjs.paths.Line([xc-w2,yc], [xc-w2, yc-r2-markShiftFour]),//左上角
         "R2CLine2": new makerjs.paths.Line([xc,yc-Ca+markShiftTwo], [xc-Chd,yc-Ca]),//左上角
        }
      };
      var myFsAMakerR1C = {    
        paths: {
         "R1CLine1": new makerjs.paths.Line([xc-Chd,yc-wc], [xc-Chd-markShift,yc-wc-markShift]),//左上角
        }
      };
      var myFsAMakerDC = {    
        paths: {
         "DCLine1": new makerjs.paths.Line([xc-h1c,yc-w1c], [xc-h1c-dc-markShiftFour-markHolesOneD,yc-w1c-markShift-markHolesOneD]),//左上角
        }
      };
         
    /**************************************************** */ 
    /****************** G   ************** */
    var myFsAMakerWG = {
      paths: {
        "WGLine0": new makerjs.paths.Line([xg+hg,yg], [xg+hg+markShiftThree,yg]),//左上角
        "WGLine1": new makerjs.paths.Line([xg+hg,yg+wg], [xg+hg+markShiftThree,yg+wg]),//左上角
        "WGLine2":new makerjs.paths.Line([xg+hg+markShift,yg], [xg+hg+markShift,yg+wg]),
      }
    };
    var myFsAMakerW1G = {
      paths: {
        "W1GLine0":new makerjs.paths.Line([xg+hg+dg+markShift,yg], [xg+hg+dg+markShift,yg+w1g]),
        "W1GLine1": new makerjs.paths.Line([xg+h1g,yg+w1g], [xg+h1g+dg+markShiftThree,yg+w1g]),//左上角
      }
    };
    var myFsAMakerW2G = {
      paths: {
        "W2GLine0":new makerjs.paths.Line([xg+hg+hg+markShiftThree,yg], [xg+hg+hg+markShiftThree,yg+w2g]),
        "W2GLine1": new makerjs.paths.Line([xg,yg+w2g], [xg+hg+hg+dg+markShiftFour,yg+w2g]),//左上角
      }
    };
    var myFsAMakerHG = {      
      paths: {
        "HGLine0":new makerjs.paths.Line([xg,yg], [xg, yg-markShiftFour]),
        "HGLine1": new makerjs.paths.Line([xg+hg,yg], [xg+hg, yg-markShiftFour]),//左上角
        "HGLine2": new makerjs.paths.Line([xg,yg-markShiftTwo], [xg+hg,yg-markShiftTwo]),//左上角
      }
    };
    var myFsAMakerH1G = {    
      paths: {
        "H1GLine0":new makerjs.paths.Line([xg+h1g,yg+w1g], [xg+h1g, yg+w1g+dg/2+markShiftFour]),
        "H1GLine1": new makerjs.paths.Line([xg,yg+w2g+markShift], [xg+h1g,yg+w2g+markShift]),//左上角
      }
    };
    var myFsAMakerR2G = {    
      paths: {
        "R2GLine1": new makerjs.paths.Line([xg,yg+w2g], [xg+r2g+markShiftFour, yg+w2g]),//左上角
        "R2GLine2": new makerjs.paths.Line([xg,yg+Ga-markShiftTwo], [xg+Ghd,yg+Ga]),//左上角
      }
    };
    var myFsAMakerR1G = {    
      paths: {
        "R1GLine1": new makerjs.paths.Line([xg+Ghd,yg+wg], [xg+Ghd+markShift,yg+wg+markShift]),//左上角
      }
    };
    var myFsAMakerDG = {    
      paths: {
        "DGLine1": new makerjs.paths.Line([xg+h1g,yg+w1g], [xg+h1g+dg+markShiftFour+markHolesOneD,yg+w1g+markShift+markHolesOneD]),//左上角
      }
    };

    
    /**************************************************** */  
    /************************   I  ******************* */
    var myFsAMakerWI = {
      paths: {
       // "WILine0": new makerjs.paths.Line([xi,yi+hi], [xi,yi+hi+markShiftThree]),//左上角
        "WILine1": new makerjs.paths.Line([xi-hi,yi+wi], [xi-hi-markShiftThree,yi+wi]),//左上角
        "WILine2":new makerjs.paths.Line([xi-hi-markShift,yi], [xi-hi-markShift,yi+wi]),
      }
    };
    var myFsAMakerW1I = {
      paths: {
       "W1ILine0":new makerjs.paths.Line([xi-hi-di-markShift,yi], [xi-hi-di-markShift,yi+w1i]),
       "W1ILine1": new makerjs.paths.Line([xi-h1i,yi+w1i], [xi-h1i-di-markShiftThree,yi+w1i]),//左上角
      }
    };
    var myFsAMakerW2I = {
      paths: {
       "W2ILine0":new makerjs.paths.Line([xi-hi-hi-markShiftThree,yi], [xi-hi-hi-markShiftThree,yi+w2i]),
        "W2ILine1": new makerjs.paths.Line([xi,yi+w2i], [xi-hi-hi-di-markShiftFour,yi+w2i]),//左上角
      }
    };
    var myFsAMakerHI = {      
      paths: {
       "HILine0":new makerjs.paths.Line([xi,yi], [xi, yi-markShiftFour]),
       "HILine1": new makerjs.paths.Line([xi-hi,yi], [xi-hi, yi-markShiftFour]),//左上角
       "HILine2": new makerjs.paths.Line([xi,yi-markShiftTwo], [xi-hi,yi-markShiftTwo]),//左上角
      }
    };
    var myFsAMakerH1I = {    
      paths: {
       "H1ILine0":new makerjs.paths.Line([xi-h1i,yi+w1i], [xi-h1i, yi+w1i+di/2+markShiftFour]),
       "H1ILine1": new makerjs.paths.Line([xi,yi+w2i+markShift], [xi-h1i,yi+w2i+markShift]),//左上角
      }
    };
    var myFsAMakerR2I = {    
      paths: {
      //  "R2ILine1": new makerjs.paths.Line([xi-w2,yi], [xi-w2, yi-r2-markShiftFour]),//左上角
       "R2ILine2": new makerjs.paths.Line([xi,yi+Ia-markShiftTwo], [xi-Ihd,yi+Ia]),//左上角
      }
    };
    var myFsAMakerR1I = {    
      paths: {
       "R1ILine1": new makerjs.paths.Line([xi-Ihd,yi+wi], [xi-Ihd-markShift,yi+wi+markShift]),//左上角
      }
    };
    var myFsAMakerDI = {    
      paths: {
       "DILine1": new makerjs.paths.Line([xi-h1i,yi+w1i], [xi-h1i-di-markShiftFour-markHolesOneD,yi+w1i+markShift+markHolesOneD]),//左上角
      }
    };
     
  /******************************************************** */  
  makerjs.model.addCaption(myFsAMakerWI, TxtWi, [xi-hi-markShiftThree,yi], [xi-hi-markShiftThree,yi+wi]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1I, TxtW1i, [xi-hi-di-markShiftThree,yi], [xi-hi-di-markShiftThree,yi+w1i]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2I, TxtW2i, [xi-hi-hi-di-markShiftFour,yi], [xi-hi-hi-di-markShiftFour,yi+w2i]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHI, TxtHi, [xi-hi,yi-markShiftFour], [xi,yi-markShiftFour]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1I, TxtH1i, [xi-h1i,yi+w2i+markShiftThree], [xi,yi+w2i+markShiftThree]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2I, TxtR2i, [xi-Ihd+markShift,yi+Ia-markShift], [xi-Ihd+markShiftThree,yi+Ia-markShiftThree]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1I, TxtR1i, [xi-Ihd-markShift,yi+wi+markShift], [xi-Ihd,yi+wi]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDI, TxtDi,[xi-h1i-di-markShiftFour-markHolesOneD,yi+w1i+markHolesOneD+markShiftFour], [xi-h1i-di-markShiftFour-markHolesOneD,yi+w1i+markShift+markHolesOneD]);//D文字标注  
   
/***************************************************/  
  /******************************************************** */
  makerjs.model.addCaption(myFsAMakerWG, TxtWg, [xg+hg+markShiftThree,yg], [xg+hg+markShiftThree,yg+wg]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1G, TxtW1g, [xg+hg+dg+markShiftThree,yg], [xg+hg+dg+markShiftThree,yg+w1g]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2G, TxtW2g, [xg+hg+hg+dg+markShiftFour,yg], [xg+hg+hg+dg+markShiftFour,yg+w2g]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHG, TxtHg, [xg,yg-markShiftFour], [xg+hg,yg-markShiftFour]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1G, TxtH1g, [xg,yg+w2g+markShiftThree], [xg+h1g,yg+w2g+markShiftThree]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2G, TxtR2g, [xg+Ghd-markShiftThree,yg+Ga-markShiftThree], [xg+Ghd-markShift,yg+Ga-markShift]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1G, TxtR1g, [xg+Ghd,yg+wg], [xg+Ghd+markShift,yg+wg+markShift]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDG, TxtDg, [xg+h1g+dg+markShiftFour+markHolesOneD,yg+w1g+markShift+markHolesOneD],[xg+h1g+dg+markShiftFour+markHolesOneD,yg+w1g+markHolesOneD+markShiftFour]);//D文字标注  
    
  /******************************************************** */ 
    
    makerjs.model.addCaption(myFsAMakerWC, TxtWc, [xc-hc-markShiftThree,yc-wc], [xc-hc-markShiftThree,yc]);//半径文字  
    makerjs.model.addCaption(myFsAMakerW1C, TxtW1c, [xc-hc-dc-markShiftThree,yc-w1c], [xc-hc-dc-markShiftThree,yc]);//W1文字标注 
    makerjs.model.addCaption(myFsAMakerW2C, TxtW2c, [xc-hc-hc-dc-markShiftFour,yc-w2c], [xc-hc-hc-dc-markShiftFour,yc]);//W1文字标注
    makerjs.model.addCaption(myFsAMakerHC, TxtHc, [xc-hc,yc+markShiftFour], [xc,yc+markShiftFour]);//H文字标注
    makerjs.model.addCaption(myFsAMakerH1C, TxtH1c, [xc-h1c,yc-w2c-markShiftThree], [xc,yc-w2c-markShiftThree]);//H1文字标注
    makerjs.model.addCaption(myFsAMakerR2C, TxtR2c, [xc-Chd+markShift,yc-Ca+markShift], [xc-Chd+markShiftThree,yc-Ca+markShiftThree]);//R2文字标注
    makerjs.model.addCaption(myFsAMakerR1C, TxtR1c, [xc-Chd-markShift,yc-wc-markShift], [xc-Chd,yc-wc]);//R1文字标注
    makerjs.model.addCaption(myFsAMakerDC, TxtDc, [xc-h1c-dc-markShiftFour-markHolesOneD,yc-w1c-markShift-markHolesOneD],[xc-h1c-dc-markShiftFour-markHolesOneD,yc-w1c-markHolesOneD-markShiftFour]);//D文字标注  
      
  
    /******************************************************** */
    
  makerjs.model.addCaption(myFsAMakerWA, TxtWa, [xa+ha+markShiftThree,ya], [xa+ha+markShiftThree,ya-wa]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1A, TxtW1a, [xa+ha+da+markShiftThree,ya], [xa+ha+da+markShiftThree,ya-w1a]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2A, TxtW2a, [xa+ha+ha+da+markShiftFour,ya], [xa+ha+ha+da+markShiftFour,ya-w2a]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHA, TxtHa, [xa,ya+markShiftFour], [xa+ha,ya+markShiftFour]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1A, TxtH1a, [xa,ya-w2a-markShiftThree], [xa+h1a,ya-w2a-markShiftThree]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2A, TxtR2a,[xa+Ahd-markShiftThree,ya-Aa+markShiftThree], [xa+Ahd-markShift,ya-Aa+markShift]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1A, TxtR1a, [xa+Ahd,ya-wa], [xa+Ahd+markShift,ya-wa-markShift]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDA, TxtDa, [xa+h1a+da+markShiftFour+markHolesOneD,ya-w1a-markShift-markHolesOneD],[xa+h1a+da+markShiftFour+markHolesOneD,ya-w1a-markHolesOneD-markShiftFour]);//D文字标注  
   
  /**************************************************** */

  /******************************************************** */
  var markers = {
    /**A */
        myFsAMakerWA,
        myFsAMakerW1A,
         myFsAMakerW2A,
         myFsAMakerHA,
        myFsAMakerH1A,
         myFsAMakerR2A,
        myFsAMakerR1A,
        myFsAMakerDA,
        /**C */
        myFsAMakerWC,
        myFsAMakerW1C,
         myFsAMakerW2C,
         myFsAMakerHC,
        myFsAMakerH1C,
         myFsAMakerR2C,
        myFsAMakerR1C,
        myFsAMakerDC,
        /** G*/        
        myFsAMakerWG,
        myFsAMakerW1G,
         myFsAMakerW2G,
         myFsAMakerHG,
        myFsAMakerH1G,
         myFsAMakerR2G,
        myFsAMakerR1G,
        myFsAMakerDG,
        /**I */
        myFsAMakerWI,
        myFsAMakerW1I,
         myFsAMakerW2I,
         myFsAMakerHI,
        myFsAMakerH1I,
         myFsAMakerR2I,
        myFsAMakerR1I,
        myFsAMakerDI,
      }
  

    // var myFilletMark = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xahx, xahy], [xawx, xawy], [xcwx, xcwy], [xchx, xchy],[xihx, xihy], [xiwx, xiwy], [xgwx, xgwy]]);
  }
}else{
  console.log("短边在X轴￥￥￥￥￥");
  if (area == "A") {    
    var myFsAMakerWA = {
      paths: {
        "WALine0": new makerjs.paths.Line([xa,ya-ha], [xa,ya-ha-markShiftThree]),//左上角
        "WALine1": new makerjs.paths.Line([xa+wa,ya-ha], [xa+wa,ya-ha-markShiftThree]),//左上角
        "WALine2":new makerjs.paths.Line([xa,ya-ha-markShift], [xa+wa,ya-ha-markShift]),
      }
    };
    var myFsAMakerW1A = {
      paths: {
       "W1ALine0":new makerjs.paths.Line([xa,ya-ha-da-markShift], [xa+w1a,ya-ha-da-markShift]),
       "W1ALine1": new makerjs.paths.Line([xa+w1a,ya-h1a], [xa+w1a,ya-h1a-da-markShiftThree]),//左上角
      }
    };
    var myFsAMakerW2A = {
      paths: {
       "W2ALine0":new makerjs.paths.Line([xa,ya-ha-ha-markShiftThree], [xa+w2a,ya-ha-ha-markShiftThree]),
        "W2ALine1": new makerjs.paths.Line([xa+w2a,ya], [xa+w2a,ya-ha-ha-da-markShiftFour]),//左上角
      }
    };
    var myFsAMakerHA = {
      
      paths: {
       "HALine0":new makerjs.paths.Line([xa,ya], [xa-markShiftFour, ya]),
       "HALine1": new makerjs.paths.Line([xa,ya-ha], [xa-markShiftFour, ya-ha]),//左上角
       "HALine2": new makerjs.paths.Line([xa-markShiftTwo,ya], [xa-markShiftTwo,ya-ha]),//左上角
      }
    };
    var myFsAMakerH1A = {    
      paths: {
       "H1ALine0":new makerjs.paths.Line([xa+w1a,ya-h1a], [xa+w1a+da/2+markShiftFour, ya-h1a]),
       "H1ALine1": new makerjs.paths.Line([xa+w2a+markShift,ya], [xa+w2a+markShift,ya-h1a]),//左上角
      }
    };
    var myFsAMakerR2A = {    
      paths: {
       "R2ALine1": new makerjs.paths.Line([xa+w2a,ya], [xa+w2a, ya-r2a-markShiftFour]),//左上角
       "R2ALine2": new makerjs.paths.Line([xa+Aa-markShiftTwo,ya], [xa+Aa,ya-Ahd]),//左上角
      }
    };
    var myFsAMakerR1A = {    
      paths: {
       "R1ALine1": new makerjs.paths.Line([xa+wa,ya-Ahd], [xa+wa+markShift,ya-Ahd-markShift]),//左上角
      }
    };
    var myFsAMakerDA = {    
      paths: {
       "DALine1": new makerjs.paths.Line([xa+w1a,ya-h1a], [xa+w1a+markShift+markHolesOneD,ya-h1a-da-markShiftFour-markHolesOneD]),//左上角
      }
    };
    /**************************************************** */
    
  makerjs.model.addCaption(myFsAMakerWA, TxtWa, [xa,ya-ha-markShiftThree], [xa+wa,ya-ha-markShiftThree]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1A, TxtW1a, [xa,ya-ha-da-markShiftThree], [xa+w1a,ya-ha-da-markShiftThree]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2A, TxtW2a, [xa,ya-ha-ha-da-markShiftFour], [xa+w2a,ya-ha-ha-da-markShiftFour]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHA, TxtHa, [xa-markShiftFour,ya-ha], [xa-markShiftFour,ya]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1A, TxtH1a, [xa+w2a+markShiftThree,ya-h1a], [xa+w2a+markShiftThree,ya]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2A, TxtR2a, [xa+Aa-markShiftThree,ya-Ahd+markShiftThree], [xa+Aa-markShift,ya-Ahd+markShift]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1A, TxtR1a, [xa+wa,ya-Ahd], [xa+wa+markShift,ya-Ahd-markShift]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDA, TxtDa, [xa+w1a+markShift+markHolesOneD,ya-h1a-da-markShiftFour-markHolesOneD],[xa+w1a+markHolesOneD+markShiftFour,ya-h1a-da-markShiftFour-markHolesOneD]);//D文字标注  
    
  /**************************************************** */
  
    var markers = {
      myFsAMakerWA,
      myFsAMakerW1A,
       myFsAMakerW2A,
       myFsAMakerHA,
      myFsAMakerH1A,
       myFsAMakerR2A,
      myFsAMakerR1A,
      myFsAMakerDA,
    }

  } else if (area == "C") {
 
    /*****************  C  *********** */
    var myFsAMakerWC = {
      paths: {
        "WCLine0": new makerjs.paths.Line([xc,yc-hc], [xc,yc-hc-markShiftThree]),//左上角
        "WCLine1": new makerjs.paths.Line([xc-wc,yc-hc], [xc-wc,yc-hc-markShiftThree]),//左上角
        "WCLine2":new makerjs.paths.Line([xc,yc-hc-markShift], [xc-wc,yc-hc-markShift]),
      }
    };
    var myFsAMakerW1C = {
      paths: {
       "W1CLine0":new makerjs.paths.Line([xc,yc-hc-dc-markShift], [xc-w1c,yc-hc-dc-markShift]),
       "W1CLine1": new makerjs.paths.Line([xc-w1c,yc-h1c], [xc-w1c,yc-h1c-dc-markShiftThree]),//左上角
      }
    };
    var myFsAMakerW2C = {
      paths: {
       "W2CLine0":new makerjs.paths.Line([xc,yc-hc-hc-markShiftThree], [xc-w2c,yc-hc-hc-markShiftThree]),
        "W2CLine1": new makerjs.paths.Line([xc-w2c,yc], [xc-w2c,yc-hc-hc-dc-markShiftFour]),//左上角
      }
    };
    var myFsAMakerHC = {      
      paths: {
       "HCLine0":new makerjs.paths.Line([xc,yc], [xc+markShiftFour, yc]),
       "HCLine1": new makerjs.paths.Line([xc,yc-hc], [xc+markShiftFour, yc-hc]),//左上角
       "HCLine2": new makerjs.paths.Line([xc+markShiftTwo,yc], [xc+markShiftTwo,yc-hc]),//左上角
      }
    };
    var myFsAMakerH1C = {    
      paths: {
       "H1CLine0":new makerjs.paths.Line([xc-w1c,yc-h1c], [xc-w1c-dc/2-markShiftFour, yc-h1c]),
       "H1CLine1": new makerjs.paths.Line([xc-w2c-markShift,yc], [xc-w2c-markShift,yc-h1c]),//左上角
      }
    };
    var myFsAMakerR2C = {    
      paths: {
      //  "R2CLine1": new makerjs.paths.Line([xc-w2,yc], [xc-w2, yc-r2-markShiftFour]),//左上角
       "R2CLine2": new makerjs.paths.Line([xc-Caa+markShiftTwo,yc], [xc-Caa,yc-Chd]),//左上角
      }
    };
    var myFsAMakerR1C = {    
      paths: {
       "R1CLine1": new makerjs.paths.Line([xc-wc,yc-Chd], [xc-wc-markShift,yc-Chd-markShift]),//左上角
      }
    };
    var myFsAMakerDC = {    
      paths: {
       "DCLine1": new makerjs.paths.Line([xc-w1c,yc-h1c], [xc-w1c-markShift-markHolesOneD,yc-h1c-dc-markShiftFour-markHolesOneD]),//左上角
      }
    };
       
  /**************************************************** */

  
  makerjs.model.addCaption(myFsAMakerWC, TxtWc, [xc-wc,yc-hc-markShiftThree], [xc,yc-hc-markShiftThree]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1C, TxtW1c, [xc-w1c,yc-hc-dc-markShiftThree], [xc,yc-hc-dc-markShiftThree]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2C, TxtW2c, [xc-w2c,yc-hc-hc-dc-markShiftFour], [xc,yc-hc-hc-dc-markShiftFour]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHC, TxtHc, [xc+markShiftFour,yc-hc], [xc+markShiftFour,yc]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1C, TxtH1c, [xc-w2c-markShiftThree,yc-h1c], [xc-w2c-markShiftThree,yc]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2C, TxtR2c, [xc-Caa+markShift,yc-Chd+markShift], [xc-Caa+markShiftThree,yc-Chd+markShiftThree]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1C, TxtR1c, [xc-wc-markShift,yc-Chd-markShift], [xc-wc,yc-Chd]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDC, TxtDc,[xc-w1c-markHolesOneD-markShiftFour,yc-h1c-dc-markShiftFour-markHolesOneD], [xc-w1c-markShift-markHolesOneD,yc-h1c-dc-markShiftFour-markHolesOneD]);//D文字标注  
    

  /******************************************************** */
    
      var markers = {
        myFsAMakerWC,
        myFsAMakerW1C,
         myFsAMakerW2C,
         myFsAMakerHC,
        myFsAMakerH1C,
         myFsAMakerR2C,
        myFsAMakerR1C,
        myFsAMakerDC,
      }
  } else if (area == "G") {
  
    /****************** G   ************** */
    var myFsAMakerWG = {
      paths: {
        "WGLine0": new makerjs.paths.Line([xg,yg+hg], [xg,yg+hg+markShiftThree]),//左上角
        "WGLine1": new makerjs.paths.Line([xg+wg,yg+hg], [xg+wg,yg+hg+markShiftThree]),//左上角
        "WGLine2":new makerjs.paths.Line([xg,yg+hg+markShift], [xg+wg,yg+hg+markShift]),
      }
    };
    var myFsAMakerW1G = {
      paths: {
        "W1GLine0":new makerjs.paths.Line([xg,yg+hg+dg+markShift], [xg+w1g,yg+hg+dg+markShift]),
        "W1GLine1": new makerjs.paths.Line([xg+w1g,yg+h1g], [xg+w1g,yg+h1g+dg+markShiftThree]),//左上角
      }
    };
    var myFsAMakerW2G = {
      paths: {
        "W2GLine0":new makerjs.paths.Line([xg,yg+hg+hg+markShiftThree], [xg+w2g,yg+hg+hg+markShiftThree]),
        "W2GLine1": new makerjs.paths.Line([xg+w2g,yg], [xg+w2g,yg+hg+hg+dg+markShiftFour]),//左上角
      }
    };
    var myFsAMakerHG = {      
      paths: {
        "HGLine0":new makerjs.paths.Line([xg,yg], [xg-markShiftFour, yg]),
        "HGLine1": new makerjs.paths.Line([xg,yg+hg], [xg-markShiftFour, yg+hg]),//左上角
        "HGLine2": new makerjs.paths.Line([xg-markShiftTwo,yg], [xg-markShiftTwo,yg+hg]),//左上角
      }
    };
    var myFsAMakerH1G = {    
      paths: {
        "H1GLine0":new makerjs.paths.Line([xg+w1g,yg+h1g], [xg+w1g+dg/2+markShiftFour, yg+h1g]),
        "H1GLine1": new makerjs.paths.Line([xg+w2g+markShift,yg], [xg+w2g+markShift,yg+h1g]),//左上角
      }
    };
    var myFsAMakerR2G = {    
      paths: {
        "R2GLine1": new makerjs.paths.Line([xg+w2g,yg], [xg+w2g, yg+r2g+markShiftFour]),//左上角
        "R2GLine2": new makerjs.paths.Line([xg+Ga-markShiftTwo,yg], [xg+Ga,yg+Ghd]),//左上角
      }
    };
    var myFsAMakerR1G = {    
      paths: {
        "R1GLine1": new makerjs.paths.Line([xg+wg,yg+Ghd], [xg+wg+markShift,yg+Ghd+markShift]),//左上角
      }
    };
    var myFsAMakerDG = {    
      paths: {
        "DGLine1": new makerjs.paths.Line([xg+w1g,yg+h1g], [xg+w1g+markShift+markHolesOneD,yg+h1g+dg+markShiftFour+markHolesOneD]),//左上角
      }
    };

    
    /**************************************************** */
  
  /******************************************************** */
  makerjs.model.addCaption(myFsAMakerWG, TxtWg, [xg,yg+hg+markShiftThree], [xg+wg,yg+hg+markShiftThree]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1G, TxtW1g, [xg,yg+hg+dg+markShiftThree], [xg+w1g,yg+hg+dg+markShiftThree]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2G, TxtW2g, [xg,yg+hg+hg+dg+markShiftFour], [xg+w2g,yg+hg+hg+dg+markShiftFour]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHG, TxtHg, [xg-markShiftFour,yg+hg], [xg-markShiftFour,yg]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1G, TxtH1g, [xg+w2g+markShiftThree,yg+h1g], [xg+w2g+markShiftThree,yg]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2G, TxtR2g, [xg+Ga-markShiftThree,yg+Ghd-markShiftThree], [xg+Ga-markShift,yg+Ghd-markShift]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1G, TxtR1g, [xg+wg,yg+Ghd], [xg+wg+markShift,yg+Ghd+markShift]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDG, TxtDg, [xg+w1g+markShift+markHolesOneD,yg+h1g+dg+markShiftFour+markHolesOneD],[xg+w1g+markHolesOneD+markShiftFour,yg+h1g+dg+markShiftFour+markHolesOneD]);//D文字标注  
    
  /******************************************************** */
  
/********************************************* */  
      var markers = {
        myFsAMakerWG,
        myFsAMakerW1G,
         myFsAMakerW2G,
         myFsAMakerHG,
        myFsAMakerH1G,
         myFsAMakerR2G,
        myFsAMakerR1G,
        myFsAMakerDG,
      }
    
  } else if (area == "I") {
  
    /************************   I  ******************* */
    var myFsAMakerWI = {
      paths: {
       // "WILine0": new makerjs.paths.Line([xi,yi+hi], [xi,yi+hi+markShiftThree]),//左上角
        "WILine1": new makerjs.paths.Line([xi-wi,yi+hi], [xi-wi,yi+hi+markShiftThree]),//左上角
        "WILine2":new makerjs.paths.Line([xi,yi+hi+markShift], [xi-wi,yi+hi+markShift]),
      }
    };
    var myFsAMakerW1I = {
      paths: {
       "W1ILine0":new makerjs.paths.Line([xi,yi+hi+di+markShift], [xi-w1i,yi+hi+di+markShift]),
       "W1ILine1": new makerjs.paths.Line([xi-w1i,yi+h1i], [xi-w1i,yi+h1i+di+markShiftThree]),//左上角
      }
    };



    var myFsAMakerW2I = {
      paths: {
       "W2ILine0":new makerjs.paths.Line([xi,yi+hi+hi+markShiftThree], [xi-w2i,yi+hi+hi+markShiftThree]),
        "W2ILine1": new makerjs.paths.Line([xi-w2i,yi], [xi-w2i,yi+hi+hi+di+markShiftFour]),//左上角
      }
    };
    var myFsAMakerHI = {      
      paths: {
       "HILine0":new makerjs.paths.Line([xi,yi], [xi+markShiftFour, yi]),
       "HILine1": new makerjs.paths.Line([xi,yi+hi], [xi+markShiftFour, yi+hi]),//左上角
       "HILine2": new makerjs.paths.Line([xi+markShiftTwo,yi], [xi+markShiftTwo,yi+hi]),//左上角
      }
    };
    var myFsAMakerH1I = {    
      paths: {
       "H1ILine0":new makerjs.paths.Line([xi-w1i,yi+h1i], [xi-w1i-di/2-markShiftFour, yi+h1i]),
       "H1ILine1": new makerjs.paths.Line([xi-w2i-markShift,yi], [xi-w2i-markShift,yi+h1i]),//左上角
      }
    };
    var myFsAMakerR2I = {    
      paths: {
      //  "R2ILine1": new makerjs.paths.Line([xi-w2,yi], [xi-w2, yi-r2-markShiftFour]),//左上角
       "R2ILine2": new makerjs.paths.Line([xi-Iaa+markShiftTwo,yi], [xi-Iaa,yi+Ihd]),//左上角
      }
    };
    var myFsAMakerR1I = {    
      paths: {
       "R1ILine1": new makerjs.paths.Line([xi-wi,yi+Ihd], [xi-wi-markShift,yi+Ihd+markShift]),//左上角
      }
    };
    var myFsAMakerDI = {    
      paths: {
       "DILine1": new makerjs.paths.Line([xi-w1i,yi+h1i], [xi-w1i-markShift-markHolesOneD,yi+h1i+di+markShiftFour+markHolesOneD]),//左上角
      }
    };

     
  /******************************************************** */
  
  makerjs.model.addCaption(myFsAMakerWI, TxtWi, [xi-wi,yi+hi+markShiftThree], [xi,yi+hi+markShiftThree]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1I, TxtW1i, [xi-w1i,yi+hi+di+markShiftThree], [xi,yi+hi+di+markShiftThree]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2I, TxtW2i, [xi-w2i,yi+hi+hi+di+markShiftFour], [xi,yi+hi+hi+di+markShiftFour]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHI, TxtHi, [xi+markShiftFour,yi+hi], [xi+markShiftFour,yi]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1I, TxtH1i, [xi-w2i-markShiftThree,yi+h1i], [xi-w2i-markShiftThree,yi]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2I, TxtR2i, [xi-Iaa+markShift,yi+Ihd-markShift], [xi-Iaa+markShiftThree,yi+Ihd-markShiftThree]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1I, TxtR1i, [xi-wi-markShift,yi+Ihd+markShift], [xi-wi,yi+Ihd]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDI, TxtDi,[xi-w1i-markHolesOneD-markShiftFour,yi+h1i+di+markShiftFour+markHolesOneD], [xi-w1i-markShift-markHolesOneD,yi+h1i+di+markShiftFour+markHolesOneD]);//D文字标注  
   
/***************************************************/  
      var markers = {
         myFsAMakerWI,
         myFsAMakerW1I,
         myFsAMakerW2I,
         myFsAMakerHI,
         myFsAMakerH1I,
         myFsAMakerR2I,
         myFsAMakerR1I,
         myFsAMakerDI,
      }   
    
  } else if (area == "AC") {
    var myFsAMakerWA = {
      paths: {
        "WALine0": new makerjs.paths.Line([xa,ya-ha], [xa,ya-ha-markShiftThree]),//左上角
        "WALine1": new makerjs.paths.Line([xa+wa,ya-ha], [xa+wa,ya-ha-markShiftThree]),//左上角
        "WALine2":new makerjs.paths.Line([xa,ya-ha-markShift], [xa+wa,ya-ha-markShift]),
      }
    };
    var myFsAMakerW1A = {
      paths: {
       "W1ALine0":new makerjs.paths.Line([xa,ya-ha-da-markShift], [xa+w1a,ya-ha-da-markShift]),
       "W1ALine1": new makerjs.paths.Line([xa+w1a,ya-h1a], [xa+w1a,ya-h1a-da-markShiftThree]),//左上角
      }
    };
    var myFsAMakerW2A = {
      paths: {
       "W2ALine0":new makerjs.paths.Line([xa,ya-ha-ha-markShiftThree], [xa+w2a,ya-ha-ha-markShiftThree]),
        "W2ALine1": new makerjs.paths.Line([xa+w2a,ya], [xa+w2a,ya-ha-ha-da-markShiftFour]),//左上角
      }
    };
    var myFsAMakerHA = {
      
      paths: {
       "HALine0":new makerjs.paths.Line([xa,ya], [xa-markShiftFour, ya]),
       "HALine1": new makerjs.paths.Line([xa,ya-ha], [xa-markShiftFour, ya-ha]),//左上角
       "HALine2": new makerjs.paths.Line([xa-markShiftTwo,ya], [xa-markShiftTwo,ya-ha]),//左上角
      }
    };
    var myFsAMakerH1A = {    
      paths: {
       "H1ALine0":new makerjs.paths.Line([xa+w1a,ya-h1a], [xa+w1a+da/2+markShiftFour, ya-h1a]),
       "H1ALine1": new makerjs.paths.Line([xa+w2a+markShift,ya], [xa+w2a+markShift,ya-h1a]),//左上角
      }
    };
    var myFsAMakerR2A = {    
      paths: {
       "R2ALine1": new makerjs.paths.Line([xa+w2a,ya], [xa+w2a, ya-r2a-markShiftFour]),//左上角
       "R2ALine2": new makerjs.paths.Line([xa+Aa-markShiftTwo,ya], [xa+Aa,ya-Ahd]),//左上角
      }
    };
    var myFsAMakerR1A = {    
      paths: {
       "R1ALine1": new makerjs.paths.Line([xa+wa,ya-Ahd], [xa+wa+markShift,ya-Ahd-markShift]),//左上角
      }
    };
    var myFsAMakerDA = {    
      paths: {
       "DALine1": new makerjs.paths.Line([xa+w1a,ya-h1a], [xa+w1a+markShift+markHolesOneD,ya-h1a-da-markShiftFour-markHolesOneD]),//左上角
      }
    };
    /*****************  C  *********** */
    var myFsAMakerWC = {
      paths: {
        "WCLine0": new makerjs.paths.Line([xc,yc-hc], [xc,yc-hc-markShiftThree]),//左上角
        "WCLine1": new makerjs.paths.Line([xc-wc,yc-hc], [xc-wc,yc-hc-markShiftThree]),//左上角
        "WCLine2":new makerjs.paths.Line([xc,yc-hc-markShift], [xc-wc,yc-hc-markShift]),
      }
    };
    var myFsAMakerW1C = {
      paths: {
       "W1CLine0":new makerjs.paths.Line([xc,yc-hc-dc-markShift], [xc-w1c,yc-hc-dc-markShift]),
       "W1CLine1": new makerjs.paths.Line([xc-w1c,yc-h1c], [xc-w1c,yc-h1c-dc-markShiftThree]),//左上角
      }
    };
    var myFsAMakerW2C = {
      paths: {
       "W2CLine0":new makerjs.paths.Line([xc,yc-hc-hc-markShiftThree], [xc-w2c,yc-hc-hc-markShiftThree]),
        "W2CLine1": new makerjs.paths.Line([xc-w2c,yc], [xc-w2c,yc-hc-hc-dc-markShiftFour]),//左上角
      }
    };
    var myFsAMakerHC = {      
      paths: {
       "HCLine0":new makerjs.paths.Line([xc,yc], [xc+markShiftFour, yc]),
       "HCLine1": new makerjs.paths.Line([xc,yc-hc], [xc+markShiftFour, yc-hc]),//左上角
       "HCLine2": new makerjs.paths.Line([xc+markShiftTwo,yc], [xc+markShiftTwo,yc-hc]),//左上角
      }
    };
    var myFsAMakerH1C = {    
      paths: {
       "H1CLine0":new makerjs.paths.Line([xc-w1c,yc-h1c], [xc-w1c-dc/2-markShiftFour, yc-h1c]),
       "H1CLine1": new makerjs.paths.Line([xc-w2c-markShift,yc], [xc-w2c-markShift,yc-h1c]),//左上角
      }
    };
    var myFsAMakerR2C = {    
      paths: {
      //  "R2CLine1": new makerjs.paths.Line([xc-w2,yc], [xc-w2, yc-r2-markShiftFour]),//左上角
       "R2CLine2": new makerjs.paths.Line([xc-Caa+markShiftTwo,yc], [xc-Caa,yc-Chd]),//左上角
      }
    };
    var myFsAMakerR1C = {    
      paths: {
       "R1CLine1": new makerjs.paths.Line([xc-wc,yc-Chd], [xc-wc-markShift,yc-Chd-markShift]),//左上角
      }
    };
    var myFsAMakerDC = {    
      paths: {
       "DCLine1": new makerjs.paths.Line([xc-w1c,yc-h1c], [xc-w1c-markShift-markHolesOneD,yc-h1c-dc-markShiftFour-markHolesOneD]),//左上角
      }
    };
   

    /**************************************************** */
    
  makerjs.model.addCaption(myFsAMakerWA, TxtWa, [xa,ya-ha-markShiftThree], [xa+wa,ya-ha-markShiftThree]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1A, TxtW1a, [xa,ya-ha-da-markShiftThree], [xa+w1a,ya-ha-da-markShiftThree]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2A, TxtW2a, [xa,ya-ha-ha-da-markShiftFour], [xa+w2a,ya-ha-ha-da-markShiftFour]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHA, TxtHa, [xa-markShiftFour,ya-ha], [xa-markShiftFour,ya]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1A, TxtH1a, [xa+w2a+markShiftThree,ya-h1a], [xa+w2a+markShiftThree,ya]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2A, TxtR2a, [xa+Aa-markShiftThree,ya-Ahd+markShiftThree], [xa+Aa-markShift,ya-Ahd+markShift]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1A, TxtR1a, [xa+wa,ya-Ahd], [xa+wa+markShift,ya-Ahd-markShift]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDA, TxtDa, [xa+w1a+markShift+markHolesOneD,ya-h1a-da-markShiftFour-markHolesOneD],[xa+w1a+markHolesOneD+markShiftFour,ya-h1a-da-markShiftFour-markHolesOneD]);//D文字标注  
    
  /**************************************************** */

  
  makerjs.model.addCaption(myFsAMakerWC, TxtWc, [xc-wc,yc-hc-markShiftThree], [xc,yc-hc-markShiftThree]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1C, TxtW1c, [xc-w1c,yc-hc-dc-markShiftThree], [xc,yc-hc-dc-markShiftThree]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2C, TxtW2c, [xc-w2c,yc-hc-hc-dc-markShiftFour], [xc,yc-hc-hc-dc-markShiftFour]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHC, TxtHc, [xc+markShiftFour,yc-hc], [xc+markShiftFour,yc]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1C, TxtH1c, [xc-w2c-markShiftThree,yc-h1c], [xc-w2c-markShiftThree,yc]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2C, TxtR2c, [xc-Caa+markShift,yc-Chd+markShift], [xc-Caa+markShiftThree,yc-Chd+markShiftThree]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1C, TxtR1c, [xc-wc-markShift,yc-Chd-markShift], [xc-wc,yc-Chd]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDC, TxtDc,[xc-w1c-markHolesOneD-markShiftFour,yc-h1c-dc-markShiftFour-markHolesOneD], [xc-w1c-markShift-markHolesOneD,yc-h1c-dc-markShiftFour-markHolesOneD]);//D文字标注  
    

  
  /******************************************************** */
  var markers = {
    /**A */
        myFsAMakerWA,
        myFsAMakerW1A,
         myFsAMakerW2A,
         myFsAMakerHA,
        myFsAMakerH1A,
         myFsAMakerR2A,
        myFsAMakerR1A,
        myFsAMakerDA,
        /**C */
        myFsAMakerWC,
        myFsAMakerW1C,
         myFsAMakerW2C,
         myFsAMakerHC,
        myFsAMakerH1C,
         myFsAMakerR2C,
        myFsAMakerR1C,
        myFsAMakerDC,
        /** G*/        
       
      }
  

    
  } else if (area == "AG") {
    var myFsAMakerWA = {
      paths: {
        "WALine0": new makerjs.paths.Line([xa,ya-ha], [xa,ya-ha-markShiftThree]),//左上角
        "WALine1": new makerjs.paths.Line([xa+wa,ya-ha], [xa+wa,ya-ha-markShiftThree]),//左上角
        "WALine2":new makerjs.paths.Line([xa,ya-ha-markShift], [xa+wa,ya-ha-markShift]),
      }
    };
    var myFsAMakerW1A = {
      paths: {
       "W1ALine0":new makerjs.paths.Line([xa,ya-ha-da-markShift], [xa+w1a,ya-ha-da-markShift]),
       "W1ALine1": new makerjs.paths.Line([xa+w1a,ya-h1a], [xa+w1a,ya-h1a-da-markShiftThree]),//左上角
      }
    };
    var myFsAMakerW2A = {
      paths: {
       "W2ALine0":new makerjs.paths.Line([xa,ya-ha-ha-markShiftThree], [xa+w2a,ya-ha-ha-markShiftThree]),
        "W2ALine1": new makerjs.paths.Line([xa+w2a,ya], [xa+w2a,ya-ha-ha-da-markShiftFour]),//左上角
      }
    };
    var myFsAMakerHA = {
      
      paths: {
       "HALine0":new makerjs.paths.Line([xa,ya], [xa-markShiftFour, ya]),
       "HALine1": new makerjs.paths.Line([xa,ya-ha], [xa-markShiftFour, ya-ha]),//左上角
       "HALine2": new makerjs.paths.Line([xa-markShiftTwo,ya], [xa-markShiftTwo,ya-ha]),//左上角
      }
    };
    var myFsAMakerH1A = {    
      paths: {
       "H1ALine0":new makerjs.paths.Line([xa+w1a,ya-h1a], [xa+w1a+da/2+markShiftFour, ya-h1a]),
       "H1ALine1": new makerjs.paths.Line([xa+w2a+markShift,ya], [xa+w2a+markShift,ya-h1a]),//左上角
      }
    };
    var myFsAMakerR2A = {    
      paths: {
       "R2ALine1": new makerjs.paths.Line([xa+w2a,ya], [xa+w2a, ya-r2a-markShiftFour]),//左上角
       "R2ALine2": new makerjs.paths.Line([xa+Aa-markShiftTwo,ya], [xa+Aa,ya-Ahd]),//左上角
      }
    };
    var myFsAMakerR1A = {    
      paths: {
       "R1ALine1": new makerjs.paths.Line([xa+wa,ya-Ahd], [xa+wa+markShift,ya-Ahd-markShift]),//左上角
      }
    };
    var myFsAMakerDA = {    
      paths: {
       "DALine1": new makerjs.paths.Line([xa+w1a,ya-h1a], [xa+w1a+markShift+markHolesOneD,ya-h1a-da-markShiftFour-markHolesOneD]),//左上角
      }
    };
  
    /****************** G   ************** */
    var myFsAMakerWG = {
      paths: {
        "WGLine0": new makerjs.paths.Line([xg,yg+hg], [xg,yg+hg+markShiftThree]),//左上角
        "WGLine1": new makerjs.paths.Line([xg+wg,yg+hg], [xg+wg,yg+hg+markShiftThree]),//左上角
        "WGLine2":new makerjs.paths.Line([xg,yg+hg+markShift], [xg+wg,yg+hg+markShift]),
      }
    };
    var myFsAMakerW1G = {
      paths: {
        "W1GLine0":new makerjs.paths.Line([xg,yg+hg+dg+markShift], [xg+w1g,yg+hg+dg+markShift]),
        "W1GLine1": new makerjs.paths.Line([xg+w1g,yg+h1g], [xg+w1g,yg+h1g+dg+markShiftThree]),//左上角
      }
    };
    var myFsAMakerW2G = {
      paths: {
        "W2GLine0":new makerjs.paths.Line([xg,yg+hg+hg+markShiftThree], [xg+w2g,yg+hg+hg+markShiftThree]),
        "W2GLine1": new makerjs.paths.Line([xg+w2g,yg], [xg+w2g,yg+hg+hg+dg+markShiftFour]),//左上角
      }
    };
    var myFsAMakerHG = {      
      paths: {
        "HGLine0":new makerjs.paths.Line([xg,yg], [xg-markShiftFour, yg]),
        "HGLine1": new makerjs.paths.Line([xg,yg+hg], [xg-markShiftFour, yg+hg]),//左上角
        "HGLine2": new makerjs.paths.Line([xg-markShiftTwo,yg], [xg-markShiftTwo,yg+hg]),//左上角
      }
    };
    var myFsAMakerH1G = {    
      paths: {
        "H1GLine0":new makerjs.paths.Line([xg+w1g,yg+h1g], [xg+w1g+dg/2+markShiftFour, yg+h1g]),
        "H1GLine1": new makerjs.paths.Line([xg+w2g+markShift,yg], [xg+w2g+markShift,yg+h1g]),//左上角
      }
    };
    var myFsAMakerR2G = {    
      paths: {
        "R2GLine1": new makerjs.paths.Line([xg+w2g,yg], [xg+w2g, yg+r2g+markShiftFour]),//左上角
        "R2GLine2": new makerjs.paths.Line([xg+Ga-markShiftTwo,yg], [xg+Ga,yg+Ghd]),//左上角
      }
    };
    var myFsAMakerR1G = {    
      paths: {
        "R1GLine1": new makerjs.paths.Line([xg+wg,yg+Ghd], [xg+wg+markShift,yg+Ghd+markShift]),//左上角
      }
    };
    var myFsAMakerDG = {    
      paths: {
        "DGLine1": new makerjs.paths.Line([xg+w1g,yg+h1g], [xg+w1g+markShift+markHolesOneD,yg+h1g+dg+markShiftFour+markHolesOneD]),//左上角
      }
    };

  

    /**************************************************** */
    
  makerjs.model.addCaption(myFsAMakerWA, TxtWa, [xa,ya-ha-markShiftThree], [xa+wa,ya-ha-markShiftThree]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1A, TxtW1a, [xa,ya-ha-da-markShiftThree], [xa+w1a,ya-ha-da-markShiftThree]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2A, TxtW2a, [xa,ya-ha-ha-da-markShiftFour], [xa+w2a,ya-ha-ha-da-markShiftFour]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHA, TxtHa, [xa-markShiftFour,ya-ha], [xa-markShiftFour,ya]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1A, TxtH1a, [xa+w2a+markShiftThree,ya-h1a], [xa+w2a+markShiftThree,ya]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2A, TxtR2a, [xa+Aa-markShiftThree,ya-Ahd+markShiftThree], [xa+Aa-markShift,ya-Ahd+markShift]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1A, TxtR1a, [xa+wa,ya-Ahd], [xa+wa+markShift,ya-Ahd-markShift]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDA, TxtDa, [xa+w1a+markShift+markHolesOneD,ya-h1a-da-markShiftFour-markHolesOneD],[xa+w1a+markHolesOneD+markShiftFour,ya-h1a-da-markShiftFour-markHolesOneD]);//D文字标注  
    
  /**************************************************** */

 
  /******************************************************** */
  makerjs.model.addCaption(myFsAMakerWG, TxtWg, [xg,yg+hg+markShiftThree], [xg+wg,yg+hg+markShiftThree]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1G, TxtW1g, [xg,yg+hg+dg+markShiftThree], [xg+w1g,yg+hg+dg+markShiftThree]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2G, TxtW2g, [xg,yg+hg+hg+dg+markShiftFour], [xg+w2g,yg+hg+hg+dg+markShiftFour]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHG, TxtHg, [xg-markShiftFour,yg+hg], [xg-markShiftFour,yg]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1G, TxtH1g, [xg+w2g+markShiftThree,yg+h1g], [xg+w2g+markShiftThree,yg]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2G, TxtR2g, [xg+Ga-markShiftThree,yg+Ghd-markShiftThree], [xg+Ga-markShift,yg+Ghd-markShift]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1G, TxtR1g, [xg+wg,yg+Ghd], [xg+wg+markShift,yg+Ghd+markShift]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDG, TxtDg, [xg+w1g+markShift+markHolesOneD,yg+h1g+dg+markShiftFour+markHolesOneD],[xg+w1g+markHolesOneD+markShiftFour,yg+h1g+dg+markShiftFour+markHolesOneD]);//D文字标注  
    
  /******************************************************** */
  


  /******************************************************** */
  var markers = {
    /**A */
        myFsAMakerWA,
        myFsAMakerW1A,
         myFsAMakerW2A,
         myFsAMakerHA,
        myFsAMakerH1A,
         myFsAMakerR2A,
        myFsAMakerR1A,
        myFsAMakerDA,
        /**C */
        /** G*/        
        myFsAMakerWG,
        myFsAMakerW1G,
         myFsAMakerW2G,
         myFsAMakerHG,
        myFsAMakerH1G,
         myFsAMakerR2G,
        myFsAMakerR1G,
        myFsAMakerDG,
        /**I */
      }
  

    // var myFilletMark = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xahx, xahy], [xawx, xawy], [xc, yc],[xi, yi], [xgwx, xgwy]]);
  } else if (area == "AI") {
    var myFsAMakerWA = {
      paths: {
        "WALine0": new makerjs.paths.Line([xa,ya-ha], [xa,ya-ha-markShiftThree]),//左上角
        "WALine1": new makerjs.paths.Line([xa+wa,ya-ha], [xa+wa,ya-ha-markShiftThree]),//左上角
        "WALine2":new makerjs.paths.Line([xa,ya-ha-markShift], [xa+wa,ya-ha-markShift]),
      }
    };
    var myFsAMakerW1A = {
      paths: {
       "W1ALine0":new makerjs.paths.Line([xa,ya-ha-da-markShift], [xa+w1a,ya-ha-da-markShift]),
       "W1ALine1": new makerjs.paths.Line([xa+w1a,ya-h1a], [xa+w1a,ya-h1a-da-markShiftThree]),//左上角
      }
    };
    var myFsAMakerW2A = {
      paths: {
       "W2ALine0":new makerjs.paths.Line([xa,ya-ha-ha-markShiftThree], [xa+w2a,ya-ha-ha-markShiftThree]),
        "W2ALine1": new makerjs.paths.Line([xa+w2a,ya], [xa+w2a,ya-ha-ha-da-markShiftFour]),//左上角
      }
    };
    var myFsAMakerHA = {
      
      paths: {
       "HALine0":new makerjs.paths.Line([xa,ya], [xa-markShiftFour, ya]),
       "HALine1": new makerjs.paths.Line([xa,ya-ha], [xa-markShiftFour, ya-ha]),//左上角
       "HALine2": new makerjs.paths.Line([xa-markShiftTwo,ya], [xa-markShiftTwo,ya-ha]),//左上角
      }
    };
    var myFsAMakerH1A = {    
      paths: {
       "H1ALine0":new makerjs.paths.Line([xa+w1a,ya-h1a], [xa+w1a+da/2+markShiftFour, ya-h1a]),
       "H1ALine1": new makerjs.paths.Line([xa+w2a+markShift,ya], [xa+w2a+markShift,ya-h1a]),//左上角
      }
    };
    var myFsAMakerR2A = {    
      paths: {
       "R2ALine1": new makerjs.paths.Line([xa+w2a,ya], [xa+w2a, ya-r2a-markShiftFour]),//左上角
       "R2ALine2": new makerjs.paths.Line([xa+Aa-markShiftTwo,ya], [xa+Aa,ya-Ahd]),//左上角
      }
    };
    var myFsAMakerR1A = {    
      paths: {
       "R1ALine1": new makerjs.paths.Line([xa+wa,ya-Ahd], [xa+wa+markShift,ya-Ahd-markShift]),//左上角
      }
    };
    var myFsAMakerDA = {    
      paths: {
       "DALine1": new makerjs.paths.Line([xa+w1a,ya-h1a], [xa+w1a+markShift+markHolesOneD,ya-h1a-da-markShiftFour-markHolesOneD]),//左上角
      }
    };
  

    /************************   I  ******************* */
    var myFsAMakerWI = {
      paths: {
       // "WILine0": new makerjs.paths.Line([xi,yi+hi], [xi,yi+hi+markShiftThree]),//左上角
        "WILine1": new makerjs.paths.Line([xi-wi,yi+hi], [xi-wi,yi+hi+markShiftThree]),//左上角
        "WILine2":new makerjs.paths.Line([xi,yi+hi+markShift], [xi-wi,yi+hi+markShift]),
      }
    };
    var myFsAMakerW1I = {
      paths: {
       "W1ILine0":new makerjs.paths.Line([xi,yi+hi+di+markShift], [xi-w1i,yi+hi+di+markShift]),
       "W1ILine1": new makerjs.paths.Line([xi-w1i,yi+h1i], [xi-w1i,yi+h1i+di+markShiftThree]),//左上角
      }
    };



    var myFsAMakerW2I = {
      paths: {
       "W2ILine0":new makerjs.paths.Line([xi,yi+hi+hi+markShiftThree], [xi-w2i,yi+hi+hi+markShiftThree]),
        "W2ILine1": new makerjs.paths.Line([xi-w2i,yi], [xi-w2i,yi+hi+hi+di+markShiftFour]),//左上角
      }
    };
    var myFsAMakerHI = {      
      paths: {
       "HILine0":new makerjs.paths.Line([xi,yi], [xi+markShiftFour, yi]),
       "HILine1": new makerjs.paths.Line([xi,yi+hi], [xi+markShiftFour, yi+hi]),//左上角
       "HILine2": new makerjs.paths.Line([xi+markShiftTwo,yi], [xi+markShiftTwo,yi+hi]),//左上角
      }
    };
    var myFsAMakerH1I = {    
      paths: {
       "H1ILine0":new makerjs.paths.Line([xi-w1i,yi+h1i], [xi-w1i-di/2-markShiftFour, yi+h1i]),
       "H1ILine1": new makerjs.paths.Line([xi-w2i-markShift,yi], [xi-w2i-markShift,yi+h1i]),//左上角
      }
    };
    var myFsAMakerR2I = {    
      paths: {
      //  "R2ILine1": new makerjs.paths.Line([xi-w2,yi], [xi-w2, yi-r2-markShiftFour]),//左上角
       "R2ILine2": new makerjs.paths.Line([xi-Iaa+markShiftTwo,yi], [xi-Iaa,yi+Ihd]),//左上角
      }
    };
    var myFsAMakerR1I = {    
      paths: {
       "R1ILine1": new makerjs.paths.Line([xi-wi,yi+Ihd], [xi-wi-markShift,yi+Ihd+markShift]),//左上角
      }
    };
    var myFsAMakerDI = {    
      paths: {
       "DILine1": new makerjs.paths.Line([xi-w1i,yi+h1i], [xi-w1i-markShift-markHolesOneD,yi+h1i+di+markShiftFour+markHolesOneD]),//左上角
      }
    };

     
  /******************************************************** */
  
    
  makerjs.model.addCaption(myFsAMakerWA, TxtWa, [xa,ya-ha-markShiftThree], [xa+wa,ya-ha-markShiftThree]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1A, TxtW1a, [xa,ya-ha-da-markShiftThree], [xa+w1a,ya-ha-da-markShiftThree]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2A, TxtW2a, [xa,ya-ha-ha-da-markShiftFour], [xa+w2a,ya-ha-ha-da-markShiftFour]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHA, TxtHa, [xa-markShiftFour,ya-ha], [xa-markShiftFour,ya]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1A, TxtH1a, [xa+w2a+markShiftThree,ya-h1a], [xa+w2a+markShiftThree,ya]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2A, TxtR2a, [xa+Aa-markShiftThree,ya-Ahd+markShiftThree], [xa+Aa-markShift,ya-Ahd+markShift]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1A, TxtR1a, [xa+wa,ya-Ahd], [xa+wa+markShift,ya-Ahd-markShift]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDA, TxtDa, [xa+w1a+markShift+markHolesOneD,ya-h1a-da-markShiftFour-markHolesOneD],[xa+w1a+markHolesOneD+markShiftFour,ya-h1a-da-markShiftFour-markHolesOneD]);//D文字标注  
    
   
  /******************************************************** */
  

  makerjs.model.addCaption(myFsAMakerWI, TxtWi, [xi-wi,yi+hi+markShiftThree], [xi,yi+hi+markShiftThree]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1I, TxtW1i, [xi-w1i,yi+hi+di+markShiftThree], [xi,yi+hi+di+markShiftThree]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2I, TxtW2i, [xi-w2i,yi+hi+hi+di+markShiftFour], [xi,yi+hi+hi+di+markShiftFour]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHI, TxtHi, [xi+markShiftFour,yi+hi], [xi+markShiftFour,yi]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1I, TxtH1i, [xi-w2i-markShiftThree,yi+h1i], [xi-w2i-markShiftThree,yi]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2I, TxtR2i, [xi-Iaa+markShift,yi+Ihd-markShift], [xi-Iaa+markShiftThree,yi+Ihd-markShiftThree]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1I, TxtR1i, [xi-wi-markShift,yi+Ihd+markShift], [xi-wi,yi+Ihd]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDI, TxtDi,[xi-w1i-markHolesOneD-markShiftFour,yi+h1i+di+markShiftFour+markHolesOneD], [xi-w1i-markShift-markHolesOneD,yi+h1i+di+markShiftFour+markHolesOneD]);//D文字标注  
   
/***************************************************/ 
  var markers = {
    /**A */
        myFsAMakerWA,
        myFsAMakerW1A,
         myFsAMakerW2A,
         myFsAMakerHA,
        myFsAMakerH1A,
         myFsAMakerR2A,
        myFsAMakerR1A,
        myFsAMakerDA,
        /**C */
        /**I */
        myFsAMakerWI,
        myFsAMakerW1I,
         myFsAMakerW2I,
         myFsAMakerHI,
        myFsAMakerH1I,
         myFsAMakerR2I,
        myFsAMakerR1I,
        myFsAMakerDI,
      }
  

    // var myFilletMark = new makerjs.models.ConnectTheDots(true, [[xg, yg], [xahx, xahy], [xawx, xawy], [xc, yc], [xihx, xihy], [xiwx, xiwy]]);
  } else if (area == "CG") {

    /*****************  C  *********** */
    var myFsAMakerWC = {
      paths: {
        "WCLine0": new makerjs.paths.Line([xc,yc-hc], [xc,yc-hc-markShiftThree]),//左上角
        "WCLine1": new makerjs.paths.Line([xc-wc,yc-hc], [xc-wc,yc-hc-markShiftThree]),//左上角
        "WCLine2":new makerjs.paths.Line([xc,yc-hc-markShift], [xc-wc,yc-hc-markShift]),
      }
    };
    var myFsAMakerW1C = {
      paths: {
       "W1CLine0":new makerjs.paths.Line([xc,yc-hc-dc-markShift], [xc-w1c,yc-hc-dc-markShift]),
       "W1CLine1": new makerjs.paths.Line([xc-w1c,yc-h1c], [xc-w1c,yc-h1c-dc-markShiftThree]),//左上角
      }
    };
    var myFsAMakerW2C = {
      paths: {
       "W2CLine0":new makerjs.paths.Line([xc,yc-hc-hc-markShiftThree], [xc-w2c,yc-hc-hc-markShiftThree]),
        "W2CLine1": new makerjs.paths.Line([xc-w2c,yc], [xc-w2c,yc-hc-hc-dc-markShiftFour]),//左上角
      }
    };
    var myFsAMakerHC = {      
      paths: {
       "HCLine0":new makerjs.paths.Line([xc,yc], [xc+markShiftFour, yc]),
       "HCLine1": new makerjs.paths.Line([xc,yc-hc], [xc+markShiftFour, yc-hc]),//左上角
       "HCLine2": new makerjs.paths.Line([xc+markShiftTwo,yc], [xc+markShiftTwo,yc-hc]),//左上角
      }
    };
    var myFsAMakerH1C = {    
      paths: {
       "H1CLine0":new makerjs.paths.Line([xc-w1c,yc-h1c], [xc-w1c-dc/2-markShiftFour, yc-h1c]),
       "H1CLine1": new makerjs.paths.Line([xc-w2c-markShift,yc], [xc-w2c-markShift,yc-h1c]),//左上角
      }
    };
    var myFsAMakerR2C = {    
      paths: {
      //  "R2CLine1": new makerjs.paths.Line([xc-w2,yc], [xc-w2, yc-r2-markShiftFour]),//左上角
       "R2CLine2": new makerjs.paths.Line([xc-Caa+markShiftTwo,yc], [xc-Caa,yc-Chd]),//左上角
      }
    };
    var myFsAMakerR1C = {    
      paths: {
       "R1CLine1": new makerjs.paths.Line([xc-wc,yc-Chd], [xc-wc-markShift,yc-Chd-markShift]),//左上角
      }
    };
    var myFsAMakerDC = {    
      paths: {
       "DCLine1": new makerjs.paths.Line([xc-w1c,yc-h1c], [xc-w1c-markShift-markHolesOneD,yc-h1c-dc-markShiftFour-markHolesOneD]),//左上角
      }
    };
    /****************** G   ************** */
    var myFsAMakerWG = {
      paths: {
        "WGLine0": new makerjs.paths.Line([xg,yg+hg], [xg,yg+hg+markShiftThree]),//左上角
        "WGLine1": new makerjs.paths.Line([xg+wg,yg+hg], [xg+wg,yg+hg+markShiftThree]),//左上角
        "WGLine2":new makerjs.paths.Line([xg,yg+hg+markShift], [xg+wg,yg+hg+markShift]),
      }
    };
    var myFsAMakerW1G = {
      paths: {
        "W1GLine0":new makerjs.paths.Line([xg,yg+hg+dg+markShift], [xg+w1g,yg+hg+dg+markShift]),
        "W1GLine1": new makerjs.paths.Line([xg+w1g,yg+h1g], [xg+w1g,yg+h1g+dg+markShiftThree]),//左上角
      }
    };
    var myFsAMakerW2G = {
      paths: {
        "W2GLine0":new makerjs.paths.Line([xg,yg+hg+hg+markShiftThree], [xg+w2g,yg+hg+hg+markShiftThree]),
        "W2GLine1": new makerjs.paths.Line([xg+w2g,yg], [xg+w2g,yg+hg+hg+dg+markShiftFour]),//左上角
      }
    };
    var myFsAMakerHG = {      
      paths: {
        "HGLine0":new makerjs.paths.Line([xg,yg], [xg-markShiftFour, yg]),
        "HGLine1": new makerjs.paths.Line([xg,yg+hg], [xg-markShiftFour, yg+hg]),//左上角
        "HGLine2": new makerjs.paths.Line([xg-markShiftTwo,yg], [xg-markShiftTwo,yg+hg]),//左上角
      }
    };
    var myFsAMakerH1G = {    
      paths: {
        "H1GLine0":new makerjs.paths.Line([xg+w1g,yg+h1g], [xg+w1g+dg/2+markShiftFour, yg+h1g]),
        "H1GLine1": new makerjs.paths.Line([xg+w2g+markShift,yg], [xg+w2g+markShift,yg+h1g]),//左上角
      }
    };
    var myFsAMakerR2G = {    
      paths: {
        "R2GLine1": new makerjs.paths.Line([xg+w2g,yg], [xg+w2g, yg+r2g+markShiftFour]),//左上角
        "R2GLine2": new makerjs.paths.Line([xg+Ga-markShiftTwo,yg], [xg+Ga,yg+Ghd]),//左上角
      }
    };
    var myFsAMakerR1G = {    
      paths: {
        "R1GLine1": new makerjs.paths.Line([xg+wg,yg+Ghd], [xg+wg+markShift,yg+Ghd+markShift]),//左上角
      }
    };
    var myFsAMakerDG = {    
      paths: {
        "DGLine1": new makerjs.paths.Line([xg+w1g,yg+h1g], [xg+w1g+markShift+markHolesOneD,yg+h1g+dg+markShiftFour+markHolesOneD]),//左上角
      }
    };

   
    /**************************************************** */
  
  
  makerjs.model.addCaption(myFsAMakerWC, TxtWc, [xc-wc,yc-hc-markShiftThree], [xc,yc-hc-markShiftThree]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1C, TxtW1c, [xc-w1c,yc-hc-dc-markShiftThree], [xc,yc-hc-dc-markShiftThree]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2C, TxtW2c, [xc-w2c,yc-hc-hc-dc-markShiftFour], [xc,yc-hc-hc-dc-markShiftFour]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHC, TxtHc, [xc+markShiftFour,yc-hc], [xc+markShiftFour,yc]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1C, TxtH1c, [xc-w2c-markShiftThree,yc-h1c], [xc-w2c-markShiftThree,yc]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2C, TxtR2c, [xc-Caa+markShift,yc-Chd+markShift], [xc-Caa+markShiftThree,yc-Chd+markShiftThree]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1C, TxtR1c, [xc-wc-markShift,yc-Chd-markShift], [xc-wc,yc-Chd]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDC, TxtDc,[xc-w1c-markHolesOneD-markShiftFour,yc-h1c-dc-markShiftFour-markHolesOneD], [xc-w1c-markShift-markHolesOneD,yc-h1c-dc-markShiftFour-markHolesOneD]);//D文字标注  
    

  /******************************************************** */
  makerjs.model.addCaption(myFsAMakerWG, TxtWg, [xg,yg+hg+markShiftThree], [xg+wg,yg+hg+markShiftThree]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1G, TxtW1g, [xg,yg+hg+dg+markShiftThree], [xg+w1g,yg+hg+dg+markShiftThree]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2G, TxtW2g, [xg,yg+hg+hg+dg+markShiftFour], [xg+w2g,yg+hg+hg+dg+markShiftFour]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHG, TxtHg, [xg-markShiftFour,yg+hg], [xg-markShiftFour,yg]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1G, TxtH1g, [xg+w2g+markShiftThree,yg+h1g], [xg+w2g+markShiftThree,yg]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2G, TxtR2g, [xg+Ga-markShiftThree,yg+Ghd-markShiftThree], [xg+Ga-markShift,yg+Ghd-markShift]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1G, TxtR1g, [xg+wg,yg+Ghd], [xg+wg+markShift,yg+Ghd+markShift]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDG, TxtDg, [xg+w1g+markShift+markHolesOneD,yg+h1g+dg+markShiftFour+markHolesOneD],[xg+w1g+markHolesOneD+markShiftFour,yg+h1g+dg+markShiftFour+markHolesOneD]);//D文字标注  
    
  
  /******************************************************** */
  var markers = {
    /**A */
        /**C */
        myFsAMakerWC,
        myFsAMakerW1C,
         myFsAMakerW2C,
         myFsAMakerHC,
        myFsAMakerH1C,
         myFsAMakerR2C,
        myFsAMakerR1C,
        myFsAMakerDC,
        /** G*/        
        myFsAMakerWG,
        myFsAMakerW1G,
         myFsAMakerW2G,
         myFsAMakerHG,
        myFsAMakerH1G,
         myFsAMakerR2G,
        myFsAMakerR1G,
        myFsAMakerDG,
        /**I */
      }
  

    // var myFilletMark = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xa, ya], [xcwx, xcwy], [xchx, xchy], [xi, yi], [xgwx, xgwy]]);
  } else if (area == "CI") {
 
    /*****************  C  *********** */
    var myFsAMakerWC = {
      paths: {
        "WCLine0": new makerjs.paths.Line([xc,yc-hc], [xc,yc-hc-markShiftThree]),//左上角
        "WCLine1": new makerjs.paths.Line([xc-wc,yc-hc], [xc-wc,yc-hc-markShiftThree]),//左上角
        "WCLine2":new makerjs.paths.Line([xc,yc-hc-markShift], [xc-wc,yc-hc-markShift]),
      }
    };
    var myFsAMakerW1C = {
      paths: {
       "W1CLine0":new makerjs.paths.Line([xc,yc-hc-dc-markShift], [xc-w1c,yc-hc-dc-markShift]),
       "W1CLine1": new makerjs.paths.Line([xc-w1c,yc-h1c], [xc-w1c,yc-h1c-dc-markShiftThree]),//左上角
      }
    };
    var myFsAMakerW2C = {
      paths: {
       "W2CLine0":new makerjs.paths.Line([xc,yc-hc-hc-markShiftThree], [xc-w2c,yc-hc-hc-markShiftThree]),
        "W2CLine1": new makerjs.paths.Line([xc-w2c,yc], [xc-w2c,yc-hc-hc-dc-markShiftFour]),//左上角
      }
    };
    var myFsAMakerHC = {      
      paths: {
       "HCLine0":new makerjs.paths.Line([xc,yc], [xc+markShiftFour, yc]),
       "HCLine1": new makerjs.paths.Line([xc,yc-hc], [xc+markShiftFour, yc-hc]),//左上角
       "HCLine2": new makerjs.paths.Line([xc+markShiftTwo,yc], [xc+markShiftTwo,yc-hc]),//左上角
      }
    };
    var myFsAMakerH1C = {    
      paths: {
       "H1CLine0":new makerjs.paths.Line([xc-w1c,yc-h1c], [xc-w1c-dc/2-markShiftFour, yc-h1c]),
       "H1CLine1": new makerjs.paths.Line([xc-w2c-markShift,yc], [xc-w2c-markShift,yc-h1c]),//左上角
      }
    };
    var myFsAMakerR2C = {    
      paths: {
      //  "R2CLine1": new makerjs.paths.Line([xc-w2,yc], [xc-w2, yc-r2-markShiftFour]),//左上角
       "R2CLine2": new makerjs.paths.Line([xc-Caa+markShiftTwo,yc], [xc-Caa,yc-Chd]),//左上角
      }
    };
    var myFsAMakerR1C = {    
      paths: {
       "R1CLine1": new makerjs.paths.Line([xc-wc,yc-Chd], [xc-wc-markShift,yc-Chd-markShift]),//左上角
      }
    };
    var myFsAMakerDC = {    
      paths: {
       "DCLine1": new makerjs.paths.Line([xc-w1c,yc-h1c], [xc-w1c-markShift-markHolesOneD,yc-h1c-dc-markShiftFour-markHolesOneD]),//左上角
      }
    };
   
    /************************   I  ******************* */
    /************************   I  ******************* */
    var myFsAMakerWI = {
      paths: {
       // "WILine0": new makerjs.paths.Line([xi,yi+hi], [xi,yi+hi+markShiftThree]),//左上角
        "WILine1": new makerjs.paths.Line([xi-wi,yi+hi], [xi-wi,yi+hi+markShiftThree]),//左上角
        "WILine2":new makerjs.paths.Line([xi,yi+hi+markShift], [xi-wi,yi+hi+markShift]),
      }
    };
    var myFsAMakerW1I = {
      paths: {
       "W1ILine0":new makerjs.paths.Line([xi,yi+hi+di+markShift], [xi-w1i,yi+hi+di+markShift]),
       "W1ILine1": new makerjs.paths.Line([xi-w1i,yi+h1i], [xi-w1i,yi+h1i+di+markShiftThree]),//左上角
      }
    };



    var myFsAMakerW2I = {
      paths: {
       "W2ILine0":new makerjs.paths.Line([xi,yi+hi+hi+markShiftThree], [xi-w2i,yi+hi+hi+markShiftThree]),
        "W2ILine1": new makerjs.paths.Line([xi-w2i,yi], [xi-w2i,yi+hi+hi+di+markShiftFour]),//左上角
      }
    };
    var myFsAMakerHI = {      
      paths: {
       "HILine0":new makerjs.paths.Line([xi,yi], [xi+markShiftFour, yi]),
       "HILine1": new makerjs.paths.Line([xi,yi+hi], [xi+markShiftFour, yi+hi]),//左上角
       "HILine2": new makerjs.paths.Line([xi+markShiftTwo,yi], [xi+markShiftTwo,yi+hi]),//左上角
      }
    };
    var myFsAMakerH1I = {    
      paths: {
       "H1ILine0":new makerjs.paths.Line([xi-w1i,yi+h1i], [xi-w1i-di/2-markShiftFour, yi+h1i]),
       "H1ILine1": new makerjs.paths.Line([xi-w2i-markShift,yi], [xi-w2i-markShift,yi+h1i]),//左上角
      }
    };
    var myFsAMakerR2I = {    
      paths: {
      //  "R2ILine1": new makerjs.paths.Line([xi-w2,yi], [xi-w2, yi-r2-markShiftFour]),//左上角
       "R2ILine2": new makerjs.paths.Line([xi-Iaa+markShiftTwo,yi], [xi-Iaa,yi+Ihd]),//左上角
      }
    };
    var myFsAMakerR1I = {    
      paths: {
       "R1ILine1": new makerjs.paths.Line([xi-wi,yi+Ihd], [xi-wi-markShift,yi+Ihd+markShift]),//左上角
      }
    };
    var myFsAMakerDI = {    
      paths: {
       "DILine1": new makerjs.paths.Line([xi-w1i,yi+h1i], [xi-w1i-markShift-markHolesOneD,yi+h1i+di+markShiftFour+markHolesOneD]),//左上角
      }
    };

     
  /******************************************************** */
  
  makerjs.model.addCaption(myFsAMakerWI, TxtWi, [xi-wi,yi+hi+markShiftThree], [xi,yi+hi+markShiftThree]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1I, TxtW1i, [xi-w1i,yi+hi+di+markShiftThree], [xi,yi+hi+di+markShiftThree]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2I, TxtW2i, [xi-w2i,yi+hi+hi+di+markShiftFour], [xi,yi+hi+hi+di+markShiftFour]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHI, TxtHi, [xi+markShiftFour,yi+hi], [xi+markShiftFour,yi]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1I, TxtH1i, [xi-w2i-markShiftThree,yi+h1i], [xi-w2i-markShiftThree,yi]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2I, TxtR2i, [xi-Iaa+markShift,yi+Ihd-markShift], [xi-Iaa+markShiftThree,yi+Ihd-markShiftThree]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1I, TxtR1i, [xi-wi-markShift,yi+Ihd+markShift], [xi-wi,yi+Ihd]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDI, TxtDi,[xi-w1i-markHolesOneD-markShiftFour,yi+h1i+di+markShiftFour+markHolesOneD], [xi-w1i-markShift-markHolesOneD,yi+h1i+di+markShiftFour+markHolesOneD]);//D文字标注  
   
/***************************************************/ 
    
  
  
  makerjs.model.addCaption(myFsAMakerWC, TxtWc, [xc-wc,yc-hc-markShiftThree], [xc,yc-hc-markShiftThree]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1C, TxtW1c, [xc-w1c,yc-hc-dc-markShiftThree], [xc,yc-hc-dc-markShiftThree]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2C, TxtW2c, [xc-w2c,yc-hc-hc-dc-markShiftFour], [xc,yc-hc-hc-dc-markShiftFour]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHC, TxtHc, [xc+markShiftFour,yc-hc], [xc+markShiftFour,yc]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1C, TxtH1c, [xc-w2c-markShiftThree,yc-h1c], [xc-w2c-markShiftThree,yc]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2C, TxtR2c, [xc-Caa+markShift,yc-Chd+markShift], [xc-Caa+markShiftThree,yc-Chd+markShiftThree]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1C, TxtR1c, [xc-wc-markShift,yc-Chd-markShift], [xc-wc,yc-Chd]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDC, TxtDc,[xc-w1c-markHolesOneD-markShiftFour,yc-h1c-dc-markShiftFour-markHolesOneD], [xc-w1c-markShift-markHolesOneD,yc-h1c-dc-markShiftFour-markHolesOneD]);//D文字标注  
    

  
  /******************************************************** */
  var markers = {
    /**A */
        /**C */
        myFsAMakerWC,
        myFsAMakerW1C,
         myFsAMakerW2C,
         myFsAMakerHC,
        myFsAMakerH1C,
         myFsAMakerR2C,
        myFsAMakerR1C,
        myFsAMakerDC,
        /** G*/        
        /**I */
        myFsAMakerWI,
        myFsAMakerW1I,
         myFsAMakerW2I,
         myFsAMakerHI,
        myFsAMakerH1I,
         myFsAMakerR2I,
        myFsAMakerR1I,
        myFsAMakerDI,
      }
  

    // var myFilletMark = new makerjs.models.ConnectTheDots(true, [[xg, yg], [xa, ya], [xcwx, xcwy], [xchx, xchy], [xihx, xihy], [xiwx, xiwy]]);
  } else if (area == "GI") {
 
    /****************** G   ************** */
    var myFsAMakerWG = {
      paths: {
        "WGLine0": new makerjs.paths.Line([xg,yg+hg], [xg,yg+hg+markShiftThree]),//左上角
        "WGLine1": new makerjs.paths.Line([xg+wg,yg+hg], [xg+wg,yg+hg+markShiftThree]),//左上角
        "WGLine2":new makerjs.paths.Line([xg,yg+hg+markShift], [xg+wg,yg+hg+markShift]),
      }
    };
    var myFsAMakerW1G = {
      paths: {
        "W1GLine0":new makerjs.paths.Line([xg,yg+hg+dg+markShift], [xg+w1g,yg+hg+dg+markShift]),
        "W1GLine1": new makerjs.paths.Line([xg+w1g,yg+h1g], [xg+w1g,yg+h1g+dg+markShiftThree]),//左上角
      }
    };
    var myFsAMakerW2G = {
      paths: {
        "W2GLine0":new makerjs.paths.Line([xg,yg+hg+hg+markShiftThree], [xg+w2g,yg+hg+hg+markShiftThree]),
        "W2GLine1": new makerjs.paths.Line([xg+w2g,yg], [xg+w2g,yg+hg+hg+dg+markShiftFour]),//左上角
      }
    };
    var myFsAMakerHG = {      
      paths: {
        "HGLine0":new makerjs.paths.Line([xg,yg], [xg-markShiftFour, yg]),
        "HGLine1": new makerjs.paths.Line([xg,yg+hg], [xg-markShiftFour, yg+hg]),//左上角
        "HGLine2": new makerjs.paths.Line([xg-markShiftTwo,yg], [xg-markShiftTwo,yg+hg]),//左上角
      }
    };
    var myFsAMakerH1G = {    
      paths: {
        "H1GLine0":new makerjs.paths.Line([xg+w1g,yg+h1g], [xg+w1g+dg/2+markShiftFour, yg+h1g]),
        "H1GLine1": new makerjs.paths.Line([xg+w2g+markShift,yg], [xg+w2g+markShift,yg+h1g]),//左上角
      }
    };
    var myFsAMakerR2G = {    
      paths: {
        "R2GLine1": new makerjs.paths.Line([xg+w2g,yg], [xg+w2g, yg+r2g+markShiftFour]),//左上角
        "R2GLine2": new makerjs.paths.Line([xg+Ga-markShiftTwo,yg], [xg+Ga,yg+Ghd]),//左上角
      }
    };
    var myFsAMakerR1G = {    
      paths: {
        "R1GLine1": new makerjs.paths.Line([xg+wg,yg+Ghd], [xg+wg+markShift,yg+Ghd+markShift]),//左上角
      }
    };
    var myFsAMakerDG = {    
      paths: {
        "DGLine1": new makerjs.paths.Line([xg+w1g,yg+h1g], [xg+w1g+markShift+markHolesOneD,yg+h1g+dg+markShiftFour+markHolesOneD]),//左上角
      }
    };

   /************************   I  ******************* */
   var myFsAMakerWI = {
    paths: {
     // "WILine0": new makerjs.paths.Line([xi,yi+hi], [xi,yi+hi+markShiftThree]),//左上角
      "WILine1": new makerjs.paths.Line([xi-wi,yi+hi], [xi-wi,yi+hi+markShiftThree]),//左上角
      "WILine2":new makerjs.paths.Line([xi,yi+hi+markShift], [xi-wi,yi+hi+markShift]),
    }
  };
  var myFsAMakerW1I = {
    paths: {
     "W1ILine0":new makerjs.paths.Line([xi,yi+hi+di+markShift], [xi-w1i,yi+hi+di+markShift]),
     "W1ILine1": new makerjs.paths.Line([xi-w1i,yi+h1i], [xi-w1i,yi+h1i+di+markShiftThree]),//左上角
    }
  };



  var myFsAMakerW2I = {
    paths: {
     "W2ILine0":new makerjs.paths.Line([xi,yi+hi+hi+markShiftThree], [xi-w2i,yi+hi+hi+markShiftThree]),
      "W2ILine1": new makerjs.paths.Line([xi-w2i,yi], [xi-w2i,yi+hi+hi+di+markShiftFour]),//左上角
    }
  };
  var myFsAMakerHI = {      
    paths: {
     "HILine0":new makerjs.paths.Line([xi,yi], [xi+markShiftFour, yi]),
     "HILine1": new makerjs.paths.Line([xi,yi+hi], [xi+markShiftFour, yi+hi]),//左上角
     "HILine2": new makerjs.paths.Line([xi+markShiftTwo,yi], [xi+markShiftTwo,yi+hi]),//左上角
    }
  };
  var myFsAMakerH1I = {    
    paths: {
     "H1ILine0":new makerjs.paths.Line([xi-w1i,yi+h1i], [xi-w1i-di/2-markShiftFour, yi+h1i]),
     "H1ILine1": new makerjs.paths.Line([xi-w2i-markShift,yi], [xi-w2i-markShift,yi+h1i]),//左上角
    }
  };
  var myFsAMakerR2I = {    
    paths: {
    //  "R2ILine1": new makerjs.paths.Line([xi-w2,yi], [xi-w2, yi-r2-markShiftFour]),//左上角
     "R2ILine2": new makerjs.paths.Line([xi-Iaa+markShiftTwo,yi], [xi-Iaa,yi+Ihd]),//左上角
    }
  };
  var myFsAMakerR1I = {    
    paths: {
     "R1ILine1": new makerjs.paths.Line([xi-wi,yi+Ihd], [xi-wi-markShift,yi+Ihd+markShift]),//左上角
    }
  };
  var myFsAMakerDI = {    
    paths: {
     "DILine1": new makerjs.paths.Line([xi-w1i,yi+h1i], [xi-w1i-markShift-markHolesOneD,yi+h1i+di+markShiftFour+markHolesOneD]),//左上角
    }
  };

   
/******************************************************** */

makerjs.model.addCaption(myFsAMakerWI, TxtWi, [xi-wi,yi+hi+markShiftThree], [xi,yi+hi+markShiftThree]);//半径文字  
makerjs.model.addCaption(myFsAMakerW1I, TxtW1i, [xi-w1i,yi+hi+di+markShiftThree], [xi,yi+hi+di+markShiftThree]);//W1文字标注 
makerjs.model.addCaption(myFsAMakerW2I, TxtW2i, [xi-w2i,yi+hi+hi+di+markShiftFour], [xi,yi+hi+hi+di+markShiftFour]);//W1文字标注
makerjs.model.addCaption(myFsAMakerHI, TxtHi, [xi+markShiftFour,yi+hi], [xi+markShiftFour,yi]);//H文字标注
makerjs.model.addCaption(myFsAMakerH1I, TxtH1i, [xi-w2i-markShiftThree,yi+h1i], [xi-w2i-markShiftThree,yi]);//H1文字标注
makerjs.model.addCaption(myFsAMakerR2I, TxtR2i, [xi-Iaa+markShift,yi+Ihd-markShift], [xi-Iaa+markShiftThree,yi+Ihd-markShiftThree]);//R2文字标注
makerjs.model.addCaption(myFsAMakerR1I, TxtR1i, [xi-wi-markShift,yi+Ihd+markShift], [xi-wi,yi+Ihd]);//R1文字标注
makerjs.model.addCaption(myFsAMakerDI, TxtDi,[xi-w1i-markHolesOneD-markShiftFour,yi+h1i+di+markShiftFour+markHolesOneD], [xi-w1i-markShift-markHolesOneD,yi+h1i+di+markShiftFour+markHolesOneD]);//D文字标注  
 
/***************************************************/ 
  
  /******************************************************** */
  makerjs.model.addCaption(myFsAMakerWG, TxtWg, [xg,yg+hg+markShiftThree], [xg+wg,yg+hg+markShiftThree]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1G, TxtW1g, [xg,yg+hg+dg+markShiftThree], [xg+w1g,yg+hg+dg+markShiftThree]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2G, TxtW2g, [xg,yg+hg+hg+dg+markShiftFour], [xg+w2g,yg+hg+hg+dg+markShiftFour]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHG, TxtHg, [xg-markShiftFour,yg+hg], [xg-markShiftFour,yg]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1G, TxtH1g, [xg+w2g+markShiftThree,yg+h1g], [xg+w2g+markShiftThree,yg]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2G, TxtR2g, [xg+Ga-markShiftThree,yg+Ghd-markShiftThree], [xg+Ga-markShift,yg+Ghd-markShift]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1G, TxtR1g, [xg+wg,yg+Ghd], [xg+wg+markShift,yg+Ghd+markShift]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDG, TxtDg, [xg+w1g+markShift+markHolesOneD,yg+h1g+dg+markShiftFour+markHolesOneD],[xg+w1g+markHolesOneD+markShiftFour,yg+h1g+dg+markShiftFour+markHolesOneD]);//D文字标注  
    
  
/***************************************************/  
  var markers = {
    /**A */
        /** G*/        
        myFsAMakerWG,
        myFsAMakerW1G,
         myFsAMakerW2G,
         myFsAMakerHG,
        myFsAMakerH1G,
         myFsAMakerR2G,
        myFsAMakerR1G,
        myFsAMakerDG,
        /**I */
        myFsAMakerWI,
        myFsAMakerW1I,
        myFsAMakerW2I,
        myFsAMakerHI,
        myFsAMakerH1I,
        myFsAMakerR2I,
        myFsAMakerR1I,
        myFsAMakerDI,
      }
  

   
    // var myFilletMark = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xa, ya], [xc, yc], [xihx, xihy], [xiwx, xiwy], [xgwx, xgwy]]);
  } else if (area == "ACG") {
    var myFsAMakerWA = {
      paths: {
        "WALine0": new makerjs.paths.Line([xa,ya-ha], [xa,ya-ha-markShiftThree]),//左上角
        "WALine1": new makerjs.paths.Line([xa+wa,ya-ha], [xa+wa,ya-ha-markShiftThree]),//左上角
        "WALine2":new makerjs.paths.Line([xa,ya-ha-markShift], [xa+wa,ya-ha-markShift]),
      }
    };
    var myFsAMakerW1A = {
      paths: {
       "W1ALine0":new makerjs.paths.Line([xa,ya-ha-da-markShift], [xa+w1a,ya-ha-da-markShift]),
       "W1ALine1": new makerjs.paths.Line([xa+w1a,ya-h1a], [xa+w1a,ya-h1a-da-markShiftThree]),//左上角
      }
    };
    var myFsAMakerW2A = {
      paths: {
       "W2ALine0":new makerjs.paths.Line([xa,ya-ha-ha-markShiftThree], [xa+w2a,ya-ha-ha-markShiftThree]),
        "W2ALine1": new makerjs.paths.Line([xa+w2a,ya], [xa+w2a,ya-ha-ha-da-markShiftFour]),//左上角
      }
    };
    var myFsAMakerHA = {
      
      paths: {
       "HALine0":new makerjs.paths.Line([xa,ya], [xa-markShiftFour, ya]),
       "HALine1": new makerjs.paths.Line([xa,ya-ha], [xa-markShiftFour, ya-ha]),//左上角
       "HALine2": new makerjs.paths.Line([xa-markShiftTwo,ya], [xa-markShiftTwo,ya-ha]),//左上角
      }
    };
    var myFsAMakerH1A = {    
      paths: {
       "H1ALine0":new makerjs.paths.Line([xa+w1a,ya-h1a], [xa+w1a+da/2+markShiftFour, ya-h1a]),
       "H1ALine1": new makerjs.paths.Line([xa+w2a+markShift,ya], [xa+w2a+markShift,ya-h1a]),//左上角
      }
    };
    var myFsAMakerR2A = {    
      paths: {
       "R2ALine1": new makerjs.paths.Line([xa+w2a,ya], [xa+w2a, ya-r2a-markShiftFour]),//左上角
       "R2ALine2": new makerjs.paths.Line([xa+Aa-markShiftTwo,ya], [xa+Aa,ya-Ahd]),//左上角
      }
    };
    var myFsAMakerR1A = {    
      paths: {
       "R1ALine1": new makerjs.paths.Line([xa+wa,ya-Ahd], [xa+wa+markShift,ya-Ahd-markShift]),//左上角
      }
    };
    var myFsAMakerDA = {    
      paths: {
       "DALine1": new makerjs.paths.Line([xa+w1a,ya-h1a], [xa+w1a+markShift+markHolesOneD,ya-h1a-da-markShiftFour-markHolesOneD]),//左上角
      }
    };
    /*****************  C  *********** */
    var myFsAMakerWC = {
      paths: {
        "WCLine0": new makerjs.paths.Line([xc,yc-hc], [xc,yc-hc-markShiftThree]),//左上角
        "WCLine1": new makerjs.paths.Line([xc-wc,yc-hc], [xc-wc,yc-hc-markShiftThree]),//左上角
        "WCLine2":new makerjs.paths.Line([xc,yc-hc-markShift], [xc-wc,yc-hc-markShift]),
      }
    };
    var myFsAMakerW1C = {
      paths: {
       "W1CLine0":new makerjs.paths.Line([xc,yc-hc-dc-markShift], [xc-w1c,yc-hc-dc-markShift]),
       "W1CLine1": new makerjs.paths.Line([xc-w1c,yc-h1c], [xc-w1c,yc-h1c-dc-markShiftThree]),//左上角
      }
    };
    var myFsAMakerW2C = {
      paths: {
       "W2CLine0":new makerjs.paths.Line([xc,yc-hc-hc-markShiftThree], [xc-w2c,yc-hc-hc-markShiftThree]),
        "W2CLine1": new makerjs.paths.Line([xc-w2c,yc], [xc-w2c,yc-hc-hc-dc-markShiftFour]),//左上角
      }
    };
    var myFsAMakerHC = {      
      paths: {
       "HCLine0":new makerjs.paths.Line([xc,yc], [xc+markShiftFour, yc]),
       "HCLine1": new makerjs.paths.Line([xc,yc-hc], [xc+markShiftFour, yc-hc]),//左上角
       "HCLine2": new makerjs.paths.Line([xc+markShiftTwo,yc], [xc+markShiftTwo,yc-hc]),//左上角
      }
    };
    var myFsAMakerH1C = {    
      paths: {
       "H1CLine0":new makerjs.paths.Line([xc-w1c,yc-h1c], [xc-w1c-dc/2-markShiftFour, yc-h1c]),
       "H1CLine1": new makerjs.paths.Line([xc-w2c-markShift,yc], [xc-w2c-markShift,yc-h1c]),//左上角
      }
    };
    var myFsAMakerR2C = {    
      paths: {
      //  "R2CLine1": new makerjs.paths.Line([xc-w2,yc], [xc-w2, yc-r2-markShiftFour]),//左上角
       "R2CLine2": new makerjs.paths.Line([xc-Caa+markShiftTwo,yc], [xc-Caa,yc-Chd]),//左上角
      }
    };
    var myFsAMakerR1C = {    
      paths: {
       "R1CLine1": new makerjs.paths.Line([xc-wc,yc-Chd], [xc-wc-markShift,yc-Chd-markShift]),//左上角
      }
    };
    var myFsAMakerDC = {    
      paths: {
       "DCLine1": new makerjs.paths.Line([xc-w1c,yc-h1c], [xc-w1c-markShift-markHolesOneD,yc-h1c-dc-markShiftFour-markHolesOneD]),//左上角
      }
    };
    /****************** G   ************** */
    var myFsAMakerWG = {
      paths: {
        "WGLine0": new makerjs.paths.Line([xg,yg+hg], [xg,yg+hg+markShiftThree]),//左上角
        "WGLine1": new makerjs.paths.Line([xg+wg,yg+hg], [xg+wg,yg+hg+markShiftThree]),//左上角
        "WGLine2":new makerjs.paths.Line([xg,yg+hg+markShift], [xg+wg,yg+hg+markShift]),
      }
    };
    var myFsAMakerW1G = {
      paths: {
        "W1GLine0":new makerjs.paths.Line([xg,yg+hg+dg+markShift], [xg+w1g,yg+hg+dg+markShift]),
        "W1GLine1": new makerjs.paths.Line([xg+w1g,yg+h1g], [xg+w1g,yg+h1g+dg+markShiftThree]),//左上角
      }
    };
    var myFsAMakerW2G = {
      paths: {
        "W2GLine0":new makerjs.paths.Line([xg,yg+hg+hg+markShiftThree], [xg+w2g,yg+hg+hg+markShiftThree]),
        "W2GLine1": new makerjs.paths.Line([xg+w2g,yg], [xg+w2g,yg+hg+hg+dg+markShiftFour]),//左上角
      }
    };
    var myFsAMakerHG = {      
      paths: {
        "HGLine0":new makerjs.paths.Line([xg,yg], [xg-markShiftFour, yg]),
        "HGLine1": new makerjs.paths.Line([xg,yg+hg], [xg-markShiftFour, yg+hg]),//左上角
        "HGLine2": new makerjs.paths.Line([xg-markShiftTwo,yg], [xg-markShiftTwo,yg+hg]),//左上角
      }
    };
    var myFsAMakerH1G = {    
      paths: {
        "H1GLine0":new makerjs.paths.Line([xg+w1g,yg+h1g], [xg+w1g+dg/2+markShiftFour, yg+h1g]),
        "H1GLine1": new makerjs.paths.Line([xg+w2g+markShift,yg], [xg+w2g+markShift,yg+h1g]),//左上角
      }
    };
    var myFsAMakerR2G = {    
      paths: {
        "R2GLine1": new makerjs.paths.Line([xg+w2g,yg], [xg+w2g, yg+r2g+markShiftFour]),//左上角
        "R2GLine2": new makerjs.paths.Line([xg+Ga-markShiftTwo,yg], [xg+Ga,yg+Ghd]),//左上角
      }
    };
    var myFsAMakerR1G = {    
      paths: {
        "R1GLine1": new makerjs.paths.Line([xg+wg,yg+Ghd], [xg+wg+markShift,yg+Ghd+markShift]),//左上角
      }
    };
    var myFsAMakerDG = {    
      paths: {
        "DGLine1": new makerjs.paths.Line([xg+w1g,yg+h1g], [xg+w1g+markShift+markHolesOneD,yg+h1g+dg+markShiftFour+markHolesOneD]),//左上角
      }
    };


    /**************************************************** */
    
  makerjs.model.addCaption(myFsAMakerWA, TxtWa, [xa,ya-ha-markShiftThree], [xa+wa,ya-ha-markShiftThree]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1A, TxtW1a, [xa,ya-ha-da-markShiftThree], [xa+w1a,ya-ha-da-markShiftThree]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2A, TxtW2a, [xa,ya-ha-ha-da-markShiftFour], [xa+w2a,ya-ha-ha-da-markShiftFour]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHA, TxtHa, [xa-markShiftFour,ya-ha], [xa-markShiftFour,ya]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1A, TxtH1a, [xa+w2a+markShiftThree,ya-h1a], [xa+w2a+markShiftThree,ya]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2A, TxtR2a, [xa+Aa-markShiftThree,ya-Ahd+markShiftThree], [xa+Aa-markShift,ya-Ahd+markShift]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1A, TxtR1a, [xa+wa,ya-Ahd], [xa+wa+markShift,ya-Ahd-markShift]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDA, TxtDa, [xa+w1a+markShift+markHolesOneD,ya-h1a-da-markShiftFour-markHolesOneD],[xa+w1a+markHolesOneD+markShiftFour,ya-h1a-da-markShiftFour-markHolesOneD]);//D文字标注  
    
  /**************************************************** */

  
  makerjs.model.addCaption(myFsAMakerWC, TxtWc, [xc-wc,yc-hc-markShiftThree], [xc,yc-hc-markShiftThree]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1C, TxtW1c, [xc-w1c,yc-hc-dc-markShiftThree], [xc,yc-hc-dc-markShiftThree]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2C, TxtW2c, [xc-w2c,yc-hc-hc-dc-markShiftFour], [xc,yc-hc-hc-dc-markShiftFour]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHC, TxtHc, [xc+markShiftFour,yc-hc], [xc+markShiftFour,yc]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1C, TxtH1c, [xc-w2c-markShiftThree,yc-h1c], [xc-w2c-markShiftThree,yc]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2C, TxtR2c, [xc-Caa+markShift,yc-Chd+markShift], [xc-Caa+markShiftThree,yc-Chd+markShiftThree]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1C, TxtR1c, [xc-wc-markShift,yc-Chd-markShift], [xc-wc,yc-Chd]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDC, TxtDc,[xc-w1c-markHolesOneD-markShiftFour,yc-h1c-dc-markShiftFour-markHolesOneD], [xc-w1c-markShift-markHolesOneD,yc-h1c-dc-markShiftFour-markHolesOneD]);//D文字标注  
    

  /******************************************************** */
  makerjs.model.addCaption(myFsAMakerWG, TxtWg, [xg,yg+hg+markShiftThree], [xg+wg,yg+hg+markShiftThree]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1G, TxtW1g, [xg,yg+hg+dg+markShiftThree], [xg+w1g,yg+hg+dg+markShiftThree]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2G, TxtW2g, [xg,yg+hg+hg+dg+markShiftFour], [xg+w2g,yg+hg+hg+dg+markShiftFour]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHG, TxtHg, [xg-markShiftFour,yg+hg], [xg-markShiftFour,yg]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1G, TxtH1g, [xg+w2g+markShiftThree,yg+h1g], [xg+w2g+markShiftThree,yg]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2G, TxtR2g, [xg+Ga-markShiftThree,yg+Ghd-markShiftThree], [xg+Ga-markShift,yg+Ghd-markShift]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1G, TxtR1g, [xg+wg,yg+Ghd], [xg+wg+markShift,yg+Ghd+markShift]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDG, TxtDg, [xg+w1g+markShift+markHolesOneD,yg+h1g+dg+markShiftFour+markHolesOneD],[xg+w1g+markHolesOneD+markShiftFour,yg+h1g+dg+markShiftFour+markHolesOneD]);//D文字标注  
    
  /******************************************************** */
  
  
  /******************************************************** */
  /******************************************************** */
  var markers = {
    /**A */
        myFsAMakerWA,
        myFsAMakerW1A,
         myFsAMakerW2A,
         myFsAMakerHA,
        myFsAMakerH1A,
         myFsAMakerR2A,
        myFsAMakerR1A,
        myFsAMakerDA,
        /**C */
        myFsAMakerWC,
        myFsAMakerW1C,
         myFsAMakerW2C,
         myFsAMakerHC,
        myFsAMakerH1C,
         myFsAMakerR2C,
        myFsAMakerR1C,
        myFsAMakerDC,
        /** G*/        
        myFsAMakerWG,
        myFsAMakerW1G,
         myFsAMakerW2G,
         myFsAMakerHG,
        myFsAMakerH1G,
         myFsAMakerR2G,
        myFsAMakerR1G,
        myFsAMakerDG,
        /**I */
      }
  

    // var myFilletMark = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xahx, xahy], [xawx, xawy], [xcwx, xcwy], [xchx, xchy],[xi, yi], [xgwx, xgwy]]);
  } else if (area == "ACI") {
    var myFsAMakerWA = {
      paths: {
        "WALine0": new makerjs.paths.Line([xa,ya-ha], [xa,ya-ha-markShiftThree]),//左上角
        "WALine1": new makerjs.paths.Line([xa+wa,ya-ha], [xa+wa,ya-ha-markShiftThree]),//左上角
        "WALine2":new makerjs.paths.Line([xa,ya-ha-markShift], [xa+wa,ya-ha-markShift]),
      }
    };
    var myFsAMakerW1A = {
      paths: {
       "W1ALine0":new makerjs.paths.Line([xa,ya-ha-da-markShift], [xa+w1a,ya-ha-da-markShift]),
       "W1ALine1": new makerjs.paths.Line([xa+w1a,ya-h1a], [xa+w1a,ya-h1a-da-markShiftThree]),//左上角
      }
    };
    var myFsAMakerW2A = {
      paths: {
       "W2ALine0":new makerjs.paths.Line([xa,ya-ha-ha-markShiftThree], [xa+w2a,ya-ha-ha-markShiftThree]),
        "W2ALine1": new makerjs.paths.Line([xa+w2a,ya], [xa+w2a,ya-ha-ha-da-markShiftFour]),//左上角
      }
    };
    var myFsAMakerHA = {
      
      paths: {
       "HALine0":new makerjs.paths.Line([xa,ya], [xa-markShiftFour, ya]),
       "HALine1": new makerjs.paths.Line([xa,ya-ha], [xa-markShiftFour, ya-ha]),//左上角
       "HALine2": new makerjs.paths.Line([xa-markShiftTwo,ya], [xa-markShiftTwo,ya-ha]),//左上角
      }
    };
    var myFsAMakerH1A = {    
      paths: {
       "H1ALine0":new makerjs.paths.Line([xa+w1a,ya-h1a], [xa+w1a+da/2+markShiftFour, ya-h1a]),
       "H1ALine1": new makerjs.paths.Line([xa+w2a+markShift,ya], [xa+w2a+markShift,ya-h1a]),//左上角
      }
    };
    var myFsAMakerR2A = {    
      paths: {
       "R2ALine1": new makerjs.paths.Line([xa+w2a,ya], [xa+w2a, ya-r2a-markShiftFour]),//左上角
       "R2ALine2": new makerjs.paths.Line([xa+Aa-markShiftTwo,ya], [xa+Aa,ya-Ahd]),//左上角
      }
    };
    var myFsAMakerR1A = {    
      paths: {
       "R1ALine1": new makerjs.paths.Line([xa+wa,ya-Ahd], [xa+wa+markShift,ya-Ahd-markShift]),//左上角
      }
    };
    var myFsAMakerDA = {    
      paths: {
       "DALine1": new makerjs.paths.Line([xa+w1a,ya-h1a], [xa+w1a+markShift+markHolesOneD,ya-h1a-da-markShiftFour-markHolesOneD]),//左上角
      }
    };
    /*****************  C  *********** */
    var myFsAMakerWC = {
      paths: {
        "WCLine0": new makerjs.paths.Line([xc,yc-hc], [xc,yc-hc-markShiftThree]),//左上角
        "WCLine1": new makerjs.paths.Line([xc-wc,yc-hc], [xc-wc,yc-hc-markShiftThree]),//左上角
        "WCLine2":new makerjs.paths.Line([xc,yc-hc-markShift], [xc-wc,yc-hc-markShift]),
      }
    };
    var myFsAMakerW1C = {
      paths: {
       "W1CLine0":new makerjs.paths.Line([xc,yc-hc-dc-markShift], [xc-w1c,yc-hc-dc-markShift]),
       "W1CLine1": new makerjs.paths.Line([xc-w1c,yc-h1c], [xc-w1c,yc-h1c-dc-markShiftThree]),//左上角
      }
    };
    var myFsAMakerW2C = {
      paths: {
       "W2CLine0":new makerjs.paths.Line([xc,yc-hc-hc-markShiftThree], [xc-w2c,yc-hc-hc-markShiftThree]),
        "W2CLine1": new makerjs.paths.Line([xc-w2c,yc], [xc-w2c,yc-hc-hc-dc-markShiftFour]),//左上角
      }
    };
    var myFsAMakerHC = {      
      paths: {
       "HCLine0":new makerjs.paths.Line([xc,yc], [xc+markShiftFour, yc]),
       "HCLine1": new makerjs.paths.Line([xc,yc-hc], [xc+markShiftFour, yc-hc]),//左上角
       "HCLine2": new makerjs.paths.Line([xc+markShiftTwo,yc], [xc+markShiftTwo,yc-hc]),//左上角
      }
    };
    var myFsAMakerH1C = {    
      paths: {
       "H1CLine0":new makerjs.paths.Line([xc-w1c,yc-h1c], [xc-w1c-dc/2-markShiftFour, yc-h1c]),
       "H1CLine1": new makerjs.paths.Line([xc-w2c-markShift,yc], [xc-w2c-markShift,yc-h1c]),//左上角
      }
    };
    var myFsAMakerR2C = {    
      paths: {
      //  "R2CLine1": new makerjs.paths.Line([xc-w2,yc], [xc-w2, yc-r2-markShiftFour]),//左上角
       "R2CLine2": new makerjs.paths.Line([xc-Caa+markShiftTwo,yc], [xc-Caa,yc-Chd]),//左上角
      }
    };
    var myFsAMakerR1C = {    
      paths: {
       "R1CLine1": new makerjs.paths.Line([xc-wc,yc-Chd], [xc-wc-markShift,yc-Chd-markShift]),//左上角
      }
    };
    var myFsAMakerDC = {    
      paths: {
       "DCLine1": new makerjs.paths.Line([xc-w1c,yc-h1c], [xc-w1c-markShift-markHolesOneD,yc-h1c-dc-markShiftFour-markHolesOneD]),//左上角
      }
    };
   

    /************************   I  ******************* */
    var myFsAMakerWI = {
      paths: {
       // "WILine0": new makerjs.paths.Line([xi,yi+hi], [xi,yi+hi+markShiftThree]),//左上角
        "WILine1": new makerjs.paths.Line([xi-wi,yi+hi], [xi-wi,yi+hi+markShiftThree]),//左上角
        "WILine2":new makerjs.paths.Line([xi,yi+hi+markShift], [xi-wi,yi+hi+markShift]),
      }
    };
    var myFsAMakerW1I = {
      paths: {
       "W1ILine0":new makerjs.paths.Line([xi,yi+hi+di+markShift], [xi-w1i,yi+hi+di+markShift]),
       "W1ILine1": new makerjs.paths.Line([xi-w1i,yi+h1i], [xi-w1i,yi+h1i+di+markShiftThree]),//左上角
      }
    };



    var myFsAMakerW2I = {
      paths: {
       "W2ILine0":new makerjs.paths.Line([xi,yi+hi+hi+markShiftThree], [xi-w2i,yi+hi+hi+markShiftThree]),
        "W2ILine1": new makerjs.paths.Line([xi-w2i,yi], [xi-w2i,yi+hi+hi+di+markShiftFour]),//左上角
      }
    };
    var myFsAMakerHI = {      
      paths: {
       "HILine0":new makerjs.paths.Line([xi,yi], [xi+markShiftFour, yi]),
       "HILine1": new makerjs.paths.Line([xi,yi+hi], [xi+markShiftFour, yi+hi]),//左上角
       "HILine2": new makerjs.paths.Line([xi+markShiftTwo,yi], [xi+markShiftTwo,yi+hi]),//左上角
      }
    };
    var myFsAMakerH1I = {    
      paths: {
       "H1ILine0":new makerjs.paths.Line([xi-w1i,yi+h1i], [xi-w1i-di/2-markShiftFour, yi+h1i]),
       "H1ILine1": new makerjs.paths.Line([xi-w2i-markShift,yi], [xi-w2i-markShift,yi+h1i]),//左上角
      }
    };
    var myFsAMakerR2I = {    
      paths: {
      //  "R2ILine1": new makerjs.paths.Line([xi-w2,yi], [xi-w2, yi-r2-markShiftFour]),//左上角
       "R2ILine2": new makerjs.paths.Line([xi-Iaa+markShiftTwo,yi], [xi-Iaa,yi+Ihd]),//左上角
      }
    };
    var myFsAMakerR1I = {    
      paths: {
       "R1ILine1": new makerjs.paths.Line([xi-wi,yi+Ihd], [xi-wi-markShift,yi+Ihd+markShift]),//左上角
      }
    };
    var myFsAMakerDI = {    
      paths: {
       "DILine1": new makerjs.paths.Line([xi-w1i,yi+h1i], [xi-w1i-markShift-markHolesOneD,yi+h1i+di+markShiftFour+markHolesOneD]),//左上角
      }
    };

     
  /******************************************************** */
  
  makerjs.model.addCaption(myFsAMakerWI, TxtWi, [xi-wi,yi+hi+markShiftThree], [xi,yi+hi+markShiftThree]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1I, TxtW1i, [xi-w1i,yi+hi+di+markShiftThree], [xi,yi+hi+di+markShiftThree]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2I, TxtW2i, [xi-w2i,yi+hi+hi+di+markShiftFour], [xi,yi+hi+hi+di+markShiftFour]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHI, TxtHi, [xi+markShiftFour,yi+hi], [xi+markShiftFour,yi]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1I, TxtH1i, [xi-w2i-markShiftThree,yi+h1i], [xi-w2i-markShiftThree,yi]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2I, TxtR2i, [xi-Iaa+markShift,yi+Ihd-markShift], [xi-Iaa+markShiftThree,yi+Ihd-markShiftThree]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1I, TxtR1i, [xi-wi-markShift,yi+Ihd+markShift], [xi-wi,yi+Ihd]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDI, TxtDi,[xi-w1i-markHolesOneD-markShiftFour,yi+h1i+di+markShiftFour+markHolesOneD], [xi-w1i-markShift-markHolesOneD,yi+h1i+di+markShiftFour+markHolesOneD]);//D文字标注  
   
/***************************************************/ 

    /**************************************************** */
    
  makerjs.model.addCaption(myFsAMakerWA, TxtWa, [xa,ya-ha-markShiftThree], [xa+wa,ya-ha-markShiftThree]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1A, TxtW1a, [xa,ya-ha-da-markShiftThree], [xa+w1a,ya-ha-da-markShiftThree]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2A, TxtW2a, [xa,ya-ha-ha-da-markShiftFour], [xa+w2a,ya-ha-ha-da-markShiftFour]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHA, TxtHa, [xa-markShiftFour,ya-ha], [xa-markShiftFour,ya]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1A, TxtH1a, [xa+w2a+markShiftThree,ya-h1a], [xa+w2a+markShiftThree,ya]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2A, TxtR2a, [xa+Aa-markShiftThree,ya-Ahd+markShiftThree], [xa+Aa-markShift,ya-Ahd+markShift]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1A, TxtR1a, [xa+wa,ya-Ahd], [xa+wa+markShift,ya-Ahd-markShift]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDA, TxtDa, [xa+w1a+markShift+markHolesOneD,ya-h1a-da-markShiftFour-markHolesOneD],[xa+w1a+markHolesOneD+markShiftFour,ya-h1a-da-markShiftFour-markHolesOneD]);//D文字标注  
    
  /**************************************************** */

  
  makerjs.model.addCaption(myFsAMakerWC, TxtWc, [xc-wc,yc-hc-markShiftThree], [xc,yc-hc-markShiftThree]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1C, TxtW1c, [xc-w1c,yc-hc-dc-markShiftThree], [xc,yc-hc-dc-markShiftThree]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2C, TxtW2c, [xc-w2c,yc-hc-hc-dc-markShiftFour], [xc,yc-hc-hc-dc-markShiftFour]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHC, TxtHc, [xc+markShiftFour,yc-hc], [xc+markShiftFour,yc]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1C, TxtH1c, [xc-w2c-markShiftThree,yc-h1c], [xc-w2c-markShiftThree,yc]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2C, TxtR2c, [xc-Caa+markShift,yc-Chd+markShift], [xc-Caa+markShiftThree,yc-Chd+markShiftThree]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1C, TxtR1c, [xc-wc-markShift,yc-Chd-markShift], [xc-wc,yc-Chd]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDC, TxtDc,[xc-w1c-markHolesOneD-markShiftFour,yc-h1c-dc-markShiftFour-markHolesOneD], [xc-w1c-markShift-markHolesOneD,yc-h1c-dc-markShiftFour-markHolesOneD]);//D文字标注  
    

  /******************************************************** */
   
  /******************************************************** */
  
  /******************************************************** */
  var markers = {
    /**A */
        myFsAMakerWA,
        myFsAMakerW1A,
         myFsAMakerW2A,
         myFsAMakerHA,
        myFsAMakerH1A,
         myFsAMakerR2A,
        myFsAMakerR1A,
        myFsAMakerDA,
        /**C */
        myFsAMakerWC,
        myFsAMakerW1C,
         myFsAMakerW2C,
         myFsAMakerHC,
        myFsAMakerH1C,
         myFsAMakerR2C,
        myFsAMakerR1C,
        myFsAMakerDC,
        /** G*/   
        /**I */
        myFsAMakerWI,
         myFsAMakerW1I,
         myFsAMakerW2I,
         myFsAMakerHI,
         myFsAMakerH1I,
         myFsAMakerR2I,
         myFsAMakerR1I,
         myFsAMakerDI,
      }
  

    // var myFilletMark = new makerjs.models.ConnectTheDots(true, [[xg, yg], [xahx, xahy], [xawx, xawy], [xcwx, xcwy], [xchx, xchy],[xihx, xihy], [xiwx, xiwy]]);
  } else if (area == "AGI") {
    var myFsAMakerWA = {
      paths: {
        "WALine0": new makerjs.paths.Line([xa,ya-ha], [xa,ya-ha-markShiftThree]),//左上角
        "WALine1": new makerjs.paths.Line([xa+wa,ya-ha], [xa+wa,ya-ha-markShiftThree]),//左上角
        "WALine2":new makerjs.paths.Line([xa,ya-ha-markShift], [xa+wa,ya-ha-markShift]),
      }
    };
    var myFsAMakerW1A = {
      paths: {
       "W1ALine0":new makerjs.paths.Line([xa,ya-ha-da-markShift], [xa+w1a,ya-ha-da-markShift]),
       "W1ALine1": new makerjs.paths.Line([xa+w1a,ya-h1a], [xa+w1a,ya-h1a-da-markShiftThree]),//左上角
      }
    };
    var myFsAMakerW2A = {
      paths: {
       "W2ALine0":new makerjs.paths.Line([xa,ya-ha-ha-markShiftThree], [xa+w2a,ya-ha-ha-markShiftThree]),
        "W2ALine1": new makerjs.paths.Line([xa+w2a,ya], [xa+w2a,ya-ha-ha-da-markShiftFour]),//左上角
      }
    };
    var myFsAMakerHA = {
      
      paths: {
       "HALine0":new makerjs.paths.Line([xa,ya], [xa-markShiftFour, ya]),
       "HALine1": new makerjs.paths.Line([xa,ya-ha], [xa-markShiftFour, ya-ha]),//左上角
       "HALine2": new makerjs.paths.Line([xa-markShiftTwo,ya], [xa-markShiftTwo,ya-ha]),//左上角
      }
    };
    var myFsAMakerH1A = {    
      paths: {
       "H1ALine0":new makerjs.paths.Line([xa+w1a,ya-h1a], [xa+w1a+da/2+markShiftFour, ya-h1a]),
       "H1ALine1": new makerjs.paths.Line([xa+w2a+markShift,ya], [xa+w2a+markShift,ya-h1a]),//左上角
      }
    };
    var myFsAMakerR2A = {    
      paths: {
       "R2ALine1": new makerjs.paths.Line([xa+w2a,ya], [xa+w2a, ya-r2a-markShiftFour]),//左上角
       "R2ALine2": new makerjs.paths.Line([xa+Aa-markShiftTwo,ya], [xa+Aa,ya-Ahd]),//左上角
      }
    };
    var myFsAMakerR1A = {    
      paths: {
       "R1ALine1": new makerjs.paths.Line([xa+wa,ya-Ahd], [xa+wa+markShift,ya-Ahd-markShift]),//左上角
      }
    };
    var myFsAMakerDA = {    
      paths: {
       "DALine1": new makerjs.paths.Line([xa+w1a,ya-h1a], [xa+w1a+markShift+markHolesOneD,ya-h1a-da-markShiftFour-markHolesOneD]),//左上角
      }
    };
  
    /****************** G   ************** */
    var myFsAMakerWG = {
      paths: {
        "WGLine0": new makerjs.paths.Line([xg,yg+hg], [xg,yg+hg+markShiftThree]),//左上角
        "WGLine1": new makerjs.paths.Line([xg+wg,yg+hg], [xg+wg,yg+hg+markShiftThree]),//左上角
        "WGLine2":new makerjs.paths.Line([xg,yg+hg+markShift], [xg+wg,yg+hg+markShift]),
      }
    };
    var myFsAMakerW1G = {
      paths: {
        "W1GLine0":new makerjs.paths.Line([xg,yg+hg+dg+markShift], [xg+w1g,yg+hg+dg+markShift]),
        "W1GLine1": new makerjs.paths.Line([xg+w1g,yg+h1g], [xg+w1g,yg+h1g+dg+markShiftThree]),//左上角
      }
    };
    var myFsAMakerW2G = {
      paths: {
        "W2GLine0":new makerjs.paths.Line([xg,yg+hg+hg+markShiftThree], [xg+w2g,yg+hg+hg+markShiftThree]),
        "W2GLine1": new makerjs.paths.Line([xg+w2g,yg], [xg+w2g,yg+hg+hg+dg+markShiftFour]),//左上角
      }
    };
    var myFsAMakerHG = {      
      paths: {
        "HGLine0":new makerjs.paths.Line([xg,yg], [xg-markShiftFour, yg]),
        "HGLine1": new makerjs.paths.Line([xg,yg+hg], [xg-markShiftFour, yg+hg]),//左上角
        "HGLine2": new makerjs.paths.Line([xg-markShiftTwo,yg], [xg-markShiftTwo,yg+hg]),//左上角
      }
    };
    var myFsAMakerH1G = {    
      paths: {
        "H1GLine0":new makerjs.paths.Line([xg+w1g,yg+h1g], [xg+w1g+dg/2+markShiftFour, yg+h1g]),
        "H1GLine1": new makerjs.paths.Line([xg+w2g+markShift,yg], [xg+w2g+markShift,yg+h1g]),//左上角
      }
    };
    var myFsAMakerR2G = {    
      paths: {
        "R2GLine1": new makerjs.paths.Line([xg+w2g,yg], [xg+w2g, yg+r2g+markShiftFour]),//左上角
        "R2GLine2": new makerjs.paths.Line([xg+Ga-markShiftTwo,yg], [xg+Ga,yg+Ghd]),//左上角
      }
    };
    var myFsAMakerR1G = {    
      paths: {
        "R1GLine1": new makerjs.paths.Line([xg+wg,yg+Ghd], [xg+wg+markShift,yg+Ghd+markShift]),//左上角
      }
    };
    var myFsAMakerDG = {    
      paths: {
        "DGLine1": new makerjs.paths.Line([xg+w1g,yg+h1g], [xg+w1g+markShift+markHolesOneD,yg+h1g+dg+markShiftFour+markHolesOneD]),//左上角
      }
    };

    /************************   I  ******************* */
    var myFsAMakerWI = {
      paths: {
       // "WILine0": new makerjs.paths.Line([xi,yi+hi], [xi,yi+hi+markShiftThree]),//左上角
        "WILine1": new makerjs.paths.Line([xi-wi,yi+hi], [xi-wi,yi+hi+markShiftThree]),//左上角
        "WILine2":new makerjs.paths.Line([xi,yi+hi+markShift], [xi-wi,yi+hi+markShift]),
      }
    };
    var myFsAMakerW1I = {
      paths: {
       "W1ILine0":new makerjs.paths.Line([xi,yi+hi+di+markShift], [xi-w1i,yi+hi+di+markShift]),
       "W1ILine1": new makerjs.paths.Line([xi-w1i,yi+h1i], [xi-w1i,yi+h1i+di+markShiftThree]),//左上角
      }
    };



    var myFsAMakerW2I = {
      paths: {
       "W2ILine0":new makerjs.paths.Line([xi,yi+hi+hi+markShiftThree], [xi-w2i,yi+hi+hi+markShiftThree]),
        "W2ILine1": new makerjs.paths.Line([xi-w2i,yi], [xi-w2i,yi+hi+hi+di+markShiftFour]),//左上角
      }
    };
    var myFsAMakerHI = {      
      paths: {
       "HILine0":new makerjs.paths.Line([xi,yi], [xi+markShiftFour, yi]),
       "HILine1": new makerjs.paths.Line([xi,yi+hi], [xi+markShiftFour, yi+hi]),//左上角
       "HILine2": new makerjs.paths.Line([xi+markShiftTwo,yi], [xi+markShiftTwo,yi+hi]),//左上角
      }
    };
    var myFsAMakerH1I = {    
      paths: {
       "H1ILine0":new makerjs.paths.Line([xi-w1i,yi+h1i], [xi-w1i-di/2-markShiftFour, yi+h1i]),
       "H1ILine1": new makerjs.paths.Line([xi-w2i-markShift,yi], [xi-w2i-markShift,yi+h1i]),//左上角
      }
    };
    var myFsAMakerR2I = {    
      paths: {
      //  "R2ILine1": new makerjs.paths.Line([xi-w2,yi], [xi-w2, yi-r2-markShiftFour]),//左上角
       "R2ILine2": new makerjs.paths.Line([xi-Iaa+markShiftTwo,yi], [xi-Iaa,yi+Ihd]),//左上角
      }
    };
    var myFsAMakerR1I = {    
      paths: {
       "R1ILine1": new makerjs.paths.Line([xi-wi,yi+Ihd], [xi-wi-markShift,yi+Ihd+markShift]),//左上角
      }
    };
    var myFsAMakerDI = {    
      paths: {
       "DILine1": new makerjs.paths.Line([xi-w1i,yi+h1i], [xi-w1i-markShift-markHolesOneD,yi+h1i+di+markShiftFour+markHolesOneD]),//左上角
      }
    };

     
  /******************************************************** */
  
  makerjs.model.addCaption(myFsAMakerWI, TxtWi, [xi-wi,yi+hi+markShiftThree], [xi,yi+hi+markShiftThree]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1I, TxtW1i, [xi-w1i,yi+hi+di+markShiftThree], [xi,yi+hi+di+markShiftThree]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2I, TxtW2i, [xi-w2i,yi+hi+hi+di+markShiftFour], [xi,yi+hi+hi+di+markShiftFour]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHI, TxtHi, [xi+markShiftFour,yi+hi], [xi+markShiftFour,yi]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1I, TxtH1i, [xi-w2i-markShiftThree,yi+h1i], [xi-w2i-markShiftThree,yi]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2I, TxtR2i, [xi-Iaa+markShift,yi+Ihd-markShift], [xi-Iaa+markShiftThree,yi+Ihd-markShiftThree]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1I, TxtR1i, [xi-wi-markShift,yi+Ihd+markShift], [xi-wi,yi+Ihd]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDI, TxtDi,[xi-w1i-markHolesOneD-markShiftFour,yi+h1i+di+markShiftFour+markHolesOneD], [xi-w1i-markShift-markHolesOneD,yi+h1i+di+markShiftFour+markHolesOneD]);//D文字标注  
   
/***************************************************/ 
    /**************************************************** */
    
  makerjs.model.addCaption(myFsAMakerWA, TxtWa, [xa,ya-ha-markShiftThree], [xa+wa,ya-ha-markShiftThree]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1A, TxtW1a, [xa,ya-ha-da-markShiftThree], [xa+w1a,ya-ha-da-markShiftThree]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2A, TxtW2a, [xa,ya-ha-ha-da-markShiftFour], [xa+w2a,ya-ha-ha-da-markShiftFour]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHA, TxtHa, [xa-markShiftFour,ya-ha], [xa-markShiftFour,ya]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1A, TxtH1a, [xa+w2a+markShiftThree,ya-h1a], [xa+w2a+markShiftThree,ya]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2A, TxtR2a, [xa+Aa-markShiftThree,ya-Ahd+markShiftThree], [xa+Aa-markShift,ya-Ahd+markShift]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1A, TxtR1a, [xa+wa,ya-Ahd], [xa+wa+markShift,ya-Ahd-markShift]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDA, TxtDa, [xa+w1a+markShift+markHolesOneD,ya-h1a-da-markShiftFour-markHolesOneD],[xa+w1a+markHolesOneD+markShiftFour,ya-h1a-da-markShiftFour-markHolesOneD]);//D文字标注  
    
  /**************************************************** */

  
  /******************************************************** */
  makerjs.model.addCaption(myFsAMakerWG, TxtWg, [xg,yg+hg+markShiftThree], [xg+wg,yg+hg+markShiftThree]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1G, TxtW1g, [xg,yg+hg+dg+markShiftThree], [xg+w1g,yg+hg+dg+markShiftThree]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2G, TxtW2g, [xg,yg+hg+hg+dg+markShiftFour], [xg+w2g,yg+hg+hg+dg+markShiftFour]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHG, TxtHg, [xg-markShiftFour,yg+hg], [xg-markShiftFour,yg]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1G, TxtH1g, [xg+w2g+markShiftThree,yg+h1g], [xg+w2g+markShiftThree,yg]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2G, TxtR2g, [xg+Ga-markShiftThree,yg+Ghd-markShiftThree], [xg+Ga-markShift,yg+Ghd-markShift]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1G, TxtR1g, [xg+wg,yg+Ghd], [xg+wg+markShift,yg+Ghd+markShift]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDG, TxtDg, [xg+w1g+markShift+markHolesOneD,yg+h1g+dg+markShiftFour+markHolesOneD],[xg+w1g+markHolesOneD+markShiftFour,yg+h1g+dg+markShiftFour+markHolesOneD]);//D文字标注  
    
  /******************************************************** */
  
  /******************************************************** */
  var markers = {
    /**A */
        myFsAMakerWA,
        myFsAMakerW1A,
         myFsAMakerW2A,
         myFsAMakerHA,
        myFsAMakerH1A,
         myFsAMakerR2A,
        myFsAMakerR1A,
        myFsAMakerDA,
        /**C */
        /** G*/        
        myFsAMakerWG,
        myFsAMakerW1G,
         myFsAMakerW2G,
         myFsAMakerHG,
        myFsAMakerH1G,
         myFsAMakerR2G,
        myFsAMakerR1G,
        myFsAMakerDG,
        /**I */
        myFsAMakerWI,
         myFsAMakerW1I,
         myFsAMakerW2I,
         myFsAMakerHI,
         myFsAMakerH1I,
         myFsAMakerR2I,
         myFsAMakerR1I,
         myFsAMakerDI,
      }
  

    // var myFilletMark = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xahx, xahy], [xawx, xawy], [xc, yc],[xihx, xihy], [xiwx, xiwy], [xgwx, xgwy]]);
  } else if (area == "CGI") {
  
    /*****************  C  *********** */
    var myFsAMakerWC = {
      paths: {
        "WCLine0": new makerjs.paths.Line([xc,yc-hc], [xc,yc-hc-markShiftThree]),//左上角
        "WCLine1": new makerjs.paths.Line([xc-wc,yc-hc], [xc-wc,yc-hc-markShiftThree]),//左上角
        "WCLine2":new makerjs.paths.Line([xc,yc-hc-markShift], [xc-wc,yc-hc-markShift]),
      }
    };
    var myFsAMakerW1C = {
      paths: {
       "W1CLine0":new makerjs.paths.Line([xc,yc-hc-dc-markShift], [xc-w1c,yc-hc-dc-markShift]),
       "W1CLine1": new makerjs.paths.Line([xc-w1c,yc-h1c], [xc-w1c,yc-h1c-dc-markShiftThree]),//左上角
      }
    };
    var myFsAMakerW2C = {
      paths: {
       "W2CLine0":new makerjs.paths.Line([xc,yc-hc-hc-markShiftThree], [xc-w2c,yc-hc-hc-markShiftThree]),
        "W2CLine1": new makerjs.paths.Line([xc-w2c,yc], [xc-w2c,yc-hc-hc-dc-markShiftFour]),//左上角
      }
    };
    var myFsAMakerHC = {      
      paths: {
       "HCLine0":new makerjs.paths.Line([xc,yc], [xc+markShiftFour, yc]),
       "HCLine1": new makerjs.paths.Line([xc,yc-hc], [xc+markShiftFour, yc-hc]),//左上角
       "HCLine2": new makerjs.paths.Line([xc+markShiftTwo,yc], [xc+markShiftTwo,yc-hc]),//左上角
      }
    };
    var myFsAMakerH1C = {    
      paths: {
       "H1CLine0":new makerjs.paths.Line([xc-w1c,yc-h1c], [xc-w1c-dc/2-markShiftFour, yc-h1c]),
       "H1CLine1": new makerjs.paths.Line([xc-w2c-markShift,yc], [xc-w2c-markShift,yc-h1c]),//左上角
      }
    };
    var myFsAMakerR2C = {    
      paths: {
      //  "R2CLine1": new makerjs.paths.Line([xc-w2,yc], [xc-w2, yc-r2-markShiftFour]),//左上角
       "R2CLine2": new makerjs.paths.Line([xc-Caa+markShiftTwo,yc], [xc-Caa,yc-Chd]),//左上角
      }
    };
    var myFsAMakerR1C = {    
      paths: {
       "R1CLine1": new makerjs.paths.Line([xc-wc,yc-Chd], [xc-wc-markShift,yc-Chd-markShift]),//左上角
      }
    };
    var myFsAMakerDC = {    
      paths: {
       "DCLine1": new makerjs.paths.Line([xc-w1c,yc-h1c], [xc-w1c-markShift-markHolesOneD,yc-h1c-dc-markShiftFour-markHolesOneD]),//左上角
      }
    };
    /****************** G   ************** */
    var myFsAMakerWG = {
      paths: {
        "WGLine0": new makerjs.paths.Line([xg,yg+hg], [xg,yg+hg+markShiftThree]),//左上角
        "WGLine1": new makerjs.paths.Line([xg+wg,yg+hg], [xg+wg,yg+hg+markShiftThree]),//左上角
        "WGLine2":new makerjs.paths.Line([xg,yg+hg+markShift], [xg+wg,yg+hg+markShift]),
      }
    };
    var myFsAMakerW1G = {
      paths: {
        "W1GLine0":new makerjs.paths.Line([xg,yg+hg+dg+markShift], [xg+w1g,yg+hg+dg+markShift]),
        "W1GLine1": new makerjs.paths.Line([xg+w1g,yg+h1g], [xg+w1g,yg+h1g+dg+markShiftThree]),//左上角
      }
    };
    var myFsAMakerW2G = {
      paths: {
        "W2GLine0":new makerjs.paths.Line([xg,yg+hg+hg+markShiftThree], [xg+w2g,yg+hg+hg+markShiftThree]),
        "W2GLine1": new makerjs.paths.Line([xg+w2g,yg], [xg+w2g,yg+hg+hg+dg+markShiftFour]),//左上角
      }
    };
    var myFsAMakerHG = {      
      paths: {
        "HGLine0":new makerjs.paths.Line([xg,yg], [xg-markShiftFour, yg]),
        "HGLine1": new makerjs.paths.Line([xg,yg+hg], [xg-markShiftFour, yg+hg]),//左上角
        "HGLine2": new makerjs.paths.Line([xg-markShiftTwo,yg], [xg-markShiftTwo,yg+hg]),//左上角
      }
    };
    var myFsAMakerH1G = {    
      paths: {
        "H1GLine0":new makerjs.paths.Line([xg+w1g,yg+h1g], [xg+w1g+dg/2+markShiftFour, yg+h1g]),
        "H1GLine1": new makerjs.paths.Line([xg+w2g+markShift,yg], [xg+w2g+markShift,yg+h1g]),//左上角
      }
    };
    var myFsAMakerR2G = {    
      paths: {
        "R2GLine1": new makerjs.paths.Line([xg+w2g,yg], [xg+w2g, yg+r2g+markShiftFour]),//左上角
        "R2GLine2": new makerjs.paths.Line([xg+Ga-markShiftTwo,yg], [xg+Ga,yg+Ghd]),//左上角
      }
    };
    var myFsAMakerR1G = {    
      paths: {
        "R1GLine1": new makerjs.paths.Line([xg+wg,yg+Ghd], [xg+wg+markShift,yg+Ghd+markShift]),//左上角
      }
    };
    var myFsAMakerDG = {    
      paths: {
        "DGLine1": new makerjs.paths.Line([xg+w1g,yg+h1g], [xg+w1g+markShift+markHolesOneD,yg+h1g+dg+markShiftFour+markHolesOneD]),//左上角
      }
    };

    /************************   I  ******************* */
    var myFsAMakerWI = {
      paths: {
       // "WILine0": new makerjs.paths.Line([xi,yi+hi], [xi,yi+hi+markShiftThree]),//左上角
        "WILine1": new makerjs.paths.Line([xi-wi,yi+hi], [xi-wi,yi+hi+markShiftThree]),//左上角
        "WILine2":new makerjs.paths.Line([xi,yi+hi+markShift], [xi-wi,yi+hi+markShift]),
      }
    };
    var myFsAMakerW1I = {
      paths: {
       "W1ILine0":new makerjs.paths.Line([xi,yi+hi+di+markShift], [xi-w1i,yi+hi+di+markShift]),
       "W1ILine1": new makerjs.paths.Line([xi-w1i,yi+h1i], [xi-w1i,yi+h1i+di+markShiftThree]),//左上角
      }
    };



    var myFsAMakerW2I = {
      paths: {
       "W2ILine0":new makerjs.paths.Line([xi,yi+hi+hi+markShiftThree], [xi-w2i,yi+hi+hi+markShiftThree]),
        "W2ILine1": new makerjs.paths.Line([xi-w2i,yi], [xi-w2i,yi+hi+hi+di+markShiftFour]),//左上角
      }
    };
    var myFsAMakerHI = {      
      paths: {
       "HILine0":new makerjs.paths.Line([xi,yi], [xi+markShiftFour, yi]),
       "HILine1": new makerjs.paths.Line([xi,yi+hi], [xi+markShiftFour, yi+hi]),//左上角
       "HILine2": new makerjs.paths.Line([xi+markShiftTwo,yi], [xi+markShiftTwo,yi+hi]),//左上角
      }
    };
    var myFsAMakerH1I = {    
      paths: {
       "H1ILine0":new makerjs.paths.Line([xi-w1i,yi+h1i], [xi-w1i-di/2-markShiftFour, yi+h1i]),
       "H1ILine1": new makerjs.paths.Line([xi-w2i-markShift,yi], [xi-w2i-markShift,yi+h1i]),//左上角
      }
    };
    var myFsAMakerR2I = {    
      paths: {
      //  "R2ILine1": new makerjs.paths.Line([xi-w2,yi], [xi-w2, yi-r2-markShiftFour]),//左上角
       "R2ILine2": new makerjs.paths.Line([xi-Iaa+markShiftTwo,yi], [xi-Iaa,yi+Ihd]),//左上角
      }
    };
    var myFsAMakerR1I = {    
      paths: {
       "R1ILine1": new makerjs.paths.Line([xi-wi,yi+Ihd], [xi-wi-markShift,yi+Ihd+markShift]),//左上角
      }
    };
    var myFsAMakerDI = {    
      paths: {
       "DILine1": new makerjs.paths.Line([xi-w1i,yi+h1i], [xi-w1i-markShift-markHolesOneD,yi+h1i+di+markShiftFour+markHolesOneD]),//左上角
      }
    };

     
  /******************************************************** */
  
  makerjs.model.addCaption(myFsAMakerWI, TxtWi, [xi-wi,yi+hi+markShiftThree], [xi,yi+hi+markShiftThree]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1I, TxtW1i, [xi-w1i,yi+hi+di+markShiftThree], [xi,yi+hi+di+markShiftThree]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2I, TxtW2i, [xi-w2i,yi+hi+hi+di+markShiftFour], [xi,yi+hi+hi+di+markShiftFour]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHI, TxtHi, [xi+markShiftFour,yi+hi], [xi+markShiftFour,yi]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1I, TxtH1i, [xi-w2i-markShiftThree,yi+h1i], [xi-w2i-markShiftThree,yi]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2I, TxtR2i, [xi-Iaa+markShift,yi+Ihd-markShift], [xi-Iaa+markShiftThree,yi+Ihd-markShiftThree]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1I, TxtR1i, [xi-wi-markShift,yi+Ihd+markShift], [xi-wi,yi+Ihd]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDI, TxtDi,[xi-w1i-markHolesOneD-markShiftFour,yi+h1i+di+markShiftFour+markHolesOneD], [xi-w1i-markShift-markHolesOneD,yi+h1i+di+markShiftFour+markHolesOneD]);//D文字标注  
   
/***************************************************/ 
    
  /**************************************************** */

  
  makerjs.model.addCaption(myFsAMakerWC, TxtWc, [xc-wc,yc-hc-markShiftThree], [xc,yc-hc-markShiftThree]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1C, TxtW1c, [xc-w1c,yc-hc-dc-markShiftThree], [xc,yc-hc-dc-markShiftThree]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2C, TxtW2c, [xc-w2c,yc-hc-hc-dc-markShiftFour], [xc,yc-hc-hc-dc-markShiftFour]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHC, TxtHc, [xc+markShiftFour,yc-hc], [xc+markShiftFour,yc]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1C, TxtH1c, [xc-w2c-markShiftThree,yc-h1c], [xc-w2c-markShiftThree,yc]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2C, TxtR2c, [xc-Caa+markShift,yc-Chd+markShift], [xc-Caa+markShiftThree,yc-Chd+markShiftThree]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1C, TxtR1c, [xc-wc-markShift,yc-Chd-markShift], [xc-wc,yc-Chd]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDC, TxtDc,[xc-w1c-markHolesOneD-markShiftFour,yc-h1c-dc-markShiftFour-markHolesOneD], [xc-w1c-markShift-markHolesOneD,yc-h1c-dc-markShiftFour-markHolesOneD]);//D文字标注  
    

  /******************************************************** */
  makerjs.model.addCaption(myFsAMakerWG, TxtWg, [xg,yg+hg+markShiftThree], [xg+wg,yg+hg+markShiftThree]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1G, TxtW1g, [xg,yg+hg+dg+markShiftThree], [xg+w1g,yg+hg+dg+markShiftThree]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2G, TxtW2g, [xg,yg+hg+hg+dg+markShiftFour], [xg+w2g,yg+hg+hg+dg+markShiftFour]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHG, TxtHg, [xg-markShiftFour,yg+hg], [xg-markShiftFour,yg]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1G, TxtH1g, [xg+w2g+markShiftThree,yg+h1g], [xg+w2g+markShiftThree,yg]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2G, TxtR2g, [xg+Ga-markShiftThree,yg+Ghd-markShiftThree], [xg+Ga-markShift,yg+Ghd-markShift]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1G, TxtR1g, [xg+wg,yg+Ghd], [xg+wg+markShift,yg+Ghd+markShift]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDG, TxtDg, [xg+w1g+markShift+markHolesOneD,yg+h1g+dg+markShiftFour+markHolesOneD],[xg+w1g+markHolesOneD+markShiftFour,yg+h1g+dg+markShiftFour+markHolesOneD]);//D文字标注  
    
  /******************************************************** */
  
  /******************************************************** */
  var markers = {
        /**C */
        myFsAMakerWC,
        myFsAMakerW1C,
         myFsAMakerW2C,
         myFsAMakerHC,
        myFsAMakerH1C,
         myFsAMakerR2C,
        myFsAMakerR1C,
        myFsAMakerDC,
        /** G*/        
        myFsAMakerWG,
        myFsAMakerW1G,
         myFsAMakerW2G,
         myFsAMakerHG,
        myFsAMakerH1G,
         myFsAMakerR2G,
        myFsAMakerR1G,
        myFsAMakerDG,
        /**I */
        myFsAMakerWI,
        myFsAMakerW1I,
        myFsAMakerW2I,
        myFsAMakerHI,
        myFsAMakerH1I,
        myFsAMakerR2I,
        myFsAMakerR1I,
        myFsAMakerDI,
      }
  

    // var myFilletMark = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xa, ya], [xcwx, xcwy], [xchx, xchy],[xihx, xihy], [xiwx, xiwy], [xgwx, xgwy]]);
  } else if (area == "ACGI") {
    var myFsAMakerWA = {
      paths: {
        "WALine0": new makerjs.paths.Line([xa,ya-ha], [xa,ya-ha-markShiftThree]),//左上角
        "WALine1": new makerjs.paths.Line([xa+wa,ya-ha], [xa+wa,ya-ha-markShiftThree]),//左上角
        "WALine2":new makerjs.paths.Line([xa,ya-ha-markShift], [xa+wa,ya-ha-markShift]),
      }
    };
    var myFsAMakerW1A = {
      paths: {
       "W1ALine0":new makerjs.paths.Line([xa,ya-ha-da-markShift], [xa+w1a,ya-ha-da-markShift]),
       "W1ALine1": new makerjs.paths.Line([xa+w1a,ya-h1a], [xa+w1a,ya-h1a-da-markShiftThree]),//左上角
      }
    };
    var myFsAMakerW2A = {
      paths: {
       "W2ALine0":new makerjs.paths.Line([xa,ya-ha-ha-markShiftThree], [xa+w2a,ya-ha-ha-markShiftThree]),
        "W2ALine1": new makerjs.paths.Line([xa+w2a,ya], [xa+w2a,ya-ha-ha-da-markShiftFour]),//左上角
      }
    };
    var myFsAMakerHA = {
      
      paths: {
       "HALine0":new makerjs.paths.Line([xa,ya], [xa-markShiftFour, ya]),
       "HALine1": new makerjs.paths.Line([xa,ya-ha], [xa-markShiftFour, ya-ha]),//左上角
       "HALine2": new makerjs.paths.Line([xa-markShiftTwo,ya], [xa-markShiftTwo,ya-ha]),//左上角
      }
    };
    var myFsAMakerH1A = {    
      paths: {
       "H1ALine0":new makerjs.paths.Line([xa+w1a,ya-h1a], [xa+w1a+da/2+markShiftFour, ya-h1a]),
       "H1ALine1": new makerjs.paths.Line([xa+w2a+markShift,ya], [xa+w2a+markShift,ya-h1a]),//左上角
      }
    };
    var myFsAMakerR2A = {    
      paths: {
       "R2ALine1": new makerjs.paths.Line([xa+w2a,ya], [xa+w2a, ya-r2a-markShiftFour]),//左上角
       "R2ALine2": new makerjs.paths.Line([xa+Aa-markShiftTwo,ya], [xa+Aa,ya-Ahd]),//左上角
      }
    };
    var myFsAMakerR1A = {    
      paths: {
       "R1ALine1": new makerjs.paths.Line([xa+wa,ya-Ahd], [xa+wa+markShift,ya-Ahd-markShift]),//左上角
      }
    };
    var myFsAMakerDA = {    
      paths: {
       "DALine1": new makerjs.paths.Line([xa+w1a,ya-h1a], [xa+w1a+markShift+markHolesOneD,ya-h1a-da-markShiftFour-markHolesOneD]),//左上角
      }
    };
    /*****************  C  *********** */
    var myFsAMakerWC = {
      paths: {
        "WCLine0": new makerjs.paths.Line([xc,yc-hc], [xc,yc-hc-markShiftThree]),//左上角
        "WCLine1": new makerjs.paths.Line([xc-wc,yc-hc], [xc-wc,yc-hc-markShiftThree]),//左上角
        "WCLine2":new makerjs.paths.Line([xc,yc-hc-markShift], [xc-wc,yc-hc-markShift]),
      }
    };
    var myFsAMakerW1C = {
      paths: {
       "W1CLine0":new makerjs.paths.Line([xc,yc-hc-dc-markShift], [xc-w1c,yc-hc-dc-markShift]),
       "W1CLine1": new makerjs.paths.Line([xc-w1c,yc-h1c], [xc-w1c,yc-h1c-dc-markShiftThree]),//左上角
      }
    };
    var myFsAMakerW2C = {
      paths: {
       "W2CLine0":new makerjs.paths.Line([xc,yc-hc-hc-markShiftThree], [xc-w2c,yc-hc-hc-markShiftThree]),
        "W2CLine1": new makerjs.paths.Line([xc-w2c,yc], [xc-w2c,yc-hc-hc-dc-markShiftFour]),//左上角
      }
    };
    var myFsAMakerHC = {      
      paths: {
       "HCLine0":new makerjs.paths.Line([xc,yc], [xc+markShiftFour, yc]),
       "HCLine1": new makerjs.paths.Line([xc,yc-hc], [xc+markShiftFour, yc-hc]),//左上角
       "HCLine2": new makerjs.paths.Line([xc+markShiftTwo,yc], [xc+markShiftTwo,yc-hc]),//左上角
      }
    };
    var myFsAMakerH1C = {    
      paths: {
       "H1CLine0":new makerjs.paths.Line([xc-w1c,yc-h1c], [xc-w1c-dc/2-markShiftFour, yc-h1c]),
       "H1CLine1": new makerjs.paths.Line([xc-w2c-markShift,yc], [xc-w2c-markShift,yc-h1c]),//左上角
      }
    };
    var myFsAMakerR2C = {    
      paths: {
      //  "R2CLine1": new makerjs.paths.Line([xc-w2,yc], [xc-w2, yc-r2-markShiftFour]),//左上角
       "R2CLine2": new makerjs.paths.Line([xc-Caa+markShiftTwo,yc], [xc-Caa,yc-Chd]),//左上角
      }
    };
    var myFsAMakerR1C = {    
      paths: {
       "R1CLine1": new makerjs.paths.Line([xc-wc,yc-Chd], [xc-wc-markShift,yc-Chd-markShift]),//左上角
      }
    };
    var myFsAMakerDC = {    
      paths: {
       "DCLine1": new makerjs.paths.Line([xc-w1c,yc-h1c], [xc-w1c-markShift-markHolesOneD,yc-h1c-dc-markShiftFour-markHolesOneD]),//左上角
      }
    };
    /****************** G   ************** */
    var myFsAMakerWG = {
      paths: {
        "WGLine0": new makerjs.paths.Line([xg,yg+hg], [xg,yg+hg+markShiftThree]),//左上角
        "WGLine1": new makerjs.paths.Line([xg+wg,yg+hg], [xg+wg,yg+hg+markShiftThree]),//左上角
        "WGLine2":new makerjs.paths.Line([xg,yg+hg+markShift], [xg+wg,yg+hg+markShift]),
      }
    };
    var myFsAMakerW1G = {
      paths: {
        "W1GLine0":new makerjs.paths.Line([xg,yg+hg+dg+markShift], [xg+w1g,yg+hg+dg+markShift]),
        "W1GLine1": new makerjs.paths.Line([xg+w1g,yg+h1g], [xg+w1g,yg+h1g+dg+markShiftThree]),//左上角
      }
    };
    var myFsAMakerW2G = {
      paths: {
        "W2GLine0":new makerjs.paths.Line([xg,yg+hg+hg+markShiftThree], [xg+w2g,yg+hg+hg+markShiftThree]),
        "W2GLine1": new makerjs.paths.Line([xg+w2g,yg], [xg+w2g,yg+hg+hg+dg+markShiftFour]),//左上角
      }
    };
    var myFsAMakerHG = {      
      paths: {
        "HGLine0":new makerjs.paths.Line([xg,yg], [xg-markShiftFour, yg]),
        "HGLine1": new makerjs.paths.Line([xg,yg+hg], [xg-markShiftFour, yg+hg]),//左上角
        "HGLine2": new makerjs.paths.Line([xg-markShiftTwo,yg], [xg-markShiftTwo,yg+hg]),//左上角
      }
    };
    var myFsAMakerH1G = {    
      paths: {
        "H1GLine0":new makerjs.paths.Line([xg+w1g,yg+h1g], [xg+w1g+dg/2+markShiftFour, yg+h1g]),
        "H1GLine1": new makerjs.paths.Line([xg+w2g+markShift,yg], [xg+w2g+markShift,yg+h1g]),//左上角
      }
    };
    var myFsAMakerR2G = {    
      paths: {
        "R2GLine1": new makerjs.paths.Line([xg+w2g,yg], [xg+w2g, yg+r2g+markShiftFour]),//左上角
        "R2GLine2": new makerjs.paths.Line([xg+Ga-markShiftTwo,yg], [xg+Ga,yg+Ghd]),//左上角
      }
    };
    var myFsAMakerR1G = {    
      paths: {
        "R1GLine1": new makerjs.paths.Line([xg+wg,yg+Ghd], [xg+wg+markShift,yg+Ghd+markShift]),//左上角
      }
    };
    var myFsAMakerDG = {    
      paths: {
        "DGLine1": new makerjs.paths.Line([xg+w1g,yg+h1g], [xg+w1g+markShift+markHolesOneD,yg+h1g+dg+markShiftFour+markHolesOneD]),//左上角
      }
    };

    /************************   I  ******************* */
    var myFsAMakerWI = {
      paths: {
       // "WILine0": new makerjs.paths.Line([xi,yi+hi], [xi,yi+hi+markShiftThree]),//左上角
        "WILine1": new makerjs.paths.Line([xi-wi,yi+hi], [xi-wi,yi+hi+markShiftThree]),//左上角
        "WILine2":new makerjs.paths.Line([xi,yi+hi+markShift], [xi-wi,yi+hi+markShift]),
      }
    };
    var myFsAMakerW1I = {
      paths: {
       "W1ILine0":new makerjs.paths.Line([xi,yi+hi+di+markShift], [xi-w1i,yi+hi+di+markShift]),
       "W1ILine1": new makerjs.paths.Line([xi-w1i,yi+h1i], [xi-w1i,yi+h1i+di+markShiftThree]),//左上角
      }
    };



    var myFsAMakerW2I = {
      paths: {
       "W2ILine0":new makerjs.paths.Line([xi,yi+hi+hi+markShiftThree], [xi-w2i,yi+hi+hi+markShiftThree]),
        "W2ILine1": new makerjs.paths.Line([xi-w2i,yi], [xi-w2i,yi+hi+hi+di+markShiftFour]),//左上角
      }
    };
    var myFsAMakerHI = {      
      paths: {
       "HILine0":new makerjs.paths.Line([xi,yi], [xi+markShiftFour, yi]),
       "HILine1": new makerjs.paths.Line([xi,yi+hi], [xi+markShiftFour, yi+hi]),//左上角
       "HILine2": new makerjs.paths.Line([xi+markShiftTwo,yi], [xi+markShiftTwo,yi+hi]),//左上角
      }
    };
    var myFsAMakerH1I = {    
      paths: {
       "H1ILine0":new makerjs.paths.Line([xi-w1i,yi+h1i], [xi-w1i-di/2-markShiftFour, yi+h1i]),
       "H1ILine1": new makerjs.paths.Line([xi-w2i-markShift,yi], [xi-w2i-markShift,yi+h1i]),//左上角
      }
    };
    var myFsAMakerR2I = {    
      paths: {
      //  "R2ILine1": new makerjs.paths.Line([xi-w2,yi], [xi-w2, yi-r2-markShiftFour]),//左上角
       "R2ILine2": new makerjs.paths.Line([xi-Iaa+markShiftTwo,yi], [xi-Iaa,yi+Ihd]),//左上角
      }
    };
    var myFsAMakerR1I = {    
      paths: {
       "R1ILine1": new makerjs.paths.Line([xi-wi,yi+Ihd], [xi-wi-markShift,yi+Ihd+markShift]),//左上角
      }
    };
    var myFsAMakerDI = {    
      paths: {
       "DILine1": new makerjs.paths.Line([xi-w1i,yi+h1i], [xi-w1i-markShift-markHolesOneD,yi+h1i+di+markShiftFour+markHolesOneD]),//左上角
      }
    };

     
  /******************************************************** */
  
  makerjs.model.addCaption(myFsAMakerWI, TxtWi, [xi-wi,yi+hi+markShiftThree], [xi,yi+hi+markShiftThree]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1I, TxtW1i, [xi-w1i,yi+hi+di+markShiftThree], [xi,yi+hi+di+markShiftThree]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2I, TxtW2i, [xi-w2i,yi+hi+hi+di+markShiftFour], [xi,yi+hi+hi+di+markShiftFour]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHI, TxtHi, [xi+markShiftFour,yi+hi], [xi+markShiftFour,yi]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1I, TxtH1i, [xi-w2i-markShiftThree,yi+h1i], [xi-w2i-markShiftThree,yi]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2I, TxtR2i, [xi-Iaa+markShift,yi+Ihd-markShift], [xi-Iaa+markShiftThree,yi+Ihd-markShiftThree]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1I, TxtR1i, [xi-wi-markShift,yi+Ihd+markShift], [xi-wi,yi+Ihd]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDI, TxtDi,[xi-w1i-markHolesOneD-markShiftFour,yi+h1i+di+markShiftFour+markHolesOneD], [xi-w1i-markShift-markHolesOneD,yi+h1i+di+markShiftFour+markHolesOneD]);//D文字标注  
   
/***************************************************/ 
    /**************************************************** */
    
  makerjs.model.addCaption(myFsAMakerWA, TxtWa, [xa,ya-ha-markShiftThree], [xa+wa,ya-ha-markShiftThree]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1A, TxtW1a, [xa,ya-ha-da-markShiftThree], [xa+w1a,ya-ha-da-markShiftThree]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2A, TxtW2a, [xa,ya-ha-ha-da-markShiftFour], [xa+w2a,ya-ha-ha-da-markShiftFour]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHA, TxtHa, [xa-markShiftFour,ya-ha], [xa-markShiftFour,ya]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1A, TxtH1a, [xa+w2a+markShiftThree,ya-h1a], [xa+w2a+markShiftThree,ya]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2A, TxtR2a, [xa+Aa-markShiftThree,ya-Ahd+markShiftThree], [xa+Aa-markShift,ya-Ahd+markShift]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1A, TxtR1a, [xa+wa,ya-Ahd], [xa+wa+markShift,ya-Ahd-markShift]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDA, TxtDa, [xa+w1a+markShift+markHolesOneD,ya-h1a-da-markShiftFour-markHolesOneD],[xa+w1a+markHolesOneD+markShiftFour,ya-h1a-da-markShiftFour-markHolesOneD]);//D文字标注  
    
  /**************************************************** */

  
  makerjs.model.addCaption(myFsAMakerWC, TxtWc, [xc-wc,yc-hc-markShiftThree], [xc,yc-hc-markShiftThree]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1C, TxtW1c, [xc-w1c,yc-hc-dc-markShiftThree], [xc,yc-hc-dc-markShiftThree]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2C, TxtW2c, [xc-w2c,yc-hc-hc-dc-markShiftFour], [xc,yc-hc-hc-dc-markShiftFour]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHC, TxtHc, [xc+markShiftFour,yc-hc], [xc+markShiftFour,yc]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1C, TxtH1c, [xc-w2c-markShiftThree,yc-h1c], [xc-w2c-markShiftThree,yc]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2C, TxtR2c, [xc-Caa+markShift,yc-Chd+markShift], [xc-Caa+markShiftThree,yc-Chd+markShiftThree]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1C, TxtR1c, [xc-wc-markShift,yc-Chd-markShift], [xc-wc,yc-Chd]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDC, TxtDc,[xc-w1c-markHolesOneD-markShiftFour,yc-h1c-dc-markShiftFour-markHolesOneD], [xc-w1c-markShift-markHolesOneD,yc-h1c-dc-markShiftFour-markHolesOneD]);//D文字标注  
    

  /******************************************************** */
  makerjs.model.addCaption(myFsAMakerWG, TxtWg, [xg,yg+hg+markShiftThree], [xg+wg,yg+hg+markShiftThree]);//半径文字  
  makerjs.model.addCaption(myFsAMakerW1G, TxtW1g, [xg,yg+hg+dg+markShiftThree], [xg+w1g,yg+hg+dg+markShiftThree]);//W1文字标注 
  makerjs.model.addCaption(myFsAMakerW2G, TxtW2g, [xg,yg+hg+hg+dg+markShiftFour], [xg+w2g,yg+hg+hg+dg+markShiftFour]);//W1文字标注
  makerjs.model.addCaption(myFsAMakerHG, TxtHg, [xg-markShiftFour,yg+hg], [xg-markShiftFour,yg]);//H文字标注
  makerjs.model.addCaption(myFsAMakerH1G, TxtH1g, [xg+w2g+markShiftThree,yg+h1g], [xg+w2g+markShiftThree,yg]);//H1文字标注
  makerjs.model.addCaption(myFsAMakerR2G, TxtR2g, [xg+Ga-markShiftThree,yg+Ghd-markShiftThree], [xg+Ga-markShift,yg+Ghd-markShift]);//R2文字标注
  makerjs.model.addCaption(myFsAMakerR1G, TxtR1g, [xg+wg,yg+Ghd], [xg+wg+markShift,yg+Ghd+markShift]);//R1文字标注
  makerjs.model.addCaption(myFsAMakerDG, TxtDg, [xg+w1g+markShift+markHolesOneD,yg+h1g+dg+markShiftFour+markHolesOneD],[xg+w1g+markHolesOneD+markShiftFour,yg+h1g+dg+markShiftFour+markHolesOneD]);//D文字标注  
    
  /******************************************************** */
  

  /******************************************************** */
  var markers = {
    /**A */
        myFsAMakerWA,
        myFsAMakerW1A,
         myFsAMakerW2A,
         myFsAMakerHA,
        myFsAMakerH1A,
         myFsAMakerR2A,
        myFsAMakerR1A,
        myFsAMakerDA,
        /**C */
        myFsAMakerWC,
        myFsAMakerW1C,
         myFsAMakerW2C,
         myFsAMakerHC,
        myFsAMakerH1C,
         myFsAMakerR2C,
        myFsAMakerR1C,
        myFsAMakerDC,
        /** G*/        
        myFsAMakerWG,
        myFsAMakerW1G,
         myFsAMakerW2G,
         myFsAMakerHG,
        myFsAMakerH1G,
         myFsAMakerR2G,
        myFsAMakerR1G,
        myFsAMakerDG,
        /**I */
        myFsAMakerWI,
        myFsAMakerW1I,
        myFsAMakerW2I,
        myFsAMakerHI,
        myFsAMakerH1I,
        myFsAMakerR2I,
        myFsAMakerR1I,
        myFsAMakerDI,
      }
  

    // var myFilletMark = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xahx, xahy], [xawx, xawy], [xcwx, xcwy], [xchx, xchy],[xihx, xihy], [xiwx, xiwy], [xgwx, xgwy]]);
  }
}
 
  return { markers };
};
// inputParam,model,myHolesNum,outParam,fixedParam
// (D,X,Y,area,plate,markers,myHolesNum,glassW,glassH,markShift,markShiftTwo,markShiftThree,markShiftFour,markHolesOneD)
 //已知相切两圆的圆心坐标及半径，求切点坐标
 function CircleTwo(x1,y1,x2,y2,r1,r2){
  //用于X轴为短边
  console.log("x1,y1,x2,y2,r1,r2==",x1,y1,x2,y2,r1,r2);
//外切圆，切点坐标为
/**
 * P[Px,Py]
 * Px=x1+((x2-x1)*r1/r1+r2)=(x2*r1+x1*r2)/(r1+r2);
 * Py=y1+[(y2-y1)*r1/(r1+r2)]=(y1*r2+y2*r1)/(r1+r2)
 * 
 */
    var x=(r1*x2+x1*r2)/(r2+r1);    
     var d=Math.sqrt((r1*r1)-(x-x1)*(x-x1));             
   var Arr = [x,d]; 
   return Arr;
 }; //已知相切两圆的圆心坐标及半径，求切点坐标
 function CircleTwoLong(x1,y1,x2,y2,r1,r2){
  //用于X轴为长边
  console.log("x1,y1,x2,y2,r1,r2==",x1,y1,x2,y2,r1,r2);
//外切圆，切点坐标为
/**
 * P[Px,Py]
 * Px=x1+((x2-x1)*r1/r1+r2)=(x2*r1+x1*r2)/(r1+r2);
 * Py=y1+[(y2-y1)*r1/(r1+r2)]=(y1*r2+y2*r1)/(r1+r2)
 * 
 */
    var y=(y1*r2+y2*r1)/(r1+r2);    //切点坐标 Y值
     var yw=Math.sqrt((r1*r1)-(y-y1)*(y-y1)); //r1 圆心X坐标与切点之间差值            
   var Arr = [y,yw]; 
   return Arr;
 };
function FloorSpring(inputParam, model, myHolesNum, outParam, fixedParam, zoom, θCut, rCut,cutLine,cutFilletRadius){
  var frame = outParam.shapeName;
  console.log("outParam=====FloorSpringFloorSpring??????????????======", outParam)
  console.log("model==", model)
  console.log("inputParam==", inputParam)
  console.log("inputParam.area==", inputParam.area)
  console.log("outParam.shapeName==////////", outParam.shapeName)
  var allKeysA = Object.getOwnPropertyNames(JSON.parse(JSON.stringify(model.plate.models)));
  if (typeof (frame) == "undefined") {
    var D=inputParam.D,R1=inputParam.R1,R2=inputParam.R2,W=inputParam.W,W1=inputParam.W1,W2=inputParam.W2,H=inputParam.H,H1=inputParam.H1,X=inputParam.X,Y=inputParam.Y,area=inputParam.area,myZoom=zoom*1, myθCut = θCut, myrCut = rCut,
    plate = model.plate, cutPlate = model.cutPlate, markers = model.markers, frame = "Rectangle",
      glassW = outParam.glassW, glassH = outParam.glassH,cutLine=cutLine*1,cutFilletRadius=cutFilletRadius*1,
      markShift = fixedParam.markShift, markShiftTwo = fixedParam.markShiftTwo,
      markShiftThree = fixedParam.markShiftThree, markShiftFour = fixedParam.markShiftFour, markHolesOneD = fixedParam.markHolesOneD,


      w = W*1*myZoom,
      w1 = W1*1*myZoom,
      w2 = W2*1*myZoom,
      h = H*1*myZoom,
      h1 = H1*1*myZoom,
      r1 = R1*1*myZoom,
      r2 = R2*1*myZoom,
      d = D*1*myZoom,
      r = d/2,
      a=0,//圆心坐标[a,b]
      b=0,//圆心坐标[a,b]  
        x0 = X*1*myZoom,
        y0 = Y*1*myZoom;  
        if(plate.models===undefined||plate.models===""){
          console.log("1111111111111111");
          plate.models={};
                  }        
                  if(cutPlate.models===undefined||cutPlate.models===""){
                      console.log("22222222222");
                      //cutPlate.models={};
                      cutPlate.models={};
                  }
                  if(markers.models===undefined||markers.models===""){            
                      console.log("333333333333");
                      markers.models={};
                  }

      if(d!==0){
        var TxtD="∮"+D;
       }
       if(r1!==0){
        var TxtR1="R1="+R1;
       }
       if(r2!==0){
        var TxtR2="R2="+R2;
       }
       if(w!==0){
        var TxtW=W;
       }
       if(w1!==0){
        var TxtW1=W1;
       }
       if(w2!==0){
        var TxtW2=W2;
       }
       if(h!==0){
        var TxtH=H;
       }
       if(h1!==0){
        var TxtH1=H1;
       }
       if(x0!==0){          
       var TxtX=X;
       }
       if(y0!==0){          
        var TxtY=Y;
       }
  } else {
    var D=inputParam.D,R1=inputParam.R1,R2=inputParam.R2,W=inputParam.W,W1=inputParam.W1,W2=inputParam.W2,H=inputParam.H,H1=inputParam.H1,X=inputParam.X,Y=inputParam.Y,area=inputParam.area,myZoom=zoom*1, myθCut = θCut, myrCut = rCut,
    plate = model.plate, cutPlate = model.cutPlate, markers = model.markers, frame = outParam.shapeName,
      glassW = outParam.glassW, glassH = outParam.glassH,cutLine=cutLine*1,cutFilletRadius=cutFilletRadius*1,
      markShift = fixedParam.markShift, markShiftTwo = fixedParam.markShiftTwo,
      markShiftThree = fixedParam.markShiftThree, markShiftFour = fixedParam.markShiftFour, markHolesOneD = fixedParam.markHolesOneD,

      w = W*1*myZoom,
   w1 = W1*1*myZoom,
   w2 = W2*1*myZoom,
   h = H*1*myZoom,
   h1 = H1*1*myZoom,
   r1 = R1*1*myZoom,
   r2 = R2*1*myZoom,
   d = D*1*myZoom,
   r = d/2,
   a=0,//圆心坐标[a,b]
   b=0,//圆心坐标[a,b]  
     x0 = X*1*myZoom,
     y0 = Y*1*myZoom;  
     if(plate.models===undefined||plate.models===""){
      console.log("1111111111111111");
      plate.models={};
              }        
              if(cutPlate.models===undefined||cutPlate.models===""){
                  console.log("22222222222");
                  //cutPlate.models={};
                  cutPlate.models={};
              }
              if(markers.models===undefined||markers.models===""){            
                  console.log("333333333333");
                  markers.models={};
              }
    /* 
   w = W*1,
   w1 = W1*1,
   w2 = W2*1,
   h = H*1,
   h1 = H1*1,
   r1 = R1*1,
   r2 = R2*1,
   d = D*1,
   r = (D*1)/2,
   a=0,//圆心坐标[a,b]
   b=0,//圆心坐标[a,b]  
     x0 = X*1,
     y0 = Y*1;
     */   
     if(d!==0){
      var TxtD="∮"+D;
     }
     if(r1!==0){
      var TxtR1="R1="+R1;
     }
     if(r2!==0){
      var TxtR2="R2="+R2;
     }
     if(w!==0){
      var TxtW=W;
     }
     if(w1!==0){
      var TxtW1=W1;
     }
     if(w2!==0){
      var TxtW2=W2;
     }
     if(h!==0){
      var TxtH=H;
     }
     if(h1!==0){
      var TxtH1=H1;
     }
     if(x0!==0){          
     var TxtX=X;
     }
     if(y0!==0){          
      var TxtY=Y;
     }
    }
  if (frame == "Rectangle") {
    console.log("frame==undefined||||*****") 

    //在A区域 计算孔的位置       
    var xa = x0, ya = glassH * 1 - y0,
    //C区域
    xc = glassW * 1 - x0, yc = glassH * 1 - y0,
    //在G区域 计算孔的位置
    xg = x0, yg = y0,
    //在I区域 计算孔的位置
    xi = glassW * 1 - x0, yi = y0,
    arrA=[],arrC=[],arrG=[],arrI=[];
    if(glassW*1>glassH * 1){
      console.log("长边在X轴￥￥￥￥￥");
      arrA=CircleTwoLong(xa+h-r1,ya-w,xa+r2,ya-w2,r1,r2);
      var Aa=ya-arrA[0]*1,  Ab=arrA[1]*1,  Ahd=h-(r1-Ab),Aaa=glassH * 1-Aa;
      arrC=CircleTwoLong(xc-h+r1,yc-w,xc-r2,yc-w2,r1,r2);
      var Ca=yc-arrC[0]*1,  Cb=arrC[1]*1,  Chd=h-(r1-Cb),Caa=glassH * 1-Ca;
      arrG=CircleTwoLong(xg+h-r1,yg+w,xg+r2,yg+w2,r1,r2);
      var Ga=arrG[0]*1,  Gb=arrG[1]*1,  Ghd=h-(r1-Gb),Gaa=glassH * 1-Ga;
      arrI=CircleTwoLong(xi-h+r1,yi+w,xi-r2,yi+w2,r1,r2); 
      var Ia=arrI[0]*1,  Ib=arrI[1]*1,  Ihd=h-(r1-Ib),Iaa=glassH * 1-Ia,
    // var a=arr[0]*1,b=arr[1]*1,aa=glassW * 1-a,hd=h-(r1-b),
    da=d,wa=w,w1a=w1,w2a=w2,ha=h,h1a=h1,ra=r,r1a=r1,r2a=r2,
       xawx1 = xa+h, xawy1 =ya,//A位置角1坐标
    xawx2 = xa+h,xawy2 = ya-w,//A位置角2坐标
    xawx3 = xa+Ahd,xawy3 = ya-Aa,//A位置角3坐标
    xawx4 = xa,xawy4 = ya-w2;//A位置角4坐标

    dc=d,wc=w,w1c=w1,w2c=w2,hc=h,h1c=h1,rc=r,r1c=r1,r2c=r2,     
    xcwx1 = xc-h, xcwy1 =yc,//C位置角1坐标
    xcwx2 = xc-h,xcwy2 = yc-w,//C位置角2坐标
    xcwx3 = xc-Chd,xcwy3 = yc-Ca,//C位置角3坐标
    xcwx4 = xc,xcwy4 = yc-w2;//C位置角4坐标

     dg=d,wg=w,w1g=w1,w2g=w2,hg=h,h1g=h1,rg=r,r1g=r1,r2g=r2,      
    xgwx1 = xg+h, xgwy1 =yg,//G位置角1坐标
    xgwx2 = xg+h,xgwy2 = yg+w,//G位置角2坐标
    xgwx3 = xg+Ghd,xgwy3 = yg+Ga,//G位置角3坐标
    xgwx4 = xg,xgwy4 = yg+w2;//G位置角4坐标
        
    di=d,wi=w,w1i=w1,w2i=w2,hi=h,h1i=h1,ri=r,r1i=r1,r2i=r2,
    xiwx1 = xi-h, xiwy1 =yi,//I位置角1坐标
            xiwx2 = xi-h,xiwy2 = yi+w,//I位置角2坐标
            xiwx3 = xi-Ihd,xiwy3 = yi+Ia,//I位置角3坐标
            xiwx4 = xi,xiwy4 = yi+w2;//I位置角4坐标 

 /**
      * ox1,oy1,ox2,oy2,r1,r
      * 圆心C1坐标点   ox1=h-r1,oy1=ya-w,
      * 圆心C2坐标点   ox2=h1,oy2=ya-w1，
      * 
      * 
      */
   
// 示例用法
const circle1A = { x: xa+r2a, y: ya-w2a, r: r2a };
const circle2A = { x: h1a, y: ya-w1a, r: ra };
const circle1C = { x: xc-r2c, y: yc-w2c, r: r2c };
const circle2C = { x: xc-h1c, y: yc-w1c, r: rc };
const circle1G = { x: xg+r2g, y: yg+w2g, r: r2g };
const circle2G = { x: h1g, y: w1g, r: rg };
const circle1I = { x: xi-r2i, y: yi+w2i, r: r2i };
const circle2I = { x: xi-h1i, y: yi+w1i, r: ri };
console.log("circle1C,circle2C==",circle1C,circle2C);
 
  var arrCulA= getClosestPoint(circle1A, circle2A);
  var arrCulC= getClosestPoint(circle1C, circle2C);
  var arrCulG= getClosestPoint(circle1G, circle2G);
  var arrCulI= getClosestPoint(circle1I, circle2I);
//d,X0,Y0
var oAd=arrCulA.d,oAX1=arrCulA.X1,oAY1=arrCulA.Y1,oAX2=arrCulA.X2,oAY2=arrCulA.Y2,oAX3=arrCulA.X3,oAY3=arrCulA.Y3,
   oCd=arrCulC.d,oCX1=arrCulC.X1,oCY1=arrCulC.Y1,oCX2=arrCulC.X2,oCY2=arrCulC.Y2,oCX3=arrCulC.X3,oCY3=arrCulC.Y3,
   oGd=arrCulG.d,oGX1=arrCulG.X1,oGY1=arrCulG.Y1,oGX2=arrCulG.X2,oGY2=arrCulG.Y2,oGX3=arrCulG.X3,oGY3=arrCulG.Y3,
   oId=arrCulI.d,oIX1=arrCulI.X1,oIY1=arrCulI.Y1,oIX2=arrCulI.X2,oIY2=arrCulI.Y2,oIX3=arrCulI.X3,oIY3=arrCulI.Y3;

    }else{
      console.log("短边在X轴￥￥￥￥￥");
      arrA=CircleTwo(xa+w,ya+r1,xa+w2,ya-r2,r1,r2);
      var Aa=arrA[0]*1,  Ab=arrA[1]*1,  Ahd=h-(r1-Ab),Aaa=glassW * 1-Aa;
      arrC=CircleTwo(xc-w,yc+r1,xc-w2,yc-r2,r1,r2);
      var Ca=arrC[0]*1,  Cb=arrC[1]*1,  Chd=h-(r1-Cb),Caa=glassW * 1-Ca;
      arrG=CircleTwo(xg+w,yg-r1,xg+w2,yg+r2,r1,r2);
      var Ga=arrG[0]*1,  Gb=arrG[1]*1,  Ghd=h-(r1-Gb),Gaa=glassW * 1-Ga;
      arrI=CircleTwo(xi-w,yi-r1,xi-w2,yi+r2,r1,r2); 
      var Ia=arrI[0]*1,  Ib=arrI[1]*1,  Ihd=h-(r1-Ib),Iaa=glassW * 1-Ia,
    // var a=arr[0]*1,b=arr[1]*1,aa=glassW * 1-a,hd=h-(r1-b),
    da=d,wa=w,w1a=w1,w2a=w2,ha=h,h1a=h1,ra=r,r1a=r1,r2a=r2,
          xawx1 = xa, xawy1 =ya-h,//A位置角1坐标
          xawx2 = xa+w,xawy2 = ya-h,//A位置角2坐标
          xawx3 = xa+Aa,xawy3 = ya-Ahd,//A位置角3坐标
          xawx4 = xa+w2,xawy4 = ya,//A位置角4坐标


          dc=d,wc=w,w1c=w1,w2c=w2,hc=h,h1c=h1,rc=r,r1c=r1,r2c=r2,     
          xcwx1 = xc, xcwy1 =yc-h,//C位置角1坐标
          xcwx2 = xc-w,xcwy2 = yc-h,//C位置角2坐标
          xcwx3 = xc-Caa,xcwy3 = yc-Chd,//C位置角3坐标
          xcwx4 = xc-w2,xcwy4 = yc,//C位置角4坐标


          dg=d,wg=w,w1g=w1,w2g=w2,hg=h,h1g=h1,rg=r,r1g=r1,r2g=r2,    
          xgwx1 = xg, xgwy1 =yg+h,//G位置角1坐标
          xgwx2 = xg+w,xgwy2 = yg+h,//G位置角2坐标
          xgwx3 = xg+Ga,xgwy3 = yg+Ghd,//G位置角3坐标
          xgwx4 = xg+w2,xgwy4 = yg,//G位置角4坐标
        
          di=d,wi=w,w1i=w1,w2i=w2,hi=h,h1i=h1,ri=r,r1i=r1,r2i=r2,
          xiwx1 = xi, xiwy1 =yi+h,//I位置角1坐标
          xiwx2 = xi-w,xiwy2 = yi+h,//I位置角2坐标
          xiwx3 = xi-Iaa,xiwy3 = yi+Ihd,//I位置角3坐标
          xiwx4 = xi-w2,xiwy4 = yi;//I位置角4坐标 
          // 示例用法
const circle1A = { x: xa+w2, y: ya-r2, r: r2a };
const circle2A = { x: w1a, y: ya-h1a, r: ra };
const circle1C = { x: xc-w2, y: yc-r2, r: r2c };
const circle2C = { x: xc-w1c, y: yc-h1c, r: rc };
const circle1G = { x: xg+w2, y: yg+r2, r: r2g };
const circle2G = { x: w1g, y: h1g, r: rg };
const circle1I = { x: xi-w2,y: yi+r2, r: r2i };
const circle2I = { x: xi-w1i, y: yi+h1i, r: ri };
console.log("circle1C,circle2C==",circle1C,circle2C);
 
  var arrCulA= getClosestPoint(circle1A, circle2A);
  var arrCulC= getClosestPoint(circle1C, circle2C);
  var arrCulG= getClosestPoint(circle1G, circle2G);
  var arrCulI= getClosestPoint(circle1I, circle2I);
//d,X0,Y0
var oAd=arrCulA.d,oAX1=arrCulA.X1,oAY1=arrCulA.Y1,oAX2=arrCulA.X2,oAY2=arrCulA.Y2,oAX3=arrCulA.X3,oAY3=arrCulA.Y3,
   oCd=arrCulC.d,oCX1=arrCulC.X1,oCY1=arrCulC.Y1,oCX2=arrCulC.X2,oCY2=arrCulC.Y2,oCX3=arrCulC.X3,oCY3=arrCulC.Y3,
   oGd=arrCulG.d,oGX1=arrCulG.X1,oGY1=arrCulG.Y1,oGX2=arrCulG.X2,oGY2=arrCulG.Y2,oGX3=arrCulG.X3,oGY3=arrCulG.Y3,
   oId=arrCulI.d,oIX1=arrCulI.X1,oIY1=arrCulI.Y1,oIX2=arrCulI.X2,oIY2=arrCulI.Y2,oIX3=arrCulI.X3,oIY3=arrCulI.Y3;
      }
       
var OffsetParam={Aa,Aaa,Ahd,Ca,Caa,Chd,Ga,Gaa,Ghd,Ia,Iaa,Ihd};
  } else if (frame == "IsoscelesTrapezoid") {
    //在A区域 计算孔的位置
    var xwd = (glassW * 1 - glassW1 * 1) / 2,
      xa = x0 + xwd, ya = glassH * 1 - y0,
      awd = xwd * h / (glassH * 1),
      cwd = awd,
      xawx = xa + w, xawy = ya,//A位置角W坐标
      xahx = xa - awd, xahy = ya - h,//A位置角H坐标   
      //C区域
      xc = glassW * 1 - xwd - x0, yc = glassH * 1 - y0,
      xcwx = xc - w, xcwy = yc,//C位置角W坐标
      xchx = xc + awd, xchy = yc - h,//C位置角H坐标
      //在G区域 计算孔的位置
      xg = x0, yg = y0,
      xgwx = xg + w, xgwy = yg,//G位置角W坐标
      xghx = xg + awd, xghy = yg + h,//G位置角H坐标
      //在I区域 计算孔的位置
      xi = glassW * 1 - x0, yi = y0;
    xiwx = xi - w, xiwy = yi,//I位置角W坐标
      xihx = xi - awd, xihy = yi + h;//I位置角H坐标
    var OffsetParam = { awd, ahd: 0, cwd, cwdd: 0, chd: 0, iwd: awd, iwdd: 0, ihd: 0 };
  } else if (frame == "RightAngledTrapezoid") {
    //在A区域 计算孔的位置
    var yhd = glassH * 1 - glassH1 * 1, xwd = glassW * 1 - glassW1 * 1,
      ahd = yhd * w / (glassW1 * 1),//Y方向偏移
      awd = ((glassW1 * 1) - w) * yhd / (glassH * 1), //X方向偏移
      iwd = xwd * h / (glassH * 1), //X方向偏移
      xa = x0, ya = glassH * 1 - y0 - yhd,
      xawx = xa + w, xawy = ya + ahd,//A位置角W坐标
      xahx = xa, xahy = ya - h,//A位置角H坐标 
      //C区域
      xc = glassW * 1 - xwd - x0, yc = glassH * 1 - y0,
      xcwx = xc - w, xcwy = yc - ahd,//C位置角W坐标
      xchx = xc + iwd, xchy = yc - h,//C位置角H坐标
      //在G区域 计算孔的位置
      xg = x0, yg = y0,
      xgwx = xg + w, xgwy = yg,//G位置角W坐标
      xghx = xg, xghy = yg + h,//G位置角H坐标
      //在I区域 计算孔的位置
      xi = glassW * 1 - x0, yi = y0;
    xiwx = xi - w, xiwy = yi,//I位置角W坐标
      xihx = xi - iwd, xihy = yi + h;//I位置角H坐标
    var OffsetParam = { awd: 0, ahd, cwd: iwd, cwdd: 0, chd: 0, iwd, iwdd: 0, ihd: 0 };
  } else if (frame == "OtherTrapezoidsA") {
    //在A区域 计算孔的位置
    var yhd = glassH1 * 1 - glassH2 * 1,
      ahd = yhd * w / ((glassW * 1) - (glassW1 * 1) - (glassW2 * 1)),//Y方向偏移
      awd = (glassW1 * 1) * h / (glassH1 * 1), //X方向偏移 A 
      iwd = (glassW2 * 1) * h / (glassH2 * 1), //X方向偏移
      gwd = (glassW1 * 1) * h / (glassH1 * 1), //X方向偏移


      xa = x0 + glassW1 * 1, ya = glassH1 * 1 - y0,
      xawx = xa + w, xawy = ya - ahd,//A位置角W坐标
      xahx = xa - awd, xahy = ya - h,//A位置角H坐标 
      //C区域
      xc = glassW * 1 - glassW2 * 1 - x0, yc = glassH2 * 1 - y0,
      xcwx = xc - w, xcwy = yc + ahd,//C位置角W坐标
      xchx = xc + iwd, xchy = yc - h,//C位置角H坐标
      //在G区域 计算孔的位置
      xg = x0, yg = y0,
      xgwx = xg + w, xgwy = yg,//G位置角W坐标
      xghx = xg + gwd, xghy = yg + h,//G位置角H坐标
      //在I区域 计算孔的位置
      xi = glassW * 1 - x0, yi = y0;
    xiwx = xi - w, xiwy = yi,//I位置角W坐标
      xihx = xi - iwd, xihy = yi + h;//I位置角H坐标
    var OffsetParam = { awd: 0, ahd: 0, cwd: iwd, cwdd: 0, chd: ahd, iwd, iwdd: 0, ihd: 0 };
  } else if (frame == "OtherTrapezoidsB") {
    //在A区域 计算孔的位置
    var yhd = glassH1 * 1 - glassH2 * 1,
      ahd = yhd * w / ((glassW * 1) - (glassW1 * 1) - (glassW2 * 1)),//Y方向偏移
      awd = (glassW1 * 1) * h / (glassH * 1), //X方向偏移 A 
      cwd = (glassW2 * 1) * h / (glassH * 1), //X方向偏移 A 
      iwd = (glassW2 * 1) * h / (glassH2 * 1), //X方向偏移
      gwd = (glassW1 * 1) * h / (glassH1 * 1), //X方向偏移
      xa = x0 + glassW1 * 1, ya = glassH * 1 - y0,
      xawx = xa + w, xawy = ya,//A位置角W坐标
      xahx = xa - awd, xahy = ya - h,//A位置角H坐标
      //C区域
      xc = glassW * 1 - glassW2 * 1 - x0, yc = glassH * 1 - y0,
      xcwx = xc - w, xcwy = yc,//C位置角W坐标
      xchx = xc + cwd, xchy = yc - h,//C位置角H坐标
      //在G区域 计算孔的位置
      xg = x0, yg = y0,
      xgwx = xg + w, xgwy = yg,//G位置角W坐标
      xghx = xg + awd, xghy = yg + h,//G位置角H坐标
      //在I区域 计算孔的位置
      xi = glassW * 1 - x0, yi = y0;
    xiwx = xi - w, xiwy = yi,//I位置角W坐标
      xihx = xi - cwd, xihy = yi + h;//I位置角H坐标
    var OffsetParam = { awd: 0, ahd: 0, cwd, cwdd: 0, chd: 0, iwd: cwd, iwdd: 0, ihd: 0 };
  } else if (frame == "ParallelogramA") {
    //在A区域 计算孔的位置
    var awd = (glassW1 * 1) * h / (glassH * 1), //X方向偏移 A
      xa = x0 + glassW1 * 1, ya = glassH * 1 - y0,
      xawx = xa + w, xawy = ya,//A位置角W坐标
      xahx = xa - awd, xahy = ya - h,//A位置角H坐标
      //C区域
      xc = glassW * 1 + glassW1 * 1 - x0, yc = glassH * 1 - y0,
      xcwx = xc - w, xcwy = yc,//C位置角W坐标
      xchx = xc - awd, xchy = yc - h,//C位置角H坐标
      //在G区域 计算孔的位置
      xg = x0, yg = y0,
      xgwx = xg + w, xgwy = yg,//G位置角W坐标
      xghx = xg + awd, xghy = yg + h,//G位置角H坐标
      //在I区域 计算孔的位置
      xi = glassW * 1 - x0, yi = y0;
    xiwx = xi - w, xiwy = yi,//I位置角W坐标
      xihx = xi + awd, xihy = yi + h;//I位置角H坐标

    var OffsetParam = { awd: 0, ahd: 0, cwd: 0, cwdd: awd, chd: 0, iwd: 0, iwdd: awd, ihd: 0 };

  } else if (frame == "ParallelogramB") {
    console.log("markers.models=", markers.models)
    //在A区域 计算孔的位置
    var awd = (glassW1 * 1) * h / (glassH * 1), //X方向偏移 A  G
      cwd = (glassW2 * 1) * h / (glassH * 1), //X方向偏移 C  I 
      xa = x0 + glassW1 * 1, ya = glassH * 1 - y0,
      xawx = xa + w, xawy = ya,//A位置角W坐标
      xahx = xa - awd, xahy = ya - h,//A位置角H坐标
      //C区域
      xc = glassW * 1 + glassW2 * 1 - x0, yc = glassH * 1 - y0,
      xcwx = xc - w, xcwy = yc,//C位置角W坐标
      xchx = xc - cwd, xchy = yc - h,//C位置角H坐标
      //在G区域 计算孔的位置
      xg = x0, yg = y0,
      xgwx = xg + w, xgwy = yg,//G位置角W坐标
      xghx = xg + awd, xghy = yg + h,//G位置角H坐标
      //在I区域 计算孔的位置
      xi = glassW * 1 - x0, yi = y0;
    xiwx = xi - w, xiwy = yi,//I位置角W坐标
      xihx = xi + cwd, xihy = yi + h;//I位置角H坐标
    var OffsetParam = { awd: 0, ahd: 0, cwd: 0, cwdd: awd, chd: 0, iwd: 0, iwdd: cwd, ihd: 0 };

  }
  if(inputParam.area===undefined){
    var ObliqueAngleData=showArea(inputParam,outParam);
    var paramCoordinate =ObliqueAngleData[1];
    var areaPoint =ObliqueAngleData[0];
    var whMarksParam=ObliqueAngleData[2];
    console.log("whMarksParam=",whMarksParam);
  }else{
// 坐标参数
// 
var paramCoordinate = {cutLine,cutFilletRadius,da,wa,w1a,w2a,ha,h1a,ra,r1a,r2a,dc,wc,w1c,w2c,hc,h1c,rc,r1c,r2c,dg,wg,w1g,w2g,hg,h1g,rg,r1g,r2g,di,wi,w1i,w2i,hi,h1i,ri,r1i,r2i, xa, ya, xawx1, xawy1,xawx2, xawy2,xawx3, xawy3,xawx4, xawy4, xc, yc, xcwx1, xcwy1, xcwx2,xcwy2,xcwx3,xcwy3,xcwx4,xcwy4, xg, yg, xgwx1, xgwy1, xgwx2, xgwy2,xgwx3, xgwy3,xgwx4, xgwy4, xi, yi, xiwx1, xiwy1, xiwx2, xiwy2, xiwx3, xiwy3, xiwx4, xiwy4,glassW,glassH,oAd,oAX1,oAY1,oAX2,oAY2,oAX3,oAY3,oCd,oCX1,oCY1,oCX2,oCY2,oCX3,oCY3,oGd,oGX1,oGY1,oGX2,oGY2,oGX3,oGY3,oId,oIX1,oIY1,oIX2,oIY2,oIX3,oIY3};
var whMarksParam={Aa,Aaa,Ahd,Ca,Caa,Chd,Ga,Gaa,Ghd,Ia,Iaa,Ihd};


var areaPoint = "";
console.log("//画1、斜角 ------", allKeysA);

// if (getCommonAll(allKeysA,frame).length == 0) {
  switch (area) {
    case "1": areaPoint = "A"; break;
    case "3": areaPoint = "C"; break;
    case "7": areaPoint = "G"; break;
    case "9": areaPoint = "I"; break;
  }
// } else {
//   switch (area) {
//     case "1": areaPoint = getStrs("A", getCommonAll(allKeysA,frame)); break;
//     case "3": areaPoint = getStrs("C", getCommonAll(allKeysA,frame)); break;
//     case "7": areaPoint = getStrs("G", getCommonAll(allKeysA,frame)); break;
//     case "9": areaPoint = getStrs("I", getCommonAll(allKeysA,frame)); break;
//   }
// }
  }
  
  /**
  * 画图
  * 
  */
  var ObjName = "myFloorSpring" + areaPoint;
  var ObjNameM = "myFloorSpring" + areaPoint + "Mark";//外框标记
  var ObjNameMCorner = "myFloorSpring" + areaPoint + "MarkCorner";//角标记
  var ObjNameO = "myFloorSpring" + areaPoint + "Obj";
  
  console.log("ObjName===||*********|||", ObjName);
  ObjName = creatFloorSpring(areaPoint, paramCoordinate);//图形
  console.log("ObjName===|||||||||", ObjName);
  ObjNameMCorner = creatFloorSpringMark(outParam, areaPoint, paramCoordinate, whMarksParam, fixedParam, OffsetParam, zoom);//图形
  console.log("ObjNameMCorner===|||||||||角标注", ObjNameMCorner);
  ObjNameO = { ObjName:ObjName[2] };
  ObjNameM = RectangleMark(outParam, model, fixedParam, zoom, frame);//外框标记
  // cutPlate.models = {};
  // plate.models = {};
  // delete markers.models.Rectangle;
  // delete markers.models.RectMarkWLine;
  // delete markers.models.RectMarkH;

  cutPlate.models["TypeCorner_myFloorSpring" + areaPoint] = ObjName[3];
  plate.models["TypeCorner_myFloorSpring" + areaPoint] = ObjName[3];

  markers.models={...ObjNameM.markers.models,...markers.models,...ObjNameMCorner.markers,...plate.models};
myHolesNum++;
return{plate,cutPlate,markers, myHolesNum}
};
export default FloorSpring;